(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
Falcon.addBinding('dateText', true, (function() {
  var FORMAT;
  FORMAT = "M/D/YYYY";
  return function(element, valueAccessor) {
    var m, node, offset, value;
    value = ko.unwrap(valueAccessor());
    if (_.isDate(value) || _.isString(value)) {
      m = moment.utc(value);
    } else if (moment.isMoment(value)) {
      m = value;
    } else if (_.isObject(value)) {
      ({value, offset} = value);
      value = ko.unwrap(value);
      offset = ko.unwrap(offset);
      m = moment.utc(value);
      if (offset) {
        m = m.utcOffset(offset);
      }
    } else {
      m = moment(null);
    }
    //END if
    if (m.isValid()) {
      node = document.createTextNode(m.format(FORMAT));
    } else {
      //TODO: Make this configurable and then more generic
      node = document.createTextNode("Invalid Date");
    }
    //END if
    return ko.virtualElements.setDomNodeChildren(element, [node]);
  };
})());

//END return
//END init

},{}],2:[function(require,module,exports){
Falcon.addBinding('dateTimeText', true, (function() {
  var FORMAT;
  FORMAT = "MM/DD/YYYY h:mma";
  return function(element, valueAccessor) {
    var m, node, value;
    value = ko.unwrap(valueAccessor());
    m = moment(value);
    if (m.isValid()) {
      node = document.createTextNode(m.format(FORMAT));
    } else {
      node = document.createTextNode("Invalid Date");
    }
    //END if
    return ko.virtualElements.setDomNodeChildren(element, [node]);
  };
})());

//END return
//END init

},{}],3:[function(require,module,exports){
var CONSTANTS;

CONSTANTS = require("../$constants/default.constants");

Falcon.addBinding("dateValue", {
  'init': function(element, valueAccessor, allBindings, viewModel, bindingContext) {
    var obs, onChange;
    obs = valueAccessor();
    if (!ko.isObservable(obs)) {
      return;
    }
    ko.computed({
      disposeWhenNodeIsRemoved: element,
      read: function() {
        var value;
        value = obs();
        if (value != null) {
          value = moment(value).format(CONSTANTS.DATE_FORMAT);
        }
        return element.value = value != null ? value : "";
      }
    });
    //END read
    //END computed
    element.addEventListener('change', onChange = function() {
      var m, value;
      value = element.value;
      m = moment(value, CONSTANTS.DATE_FORMAT);
      element.removeEventListener('change', onChange);
      if (m.isValid()) {
        obs(m.toDate());
      } else {
        obs(null);
      }
      //END if
      return element.addEventListener('change', onChange);
    });
    return Falcon.onDispose(element, function() {
      return element.removeEventListener('change', onChange);
    });
  }
});

//END onDispose
//END dateValue

},{"../$constants/default.constants":48}],4:[function(require,module,exports){
Falcon.addBinding('daysUntilText', true, function(element, valueAccessor, allBindings) {
  var add, daysUntil, m, node, offset, ref, value;
  value = ko.unwrap(valueAccessor());
  add = (ref = ko.unwrap(allBindings.get('daysUntilTextAdd'))) != null ? ref : 0;
  if (_.isDate(value) || _.isString(value)) {
    m = moment.utc(value);
  } else if (moment.isMoment(value)) {
    m = value;
  } else if (_.isObject(value)) {
    ({value, offset} = value);
    value = ko.unwrap(value);
    offset = ko.unwrap(offset);
    m = moment.utc(value);
    if (offset) {
      m = m.utcOffset(offset);
    }
  } else {
    m = moment(null);
  }
  //END if
  daysUntil = m.diff(moment.utc(), 'days') + add;
  if (daysUntil < 0) {
    daysUntil = 0;
  }
  node = document.createTextNode(daysUntil);
  return ko.virtualElements.setDomNodeChildren(element, [node]);
});

//END init

},{}],5:[function(require,module,exports){
Falcon.addBinding('decimal', true, function(element, valueAccessor) {
  var node, value;
  value = ko.unwrap(valueAccessor());
  node = document.createTextNode(numeral(value).format('0,0.00'));
  return ko.virtualElements.setDomNodeChildren(element, [node]);
});

//END return
//END init

},{}],6:[function(require,module,exports){
//---------------------------------------------
// followCursor
//---------------------------------------------
Falcon.addBinding('followCursor', (function() {
  return {
    'init': function(element, valueAccessor) {
      var $childElemens, $element;
      $element = $(element);
      $childElemens = null;
      ko.computed(() => {
        var querySelector;
        querySelector = ko.unwrap(valueAccessor());
        return $childElemens = $element.find(querySelector);
      });
      return element.addEventListener('mousemove', function(event) {
        var left, top, x, y;
        ({top, left} = $element.offset());
        x = event.pageX - left;
        y = event.pageY - top;
        return $childElemens.css({
          position: 'absolute',
          top: y,
          left: x
        });
      });
    }
  };
})());

//END init
//END followCursor

},{}],7:[function(require,module,exports){
Falcon.addBinding('fromNowText', true, function(element, valueAccessor) {
  var m, node, offset, value;
  value = ko.unwrap(valueAccessor());
  if (_.isDate(value) || _.isString(value)) {
    m = moment.utc(value);
  } else if (moment.isMoment(value)) {
    m = value;
  } else if (_.isObject(value)) {
    ({value, offset} = value);
    value = ko.unwrap(value);
    offset = ko.unwrap(offset);
    m = moment.utc(value);
    if (offset) {
      m = m.utcOffset(offset);
    }
  } else {
    m = moment(null);
  }
  //END if
  if (m.isValid()) {
    node = document.createTextNode(m.fromNow());
  } else {
    //TODO: Make this configurable and then more generic
    node = document.createTextNode("Invalid Date");
  }
  //END if
  return ko.virtualElements.setDomNodeChildren(element, [node]);
});

//END init

},{}],8:[function(require,module,exports){
Falcon.addBinding('hashHref', {
  'update': function(element, valueAccessor, allBindings, viewModel, bindingContext) {
    var ref, ref1, ref2, url, value;
    value = (ref = valueAccessor()) != null ? ref : "";
    if (ko.isObservable(value)) {
      url = ((ref1 = value()) != null ? ref1 : "").toString();
    } else if (_.isFunction(value)) {
      url = ((ref2 = value(bindingContext['$data'])) != null ? ref2 : "").toString();
    } else {
      url = value.toString();
    }
    //END if
    return element.setAttribute("href", `#${url}`);
  }
});

//END addBinding

},{}],9:[function(require,module,exports){
Falcon.addBinding('href', function(element, valueAccessor) {
  element.setAttribute('href', ko.unwrap(valueAccessor()));
  return element.setAttribute('target', '_blank');
});

//END addBinding

},{}],10:[function(require,module,exports){
Falcon.addBinding('integer', true, function(element, valueAccessor) {
  var node, value;
  value = ko.unwrap(valueAccessor());
  node = document.createTextNode(numeral(value).format('0,0'));
  return ko.virtualElements.setDomNodeChildren(element, [node]);
});

//END return
//END init

},{}],11:[function(require,module,exports){
Falcon.addBinding('isHovered', {
  'init': function(element, valueAccessor) {
    var $element, mouseenter, mouseleave, obs;
    obs = valueAccessor();
    if (!ko.isObservable(obs)) {
      return;
    }
    $element = $(element);
    $element.on('mouseenter', mouseenter = function() {
      return obs(true);
    });
    $element.on('mouseleave', mouseleave = function() {
      return obs(false);
    });
    return Falcon.onDispose(element, function() {
      $element.off('mouseenter', mouseenter);
      return $element.off('mouseleave', mouseleave);
    });
  }
});

//END onDispose
//END isHovered

},{}],12:[function(require,module,exports){
Falcon.addBinding('moment', true, (function() {
  var $hours, $minutes, $seconds;
  $seconds = ko.observable(0);
  $minutes = ko.observable(0);
  $hours = ko.observable(0);
  setInterval(function() {
    return $seconds($seconds() + 1);
  }, 1000);
  setInterval(function() {
    return $minutes($minutes() + 1);
  }, 30 * 1000);
  setInterval(function() {
    return $hours($hours() + 1);
  }, 30 * 60 * 1000);
  return {
    'update': function(element, valueAccessor, allBindings) {
      var current_moment, now, textNode, value;
      ko.virtualElements.emptyNode(element);
      value = ko.unwrap(valueAccessor());
      if (value == null) {
        return;
      }
      current_moment = moment(value);
      now = moment().subtract(1, 'seconds');
      if (current_moment.isAfter(now)) {
        current_moment = now;
      }
      if (current_moment.isAfter(moment().subtract(1, 'minute'))) {
        current_moment = current_moment.fromNow();
        $seconds();
      } else if (current_moment.isAfter(moment().subtract(1, 'hour'))) {
        current_moment = current_moment.fromNow();
        $minutes();
      } else if (current_moment.isAfter(moment().subtract(1, 'days'))) {
        current_moment = current_moment.fromNow();
        $hours();
      } else if (current_moment.isAfter(moment().subtract(1, 'weeks'))) {
        current_moment = current_moment.format('dddd'); // Day of week
      } else {
        current_moment = current_moment.format('l'); // Physical Date
      }
      //END if
      textNode = document.createTextNode(current_moment);
      return ko.virtualElements.setDomNodeChildren(element, [textNode]);
    }
  };
})());

//END update
//END moment

},{}],13:[function(require,module,exports){
Falcon.addBinding('monthText', true, (function() {
  var FORMAT;
  FORMAT = "MMMM";
  return function(element, valueAccessor) {
    var m, node, value;
    value = ko.unwrap(valueAccessor());
    m = moment(value);
    if (m.isValid()) {
      node = document.createTextNode(m.format(FORMAT));
    } else {
      node = document.createTextNode("Invalid Date");
    }
    //END if
    return ko.virtualElements.setDomNodeChildren(element, [node]);
  };
})());

//END return
//END init

},{}],14:[function(require,module,exports){
Falcon.addBinding('monthYearText', true, (function() {
  var FORMAT;
  FORMAT = "MMMM, YYYY";
  return function(element, valueAccessor) {
    var m, node, value;
    value = ko.unwrap(valueAccessor());
    m = moment(value);
    if (m.isValid()) {
      node = document.createTextNode(m.format(FORMAT));
    } else {
      node = document.createTextNode("Invalid Date");
    }
    //END if
    return ko.virtualElements.setDomNodeChildren(element, [node]);
  };
})());

//END return
//END init

},{}],15:[function(require,module,exports){
Falcon.addBinding("onEnter", {
  'init': function(element, valueAccessor) {
    var keydown;
    element.addEventListener('keydown', keydown = function(event) {
      var callback, keyCode, ref;
      keyCode = (ref = event.keyCode) != null ? ref : event.which;
      if (keyCode !== KeyboardCommands.ENTER_KEY) {
        return true;
      }
      event.preventDefault();
      callback = valueAccessor();
      if (_.isFunction(callback)) {
        callback();
      }
      return false;
    });
    //END keydown
    return Falcon.onDispose(element, function() {
      return element.removeEventListener('keydown', keydown);
    });
  }
});

//END onDispose
//END onEnter

},{}],16:[function(require,module,exports){
Falcon.addBinding('onScrollBottom', (function() {
  var THRESHOLD;
  THRESHOLD = 100;
  return {
    'init': function(element, valueAccessor, allBindings) {
      var callback, clientHeight, isDisabled, is_refreshing, onScroll, ref, scrollHeight, scrollTop;
      is_refreshing = false;
      callback = valueAccessor();
      if (!_.isFunction(callback)) {
        callback = (function() {});
      }
      isDisabled = (ref = allBindings.get('onScrollBottomDisabled')) != null ? ref : false;
      scrollHeight = 0;
      clientHeight = 0;
      scrollTop = 0;
      element.addEventListener('scroll', onScroll = function() {
        var scrollTopTrigger, scrollableAmount;
        if (ko.unwrap(isDisabled)) {
          return;
        }
        scrollableAmount = element.scrollHeight - element.clientHeight;
        scrollTopTrigger = scrollableAmount - THRESHOLD;
        if (element.scrollTop >= scrollTopTrigger) {
          return callback();
        }
      });
      //END addEventListener
      return Falcon.onDispose(element, function() {
        return element.removeEventListener('scroll', onScroll);
      });
    }
  };
})());

//END init
//END onScrollBottom

},{}],17:[function(require,module,exports){
Falcon.addBinding('percent', true, function(element, valueAccessor) {
  var node, value;
  value = ko.unwrap(valueAccessor());
  node = document.createTextNode(numeral(value).format('0.00%'));
  return ko.virtualElements.setDomNodeChildren(element, [node]);
});

//END return
//END init

},{}],18:[function(require,module,exports){
//---------------------------------------------
// preventDefault
//---------------------------------------------
Falcon.addBinding('preventDefault', (function() {
  var stop;
  stop = function(event) {
    return event.preventDefault();
  };
  return {
    'init': function(element, valueAccessor) {
      var $element, value;
      $element = $(element);
      value = ko.unwrap(valueAccessor());
      if (!_.isString(value)) {
        value = "";
      }
      if (_.isEmpty(value)) {
        return;
      }
      if (value === 'touch') {
        element.addEventListener('touchstart', stop);
        element.addEventListener('touchend', stop);
      } else if (value === 'mouse') {
        element.addEventListener('mousedown', stop);
        element.addEventListener('mouseup', stop);
        element.addEventListener('click', stop);
      } else {
        element.addEventListener(value, stop);
      }
    }
  };
})());

//END init
//END preventDefault
//END if

},{}],19:[function(require,module,exports){
var RPC;

RPC = require("../rpc");

Falcon.addBinding('s3Upload', (function() {
  var bucket;
  bucket = null;
  return {
    'init': function(element, valueAccessor, allBindings, viewModel, bindingContent) {
      var fileNameObs, fileUrlObs, isUploadingObs, onChange, options, ref;
      options = (ref = ko.unwrap(valueAccessor())) != null ? ref : {};
      fileUrlObs = options.fileUrl;
      fileNameObs = options.fileName;
      isUploadingObs = options.isUploading;
      if (!ko.isObservable(fileUrlObs)) {
        return typeof console !== "undefined" && console !== null ? console.error("'fileUrl' assignment must be an observable") : void 0;
      }
      element.addEventListener('change', onChange = function() {
        var file;
        if (!(element.files.length > 0)) {
          fileUrlObs(null);
          if (ko.isWriteableObservable(fileNameObs)) {
            fileNameObs(null);
          }
          return;
        }
        //END unless
        file = element.files[0];
        element.disabled = true;
        if (ko.isWriteableObservable(isUploadingObs)) {
          isUploadingObs(true);
        }
        return RPC.promiseUploadFile(file).then((url) => {
          fileUrlObs(url);
          if (ko.isWriteableObservable(fileNameObs)) {
            return fileNameObs(file.name);
          }
        }).fail(() => {
          if (typeof console !== "undefined" && console !== null) {
            console.error("An error occurred while uploading file");
          }
          fileUrlObs(null);
          if (ko.isWriteableObservable(fileNameObs)) {
            return fileNameObs(null);
          }
        }).fin(() => {
          element.disabled = false;
          if (ko.isWriteableObservable(isUploadingObs)) {
            return isUploadingObs(false);
          }
        }).done();
      });
      //END RPC
      //END addEventListener
      return Falcon.onDispose(element, function() {
        return element.removeEventListener('change', onChange);
      });
    }
  };
})());

//END return
//END s3Upload

},{"../rpc":89}],20:[function(require,module,exports){
var Contest, FPT, Franchisee, Region, User;

User = require("../$models/user.model");

Franchisee = require("../$models/franchisee.model");

FPT = require("../$models/fpt.model");

Contest = require("../$models/contest.model");

Region = require("../$models/region.model");

Falcon.addBinding('selectize', (function() {
  var generateOption, generateOptions;
  generateOption = function(option) {
    var label, search, value;
    value = label = search = null;
    if (option instanceof User) {
      value = option.get("id");
      label = `${option.get("name")} (${option.get("email")})`;
      search = label;
    } else if (option instanceof Franchisee) {
      value = option.get("id");
      label = option.get("name");
      search = label;
    } else if (option instanceof FPT) {
      value = option.get("id");
      label = option.get("name");
      search = label;
    } else if (option instanceof Contest) {
      value = option.get("id");
      label = option.get("name");
      search = label;
    } else if (option instanceof Region) {
      value = option.get("id");
      label = option.get("name");
      search = label;
    } else {
      if (typeof console !== "undefined" && console !== null) {
        console.error("[selectize.binding] Could not generate option for: ", option);
      }
    }
    //END if
    return {value, label, search};
  };
  //END generateOption
  generateOptions = function(options) {
    var option;
    if (Falcon.isCollection(options)) {
      options = options.all();
    }
    return (function() {
      var i, len, results1;
      results1 = [];
      for (i = 0, len = options.length; i < len; i++) {
        option = options[i];
        results1.push(generateOption(option));
      }
      return results1;
    })();
  };
  return {
    //END generateOptions
    'init': function(element, valueAccessor, allBindings, viewModel, bindingContext) {
      var $element, _change, is_setting, observable, selectize, selectizeLoad, selectizeMaxItems, selectizeMaxOptions, selectizeOnCreate, selectizeOnRemove, selectizeOptions, values;
      values = null;
      selectizeOptions = {
        valueField: 'value',
        labelField: 'label',
        searchField: 'search',
        closeAfterSelect: false,
        hideSelected: true,
        persist: true
      };
      selectizeOnCreate = allBindings.get('selectizeOnCreate');
      selectizeOnRemove = allBindings.get('selectizeOnRemove');
      selectizeLoad = allBindings.get('selectizeLoad');
      selectizeMaxItems = ko.unwrap(allBindings.get('selectizeMaxItems'));
      selectizeMaxOptions = ko.unwrap(allBindings.get('selectizeMaxOptions'));
      if (_.isFunction(selectizeOnCreate)) {
        selectizeOptions['create'] = function(value) {
          var d;
          d = selectizeOnCreate.call(viewModel, value);
          return generateOption(d);
        };
      }
      //END create
      //END if
      if (_.isNumber(selectizeMaxItems)) {
        selectizeOptions['maxItems'] = selectizeMaxItems;
      }
      //END if
      if (_.isNumber(selectizeMaxOptions)) {
        selectizeOptions['maxOptions'] = selectizeMaxOptions;
      }
      //END if
      if (_.isFunction(selectizeLoad)) {
        selectizeOptions['load'] = function(query, callback) {
          return selectizeLoad(query, (results) => {
            results = generateOptions(results);
            return callback(results);
          });
        };
      }
      //END if
      $element = $(element).selectize(selectizeOptions);
      selectize = $element.get(0).selectize;
      if (_.isFunction(selectizeOnRemove)) {
        selectize.on('item_remove', function(value) {
          return selectizeOnRemove.call(viewModel, value);
        });
      }
      //END on
      //END if
      ko.computed({
        disposeWhenNodeIsRemoved: element,
        read: function() {
          values = ko.unwrap(valueAccessor());
          selectize.clearOptions();
          selectize.addOption(generateOptions(values));
          return selectize.refreshOptions(false);
        }
      });
      //END read
      //END computed
      if (allBindings.get('selectizeValue')) {
        observable = allBindings.get('selectizeValue');
        is_setting = false;
        ko.computed({
          disposeWhenNodeIsRemoved: element,
          read: function() {
            values = ko.unwrap(observable);
            if (is_setting) {
              return;
            }
            if (!_.isArray(values)) {
              values = [values];
            }
            values = _.uniq(values);
            return selectize.setValue(values);
          }
        });
        //END read
        //END computed
        if (ko.isObservable(observable)) {
          selectize.on("change", _change = function() {
            var value;
            is_setting = true;
            value = selectize.getValue();
            if (selectize.settings.mode === "multi") {
              if (_.isString(value)) {
                value = value.split(",");
              }
              if (!_.isArray(value)) {
                value = [];
              }
              value = _.chain(value).uniq().compact().value();
            }
            //END if
            observable(value);
            return is_setting = false;
          });
          //END on change
          return Falcon.onDispose(element, function() {
            return selectize.off("change", _change);
          });
        }
      }
    }
  };
})());

//END onDispose
//END if
//END if
//END return
//END selectize binding

},{"../$models/contest.model":56,"../$models/fpt.model":60,"../$models/franchisee.model":63,"../$models/region.model":74,"../$models/user.model":81}],21:[function(require,module,exports){
Falcon.addBinding("src", (function() {
  var ERROR_SRC, _loadImage, _resolveFileSrc, _resolveSrc;
  ERROR_SRC = ""; //TODO: Find an image to add as the error source
  _resolveSrc = function(src) {
    src = ko.unwrap(src);
    if (src instanceof Comment) {
      src = src.get('user');
    }
    if (src instanceof User) {
      src = src.get('default_avatar_url');
    }
    return Helpers.trim(src);
  };
  //END _resolveSrc
  _resolveFileSrc = function(src) {
    var mimetype, thumbnail;
    thumbnail = src.get('thumbnail');
    if (!_.isEmpty(thumbnail)) {
      return thumbnail;
    }
    mimetype = Helpers.trim(src.get('mimetype')).toLowerCase();
    thumbnail = (function() {
      switch (mimetype) {
        case 'video/x-ms-asf':
          return "asf.png";
        case 'video/3gpp':
        case 'video/3gpp2':
          return "3gp.png";
        case 'application/x-7z-compressed':
          return "7z.png";
        case 'application/illustrator':
          return "ai.png";
        case 'application/vnd.android.package-archive':
          return "apk.png";
        case 'video/x-ms-asf':
          return "asf.png";
        case 'video/avi':
        case 'video/x-msvideo':
          return "avi.png";
        case 'image/bmp':
          return "bmp.png";
        case 'text/css':
          return "css.png";
        case 'text/csv':
          return "csv.png";
        case 'video/divx':
          return "divx.png";
        case 'application/x-msdownload':
          return "dll.png";
        case 'application/msword':
        case 'application/vnd.ms-word':
          return "doc.png";
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          return "docx.png";
        case 'image/vnd.dwg':
        case 'image/x-dwg':
          return "dwg.png";
        case 'application/postscript':
        case 'application/eps':
        case 'application/x-eps':
        case 'image/eps':
        case 'image/x-eps':
          return "eps.png";
        case 'application/x-msdos-program':
        case 'application/x-msdownload':
          return "exe.png";
        case 'video/x-flv':
          return "flv.png";
        case 'image/gif':
          return "gif.png";
        case 'application/gzip':
          return "gz.png";
        case 'text/html':
          return "html.png";
        case 'image/x-ico':
          return "ico.png";
        case 'application/x-iso9660-image':
          return "iso.png";
        case 'application/java-archive':
          return "jar.png";
        case 'image/jpeg':
          return "jpg.png";
        case 'application/javascript':
        case 'text/javascript':
          return "js.png";
        case 'video/quicktime':
          return "mov.png";
        case 'audio/mpeg':
        case 'audio/mpa':
        case 'audio/mpa-robust':
          return "mp3.png";
        case 'video/mp4':
        case 'audio/mp4':
          return "mp4.png";
        case 'video/mpeg':
          return "mpeg.png";
        case 'application/pdf':
        case 'application/x-pdf':
        case 'application/x-bzpdf':
        case 'application/x-gzpdf':
          return "pdf.png";
        case 'application/x-php':
          return "php.png";
        case 'image/png':
        case 'image/x-png':
          return "png.png";
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.ms-powerpoint.presentation.macroEnabled.12':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
          return "ppt.png";
        case 'application/photoshop':
        case 'image/vnd.adobe.photoshop':
        case 'application/psd':
        case 'application/x-photoshop':
        case 'image/photoshop':
        case 'image/psd':
        case 'image/x-photoshop':
        case 'image/x-psd':
          return "psd.png";
        case 'application/rar':
        case 'application/x-rar-compressed':
          return "rar.png";
        case 'image/svg+xml':
          return "svg.png";
        case 'application/vnd.adobe.flash-movie':
        case 'application/x-shockwave-flash':
        case 'application/futuresplash':
          return "swf.png";
        case 'application/x-tar':
        case 'application/tar':
        case 'application/x-gtar':
          return "tar.png";
        case 'image/tiff':
        case 'application/tif':
        case 'application/tiff':
        case 'application/x-tif':
        case 'application/x-tiff':
        case 'image/tif':
        case 'image/x-tif':
        case 'image/x-tiff':
          return "tiff.png";
        case 'text/plain':
          return "txt.png";
        case 'audio/vnd.wave':
        case 'audio/wav':
        case 'audio/wave':
        case 'audio/x-wav':
        case 'audio/s-wav':
          return "wav.png";
        case 'application/zip':
        case 'application/x-compress':
        case 'application/x-compressed':
        case 'application/x-zip':
        case 'application/x-zip-compressed':
        case 'application/zip-compressed':
        case 'application/x-7zip-compressed':
          return "zip.png";
        default:
          return "blank.png";
      }
    })();
    // when '' then "ae.png"
    // when '' then "bak.png"
    // when '' then "cdr.png"
    // when '' then "dw.png"
    // when '' then "fw.png"
    // when '' then "ps.png"
    // when '' then "sys.png"
    //END switch
    return `/images/fileicons/${thumbnail}`;
  };
  //END _resolveFileSrc
  _loadImage = function(element, src, callback) {
    var _complete, _error, _load, image;
    if (element.getAttribute('src') === src) {
      return;
    }
    if ((!_.isString(src)) || _.isEmpty(src)) {
      DOMHelpers.addClass(element, 'loaded');
      element.setAttribute('src', "");
      return typeof callback === "function" ? callback() : void 0;
    }
    //END if
    image = new Image();
    DOMHelpers.removeClass(element, 'loaded');
    _complete = function() {
      DOMHelpers.addClass(element, 'loaded');
      image.removeEventListener('load', _load);
      image.removeEventListener('error', _error);
      return typeof callback === "function" ? callback() : void 0;
    };
    //END _complete
    image.addEventListener('load', _load = function() {
      if (image.height > image.width) {
        DOMHelpers.addClass(element, 'portrait');
        DOMHelpers.removeClass(element, 'landscape');
      } else {
        DOMHelpers.removeClass(element, 'portrait');
        DOMHelpers.addClass(element, 'landscape');
      }
      //END if
      element.setAttribute('src', src);
      return _complete();
    });
    //END load
    image.addEventListener('error', _error = function() {
      element.setAttribute('src', ERROR_SRC);
      return _complete();
    });
    //END addEventListener
    return image.src = src;
  };
  return {
    //END _loadImage
    'init': function(element, valueAccessor, allBindings) {
      var current_src;
      current_src = null;
      return ko.computed({
        disposeWhenNodeIsRemoved: element,
        read: function() {
          var is_loading, src, value;
          value = valueAccessor();
          src = _resolveSrc(value);
          if (src === current_src) {
            return;
          }
          current_src = src;
          is_loading = allBindings.get('srcIsLoading');
          if (ko.isObservable(is_loading)) {
            is_loading(true);
            return _loadImage(element, src, function() {
              return is_loading(false);
            });
          } else {
            return _loadImage(element, src);
          }
        }
      });
    }
  };
})());

//END if
//END read
//END computed
//END init
//END addBinding

},{}],22:[function(require,module,exports){
//---------------------------------------------
// stopEvent
//---------------------------------------------
Falcon.addBinding('stopEvent', (function() {
  var stop;
  stop = function(event) {
    event.stopPropagation();
    event.preventDefault();
    return false;
  };
  return {
    //END stop
    'init': function(element, valueAccessor) {
      var $element, value;
      $element = $(element);
      value = ko.unwrap(valueAccessor());
      if (!_.isString(value)) {
        value = "";
      }
      if (_.isEmpty(value)) {
        return;
      }
      if (value === 'touch') {
        element.addEventListener('touchstart', stop);
        element.addEventListener('touchend', stop);
      } else if (value === 'mouse') {
        element.addEventListener('mousedown', stop);
        element.addEventListener('mouseup', stop);
        element.addEventListener('click', stop);
      } else {
        element.addEventListener(value, stop);
      }
    }
  };
})());

//END init
//END stopEvent
//END if

},{}],23:[function(require,module,exports){
//---------------------------------------------
// stopPropagation
//---------------------------------------------
Falcon.addBinding('stopPropagation', (function() {
  var stop;
  stop = function(event) {
    return event.stopPropagation();
  };
  return {
    'init': function(element, valueAccessor) {
      var value;
      value = ko.unwrap(valueAccessor());
      if (!_.isString(value)) {
        value = "";
      }
      if (_.isEmpty(value)) {
        return;
      }
      if (value === 'touch') {
        element.addEventListener('touchstart', stop);
        element.addEventListener('touchend', stop);
      } else if (value === 'mouse') {
        element.addEventListener('mousedown', stop);
        element.addEventListener('mouseup', stop);
        element.addEventListener('click', stop);
      } else {
        element.addEventListener(value, stop);
      }
    }
  };
})());

//END stopPropagation
//END init
//END if
Falcon.addBinding('stopBubble', Falcon.getBinding('stopPropagation'));

},{}],24:[function(require,module,exports){
var ContestFinalist, ContestFinalists, PromiseBaseCollection;

PromiseBaseCollection = require("./promise.base.collection");

ContestFinalist = require("../$models/contest_finalist.model");

module.exports = ContestFinalists = (function() {
  class ContestFinalists extends PromiseBaseCollection {};

  ContestFinalists.prototype.model = ContestFinalist;

  ContestFinalists.prototype.label = "ContestFinalists";

  return ContestFinalists;

}).call(this);

//END ContestFinalists

},{"../$models/contest_finalist.model":57,"./promise.base.collection":35}],25:[function(require,module,exports){
var ContestWinner, ContestWinners, PromiseBaseCollection;

PromiseBaseCollection = require("./promise.base.collection");

ContestWinner = require("../$models/contest_winner.model");

module.exports = ContestWinners = (function() {
  class ContestWinners extends PromiseBaseCollection {};

  ContestWinners.prototype.model = ContestWinner;

  ContestWinners.prototype.label = "ContestWinners";

  return ContestWinners;

}).call(this);

//END ContestWinners

},{"../$models/contest_winner.model":58,"./promise.base.collection":35}],26:[function(require,module,exports){
var Contest, Contests, PromiseBaseCollection;

PromiseBaseCollection = require("./promise.base.collection");

Contest = require("../$models/contest.model");

module.exports = Contests = (function() {
  class Contests extends PromiseBaseCollection {};

  Contests.prototype.model = Contest;

  Contests.prototype.label = "Contests";

  Contests.prototype.observables = {
    'sorted': function() {
      return this.sort((a, b) => {
        var a_end_date, a_type, b_end_date, b_type;
        a_type = a.get("type");
        b_type = b.get("type");
        if ((a_type === Contest.FRANCHISEE_TYPE) && (b_type !== Contest.FRANCHISEE_TYPE)) {
          return -1;
        }
        if ((a_type !== Contest.FRANCHISEE_TYPE) && (b_type === Contest.FRANCHISEE_TYPE)) {
          return 1;
        }
        if ((a_type === Contest.FPT_TYPE) && (b_type !== Contest.FPT_TYPE)) {
          return -1;
        }
        if ((a_type !== Contest.FPT_TYPE) && (b_type === Contest.FPT_TYPE)) {
          return 1;
        }
        if ((a_type === Contest.GLOBAL_TYPE) && (b_type !== Contest.GLOBAL_TYPE)) {
          return -1;
        }
        if ((a_type !== Contest.GLOBAL_TYPE) && (b_type === Contest.GLOBAL_TYPE)) {
          return 1;
        }
        a_end_date = moment(a.get("end_date"));
        b_end_date = moment(b.get("end_date"));
        if (a_end_date.isBefore(b_end_date)) {
          return -1;
        }
        if (a_end_date.isAfter(b_end_date)) {
          return 1;
        }
        return 0;
      });
    }
  };

  return Contests;

}).call(this);

//END observables
//END Contests

},{"../$models/contest.model":56,"./promise.base.collection":35}],27:[function(require,module,exports){
var Entries, Entry, PromiseBaseCollection;

PromiseBaseCollection = require("./promise.base.collection");

Entry = require("../$models/entry.model");

module.exports = Entries = (function() {
  class Entries extends PromiseBaseCollection {};

  Entries.prototype.model = Entry;

  Entries.prototype.label = "Entries";

  return Entries;

}).call(this);

//END Entries

},{"../$models/entry.model":59,"./promise.base.collection":35}],28:[function(require,module,exports){
var FPTContestStatistic, FPTContestStatistics, PromiseBaseCollection;

PromiseBaseCollection = require("./promise.base.collection");

FPTContestStatistic = require("../$models/fpt_contest_statistic.model");

module.exports = FPTContestStatistics = (function() {
  class FPTContestStatistics extends PromiseBaseCollection {};

  FPTContestStatistics.prototype.model = FPTContestStatistic;

  FPTContestStatistics.prototype.label = "FPTContestStatistics";

  return FPTContestStatistics;

}).call(this);

//END FPTContestStatistics

},{"../$models/fpt_contest_statistic.model":61,"./promise.base.collection":35}],29:[function(require,module,exports){
var FPTStatistic, FPTStatistics, PromiseBaseCollection;

PromiseBaseCollection = require("./promise.base.collection");

FPTStatistic = require("../$models/fpt_statistic.model");

module.exports = FPTStatistics = (function() {
  class FPTStatistics extends PromiseBaseCollection {};

  FPTStatistics.prototype.model = FPTStatistic;

  FPTStatistics.prototype.label = "FPTStatistics";

  return FPTStatistics;

}).call(this);

//END FPTStatistics

},{"../$models/fpt_statistic.model":62,"./promise.base.collection":35}],30:[function(require,module,exports){
var FPT, FPTs, PromiseBaseCollection;

PromiseBaseCollection = require("./promise.base.collection");

FPT = require("../$models/fpt.model");

module.exports = FPTs = (function() {
  class FPTs extends PromiseBaseCollection {};

  FPTs.prototype.model = FPT;

  FPTs.prototype.label = "FPTs";

  return FPTs;

}).call(this);

//END FPTs

},{"../$models/fpt.model":60,"./promise.base.collection":35}],31:[function(require,module,exports){
var FranchiseeContestStatistic, FranchiseeContestStatistics, PromiseBaseCollection;

PromiseBaseCollection = require("./promise.base.collection");

FranchiseeContestStatistic = require("../$models/franchisee_contest_statistic.model");

module.exports = FranchiseeContestStatistics = (function() {
  class FranchiseeContestStatistics extends PromiseBaseCollection {};

  FranchiseeContestStatistics.prototype.model = FranchiseeContestStatistic;

  FranchiseeContestStatistics.prototype.label = "FranchiseeContestStatistics";

  return FranchiseeContestStatistics;

}).call(this);

//END FranchiseeContestStatistics

},{"../$models/franchisee_contest_statistic.model":64,"./promise.base.collection":35}],32:[function(require,module,exports){
var FranchiseeSetting, FranchiseeSettings, PromiseBaseCollection;

PromiseBaseCollection = require("./promise.base.collection");

FranchiseeSetting = require("../$models/franchisee_setting.model");

module.exports = FranchiseeSettings = (function() {
  class FranchiseeSettings extends PromiseBaseCollection {};

  FranchiseeSettings.prototype.model = FranchiseeSetting;

  FranchiseeSettings.prototype.label = "FranchiseeSettings";

  return FranchiseeSettings;

}).call(this);

//END FranchiseeSettings

},{"../$models/franchisee_setting.model":65,"./promise.base.collection":35}],33:[function(require,module,exports){
var FranchiseeStatistic, FranchiseeStatistics, PromiseBaseCollection;

PromiseBaseCollection = require("./promise.base.collection");

FranchiseeStatistic = require("../$models/franchisee_statistic.model");

module.exports = FranchiseeStatistics = (function() {
  class FranchiseeStatistics extends PromiseBaseCollection {};

  FranchiseeStatistics.prototype.model = FranchiseeStatistic;

  FranchiseeStatistics.prototype.label = "FranchiseeStatistics";

  return FranchiseeStatistics;

}).call(this);

//END FranchiseeStatistics

},{"../$models/franchisee_statistic.model":66,"./promise.base.collection":35}],34:[function(require,module,exports){
var Franchisee, Franchisees, PromiseBaseCollection;

PromiseBaseCollection = require("./promise.base.collection");

Franchisee = require("../$models/franchisee.model");

module.exports = Franchisees = (function() {
  class Franchisees extends PromiseBaseCollection {};

  Franchisees.prototype.model = Franchisee;

  Franchisees.prototype.label = "Franchisees";

  return Franchisees;

}).call(this);

//END Franchisees

},{"../$models/franchisee.model":63,"./promise.base.collection":35}],35:[function(require,module,exports){
var PromiseBaseCollection,
  splice = [].splice;

module.exports = PromiseBaseCollection = (function() {
  var DATETIME_FORMAT, makeFilterKey;

  class PromiseBaseCollection extends Falcon.Collection {
    constructor() {
      super(...arguments);
      this.hasNextPage = ko.observable(true);
      this.sort_key = ko.observable(this.sort_key);
      this.sort_parameter = ko.observable(this.sort_parameter);
      this.sort_direction = ko.observable(this.sort_direction);
    }

    //END constructor
    promiseFetch(options) {
      return Q.Promise((resolve, reject) => {
        options = RequestHelpers.preparePromiseOptions(resolve, reject, options, `An error occurred while fetching ${this.label}`);
        return this.fetch(options);
      });
    }

    //END promiseFetch
    promiseFetchNextPage(options = {}) {
      return Q.Promise((resolve, reject) => {
        var next_page_number, previous_page_number;
        previous_page_number = this.getPageNumber();
        next_page_number = (previous_page_number != null ? previous_page_number : 1) + 1;
        this.setPageNumber(next_page_number);
        if (options['fill_options'] == null) {
          options['fill_options'] = {
            'method': 'append'
          };
        }
        return this.promiseFetch(options).then(resolve).fail((error) => {
          this.setPageNumber(previous_page_number);
          return reject(error);
        });
      });
    }

    //END promiseFetchNextPage
    promiseCreateAll(options) {
      return Q.Promise((resolve, reject) => {
        var promises;
        promises = [];
        this.each((model) => {
          return promises.push(model.promiseCreate(options));
        });
        //END each
        return Q.all(promises).then(resolve, reject);
      });
    }

    //END promiseCreateAll
    parseResponseData(data, type, options) {
      if (type === Falcon.DELETE) {
        return [];
      }
      return this.model.prototype.expand(data).toArray();
    }

    //END parseResponseData
    sync(type, options, context) {
      var filter, previous_length, ref, success, value;
      if (_.isFunction(options)) {
        options = {
          complete: options
        };
      }
      if (!_.isObject(options)) {
        options = {};
      }
      if (options['params'] == null) {
        options['params'] = {};
      }
      if (this.filters != null) {
        ref = this.filters;
        for (filter in ref) {
          value = ref[filter];
          if (!(!(filter in options['params']))) {
            continue;
          }
          value = ko.unwrap(value);
          options['params'][filter] = encodeURIComponent((function() {
            switch (false) {
              case !_.isArray(value):
                return value.join(",");
              case !Falcon.isCollection(value):
                return value.pluck("id").join(",");
              case !Falcon.isModel(value):
                return value.get("id");
              case !_.isDate(value):
                return moment(value).format();
              default:
                return value;
            }
          })());
        }
      }
      //END switch
      //END for
      //END if
      if (this.is_paged) {
        if (this.hasPageSize()) {
          options['params']['page[size]'] = this.getPageSize();
        }
        if (this.hasPageNumber()) {
          options['params']['page[number]'] = this.getPageNumber();
        }
      } else {
        options['params']['page'] = false;
      }
      if (this.hasSort()) {
        //END if
        options['params']['sort'] = encodeURIComponent(this.getSortQueryParam());
      }
      previous_length = this.length();
      success = options['success'];
      options['success'] = (collection, response) => {
        var count, has_next_page, number, page, ref1, size;
        has_next_page = false;
        this.meta = (ref1 = response != null ? response['meta'] : void 0) != null ? ref1 : null;
        if (this.meta != null) {
          ({count, page} = this.meta);
          this.count = count;
          if (page != null) {
            ({size, number} = page);
            this.setPageSize(size);
            this.setPageNumber(number);
            if ((size != null) && (number != null) && (count != null)) {
              has_next_page = (size * number) < this.count;
            }
          }
        } else {
          //END if
          //END if
          has_next_page = previous_length !== this.length();
        }
        //END if
        this.hasNextPage(has_next_page);
        return success != null ? success.call(this, collection, response) : void 0;
      };
      //END success
      return super.sync(type, options, context);
    }

    //END makeFilterKey
    clearFilters() {
      this.filters = null;
      return this;
    }

    //END clearFilters
    clearFilter(...keys) {
      var key;
      if (this.filters == null) {
        return this;
      }
      key = makeFilterKey(keys);
      if (!(key in this.filters)) {
        return this;
      }
      delete this.filters[key];
      return this;
    }

    //END clearFilter
    getFilter(...keys) {
      var key;
      if (this.filters == null) {
        return void 0;
      }
      key = makeFilterKey(keys);
      return this.filters[key];
    }

    //END getFilter
    setFilter(...keys) {
      var key, limit, ref, value;
      ref = keys, [...keys] = ref, [value] = splice.call(keys, -1);
      key = makeFilterKey(keys);
      if (this.filters == null) {
        this.filters = {};
      }
      this.filters[key] = value;
      limit = Helpers.trim(limit).toLowerCase();
      return this;
    }

    //END setFilter
    toggleFilter(...keys) {
      var is_empty, ref, value;
      ref = keys, [...keys] = ref, [value] = splice.call(keys, -1);
      is_empty = (function() {
        switch (false) {
          case !_.isArray(value):
            return value.length === 0;
          case !_.isString(value):
            return value.length === 0;
          case !Falcon.isCollection(value):
            return value.length() === 0;
          default:
            return value == null;
        }
      })();
      //END switch
      if (is_empty) {
        this.clearFilter(...keys);
      } else {
        this.setFilter(...keys, value);
      }
      //END if
      return this;
    }

    //END toggleFilter
    getIsPaged() {
      return this.is_paged;
    }

    setIsPaged(is_paged) {
      this.is_paged = is_paged;
      return this;
    }

    //END setIsPaged
    getPageSize() {
      return this.page_size;
    }

    hasPageSize() {
      return this.page_size != null;
    }

    setPageSize(size) {
      this.page_size = size;
      return this;
    }

    //END setPageSize
    getPageNumber() {
      return this.page_number;
    }

    hasPageNumber() {
      return this.page_number != null;
    }

    setPageNumber(number) {
      this.page_number = number;
      return this;
    }

    //END setPageNumber
    hasSort() {
      return this.sort_key() != null;
    }

    sortBy(key, direction = "asc", parameter = null) {
      if (key == null) {
        this.clearSort();
      }
      if (!_.isString(key)) {
        throw new Error("key must be a String");
      }
      //END unless
      this.setSortKey(key);
      this.setSortDirection(direction);
      this.setSortParameter(parameter);
      return this;
    }

    //END sortBy
    clearSort() {
      this.sort_key(null);
      this.sort_direction(null);
      this.sort_parameter(null);
      return this;
    }

    //END clear Sort
    getSortQueryParam() {
      var sort_query_param;
      if (!this.hasSort()) {
        return null;
      }
      sort_query_param = "";
      if (this.getSortDirection() === "descending") {
        sort_query_param = "-";
      } else {
        sort_query_param = "+";
      }
      //END if
      sort_query_param += this.getSortKey();
      if (this.hasSortParameter()) {
        sort_query_param += `[${this.getSortParameter()}]`;
      }
      //END if
      return sort_query_param;
    }

    //END getSortQueryParam
    getSortKey() {
      return this.sort_key();
    }

    hasSortKey() {
      return this.sort_key() != null;
    }

    setSortKey(key) {
      this.sort_key(key);
      return this;
    }

    //END setSortKey
    getSortDirection() {
      var ref;
      if ((ref = this.sort_direction()) === "-" || ref === "desc" || ref === "descending") {
        return "descending";
      } else {
        return "ascending";
      }
    }

    //END if
    //END getSortDirection
    setSortDirection(sort_direction) {
      if (!_.isString(sort_direction)) {
        sort_direction = "ascending";
      }
      sort_direction = Helpers.trim(sort_direction).toLowerCase();
      if (sort_direction === "-" || sort_direction === "desc" || sort_direction === "descending") {
        this.sort_direction("descending");
      } else {
        this.sort_direction("ascending");
      }
      //END if
      return this;
    }

    //END setSortDirection
    toggleSortDirection() {
      if (this.getSortDirection() === "descending") {
        this.setSortDirection("ascending");
      } else {
        this.setSortDirection("descending");
      }
      //END if
      return this;
    }

    //END toggleSortDirection
    getSortParameter() {
      return this.sort_parameter();
    }

    hasSortParameter() {
      return this.sort_parameter() != null;
    }

    setSortParameter(parameter) {
      this.sort_parameter(parameter);
      return this;
    }

    //END setSortParameter
    clearSortParameter() {
      return this.setSortParameter(null);
    }

    clone() {
      var clone;
      clone = super.clone(...arguments);
      clone.filters = _.clone(this.filters);
      clone.sort_key = this.sort_key;
      clone.sort_direction = this.sort_direction;
      clone.page_size = this.page_size;
      clone.page_number = this.page_number;
      return clone;
    }

    //END clone
    reset() {
      var ret;
      ret = super.reset(...arguments);
      this.page_size = null;
      this.page_number = null;
      this.hasNextPage(true);
      return ret;
    }

    //END reset
    hardReset() {
      var ret;
      ret = this.reset();
      this.filters = null;
      this.sort_key = null;
      this.sort_direction = "+";
      return ret;
    }

  };

  DATETIME_FORMAT = "";

  PromiseBaseCollection.prototype.label = "";

  PromiseBaseCollection.prototype.filters = null;

  PromiseBaseCollection.prototype.meta = null;

  PromiseBaseCollection.prototype.count = null;

  PromiseBaseCollection.prototype.is_paged = true;

  PromiseBaseCollection.prototype.page_size = null;

  PromiseBaseCollection.prototype.page_number = null;

  PromiseBaseCollection.prototype.hasNextPage = null; //Becomes an obsevable

  PromiseBaseCollection.prototype.sort_key = null;

  PromiseBaseCollection.prototype.sort_parameter = null;

  PromiseBaseCollection.prototype.sort_direction = null;

  //END sync
  makeFilterKey = function(keys) {
    var i, k, key, len;
    key = 'filter';
    for (i = 0, len = keys.length; i < len; i++) {
      k = keys[i];
      key += `[${k}]`;
    }
    return key;
  };

  return PromiseBaseCollection;

}).call(this);

//END hardReset
//END class

},{}],36:[function(require,module,exports){
var PromiseBaseCollection, Question, Questions;

PromiseBaseCollection = require("./promise.base.collection");

Question = require("../$models/question.model");

module.exports = Questions = (function() {
  class Questions extends PromiseBaseCollection {};

  Questions.prototype.model = Question;

  Questions.prototype.label = "Questions";

  return Questions;

}).call(this);

//END Questions

},{"../$models/question.model":70,"./promise.base.collection":35}],37:[function(require,module,exports){
var PromiseBaseCollection, RaceOption, RaceOptions;

PromiseBaseCollection = require("./promise.base.collection");

RaceOption = require("../$models/race_option.model");

module.exports = RaceOptions = (function() {
  class RaceOptions extends PromiseBaseCollection {};

  RaceOptions.prototype.model = RaceOption;

  RaceOptions.prototype.label = "RaceOptions";

  return RaceOptions;

}).call(this);

//END RaceOptions

},{"../$models/race_option.model":72,"./promise.base.collection":35}],38:[function(require,module,exports){
var PromiseBaseCollection, RaceSelection, RaceSelections;

PromiseBaseCollection = require("./promise.base.collection");

RaceSelection = require("../$models/race_selection.model");

module.exports = RaceSelections = (function() {
  class RaceSelections extends PromiseBaseCollection {};

  RaceSelections.prototype.model = RaceSelection;

  RaceSelections.prototype.label = "RaceSelections";

  return RaceSelections;

}).call(this);

//END Surveys

},{"../$models/race_selection.model":73,"./promise.base.collection":35}],39:[function(require,module,exports){
var PromiseBaseCollection, Race, Races;

PromiseBaseCollection = require("./promise.base.collection");

Race = require("../$models/race.model");

module.exports = Races = (function() {
  class Races extends PromiseBaseCollection {};

  Races.prototype.model = Race;

  Races.prototype.label = "Races";

  return Races;

}).call(this);

//END Races

},{"../$models/race.model":71,"./promise.base.collection":35}],40:[function(require,module,exports){
var PromiseBaseCollection, RegionContestStatistic, RegionContestStatistics;

PromiseBaseCollection = require("./promise.base.collection");

RegionContestStatistic = require("../$models/region_contest_statistic.model");

module.exports = RegionContestStatistics = (function() {
  class RegionContestStatistics extends PromiseBaseCollection {};

  RegionContestStatistics.prototype.model = RegionContestStatistic;

  RegionContestStatistics.prototype.label = "RegionContestStatistics";

  return RegionContestStatistics;

}).call(this);

//END RegionContestStatistics

},{"../$models/region_contest_statistic.model":75,"./promise.base.collection":35}],41:[function(require,module,exports){
var PromiseBaseCollection, RegionStatistic, RegionStatistics;

PromiseBaseCollection = require("./promise.base.collection");

RegionStatistic = require("../$models/region_statistic.model");

module.exports = RegionStatistics = (function() {
  class RegionStatistics extends PromiseBaseCollection {};

  RegionStatistics.prototype.model = RegionStatistic;

  RegionStatistics.prototype.label = "RegionStatistics";

  return RegionStatistics;

}).call(this);

//END RegionStatistics

},{"../$models/region_statistic.model":76,"./promise.base.collection":35}],42:[function(require,module,exports){
var PromiseBaseCollection, Region, Regions;

PromiseBaseCollection = require("./promise.base.collection");

Region = require("../$models/region.model");

module.exports = Regions = (function() {
  class Regions extends PromiseBaseCollection {};

  Regions.prototype.model = Region;

  Regions.prototype.label = "Regions";

  return Regions;

}).call(this);

//END Regions

},{"../$models/region.model":74,"./promise.base.collection":35}],43:[function(require,module,exports){
var PromiseBaseCollection, SurveyAnswer, SurveyAnswers;

PromiseBaseCollection = require("./promise.base.collection");

SurveyAnswer = require("../$models/survey_answer.model");

module.exports = SurveyAnswers = (function() {
  class SurveyAnswers extends PromiseBaseCollection {};

  SurveyAnswers.prototype.model = SurveyAnswer;

  SurveyAnswers.prototype.label = "SurveyAnswers";

  return SurveyAnswers;

}).call(this);

//END SurveyAnswers

},{"../$models/survey_answer.model":79,"./promise.base.collection":35}],44:[function(require,module,exports){
var PromiseBaseCollection, SurveyResponse, SurveyResponses;

PromiseBaseCollection = require("./promise.base.collection");

SurveyResponse = require("../$models/survey_response.model");

module.exports = SurveyResponses = (function() {
  class SurveyResponses extends PromiseBaseCollection {};

  SurveyResponses.prototype.model = SurveyResponse;

  SurveyResponses.prototype.label = "SurveyResponses";

  return SurveyResponses;

}).call(this);

//END Surveys

},{"../$models/survey_response.model":80,"./promise.base.collection":35}],45:[function(require,module,exports){
var PromiseBaseCollection, Survey, Surveys;

PromiseBaseCollection = require("./promise.base.collection");

Survey = require("../$models/survey.model");

module.exports = Surveys = (function() {
  class Surveys extends PromiseBaseCollection {};

  Surveys.prototype.model = Survey;

  Surveys.prototype.label = "Surveys";

  return Surveys;

}).call(this);

//END Surveys

},{"../$models/survey.model":78,"./promise.base.collection":35}],46:[function(require,module,exports){
var PromiseBaseCollection, UserContestStatistic, UserContestStatistics;

PromiseBaseCollection = require("./promise.base.collection");

UserContestStatistic = require("../$models/user_contest_statistic.model");

module.exports = UserContestStatistics = (function() {
  class UserContestStatistics extends PromiseBaseCollection {};

  UserContestStatistics.prototype.model = UserContestStatistic;

  UserContestStatistics.prototype.label = "UserContestStatistics";

  return UserContestStatistics;

}).call(this);

//END UserContestStatistics

},{"../$models/user_contest_statistic.model":82,"./promise.base.collection":35}],47:[function(require,module,exports){
var PromiseBaseCollection, User, Users;

PromiseBaseCollection = require("./promise.base.collection");

User = require("../$models/user.model");

module.exports = Users = (function() {
  class Users extends PromiseBaseCollection {};

  Users.prototype.model = User;

  Users.prototype.label = "Users";

  return Users;

}).call(this);

//END Users

},{"../$models/user.model":81,"./promise.base.collection":35}],48:[function(require,module,exports){
module.exports = {
  URL_REGEX: /(https?:\/\/)?(([^\s]+\.)?[^\s]+\.[^\s]+)/gi,
  STRICT_URL_REGEX: /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]+)([\/\w \.-]*)*\/?$/i,
  EMAIL_REGEX: /^([a-z0-9_\.\+\-]+)@([\da-z\.\+\-]+)\.([a-z\.]+)$/i,
  UUID_REGEX: /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i,
  PASSWORD_REGEX: /^([^\s]{5}[^\s]+)$/i,
  HASHTAG_REGEX: /#([a-zA-Z0-9\-_]+)/gi,
  HTML_TAG_REGEX: /<[^>]+>/gi,
  DATE_FORMAT: "M/D/YYYY"
};

},{}],49:[function(require,module,exports){
var STATES;

STATES = [];

STATES.push(STATES['AL'] = {
  abbr: "AL",
  name: "Alabama"
});

STATES.push(STATES['AK'] = {
  abbr: "AK",
  name: "Alaska"
});

STATES.push(STATES['AZ'] = {
  abbr: "AZ",
  name: "Arizona"
});

STATES.push(STATES['AR'] = {
  abbr: "AR",
  name: "Arkansas"
});

STATES.push(STATES['CA'] = {
  abbr: "CA",
  name: "California"
});

STATES.push(STATES['CO'] = {
  abbr: "CO",
  name: "Colorado"
});

STATES.push(STATES['CT'] = {
  abbr: "CT",
  name: "Connecticut"
});

STATES.push(STATES['DE'] = {
  abbr: "DE",
  name: "Delaware"
});

STATES.push(STATES['DC'] = {
  abbr: "DC",
  name: "District Of Columbia"
});

STATES.push(STATES['FL'] = {
  abbr: "FL",
  name: "Florida"
});

STATES.push(STATES['GA'] = {
  abbr: "GA",
  name: "Georgia"
});

STATES.push(STATES['HI'] = {
  abbr: "HI",
  name: "Hawaii"
});

STATES.push(STATES['ID'] = {
  abbr: "ID",
  name: "Idaho"
});

STATES.push(STATES['IL'] = {
  abbr: "IL",
  name: "Illinois"
});

STATES.push(STATES['IN'] = {
  abbr: "IN",
  name: "Indiana"
});

STATES.push(STATES['IA'] = {
  abbr: "IA",
  name: "Iowa"
});

STATES.push(STATES['KS'] = {
  abbr: "KS",
  name: "Kansas"
});

STATES.push(STATES['KY'] = {
  abbr: "KY",
  name: "Kentucky"
});

STATES.push(STATES['LA'] = {
  abbr: "LA",
  name: "Louisiana"
});

STATES.push(STATES['ME'] = {
  abbr: "ME",
  name: "Maine"
});

STATES.push(STATES['MD'] = {
  abbr: "MD",
  name: "Maryland"
});

STATES.push(STATES['MA'] = {
  abbr: "MA",
  name: "Massachusetts"
});

STATES.push(STATES['MI'] = {
  abbr: "MI",
  name: "Michigan"
});

STATES.push(STATES['MN'] = {
  abbr: "MN",
  name: "Minnesota"
});

STATES.push(STATES['MS'] = {
  abbr: "MS",
  name: "Mississippi"
});

STATES.push(STATES['MO'] = {
  abbr: "MO",
  name: "Missouri"
});

STATES.push(STATES['MT'] = {
  abbr: "MT",
  name: "Montana"
});

STATES.push(STATES['NE'] = {
  abbr: "NE",
  name: "Nebraska"
});

STATES.push(STATES['NV'] = {
  abbr: "NV",
  name: "Nevada"
});

STATES.push(STATES['NH'] = {
  abbr: "NH",
  name: "New Hampshire"
});

STATES.push(STATES['NJ'] = {
  abbr: "NJ",
  name: "New Jersey"
});

STATES.push(STATES['NM'] = {
  abbr: "NM",
  name: "New Mexico"
});

STATES.push(STATES['NY'] = {
  abbr: "NY",
  name: "New York"
});

STATES.push(STATES['NC'] = {
  abbr: "NC",
  name: "North Carolina"
});

STATES.push(STATES['ND'] = {
  abbr: "ND",
  name: "North Dakota"
});

STATES.push(STATES['OH'] = {
  abbr: "OH",
  name: "Ohio"
});

STATES.push(STATES['OK'] = {
  abbr: "OK",
  name: "Oklahoma"
});

STATES.push(STATES['OR'] = {
  abbr: "OR",
  name: "Oregon"
});

STATES.push(STATES['PA'] = {
  abbr: "PA",
  name: "Pennsylvania"
});

STATES.push(STATES['RI'] = {
  abbr: "RI",
  name: "Rhode Island"
});

STATES.push(STATES['SC'] = {
  abbr: "SC",
  name: "South Carolina"
});

STATES.push(STATES['SD'] = {
  abbr: "SD",
  name: "South Dakota"
});

STATES.push(STATES['TN'] = {
  abbr: "TN",
  name: "Tennessee"
});

STATES.push(STATES['TX'] = {
  abbr: "TX",
  name: "Texas"
});

STATES.push(STATES['UT'] = {
  abbr: "UT",
  name: "Utah"
});

STATES.push(STATES['VT'] = {
  abbr: "VT",
  name: "Vermont"
});

STATES.push(STATES['VA'] = {
  abbr: "VA",
  name: "Virginia"
});

STATES.push(STATES['WA'] = {
  abbr: "WA",
  name: "Washington"
});

STATES.push(STATES['WV'] = {
  abbr: "WV",
  name: "West Virginia"
});

STATES.push(STATES['WI'] = {
  abbr: "WI",
  name: "Wisconsin"
});

STATES.push(STATES['WY'] = {
  abbr: "WY",
  name: "Wyoming"
});

module.exports = STATES;

},{}],50:[function(require,module,exports){
var EMAIL_REGEX, Helpers, PASSWORD_REGEX, STRICT_URL_REGEX, URL_REGEX, UUID_REGEX;

({URL_REGEX, EMAIL_REGEX, STRICT_URL_REGEX, PASSWORD_REGEX, UUID_REGEX} = require("../$constants/default.constants"));

module.exports = Helpers = new ((function() {
  var _Class;

  _Class = class {
    //END if
    //END trim
    trimSlashes(str) {
      return (str != null ? str : "").toString().replace(/^\/+/, '').replace(/\/+$/, '');
    }

    reduceSlashes(str) {
      return Helpers.trimSlashes(str).replace(/\/\/+/gi, '/');
    }

    injectHTMLEntities(str) {
      return str.replace("&", "&amp;").replace("<", "&lt;").replace(">", "&gt;").replace("  ", " &nbsp;");
    }

    //END injectHTMLEntities
    injectAnchorTags(str) {
      var label, match, protocol, regex, returned_str, start_index, url;
      returned_str = "";
      regex = new RegExp(URL_REGEX);
      start_index = 0;
      while (match = regex.exec(str)) {
        returned_str += str.slice(start_index, match.index);
        start_index = regex.lastIndex;
        [label, protocol, url] = match;
        if (protocol == null) {
          protocol = "http://";
        }
        url = protocol + url;
        returned_str += `<a href=\"${url}\">${label}</a>`;
      }
      //END while
      returned_str += str.slice(start_index);
      return returned_str;
    }

    //END injectAnchorTags

      //--------------------------------------------------------------
    // Method: concat
    //	Concatenates all of the values, observable or not into a single
    //	string.
    //--------------------------------------------------------------
    concat() {
      var arg, i, len, ret;
      ret = "";
      for (i = 0, len = arguments.length; i < len; i++) {
        arg = arguments[i];
        arg = ko.unwrap(arg);
        if (arg != null) {
          ret += arg.toString();
        }
      }
      //END for
      return ret;
    }

    //END concat
    join(arr, glue) {
      arr = ko.unwrap(arr);
      if (!_.isArray(arr)) {
        arr = [];
      }
      return arr.join(glue);
    }

    //END join

      //--------------------------------------------------------------
    // Method: isEmail
    //	Checks to see if the string or observable is an email address
    //--------------------------------------------------------------
    isEmail(emailStr) {
      emailStr = ko.unwrap(emailStr);
      if (!_.isString(emailStr)) {
        return false;
      }
      emailStr = Helpers.trim(emailStr);
      return (new RegExp(EMAIL_REGEX)).test(emailStr);
    }

    //END isEmail

      //--------------------------------------------------------------
    // Method: isUrl
    //	Checks to see if the string or observable is a url
    //--------------------------------------------------------------
    isUrl(urlStr) {
      urlStr = ko.unwrap(urlStr);
      if (!_.isString(urlStr)) {
        return false;
      }
      urlStr = Helpers.trim(urlStr);
      return (new RegExp(STRICT_URL_REGEX)).test(urlStr);
    }

    //END isUrl
    hasUrl(string) {
      if (!_.isString(string)) {
        return false;
      }
      return (new RegExp(URL_REGEX)).test(string);
    }

    //END hasUrl
    isPassword(password) {
      password = ko.unwrap(password);
      if (!_.isString(password)) {
        return false;
      }
      return (new RegExp(PASSWORD_REGEX)).test(password);
    }

    //END isPassword
    isUUID(uuid) {
      uuid = ko.unwrap(uuid);
      if (!_.isString(uuid)) {
        return false;
      }
      return (new RegExp(UUID_REGEX)).test(uuid);
    }

    //END isUUID
    makeErrorData(error) {
      return {
        errors: [error]
      };
    }

    parseError(response, default_human = "An error occurred") {
      var ref;
      if (response instanceof Error) {
        return {
          human: response.message
        };
      }
      if (!_.isObject(response)) {
        return {
          human: default_human
        };
      }
      if (!response.hasOwnProperty('human')) {
        return {
          human: default_human
        };
      }
      return {
        human: (ref = response.human) != null ? ref : default_human,
        //TODO: Add Validations
        validations: {}
      };
    }

    //END parseError
    parseDate(date_string) {
      var date;
      date = date_string;
      return date;
    }

    //END parseDate
    parseInt(value) {
      if (value === null) {
        return null;
      }
      value = parseInt(value);
      if (_.isNaN(value)) {
        return null;
      } else {
        return value;
      }
    }

    //END parseInt

      //--------------------------------------------------------------
    // Method: pluralize
    //	Simple if statement to pluralize a label based on a count value
    //--------------------------------------------------------------
    pluralize(count, one_label, many_label) {
      count = ko.unwrap(count);
      if (count === 1) {
        return `${count} ${one_label}`;
      } else {
        return `${count} ${many_label}`;
      }
    }

    //END if
    //END pluralize
    possessive(obs) {
      var value;
      value = Helpers.trim(ko.unwrap(obs));
      if (!_.isString(value)) {
        return "";
      }
      if (value.lastIndexOf("s") === value.length - 1) {
        return `${value}'`;
      } else {
        return `${value}'s`;
      }
    }

    //END if
    //END possessive

      //--------------------------------------------------------------
    // Method: toggle
    //	Toggles a label based on a predicate value
    //--------------------------------------------------------------
    toggle(predicate, true_value, false_value) {
      predicate = ko.unwrap(predicate);
      if (_.isNumber(predicate)) {
        predicate = predicate === 1;
      }
      return (predicate ? true_value : false_value);
    }

    //END toggle
    isLessThan(a, b) {
      a = ko.unwrap(a);
      b = ko.unwrap(b);
      return a < b;
    }

    //END isLessThan
    isGreaterThan(a, b) {
      a = ko.unwrap(a);
      b = ko.unwrap(b);
      return a > b;
    }

    //END isGreaterThan

      //--------------------------------------------------------------
    // Method: isBetween
    //	Checks if a value is in between a range, exclusive
    //--------------------------------------------------------------
    isBetween(count, min, max) {
      count = ko.unwrap(count);
      if (count <= min) {
        return false;
      }
      if (count >= max) {
        return false;
      }
      return true;
    }

    //END isBetween

      //--------------------------------------------------------------
    // Method: isntBetween
    //	Checks if a value is in between a range, exclusive
    //--------------------------------------------------------------
    isntBetween(count, min, max) {
      return !Helpers.isBetween(...arguments);
    }

    not(value) {
      return !ko.unwrap(value);
    }

    //--------------------------------------------------------------
    // Method: formatUrl
    //	Formats the url properly
    //--------------------------------------------------------------
    formatUrl(url) {
      var has_protocol;
      url = Helpers.trim(ko.unwrap(url));
      has_protocol = (url.toLowerCase().indexOf("http://") === 0) || (url.toLowerCase().indexOf("https://") === 0);
      if (!has_protocol) {
        url = `http://${url}`;
      }
      return url;
    }

    //END formatUrl
    compare(a, b) {
      a = ko.unwrap(a);
      b = ko.unwrap(b);
      if (a < b) {
        return -1;
      }
      if (a > b) {
        return 1;
      }
      return 0;
    }

    //END compare
    compareInt(a, b) {
      a = parseInt(ko.unwrap(a));
      b = parseInt(ko.unwrap(b));
      if (a < b) {
        return -1;
      }
      if (a > b) {
        return 1;
      }
      return 0;
    }

    //END compareInt
    compareFloat(a, b) {
      a = parseFloat(ko.unwrap(a));
      b = parseFloat(ko.unwrap(b));
      if (a < b) {
        return -1;
      }
      if (a > b) {
        return 1;
      }
      return 0;
    }

    //END compareFloat
    regexIndexOf(str, regex, offset = 0) {
      var index;
      if (!_.isString(str)) {
        return -1;
      }
      if (!_.isRegExp(regex)) {
        return -1;
      }
      index = str.substring(offset).search(regex);
      return (index < 0 ? -1 : index + offset);
    }

    //END regexIndexOf
    randomId() {
      return Math.floor(Math.random() * 1000000000 + 1);
    }

    hasWord(string, word) {
      var regex, regex_str;
      string = Helpers.trim(ko.unwrap(string)) + " ";
      regex_str = Helpers.trim(ko.unwrap(word)).replace(/([!$^{[.+\\(?])/gi, "\\$1");
      regex = new RegExp(`${regex_str}([^a-zA-Z0-9-_])`, "gi");
      return regex.test(string);
    }

    //END hasWord
    equals(one, two, strict = true) {
      if (strict) {
        return ko.unwrap(one) === ko.unwrap(two);
      } else {
        return ko.unwrap(one) === ko.unwrap(two);
      }
    }

    //END if
    //END equals
    padLeft(string, padding, length) {
      if (!((padding != null) && padding.length > 0)) {
        return string;
      }
      while (string.length < length) {
        string = `${padding}${string}`;
      }
      //END while
      return string;
    }

  };

  _Class.prototype.IS_SAFARI = navigator.userAgent.indexOf("Safari") > -1;

  //--------------------------------------------------------------
  // Method: trim
  //	Trims white space from the beginning and end of a string
  //--------------------------------------------------------------
  _Class.prototype.trim = (function() {
    if (String.prototype.trim != null) {
      return function(str) {
        return String.prototype.trim.call((str != null ? str : "").toString());
      };
    } else {
      return function(str) {
        return (str != null ? str : "").toString().replace(/^\s+/, '').replace(/\s+$/, '');
      };
    }
  })();

  return _Class;

}).call(this))();

//END padLeft
//END Helpers

},{"../$constants/default.constants":48}],51:[function(require,module,exports){
var DOMHelpers;

window.DOMHelpers = module.exports = DOMHelpers = new (class {
  defer(duration, callback) {
    if (_.isFunction(duration)) {
      [callback, duration] = [duration, null];
    }
    if (_.isNumber(duration)) {
      return setTimeout((function() {
        return requestAnimationFrame(callback);
      }), duration);
    } else {
      return setTimeout(function() {
        return requestAnimationFrame(callback);
      });
    }
  }

  //END if
  //END defer
  classList(element) {
    var classList, item, ref;
    if (element == null) {
      return [];
    }
    if ('classList' in element) {
      return element.classList;
    }
    classList = ((ref = element.className) != null ? ref : "").replace(/\s+/, " ").split(" ");
    classList = (function() {
      var j, len, results;
      results = [];
      for (j = 0, len = classList.length; j < len; j++) {
        item = classList[j];
        if (item.length > 0) {
          results.push(item);
        }
      }
      return results;
    })();
    classList.contains = function(item) {
      return Array.prototype.indexOf.call(classList, item) > -1;
    };
    return classList;
  }

  //END classList
  findScrollParent(element) {
    var parent, ref;
    parent = element.parentNode;
    if (parent == null) {
      return element;
    }
    if ((parent === document.body) || ((ref = window.getComputedStyle(parent).overflowY) === 'auto' || ref === 'scroll')) {
      return parent;
    }
    return DOMHelpers.findScrollParent(parent);
  }

  //END findScrollParent
  findFormParent(element) {
    var parent, ref;
    if ((parent = element.parentNode) == null) {
      return null;
    }
    if (((ref = parent.tagName) != null ? ref : "").toString().toLowerCase() === "form") {
      return parent;
    }
    return DOMHelpers.findFormParent(parent);
  }

  //END findFormParent
  findParentByTagName(element, tag_name) {
    var parent;
    tag_name = tag_name.toLowerCase();
    parent = element.parentNode;
    while ((parent != null) && parent.nodeType !== Node.ELEMENT_NODE) {
      parent = parent.parentNode;
    }
    if (parent == null) {
      return null;
    }
    if (parent.tagName.toLowerCase() === tag_name) {
      return parent;
    }
    return DOMHelpers.findParentByTagName(parent, tag_name);
  }

  //END findParentByClassName
  findParentByClassName(element, class_name) {
    var parent;
    parent = element.parentNode;
    while ((parent != null) && parent.nodeType !== Node.ELEMENT_NODE) {
      parent = parent.parentNode;
    }
    if (parent == null) {
      return null;
    }
    if (DOMHelpers.classList(parent).contains(class_name)) {
      return parent;
    }
    return DOMHelpers.findParentByClassName(parent, class_name);
  }

  //END findParentByClassName
  findSiblingByClassName(element, class_name) {
    var sibling;
    sibling = element.nextSibling;
    while ((sibling != null) && sibling.nodeType !== Node.ELEMENT_NODE) {
      sibling = sibling.nextSibling;
    }
    if (sibling == null) {
      return null;
    }
    if (DOMHelpers.classList(sibling).contains(class_name)) {
      return sibling;
    }
    return DOMHelpers.findSiblingByClassName(sibling, class_name);
  }

  //END findSiblingByClassName
  findDescendantByClassName(element, class_name) {
    return element.querySelector(`.${class_name}`);
  }

  //END findDescendantByClassName
  hasClass(element, className) {
    return DOMHelpers.classList(element).contains(className);
  }

  addClass(element, className) {
    if (element == null) {
      return this;
    }
    if ('classList' in element) {
      if (!element.classList.contains(className)) {
        element.classList.add(className);
      }
    } else {
      if (!DOMHelpers.classList(element).contains(className)) {
        element.className += ` ${className}`;
      }
    }
    //END if
    return this;
  }

  //END addClass
  addClassAsync(element, className) {
    DOMHelpers.defer(67, function() {
      return DOMHelpers.addClass(element, className);
    });
    return this;
  }

  //END addClass
  removeClass(element, className) {
    if (element == null) {
      return this;
    }
    if ('classList' in element) {
      if (element.classList.contains(className)) {
        element.classList.remove(className);
      }
    } else {
      element.className = element.className.replace(className, "");
    }
    //END if
    return this;
  }

  //END removeClass
  removeClassAsync(element, className) {
    DOMHelpers.defer(67, function() {
      return DOMHelpers.removeClass(element, className);
    });
    return this;
  }

  //END removeClass
  toggleClass(element, className, predicate) {
    if (predicate) {
      DOMHelpers.addClass(element, className);
    } else {
      DOMHelpers.removeClass(element, className);
    }
    //END if
    return this;
  }

  //END toggleClass
  toggleClassAsync(element, className, predicate) {
    DOMHelpers.defer(function() {
      return DOMHelpers.toggleClass(element, className, predicate);
    });
    return this;
  }

  //END toggleClassAsync
  hasPreviousSibling(element) {
    var previous;
    previous = element.previousSibling;
    if (previous == null) {
      return false;
    }
    if (previous.nodeType === Node.ELEMENT_NODE) {
      return true;
    }
    return DOMHelpers.hasPreviousSibling(previous);
  }

  //END hasPreviousSibling
  hasNextSibling(element) {
    var next;
    next = element.nextSibling;
    if (next == null) {
      return false;
    }
    if (next.nodeType === Node.ELEMENT_NODE) {
      return true;
    }
    return DOMHelpers.hasNextSibling(next);
  }

  //END hasNextSibling
  removeNode(element) {
    element.parentNode.removeChild(element);
    return this;
  }

  //END removeNode
  getDuration(element) {
    var computed_duration, duration;
    computed_duration = window.getComputedStyle(element).transitionDuration;
    duration = parseFloat(computed_duration);
    return Math.floor(duration * 1000);
  }

  //END getDuration
  scrollToInputElement(element, scroll_parent) {
    var $element, ref, ref1;
    if (scroll_parent == null) {
      scroll_parent = DOMHelpers.findScrollParent(element);
    }
    if (!((element != null) && (scroll_parent != null))) {
      return;
    }
    if ((ref = window.getComputedStyle(element).position) === 'absolute' || ref === 'fixed') {
      return;
    }
    if ((ref1 = element.tagName.toLowerCase()) !== 'input' && ref1 !== 'textarea') {
      return;
    }
    $element = $(element);
    return scroll_parent.scrollTop = $element.offset().top + $element.outerHeight();
  }

  //END scrollToElement
  getTransformString(element) {
    var computed_style;
    computed_style = window.getComputedStyle(element, null);
    return computed_style.getPropertyValue('transform') || computed_style.getPropertyValue('-webkit-transform') || computed_style.getPropertyValue('-moz-transform') || computed_style.getPropertyValue('-ms-transform') || computed_style.getPropertyValue('-o-transform');
  }

  //END getTransformString
  setTransform(element, transformString) {
    element.style.webkitTransform = transformString;
    element.style.MozTransform = transformString;
    element.style.msTransform = transformString;
    element.style.OTransform = transformString;
    element.style.transform = transformString;
    return this;
  }

  //END setTransform
  removeTransform(element) {
    element.style.webkitTransform = null;
    element.style.MozTransform = null;
    element.style.msTransform = null;
    element.style.OTransform = null;
    element.style.transform = null;
    return this;
  }

  //END removeTransform
  afterTransition(element, callback) {
    var _callback, duration, timeout;
    duration = DOMHelpers.getDuration(element);
    timeout = null;
    _callback = function() {
      element.removeEventListener("webkitTransitionEnd", _callback);
      if (timeout != null) {
        clearTimeout(timeout);
      }
      _callback = null;
      return callback();
    };
    //END _callback

    // Add callbacks for detecting the transition end
    // 50 is added to the timeout as an aribtrary non-noticable
    // number to trigger the timeout presumably after the actual
    // animation is finished.
    element.addEventListener("webkitTransitionEnd", _callback);
    if (duration) {
      timeout = setTimeout(_callback, duration + 50);
    }
    return this;
  }

  //END afterTransition
  setOpacity(element, opacity) {
    element.style.opacity = opacity;
    element.style.filter = `alpha(opacity=${opacity * 100})`;
    return this;
  }

  //END setOpacity
  setScale(element, scale_x, scale_y) {
    if (scale_y == null) {
      scale_y = scale_x;
    }
    DOMHelpers.setTransform(element, 'scale(#{scale_x}, #{scale_y})');
    return this;
  }

  //END setScale
  getStyle(element, key) {
    var ref;
    return (ref = window.getComputedStyle(element)) != null ? ref[key] : void 0;
  }

  hideKeyboard() {
    var activeElement;
    if ((activeElement = document.activeElement) == null) {
      return this;
    }
    activeElement.blur();
    return this;
  }

  //END hideKeyboard
  getOffsetTop(element) {
    var offsetParent, parentOffsetTop, ref, ref1;
    offsetParent = element.offsetParent;
    parentOffsetTop = 0;
    if ((offsetParent != null ? offsetParent.nodeType : void 0) === Node.ELEMENT_NODE) {
      parentOffsetTop = (ref = DOMHelpers.getOffsetTop(offsetParent)) != null ? ref : 0;
    }
    //END if
    return ((ref1 = element.offsetTop) != null ? ref1 : 0) + parentOffsetTop;
  }

  //END getOffsetTop
  findNodeByClassName(node_list, class_name) {
    var j, len, node;
    for (j = 0, len = node_list.length; j < len; j++) {
      node = node_list[j];
      if (node.nodeType === Node.ELEMENT_NODE) {
        if (DOMHelpers.classList(node).contains(class_name)) {
          return node;
        }
      }
    }
    //END for
    return null;
  }

  //END findNodeByClassName
  getCaretPosition(element) {
    var $document, $window, pre_caret_range, range, ref, ref1, selection, text_range;
    $document = (ref = element.ownerDocument) != null ? ref : element.document;
    $window = (ref1 = $document.defaultView) != null ? ref1 : $document.parentWindow;
    if ('getSelection' in $window) {
      selection = $window.getSelection();
      if (!(selection.rangeCount > 0)) {
        return 0;
      }
      range = selection.getRangeAt(0);
      pre_caret_range = range.cloneRange();
      pre_caret_range.selectNodeContents(element);
      pre_caret_range.setEnd(range.endContainer, range.endOffset);
      return pre_caret_range.toString().length;
    } else if ((selection = $document.selection) && selection.type !== "Control") {
      text_range = selection.createRange();
      pre_caret_range = $document.body.createTextRange();
      pre_caret_range.moveToElementText(element);
      pre_caret_range.setEndPoint("EndToEnd", text_range);
      return pre_caret_range.text.length;
    }
    //END if
    return 0;
  }

  //END getCaretPosition

    //TODO: Make this work for older browsers
  setCaretPosition(node, offset) {
    var range, recurse, result, selection;
    if (node == null) {
      return;
    }
    recurse = function(node) {
      var j, len, ref, result;
      if (node.nodeType === Node.TEXT_NODE) {
        return {node, offset};
      }
      ref = node.childNodes;
      //END if
      for (j = 0, len = ref.length; j < len; j++) {
        node = ref[j];
        if (typeof result !== "undefined" && result !== null) {
          return result;
        }
        switch (node.nodeType) {
          case Node.TEXT_NODE:
            if (offset <= node.length) {
              return {node, offset};
            }
            offset -= node.length;
            break;
          //END when
          case Node.ELEMENT_NODE:
            result = recurse(node);
            if (result != null) {
              return result;
            }
        }
      }
      //END when
      //END switch
      //END for
      return null;
    };
    //END recurse
    result = recurse(node);
    if (result != null) {
      ({node, offset} = result);
      range = document.createRange();
      selection = window.getSelection();
      range.setStart(node, offset);
      range.collapse(true);
      selection.removeAllRanges();
      return selection.addRange(range);
    }
  }

  //END if
  //END setCaretPosition

    //TODO: Make this work for older browsers
  getCaretNode(element) {
    var node, selection;
    selection = typeof window.getSelection === "function" ? window.getSelection() : void 0;
    if (selection == null) {
      return null;
    }
    node = selection.anchorNode;
    if (node == null) {
      return null;
    }
    if (!element.contains(node)) {
      return null;
    }
    return node;
  }

  //END getCaretNode

    //TODO: Make this work for older browsers
  injectNodeAtCaret(node) {
    var range, selection;
    selection = window.getSelection();
    if (selection.rangeCount > 0) {
      range = selection.getRangeAt(0);
      range.deleteContents();
      range.insertNode(node);
      range.setStartAfter(node);
      range.collapse(true);
      selection.removeAllRanges();
      return selection.addRange(range);
    }
  }

  //END if
  //END injectNodeAtCaret
  collapseAllHighlghts() {
    var ref;
    return (ref = window.getSelection()) != null ? ref.removeAllRanges() : void 0;
  }

  //END collapseAllHighlghts
  collapseHighlight() {
    var endContainer, endOffset, range, selection;
    selection = window.getSelection();
    if (!(selection.rangeCount > 0)) {
      return 0;
    }
    ({endOffset, endContainer} = selection.getRangeAt(0));
    selection.removeAllRanges();
    range = document.createRange();
    range.setStart(endContainer, endOffset);
    range.collapse(true);
    return selection.addRange(range);
  }

  //END collapseHighlight
  highlight(element, start_offset, end_offset) {
    var childNode, currentNode, endNode, j, len, previousNode, range, ref, selection, startNode;
    if (!_.isNumber(start_offset)) {
      return;
    }
    if (!_.isNumber(end_offset)) {
      return;
    }
    if (!(start_offset < end_offset)) {
      return;
    }
    range = document.createRange();
    selection = window.getSelection();
    startNode = null;
    endNode = null;
    currentNode = null;
    previousNode = null;
    ref = element.childNodes;
    for (j = 0, len = ref.length; j < len; j++) {
      childNode = ref[j];
      previousNode = currentNode;
      currentNode = childNode;
      while (currentNode.childNodes.length > 0) {
        currentNode = currentNode.childNodes[0];
      }
      //END while
      if (previousNode != null) {
        if (startNode == null) {
          start_offset -= previousNode.length;
        }
        if (endNode == null) {
          end_offset -= previousNode.length;
        }
      }
      if ((startNode == null) && start_offset <= currentNode.length) {
        //END if
        startNode = currentNode;
      }
      if ((endNode == null) && end_offset <= currentNode.length) {
        endNode = currentNode;
      }
      if ((startNode != null) && (endNode != null)) {
        break;
      }
    }
    //END for
    if (startNode == null) {
      startNode = element;
    }
    if (endNode == null) {
      endNode = currentNode;
    }
    if ((startNode != null) && (endNode != null)) {
      range.setStart(startNode, start_offset);
      range.setEnd(endNode, end_offset);
      selection.removeAllRanges();
      return selection.addRange(range);
    }
  }

  //END if
  //END highlight
  hasSelection(element) {
    var i, j, range, ref, selection;
    selection = window.getSelection();
    if (!(selection.rangeCount > 0)) {
      return false;
    }
    for (i = j = 0, ref = selection.rangeCount; (0 <= ref ? j < ref : j > ref); i = 0 <= ref ? ++j : --j) {
      range = selection.getRangeAt(i);
      if (!range.collapsed) {
        if (element.contains(range.startContainer)) {
          return true;
        }
        if (element.contains(range.endContainer)) {
          return true;
        }
      }
    }
    //END unless
    //END for
    return false;
  }

  //END hasSelection
  getText(node) {
    switch (false) {
      case !('textContent' in node):
        return node.textContent;
      case !('text' in node):
        return node.text;
      case !('innerText' in node):
        return node.innerText;
      case !('data' in node):
        return node.data;
      default:
        throw new Error("Could not get text of node");
    }
  }

  //END getText
  setText(node, text) {
    switch (false) {
      case !('textContent' in node):
        return node.textContent = text;
      case !('text' in node):
        return node.text = text;
      case !('innerText' in node):
        return node.innerText = text;
      case !('data' in node):
        return node.data = text;
      default:
        throw new Error("Could not set text of node");
    }
  }

  //END setText
  concatText(target_text_node, text) {
    switch (false) {
      case !('textContent' in target_text_node):
        return target_text_node.textContent += text;
      case !('text' in target_text_node):
        return target_text_node.text += text;
      case !('innerText' in target_text_node):
        return target_text_node.innerText += text;
      case !('data' in target_text_node):
        return target_text_node.data += text;
      default:
        throw new Error("Could not set text of node");
    }
  }

})();

//END concatText
//END DOMHelpers

},{}],52:[function(require,module,exports){
var RequestHelpers;

module.exports = RequestHelpers = new ((function() {
  var UNAUTHORIZED, _Class;

  _Class = class {
    preparePromiseOptions(resolve, reject, options, default_human_error) {
      var _error, _success;
      if (_.isFunction(options)) {
        options = {
          complete: options
        };
      }
      if (!_.isObject(options)) {
        options = {};
      }
      _success = options.success;
      options.success = function(model) {
        resolve(model);
        if (_.isFunction(_success)) {
          return _success.apply(this, arguments);
        }
      };
      //END options.success
      _error = options.error;
      options.error = function(model, error, options, {xhr}) {
        error = (function() {
          var ref;
          switch (parseInt((ref = xhr != null ? xhr.status : void 0) != null ? ref : 0)) {
            case 401:
              return UNAUTHORIZED;
            default:
              return Helpers.parseError(error, default_human_error);
          }
        })();
        //END switch
        reject(error);
        if (_.isFunction(_error)) {
          return _error.apply(this, arguments);
        }
      };
      //END options.error
      return options;
    }

    //END preparePromiseOptions
    isUnauthorized(error) {
      return error === UNAUTHORIZED;
    }

  };

  UNAUTHORIZED = {
    human: "Session Expired"
  };

  return _Class;

}).call(this))();

//END RequestHelpers

},{}],53:[function(require,module,exports){
module.exports = {
  code: "en/ca",
  translations: {
    "USA/English": "Canada/English",
    "Enter Your Game Code": "Enter Your Game Code",
    "{{daysLeftPrefix}}": ""
  }
};

},{}],54:[function(require,module,exports){
module.exports = {
  code: "en/us",
  translations: {
    "USA/English": "USA/English",
    "Enter Your Game Code": "Enter Your Game Code",
    "{{daysLeftPrefix}}": ""
  }
};

},{}],55:[function(require,module,exports){
var AgraveUni, CcedillaUni, EacuteUni, EcircUni, EgraveUni, agraveUni, ccedillaUni, eacuteUni, ecircUni, egraveUni;

AgraveUni = "\u00C0"; // À

CcedillaUni = "\u00C7"; // Ç

EgraveUni = "\u00C8"; // È

EacuteUni = "\u00C9"; // É

EcircUni = "\u00CA"; // Ê

// TODO: Î
agraveUni = "\u00E0"; // à

ccedillaUni = "\u00E7"; // ç

egraveUni = "\u00E8"; // è

eacuteUni = "\u00E9"; // é

ecircUni = "\u00EA"; // ê

module.exports = {
  code: "fr/ca",
  translations: {
    "USA/English": `Canada/Fran${ccedillaUni}ais`,
    "Snap-on Partners in Profitability!": "Snap-on Partners in Profitability!",
    "Rule the Road 2018": "Rule the Road 2018",
    "Win a Snap-on® special edition Traxxax® X-Maxx Monster Truck": `Gagnez un Monster Truck Snap-on® Traxxas® X-Maxx ${EacuteUni}dition sp${eacuteUni}ciale`,
    "Every entry also gives you a chance to win.": "Chaque bulletin vous donne une chance de gagner.",
    "Snap-on® Shopping Spree $5,000": "Magasinage en folie Snap-on® de 5 000 $",
    "$50,000 Tool Package": "50 000 $ en outils",
    "Contest Re-opens soon!": "Le concours commence bientôt!",
    "Own the Water 2018": "Own the Water 2018",
    "Win a Snap-on® special edition Traxxas® DCB M41 Widebody 4&quot; Race Boat": `Gagnez un bateau de course Snap-on® Traxxas DCB M41 Widebody 41 po ${EacuteUni}dition sp${eacuteUni}ciale`,
    "Enter Your Game Code": "ENTRER VOTRE CODE DE JEU",
    "Continue": "CONTINUER",
    "Email": "Courriel",
    "Snap-on is a trademark of Snap-on Incorporated.": "SNAP-ON EST UNE MARQUE DE COMMERCE DE SNAP-ON INCORPORATED.",
    "&copy;Snap-on Incorporated 2023. All other marks are trademarks of their respective holders.": `&copy;SNAP-ON INCORPORATED 2023. TOUTES LES AUTRES MARQUES DE COMMERCE SONT LA PROPRI${EacuteUni}T${EacuteUni} DE LEUR D${EacuteUni}TENTEUR RESPECTIF.`,
    "Privacy": `VIE PRIV${EacuteUni}E`,
    "Terms of Use": "CONDITIONS D'UTILISATION",
    "Official Rules": `R${EgraveUni}GLEMENTS OFFICIELS`,
    "We think you're in the": `Nous pensons que vous ${EcircUni}tes r${EacuteUni}sidents de`,
    "Is that correct?": "Est-ce exact?",
    // "USA/English": "USA/English"
    // "Canada/English": "Canada/English"
    // "Canada/Francais": "Canada/Fran#{ccedillaUni}ais"
    "Excellent!": "Excellent!",
    "Excellent": "Excellent",
    "Sign in or register<br>to claim this entry": `OUVRIR UNE SESSION OU S'INSCRIRE POUR R${EacuteUni}CLAMER VOTRE BULLETIN`,
    "is a valid code.": "est un code valide.",
    "Sign in or register to claim this entry": `Ouvrir une session ou s'inscrire pour r${eacuteUni}clamer votre bulletin`,
    "Sign In": "S'ENREGISTRER",
    "Signin": "S'ENREGISTRER",
    "Sign In": "S'ENREGISTRER",
    "Sign Out": "FERMER LA SESSION",
    "Register": "S'inscrire",
    "Your Email Address": "Votre adresse de courriel",
    "Password": "Mot de passe",
    "Enter your Password": "Entrer votre mot de passe",
    "Enter Your Password": "Entrer votre mot de passe",
    "Keep me signed in": "Garder ma session ouverte",
    "Continue": "Continuer",
    "Forgot Your Password?": `J'AI OUBLI${EacuteUni} MON MOT DE PASSE`,
    "Name - First Name Last Name": `Nom - Pr${eacuteUni}nom`,
    "Name": "Nom",
    "Your Name": "Votre nom",
    "First Name": `PR${EacuteUni}NOM`,
    "Your First Name": `Votre PR${EacuteUni}NOM`,
    "Last Name": "Nom",
    "Your Last Name": "Votre nom",
    "Email Address": "ADRESSE DE COURRIEL",
    "Your Email Address": "Votre adresse de courriel",
    "Verify Email Address": `V${EacuteUni}RIFIER L'ADRESSE DE COURRIEL`,
    "Phone Number": `NUM${EacuteUni}RO DE T${EacuteUni}L${EacuteUni}PHONE`,
    "Your Phone Number": `Votre num${EacuteUni}ro de t${EacuteUni}l${EacuteUni}phone`,
    "PASSWORD": "MOT DE PASSE",
    "Choose A Password": "Choisir un mot de passe",
    "Verify Password": `V${EacuteUni}RIFIER LE MOT DE PASSE`,
    "Verify Your Password": `V${EacuteUni}rifier le mot de passe`,
    "Passwords do not match": "LES MOTS DE PASSE NE CONCORDENT PAS",
    "Check this box to verify that you<br />have read the": "Cochez cette case pour confirmer que<br /> vous avez lu",
    "official rules": `les r${EgraveUni}glements officiels`,
    "(Official Rules)": `(les r${EgraveUni}glements officiels)`,
    "Opt-in for a chance to win the Custom Snap-on RC Truck or Boat": `S'inscrire pour courir la chance de gagner une t${EacuteUni}l${EacuteUni}commande pour bateau ou camion Snap-on.`,
    "(See your Snap-on franchisee for contest rules)": `(voir votre franchis${EacuteUni} Snap-on pour les d${EacuteUni}tails)`,
    "Opt-in for a chance to win the 5,000 Snap-on Shopping Spree": "S'inscrire pour courir la chance de gagner un magasinage en folie Snap-on de 5 000 $.",
    "Opt-in for a chance to win the 50,000 Ultimate Snap-on Tool Set": "S'inscrire pour courir la chance de gagner un ensemble ultime de 50 000 $ en outils.",
    "Would you like Snap-on Tools <br /> to send you game updates?": `Voulez-vous que Outils Snap-on <br /> vous envoie des mises ${AgraveUni} jour sur le concours?`,
    "Send me Snap-on game updates, newsletters and promotions by email.": `Envoyez-moi des mises ${AgraveUni} jour, des bulletins ${EacuteUni}lectroniques et des promotions par courriel.`,
    "Back": `PR${EacuteUni}C${EacuteUni}DENT`,
    "Check this box to verify that you have read the": "COCHEZ CETTE CASE POUR CONFIRMER QUE VOUS AVEZ LU",
    "Opt-in for a chance to win the Snap-on Customize Roll Cab Contest": "COCHEZ POUR COURIR LA CHANCE DE GAGNER LE CONCOURS « PERSONNALISER VOTRE SERVANTE MOBILE SNAP-ON",
    "YOU'RE ENTERED [FIRST NAME]!": `VOUS ${EcircUni}TES INSCRIT [PR${EacuteUni}NOM]!`,
    "GOOD LUCK!": "BONNE CHANCE!",
    "You&lsquo;ve Just Added": "VOUS VENEZ D'AJOUTER",
    "YOU'VE JUST ADDED [X] ENTRY FOR THIS DRAWING": "VOUS VENEZ D'AJOUTER [X] BULLETIN(S) POUR CE TIRAGE.",
    "Entries in this Phase": "Bulletin(s) dans cette phase",
    "Days Until Prize Drawing": "Jour(s) avant le tirage",
    "Days Until Contest Opens": `Jour(s) avant le d${EacuteUni}but du concours`,
    "won this phase!": `a remport${EacuteUni} cette phase!`,
    "Entries for Shopping Spree": "BULLETINS DANS CETTE PHASE",
    "Win a chance to build<br/>&amp; Customize your own<br/>Snap-on<span>&reg;</span> Roll Cab": "COUREZ LA CHANCE DE<br/>CONSTRUIRE ET DE<br/>PERSONNALISER VOTRE<br/>SERVANTE MOBILE SNAP-ON<span>&reg;</span>",
    "In Algona, Iowa": `${AgraveUni} ALGONA, IOWA`,
    "&ndash; The Storage Capital Of the World": `&ndash; LA CAPITALE MONDIALE DES UNIT${EacuteUni}S DE RANGEMENT`,
    "Currently you have<br />contest entries": `VOUS AVEZ PR${EacuteUni}SENTEMENT<br/>BULLETINS DANS CETTE PHASE`,
    "Days Left to Enter": "JOURS RESTANTS<br/>POUR PARTICIPER",
    "Prize Drawing on October 5th": "LE TIRAGE A LIEU LE 5 OCTOBRE",
    "Sorry our login information doesn't match our records.": `D${eacuteUni}sol${eacuteUni}, vos donn${eacuteUni}es d'ouverture de session ne correspondent pas ${agraveUni} celles de nos dossiers.`,
    "An unspecified error has occurred.": "Une erreur inconnue est survenue.",
    "Please try reloading the page.": "Veuillez actualiser cette page.",
    "Sorry, this game code isn't valid.": `D${eacuteUni}sol${eacuteUni}, ce code de jeu est non valide.`,
    "/images/slide-1-desktop.png": "/images/slide-1-desktop.fr.png",
    "/images/slide-2-desktop.png": "/images/slide-2-desktop.fr.png",
    "/images/slide-3-desktop.png": "/images/slide-3-desktop.fr.png",
    "/images/slide-1-mobile.png": "/images/slide-1-mobile.fr.png",
    "/images/slide-2-mobile.png": "/images/slide-2-mobile.fr.png",
    "/images/slide-3-mobile.png": "/images/slide-3-mobile.fr.png",
    "/images/thanks.png": "/images/thanks.fr.png",
    "/images/franchisee-pt-1-header.png": "/images/franchisee-pt-1-header.fr.png",
    "/images/franchisee-pt-2-header.png": "/images/franchisee-pt-2-header.fr.png",
    "/images/fpt-header.png": "/images/fpt-header.fr.png",
    "/images/global-header.png": "/images/global-header.fr.png",
    "https://www.snapon.com/Terms-and-Conditions": "https://www.snapon.com/Terms-and-Conditions",
    "https://www.snapon.com/EN/Privacy-Policy": "https://www.snapon.com/EN/Privacy-Policy",
    "Edit Profile": "modifier le profil",
    "Enter Another Game Code": "entrer un autre code de jeu",
    "Add This Code": "ajouter ce code",
    "Account Information": "RENSEIGNEMENTS SUR LE COMPTE",
    "Change Password": "CHANGER LE MOT DE PASSE",
    "Current Password": "MOT DE PASSE ACTUEL",
    "Your Current Password...": "Votre mot de passe actuel...",
    "New Password": "NOUVEAU MOT DE PASSE",
    "New Password...": "NOUVEAU MOT DE PASSE...",
    "Retype New Password": "CONFIRMER LE MOT DE PASSE",
    "Retype New Password...": "CONFIRMER LE MOT DE PASSE...",
    "Change": "MODIFIER",
    "Address": "ADRESSE",
    "Apt/Suite #": "App./Suite",
    "City": "VILLE",
    "State": `${EacuteUni}TAT`,
    "Save": "ENREGISTRER",
    "Zip Code": "CODE POSTA",
    "Hello": "Bonjour",
    "Home": "Accueil",
    "Changing...": "En cours de modification...",
    "Saving...": "En cours d'enregistrement...",
    "Province": "Province",
    "Retype Password...": "Tapez de nouveau le mot de passe...",
    "Email Address...": "ADRESSE DE COURRIEL...",
    "Email Must Not Be Empty": "Adresse de courriel obligatoire",
    "Email must not be empty": "Adresse de courriel obligatoire",
    "Your Name...": "Votre nom...",
    "Name must not be empty": "Nom obligatoire",
    "Password must be at least 6 characters long and must not contain white space": `LE MOT DE PASSE DOIT COMPTER AU MOINS 6 CARACT${EgraveUni}RES ET NE CONTENIR AUCUN ESPACE`,
    "Email is formatted incorrectly": "FORMAT DE COURRIEL NON VALIDE",
    "Invalid email or password": "COURRIEL OU MOT DE PASSE NON VALIDE",
    "Please enter a valid phone number": `Veuillez entrer un num${egraveUni}ro de t${egraveUni}l${egraveUni}phone valide`,
    "That&apos;s A Valid Code. Good Luck!": "C&apos;EST UN CODE VALIDE. BONNE CHANCE!",
    "You&apos;ve Just Added": "VOUS VENEZ D'AJOUTER",
    "Entry for This Drawing": "BULLETIN(S) POUR CE TIRAGE.",
    "Enter Contest": "PARTICIPER",
    "Retype Email Address": "Inscrire votre adresse de courriel de nouveau",
    "Retype Your Email Address": "Inscrire votre adresse de courriel de nouveau",
    "Please re-enter your email": "Veuillez inscrire votre adresse de courriel de nouveau",
    "Emails do not match": "Les adresses de courriel ne concordent pas",
    "./videos/boat_en.mp4": "./videos/boat_fr.mp4",
    "./videos/boat_en.ogv": "./videos/boat_fr.ogv",
    "./videos/boat_en.webm": "./videos/boat_fr.webm",
    "Winning Entries": void 0,
    "SEE YOUR FRANCHISEE FOR OFFICIAL GAME RULES": `VOYEZ VOTRE FRANCHIS${EacuteUni} POUR CONNAÎTRE LES R${EgraveUni}GLEMENTS OFFICIELS`,
    "DID YOU SIGN UP FOR DOUBLE-PLAY?": `VOUS VOUS ${EcircUni}TES INSCRIT AU DOUBLE JEU?`,
    "THAT'S GREAT - YOU CAN USE THE SAME LOGIN!": `MERVEILLEUX &mdash; VOUS POUVEZ ALORS UTILISER LE M${EcircUni}ME IDENTIFIANT!`,
    "Entries for cooler cart": `Bulletins pour le chariot-glaci${egraveUni}re`,
    "Log In": "OUVRIR UNE SESSION",
    "Login": "OUVRIR UNE SESSION",
    "Verify Email": "CONFIRMER LE COURRIEL",
    "Phone": "T&Eacute;L&Eacute;PHONE",
    "Opt-in for a chance to win the MECUM AUCTION EXPERIENCE": "INSCRIVEZ-VOUS POUR COURIR LA CHANCE DE REMPORTER L&rsquo;EXP&Eacute;RIENCE &laquo; VENTE AUX ENCH&Egrave;RES &raquo; MECUM",
    "Submit": "SOUMETTRE",
    "You've got a valid code!": "VOTRE CODE EST VALIDE!",
    "Log in to Claim Your Piece": "CONNECTEZ-VOUS POUR R&Eacute;CLAMER VOTRE PI&Egrave;CE DE JEU.",
    "Your Email": "VOTRE COURRIEL",
    "Register to Claim Your Piece": "Inscrivez-vous pour r&eacute;clamer votre pi&egrave;ce",
    "First name must not be empty": "Pr&eacute;nom obligatoire",
    "Last name must not be empty": "Nom obligatoire",
    "Please re-enter your password": "Veuillez entrer votre mot de passe de nouveau",
    "Please enter your current password": "Veuillez entrer votre mot de passe actuel",
    "Please enter a new password": "Veuillez entrer un nouveau mot de passe",
    "Go!": "ALLEZ!",
    "You Have": "VOUS AVEZ",
    "Entries<br/>To Win": "BULLETIN DE<br/>PARTICIPATION",
    "You've<small>Completed<br/>a car!</small>": "VOUS AVEZ <small>TERMIN&Eacute;<br/> UNE VOITURE!</small>",
    "Enter a new code": "ENTREZ UN<br class='is-only-on-phone'/>NOUVEAU CODE",
    "{{daysLeftPrefix}}": "<strong>ENCORE</strong>",
    "<strong>Days Left, Contest Ends<strong> March 15": "<strong>JOURS...<br/>LE CONCOURS PREND FIN LE 15 MARS.",
    "Your Garage": "VOTRE GARAGE",
    "Get Another Entry with Every Completed Car": "OBTENEZ UN AUTRE BULLETIN POUR CHAQUE VOITURE COMPL&Egrave;TE.",
    "Share Your<br/>Collection": "PARTAGER VOTRE<br/>COLLECTION",
    "Completed Cars": "VOITURES COMPL&Egrave;TES",
    "Dashboard": "TABLEAU DE BORD",
    "Account Settings": "PARAM&Egrave;TRES DU COMPTE",
    "Skip": "PASSER",
    "Next": "SUIVANT",
    "Finish": "TERMINER",
    "WELCOME TO<br/>Partners in Profitability<br/>LET\'S GET STARTED": "BIENVENUE &Agrave;<br/>&laquo; Partners in Profitability &raquo;<br/>COMMENCEZ",
    "ENTER YOUR GAME CODE HERE": "ENTREZ VOS CODES DE JEU ICI",
    "Enter Your Code": "ENTREZ VOTRE CODE",
    "Get Started!": "COMMENCEZ!",
    "With each completed car,<br/> you get another free entry": "&Agrave; CHAQUE VOITURE COMPL&Egrave;TE, VOUS OBTENEZ<br/>UN AUTRE BULLETIN DE PARTICIPATION!",
    "Share your progress<br/>with your friends": "PARTAGER VOTRE<br/>POSITION AVEC VOS AMIS",
    "Take our brief <strong>Survey</strong> and <br/> receive a <strong>free entry.</strong>": "R&eacute;pondez &agrave; un cours <strong>SONDAGE</strong>, et obtenez un <strong>BULLETIN<br/>DE PARTICIPATION EN PRIME</strong>",
    "Take our brief<br/> survey and receive<br /> a free entry.": "R&eacute;pondez &agrave; un cours SONDAGE, et obtenez un BULLETIN DE PARTICIPATION EN PRIME",
    "Get Started": "COMMENCEZ!",
    "Start": "COMMENCEZ!",
    "<strong>Survey Complete!</strong><br/>Keep rolling! Way to score another entry": "<strong>Sondage termin&eacute;</strong><br/>Ne vous arr&ecirc;tez pas! Accumulez d'autres bulletins de participation.",
    "Survey Complete!<br/>Keep rolling! Way to score another entry": "Sondage termin&eacute;<br/>Ne vous arr&ecirc;tez pas! Accumulez d'autres bulletins de participation.",
    "/images/dashboard/grand-prize-mobile.png": "/images/dashboard/grand-prize-mobile_fr.png",
    "/images/dashboard/grand-prize.png": "/images/dashboard/grand-prize_fr.png",
    "/images/dashboard/1st-prize-mobile.png": "/images/dashboard/1st-prize-mobile_fr.png",
    "/images/dashboard/1st-prize.png": "/images/dashboard/1st-prize_fr.png",
    "/images/home/hero-mobile.png": "/images/home/hero-mobile_fr.png",
    "/images/hero.png": "/images/hero-fr.png",
    "/images/home/jan-through-march.png": "/images/home/jan-through-march_fr.png",
    "/images/home/1st-prize-mobile.png": "/images/home/1st-prize-mobile_fr.png",
    "/images/home/1st-prize.png": "/images/home/1st-prize_fr.png",
    "/images/home/every-eight-weeks-mobile.png": "/images/home/every-eight-weeks-mobile_fr.png",
    "/images/home/every-eight-weeks.png": "/images/home/every-eight-weeks_fr.png",
    "/images/tutorial/enter-game-code.jpg": "/images/tutorial/enter-game-code_fr.jpg",
    "/images/tutorial/pieces.jpg": "/images/tutorial/pieces_fr.jpg",
    "/images/tutorial/collectibles.jpg": "/images/tutorial/collectibles_fr.jpg",
    "/images/tutorial/share.jpg": "/images/tutorial/share_fr.jpg",
    "Thanks for playing!": "MERCI DE VOTRE PARTICIPATION!",
    "Winners will be announced in April 2019.": `LES GAGNANTS SERONT ANNONC${EacuteUni}S EN AVRIL 2019.`,
    "Follow Snap-on Tools on Facebook": "Suivez Outils Snap-on sur Facebook",
    "Total<small>Entries</small>": "<small>BULLETINS</small>AU TOTAL",
    "Scan QR or enter code": "Balayez le code QR ou entrez le code",
    "/images/garage-banner.jpg": "/images/garage-banner-fr.jpg",
    "Success valid code": `VOUS AVEZ R${EacuteUni}USSI!`,
    "Success": `VOUS AVEZ R${EacuteUni}USSI!`,
    "Congratulations": `F${EacuteUni}LICITATIONS!`,
    "You&apos;VE COMPLETED A CAR": `VOUS AVEZ TERMIN${EacuteUni} UNE VOITURE`,
    "/videos/video.mp4": "/videos/video-fr.mp4",
    "/images/footer-banner.png": "/images/footer-banner-fr.png",
    "/images/footer-banner-mobile.png": "/images/footer-banner-mobile-fr.png",
    "/images/game_over_en.png": "/images/game_over_fr.png",
    //----------------
    "9 GRAND PRIZE WINNERS": "9 GAGNANTS DU GRAND PRIX",
    "ENTER BY: Feb 12 / Mar 19 / Apr 23": `PARTICIPEZ D'ICI LE : 12 F${EacuteUni}VRIER/19 MARS/23 AVRIL`,
    "THE GRAND PRIZE PACKAGE INCLUDES:": "LE GRAND PRIX COMPREND :",
    "<strong>Corvette&reg; c8</strong> performance driving school at Spring Mountain Motor Resort": `<strong>CORVETTE C8</strong>, dans une ${eacuteUni}cole de conduite haute performance ${agraveUni} Spring Mountain Motor Resort PLUS`,
    "<strong>Drift</strong> experience in a smokin&apos;-hot drift car": `<strong>EXP${EacuteUni}RIENCE ULTIME</strong> au volant d'une voiture de haute performance`,
    "<strong>Off-road Course</strong> in a trophy truck": `<strong>PARCOURS HORS ROUTE</strong> au volant d'un camion prim${eacuteUni}`,
    "Enter Code": "ENTRER LE CODE",
    "Total Entries": "BULLETINS AU TOTAL",
    "days left to complete entries": "JOURS RESTANTS POUR PARTICIPER",
    "Every completed car earns an entry": `UN BULLETIN DE PARTICIPATION POUR CHAQUE VOITURE COMPL${EgraveUni}TE`,
    "Enter by:": "PARTICIPEZ D'ICI LE:",
    "Feb 12": `12 F${EacuteUni}VRIER`,
    "Mar 19": "19 MARS",
    "Apr 23": "23 AVRIL",
    "Success!": `R${EacuteUni}USSI!`,
    "You win 1 entry!": "VOUS REMPORTEZ 1 BULLETIN DE PARTICIPATION",
    "Car Completed": `VOITURE COMPL${EgraveUni}TE`,
    "Send me Snap-on game updates, newsletters and promotions.": `ENVOYEZ-MOI DES MISES ${AgraveUni} JOUR SUR LE CONCOURS, DES BULLETINS ${EacuteUni}LECTRONIQUES ET DES PROMOTIONS.`,
    "Forgot Password": `J'AI OUBLI${EacuteUni} MON MOT DE PASSE`,
    "Survey Complete!<br/>Way to score another entry!": "Sondage termin&eacute;!<br />En route vers une autre carte de participation",
    "Tired of typing? Scan the QR code with your smart phone camera!": `Fatigu${eacuteUni} de taper? Balayez le code QR avec la cam${eacuteUni}ra de votre t${eacuteUni}l${eacuteUni}phone intelligent!`,
    "WE HOPE YOU<br />REACHED THE PODIUM": `NOUS ESP${EacuteUni}RONS QUE<br />VOUS AVEZ ATTEINT LE PODIUM`,
    "Dream Drive III has ended, and we&apos;re loading up the trailers and planning for next year&apos;s promotion. Thank you for playing, and be sure to follow Snap-on Tools on Facebook and Instagram.": `La promotion Dream Drive II est termin${eacuteUni}e et nous nous affairons ${agraveUni} remplir les remorques et a planifi${eacuteUni} la promotion de l'an prochain. Merci d'avoir particip${eacuteUni}, et ne manquez pas de suivre Outils Snap-on sur Facebook et Instagram.`,
    "<small>In this race,</small>Every day is qualifying": "<small>DANS CETTE COURSE,</small> CHAQUE JOUR EST UNE",
    "<small>Welcome</small>": "<small>BIENVENUE</small>",
    "Your Total Laps": "Total de vos tours",
    "Congratulations!": `F${EacuteUni}LICITATIONS!`,
    "You've gained": `Vous avez remport${eacuteUni}`,
    "Lap": "TOUR",
    "Laps": "TOURS",
    "Go": "PARTEZ",
    "PRIZE PACKAGE INCLUDES:": "PRIX OFFERTS:",
    "<strong>Five winners and their guests</strong> will be Snap-on VIPs at the 2023 Indy 500<sup>&reg;</sup>": `<strong>CINQ GAGNANTS ET LEUR INVIT${EacuteUni}</strong> seront des VIP de Snap-on au Indy 500<sup>&reg;</sup> 2023.`,
    "<strong>Ten winners and their guests</strong> will attend the Ultimate Go-Fast Experience at Spring Mountain Motor Resort": `<strong>DIX GAGNANTS ET LEUR INVIT${EacuteUni}</strong> remportent l'exp${eacuteUni}rience ultime « Go-Fast » au Spring Mountain Motor Resort`,
    "You entered the mystery code!": `Vous avez entr${eacuteUni} le code myst${egraveUni}re!`,
    "Check back the week of": `V${eacuteUni}rifiez la semaine du`,
    "to pick your driver. If you pick right, you'll gain an additional lap when they win.": `pour s${eacuteUni}lectionner votre pilote. Si vous s${eacuteUni}lectionnez le pilote gagnant, vous remportez un tour suppl${eacuteUni}mentaire.`,
    "Don't be left at the starting line.": `Ne restez pas sur la ligne de d${eacuteUni}part.`,
    "Pick your winning driver for this week's race.": `S${eacuteUni}lectionnez votre pilote gagnant de la course de cette semaine.`,
    "You've selected": `Vous avez s${eacuteUni}lectionn${eacuteUni} `,
    "for this week's race. It's time to start chilling the champagne.": "pour la course de cette semaine. Il est temps de mettre le champagne au frais.",
    "Take the survey,": `R${EacuteUni}PONDEZ AU SONDAGE,`,
    "Gain a Lap": "REMPORTEZ UN TOUR",
    "Congratulations!": `F${EacuteUni}LICITATIONS!`,
    "You've Gained": `Vous avez remport${eacuteUni}`,
    "Win Extra Laps!": `REMPORTEZ DES TOURS SUPPL${EacuteUni}MENTAIRES!`,
    "Pick the Winning Driver": `S${eacuteUni}lectionnez le pilote gagnant`,
    "Pick a driver for the upcoming race. Whether it's the points leader or your gut for a dark horse, you'll gain an extra lap if they win!": `S${eacuteUni}lectionnez un pilote pour la prochaine course.  Que ce soit le pilote ayant le plus de points ou celui qui vous inspire, sa victoire vous permettra de remporter un tour suppl${eacuteUni}mentaire!`,
    "Select": `S${EacuteUni}LECTIONNER`,
    "Checkered flag": "DRAPEAU EN DAMIERS",
    "Enter by April 22": "PARTICIPEZ D'ICI LE 22 AVRIL",
    "Find out who wins the Snap-on Custom Racing Helmet. Maybe you'll be swigging the champagne (or cold milk, of course).": `D${eacuteUni}couvrez qui gagne le casque de course Snap-on personnalis${eacuteUni}. Vous sabrerez peut-${ecircUni}tre le champagne (ou du lait frais).`,
    "Off the line": `LA LIGNE DE D${EacuteUni}PART`,
    "Go! Go! Go! All laps gained during this period enter you to win the INDY 500 Experience and Ultimate Go-Fast Experience at Spring Mountain Motor Resort.": `Allez! Allez! Allez! Tous les tours accumul${eacuteUni}s pendant cette p${eacuteUni}riode vous donnent la chance de remporter l'exp${eacuteUni}rience INDY 500 et l'exp${eacuteUni}rience du CFS 500 ultime « Go-Fast » au Spring Mountain Motor Resort.`,
    "WIDE OPEN": "VITESSE MAXIMALE",
    "Keep the momentum going. All laps gained during this period enter you to win the Ultimate Go-Fast Experience at Spring Mountain Motor Resort.": `Ne perdez pas le rythme. Tous les tours accumul${eacuteUni}s pendant cette p${eacuteUni}riode vous donnent la chance de remporter l'exp${eacuteUni}rience ultime « Go-Fast » au Spring Mountain Motor Resort.`,
    "FASTEST LAP": "TOUR LE PLUS RAPIDE",
    "ENTER BY MARCH 18": "PARTICIPEZ D'ICI LE 18 MARS",
    "Keep the pedal to the metal and find out who gets the Snap-on SubStation Power Cart.": `Ne relâchez pas l'acc${eacuteUni}l${eacuteUni}rateur et d${eacuteUni}couvrez qui remporte le chariot de recharge Snap-on.`,
    "Pit stop": `ARR${EcircUni}T AU PUITS`,
    "ENTER BY FEBRUARY 11": `PARTICIPEZ D'ICI LE 11 F${EacuteUni}VRIER`,
    "Fuel up and find out who gets the Neon Sign!": `Faites le plein et d${eacuteUni}couvrez qui remporte l'affiche n${eacuteUni}on!`,
    "No entry found matching this code": `Aucun bulletin n'a ${eacuteUni}t${eacuteUni} trouv${eacuteUni} pour ce code.`,
    "Email is already taken.": `Cette adresse de courriel est d${eacuteUni}j${agraveUni} utilis${eacuteUni}e.`,
    "Email is already taken. Click <a href=\"#/forgot_password\">here</a> to reset password.": `Cette adresse de courriel est d${eacuteUni}j${agraveUni} utilis${eacuteUni}e. <a href=\"#/forgot_password\">Cliquez ici pour r${eacuteUni}initialiser le mot de passe.</a>`,
    "Account exists, please <a href=\"#/login\">login</a> or <a href=\"#/forgot_password\">reset password</a>": `Le compte existe d${eacuteUni}j${agraveUni}. <a href=\"#/login\">Veuillez ouvrir une session</a> ou <a href=\"#/forgot_password\">r${eacuteUni}initialiser votre mot de passe.</a>`,
    "Share your win!": "Partagez votre victoire!",
    "super-speedway-share.png": "super-speedway-share-fr.png",
    "/images/contests/phase-1.png": "/images/contests/phase-1.fr.png",
    "/images/contests/phase-2.png": "/images/contests/phase-2.fr.png",
    "/images/contests/phase-3.png": "/images/contests/phase-3.fr.png",
    "/images/contests/phase-4.png": "/images/contests/phase-4.fr.png",
    "<strong>Indy Meet</strong> &amp;<br /> <strong>Compete Adventure</strong>": "<strong>LA FOLLE</strong><br /><strong>AVENTURE INDY</strong>",
    "WINNERS AT EVERY TURN &ndash; INCLUDING 12 GRAND PRIZES": `DES GAGNANTS ${AgraveUni} CHAQUE TOUR &ndash; Y COMPRIS 12 GRANDS PRIX`,
    "Watch the video to learn more": `Visionnez la vid${eacuteUni}o pour obtenir un compl${eacuteUni}ment d'information`,
    "January": "JANVIER",
    "Qualifying": "QUALIFICATION",
    "February": `F${EacuteUni}VRIER`,
    "Green Flag": "DRAPEAU VERT",
    "March": "MARS",
    "Flat Out": "TOUT DONNER",
    "April": "AVRIL",
    "Final Sprint": "SPRINT FINAL",
    "There are over 1,100 total prizes. So enter early and often through April, and rack up those laps!": "Plus de 1 100 prix — participez tôt et souvent, et accumulez les tours!",
    "Upcoming Phases": "PHASES SUIVANTES",
    "snapon.com": "snapon.com",
    "GO": "ALLER",
    "Welcome": "BIENVENUE",
    "to pick your driver for a chance to gain additional laps!": `pour s${eacuteUni}lectionner votre pilote et courir la chance de remporter des tours suppl${eacuteUni}mentaires.`,
    "Pedal to the Metal": "PLEINS GAZ",
    "Welcome to the team": `BIENVENUE DANS L'${EacuteUni}QUIPE`,
    "Pit boss bonus": "PRIME AU PUITS",
    "Hit the nitrous": `ACC${EacuteUni}L${EacuteUni}RATION MAXIMALE`,
    "Reset": `R${EacuteUni}INITIALISER`,
    "Password Reset Sent!": `Le mot de passe a ${eacuteUni}t${eacuteUni} r${eacuteUni}initialis${eacuteUni}!`,
    'Snap-on Logo': "Logo Snap-on",
    'Win a VIP trip': "Gagnez un voyage",
    'Your total laps:': "VOTRE TOTAL DE TOURS:",
    'Five grand prize winners will receive': "CINQ GAGNANTS DU GRAND PRIX REMPORTENT",
    'Airfare': `Transport a${eacuteUni}rien`,
    'Hotel': `H${eacuteUni}bergement`,
    'Meals': "Repas",
    'Transportation': "Transport",
    'Event Tickets': `Billets pour l'${eacuteUni}v${eacuteUni}nement`,
    'VIP Pass to the Snap-on Hospitality Suite for the entire weekend': "Passe VIP pour l'Hospitality Suite de Snap-on pendant tout le week-end",
    'To Honda Indy Toronto': "AU HONDA INDY TORONTO",
    'July 14 - 16, 2023': "14 AU 16 JUILLET 2023"
  }
};

},{}],56:[function(require,module,exports){
var Contest, PromiseBaseModel;

PromiseBaseModel = require("./promise.base.model");

module.exports = Contest = (function() {
  class Contest extends PromiseBaseModel {
    //END observables
    isGlobalType() {
      return this.get('type') === Contest.GLOBAL_TYPE;
    }

    isFPTType() {
      return this.get('type') === Contest.FPT_TYPE;
    }

    isFranchiseeType() {
      return this.get('type') === Contest.FRANCHISEE_TYPE;
    }

    expand(data) {
      var JSONApiExpander;
      JSONApiExpander = require("../jsonapi_expander");
      return new JSONApiExpander(data).attributes(Contest.prototype.attributes);
    }

    //END expand
    hasEnded() {
      var m;
      m = moment.utc(this.get('end_date'));
      if (!m.isValid()) {
        return false;
      }
      return m.isBefore(moment.utc());
    }

  };

  Contest.prototype.endpoint = 'contests';

  Contest.prototype.type = 'contests';

  Contest.prototype.label = 'Contest';

  Contest.STATUSES = [Contest.NOT_STARTED_STATUS = "not_started", Contest.STARTED_STATUS = "started", Contest.COMPLETED_STATUS = "completed"];

  Contest.TYPES = [Contest.GLOBAL_TYPE = "global", Contest.FPT_TYPE = "fpt", Contest.FRANCHISEE_TYPE = "franchisee"];

  Contest.prototype.attributes = ['id', 'name', 'type', 'code', 'status', 'winners_count', 'start_date', 'end_date', 'created_at', 'updated_at'];

  Contest.prototype.observables = {
    'id': void 0,
    'name': void 0,
    'code': void 0,
    'type': Contest.GLOBAL_TYPE,
    'status': Contest.NOT_STARTED_STATUS,
    'start_date': void 0,
    'end_date': void 0,
    'winners_count': void 0,
    'created_at': void 0,
    'updated_at': void 0
  };

  return Contest;

}).call(this);

//enD hasEnded
//END Contest

},{"../jsonapi_expander":87,"./promise.base.model":69}],57:[function(require,module,exports){
var ContestFinalist, Helpers, PromiseBaseModel;

PromiseBaseModel = require("./promise.base.model");

Helpers = require("../$helpers/default.helpers");

module.exports = ContestFinalist = (function() {
  class ContestFinalist extends PromiseBaseModel {
    //END observables
    expand(data) {
      var Contest, Entry, FPT, Franchisee, FranchiseeContestStatistic, JSONApiExpander, User, UserContestStatistic;
      JSONApiExpander = require("../jsonapi_expander");
      Entry = require("./entry.model");
      Contest = require("./contest.model");
      User = require("./user.model");
      FPT = require("./fpt.model");
      Franchisee = require("./franchisee.model");
      FranchiseeContestStatistic = require("./franchisee_contest_statistic.model");
      UserContestStatistic = require("./user_contest_statistic.model");
      return new JSONApiExpander(data).relation('entry').attributes(Entry.prototype.attributes).done().relation('contest').attributes(Contest.prototype.attributes).done().relation('redeemer').attributes(User.prototype.attributes).done().relation('fpt').attributes(FPT.prototype.attributes).done().relation('franchisee').attributes(Franchisee.prototype.attributes).done().relation('franchisee_contest_statistic').attributes(FranchiseeContestStatistic.prototype.attributes).done().relation('user_contest_statistic').attributes(UserContestStatistic.prototype.attributes).done().attributes(ContestFinalist.prototype.attributes);
    }

  };

  ContestFinalist.prototype.endpoint = 'contest_finalists';

  ContestFinalist.prototype.type = 'contest_finalists';

  ContestFinalist.prototype.label = 'Contest Finalist';

  ContestFinalist.prototype.attributes = ['id', 'rank', 'contest_id', 'entry_id', 'franchisee_id', 'fpt_id', 'created_at', 'updated_at'];

  ContestFinalist.prototype.defaults = {
    'contest': function() {
      var Contest;
      Contest = require("./contest.model");
      return new Contest();
    },
    'redeemer': function() {
      var User;
      User = require("./user.model");
      return new User();
    },
    'fpt': function() {
      var FPT;
      FPT = require("./fpt.model");
      return new FPT();
    },
    'franchisee': function() {
      var Franchisee;
      Franchisee = require("./franchisee.model");
      return new Franchisee();
    },
    'entry': function() {
      var Entry;
      Entry = require("./entry.model");
      return new Entry();
    },
    'franchisee_contest_statistic': function() {
      var FranchiseeContestStatistic;
      FranchiseeContestStatistic = require("./franchisee_contest_statistic.model");
      return new FranchiseeContestStatistic();
    },
    'user_contest_statistic': function() {
      var UserContestStatistic;
      UserContestStatistic = require("./user_contest_statistic.model");
      return new UserContestStatistic();
    }
  };

  //END defaults
  ContestFinalist.prototype.observables = {
    'id': void 0,
    'rank': void 0,
    'entry_id': void 0,
    'contest_id': void 0,
    'franchisee_id': void 0,
    'fpt_id': void 0,
    'created_at': "",
    'updated_at': ""
  };

  return ContestFinalist;

}).call(this);

//END expand
//END ContestFinalist

},{"../$helpers/default.helpers":50,"../jsonapi_expander":87,"./contest.model":56,"./entry.model":59,"./fpt.model":60,"./franchisee.model":63,"./franchisee_contest_statistic.model":64,"./promise.base.model":69,"./user.model":81,"./user_contest_statistic.model":82}],58:[function(require,module,exports){
var ContestWinner, Helpers, PromiseBaseModel;

PromiseBaseModel = require("./promise.base.model");

Helpers = require("../$helpers/default.helpers");

module.exports = ContestWinner = (function() {
  class ContestWinner extends PromiseBaseModel {
    //END observables
    hasWinner() {
      if (Helpers.isUUID(this.get('entry_id'))) {
        return true;
      }
      if (Helpers.trim((this.get('winner_name') || "").toString()).length > 0) {
        return true;
      }
      return false;
    }

    //END hasWinner
    expand(data) {
      var Contest, FPT, Franchisee, JSONApiExpander, User;
      JSONApiExpander = require("../jsonapi_expander");
      Contest = require("./contest.model");
      User = require("./user.model");
      FPT = require("./fpt.model");
      Franchisee = require("./franchisee.model");
      return new JSONApiExpander(data).relation('contest').attributes(Contest.prototype.attributes).done().relation('redeemer').attributes(User.prototype.attributes).done().relation('fpt').attributes(FPT.prototype.attributes).done().relation('franchisee').attributes(Franchisee.prototype.attributes).done().attributes(ContestWinner.prototype.attributes);
    }

  };

  ContestWinner.prototype.endpoint = 'contest_winners';

  ContestWinner.prototype.type = 'contest_winners';

  ContestWinner.prototype.label = 'Contest Winner';

  ContestWinner.prototype.attributes = ['id', 'contest_id', 'entry_id', 'franchisee_id', 'fpt_id', 'winner_name', 'created_at', 'updated_at'];

  ContestWinner.prototype.defaults = {
    'contest': function() {
      var Contest;
      Contest = require("./contest.model");
      return new Contest();
    },
    'redeemer': function() {
      var User;
      User = require("./user.model");
      return new User();
    },
    'fpt': function() {
      var FPT;
      FPT = require("./fpt.model");
      return new FPT();
    },
    'franchisee': function() {
      var Franchisee;
      Franchisee = require("./franchisee.model");
      return new Franchisee();
    }
  };

  //END defaults
  ContestWinner.prototype.observables = {
    'id': void 0,
    'entry_id': void 0,
    'contest_id': void 0,
    'franchisee_id': void 0,
    'fpt_id': void 0,
    'winner_name': void 0,
    'created_at': "",
    'updated_at': ""
  };

  return ContestWinner;

}).call(this);

//END expand
//END ContestWinner

},{"../$helpers/default.helpers":50,"../jsonapi_expander":87,"./contest.model":56,"./fpt.model":60,"./franchisee.model":63,"./promise.base.model":69,"./user.model":81}],59:[function(require,module,exports){
var Entry, PromiseBaseModel;

PromiseBaseModel = require("./promise.base.model");

module.exports = Entry = (function() {
  class Entry extends PromiseBaseModel {
    //END observables
    expand(data) {
      var Contest, Contests, FPT, Franchisee, JSONApiExpander, Region, User;
      JSONApiExpander = require("../jsonapi_expander");
      Franchisee = require("./franchisee.model");
      FPT = require("./fpt.model");
      Region = require("./region.model");
      User = require("./user.model");
      Contest = require("./contest.model");
      Contests = require("../$collections/contests.collection");
      return new JSONApiExpander(data).relation('redeemer').attributes(User.prototype.attributes).done().relation('franchisee').attributes(Franchisee.prototype.attributes).done().relation('fpt').attributes(FPT.prototype.attributes).done().relation('region').attributes(Region.prototype.attributes).done().relation('contests').attributes(Contest.prototype.attributes).done().relation('virtual_entries').attributes(Entry.prototype.attributes).done().attributes(Entry.prototype.attributes);
    }

    //END expand
    static isValidCode(code) {
      if (!_.isString(code)) {
        return false;
      }
      return /^[a-z]{12}$/i.test(code);
    }

  };

  Entry.prototype.endpoint = 'entries';

  Entry.prototype.type = 'entries';

  Entry.prototype.label = 'Entry';

  Entry.prototype.attributes = ['id', 'code', 'bonus_entries', 'redeemer_id', 'redeemed_at', 'created_at', 'updated_at'];

  Entry.prototype.defaults = {
    'redeemer': function() {
      var User;
      User = require("./user.model");
      return new User();
    },
    'franchisee': function() {
      var Franchisee;
      Franchisee = require("./franchisee.model");
      return new Franchisee();
    },
    'fpt': function() {
      var FPT;
      FPT = require("./fpt.model");
      return new FPT();
    },
    'region': function() {
      var Region;
      Region = require("./region.model");
      return new Region();
    },
    'contests': function() {
      var Contests;
      Contests = require("../$collections/contests.collection");
      return new Contests();
    },
    'virtual_entries': function() {
      var Entries;
      Entries = require("../$collections/entries.collection");
      return new Entries();
    }
  };

  //END defaults
  Entry.prototype.observables = {
    'id': void 0,
    'code': void 0,
    'bonus_entries': void 0,
    'redeemer_id': void 0,
    'redeemed_at': void 0,
    'created_at': void 0,
    'updated_at': void 0
  };

  return Entry;

}).call(this);

//END isValidCode
//END Entry

},{"../$collections/contests.collection":26,"../$collections/entries.collection":27,"../jsonapi_expander":87,"./contest.model":56,"./fpt.model":60,"./franchisee.model":63,"./promise.base.model":69,"./region.model":74,"./user.model":81}],60:[function(require,module,exports){
var FPT, PromiseBaseModel;

PromiseBaseModel = require("./promise.base.model");

module.exports = FPT = (function() {
  class FPT extends PromiseBaseModel {
    //END average_entries_per_participant
    //END observables
    hasOwner() {
      return Helpers.isUUID(this.get('owner_id'));
    }

    expand(data) {
      var FPTContestStatistic, FPTContestStatistics, FPTStatistic, FPTStatistics, JSONApiExpander, Region, RegionContestStatistic, RegionStatistic, User;
      JSONApiExpander = require("../jsonapi_expander");
      User = require("./user.model");
      Region = require("./region.model");
      FPTStatistic = require("./fpt_statistic.model");
      FPTStatistics = require("../$collections/fpt_statistics.collection");
      FPTContestStatistic = require("./fpt_contest_statistic.model");
      FPTContestStatistics = require("../$collections/fpt_contest_statistics.collection");
      RegionStatistic = require("./region_statistic.model");
      RegionContestStatistic = require("./region_contest_statistic.model");
      return new JSONApiExpander(data).relation('owner').attributes(User.prototype.attributes).done().relation('region').attributes(Region.prototype.attributes).relation('statistics').attributes(RegionStatistic.prototype.attributes).done().relation('contest_statistics').attributes(RegionContestStatistic.prototype.attributes).done().done().relation('statistics').attributes(FPTStatistic.prototype.attributes).done().relation('contest_statistics').attributes(FPTContestStatistic.prototype.attributes).done().attributes(FPT.prototype.attributes);
    }

  };

  FPT.prototype.endpoint = 'fpts';

  FPT.prototype.type = 'fpts';

  FPT.prototype.label = 'FPT';

  FPT.prototype.attributes = ['id', 'name', 'email', 'owner_id', 'region_id', 'snapon_sso_id', 'created_at', 'updated_at'];

  FPT.prototype.defaults = {
    'owner': function() {
      var User;
      User = require("./user.model");
      return new User();
    },
    'region': function() {
      var Region;
      Region = require("./region.model");
      return new Region();
    },
    'statistics': function() {
      var FPTStatistics;
      FPTStatistics = require("../$collections/fpt_statistics.collection");
      return new FPTStatistics();
    },
    'contest_statistics': function() {
      var FPTContestStatistics;
      FPTContestStatistics = require("../$collections/fpt_contest_statistics.collection");
      return new FPTContestStatistics();
    }
  };

  //END defaults
  FPT.prototype.observables = {
    'id': void 0,
    'name': void 0,
    'email': void 0,
    'owner_id': void 0,
    'region_id': void 0,
    'snapon_sso_id': void 0,
    'created_at': void 0,
    'updated_at': void 0,
    'average_entries_per_participant': function() {
      var participant_count, redeemed_entry_count;
      participant_count = this.get('participant_count') || 0;
      if (!(participant_count > 0)) {
        return 0;
      }
      redeemed_entry_count = this.get('redeemed_entry_count') || 0;
      return redeemed_entry_count / participant_count;
    }
  };

  return FPT;

}).call(this);

//END expand
//END GameKit

},{"../$collections/fpt_contest_statistics.collection":28,"../$collections/fpt_statistics.collection":29,"../jsonapi_expander":87,"./fpt_contest_statistic.model":61,"./fpt_statistic.model":62,"./promise.base.model":69,"./region.model":74,"./region_contest_statistic.model":75,"./region_statistic.model":76,"./user.model":81}],61:[function(require,module,exports){
var FPTContestStatistic, PromiseBaseModel;

PromiseBaseModel = require("./promise.base.model");

module.exports = FPTContestStatistic = (function() {
  class FPTContestStatistic extends PromiseBaseModel {
    //END average_entries_per_participant
    //END observables
    expand(data) {
      var Contest, JSONApiExpander;
      JSONApiExpander = require("../jsonapi_expander");
      Contest = require("./contest.model");
      return new JSONApiExpander(data).attributes(FPTContestStatistic.prototype.attributes).relation('contest').attributes(Contest.prototype.attributes).done();
    }

  };

  FPTContestStatistic.prototype.endpoint = 'fpt_contest_statistics';

  FPTContestStatistic.prototype.type = 'fpt_contest_statistics';

  FPTContestStatistic.prototype.label = 'FPT Contest Statistics';

  FPTContestStatistic.prototype.attributes = ['fpt_id', 'contest_id', 'entry_count', 'virtual_entry_count', 'redeemed_entry_count', 'redeemed_virtual_entry_count', 'participant_count', 'game_kit_count', 'registered_franchisee_count'];

  FPTContestStatistic.prototype.defaults = {
    'fpt_id': void 0,
    'contest_id': void 0
  };

  //END defaults
  FPTContestStatistic.prototype.observables = {
    'entry_count': 0,
    'virtual_entry_count': 0,
    'redeemed_entry_count': 0,
    'redeemed_virtual_entry_count': 0,
    'participant_count': 0,
    'game_kit_count': 0,
    'registered_franchisee_count': 0,
    'average_entries_per_participant': function() {
      var participant_count, redeemed_entry_count;
      participant_count = this.get('participant_count') || 0;
      if (!(participant_count > 0)) {
        return 0;
      }
      redeemed_entry_count = this.get('redeemed_entry_count') || 0;
      return redeemed_entry_count / participant_count;
    }
  };

  return FPTContestStatistic;

}).call(this);

//END expand
//END FPTContestStatistic

},{"../jsonapi_expander":87,"./contest.model":56,"./promise.base.model":69}],62:[function(require,module,exports){
var FPTStatistic, PromiseBaseModel;

PromiseBaseModel = require("./promise.base.model");

module.exports = FPTStatistic = (function() {
  class FPTStatistic extends PromiseBaseModel {
    //END average_entries_per_participant
    //END observables
    expand(data) {
      var JSONApiExpander;
      JSONApiExpander = require("../jsonapi_expander");
      return new JSONApiExpander(data).attributes(FPTStatistic.prototype.attributes);
    }

  };

  FPTStatistic.prototype.endpoint = 'fpt_statistics';

  FPTStatistic.prototype.type = 'fpt_statistics';

  FPTStatistic.prototype.label = 'FPT Statistics';

  FPTStatistic.prototype.attributes = ['fpt_id', 'entry_count', 'virtual_entry_count', 'redeemed_entry_count', 'redeemed_virtual_entry_count', 'participant_count', 'game_kit_count', 'registered_franchisee_count', "survey_response_count", 'regional_acquisition_percentage'];

  FPTStatistic.prototype.defaults = {
    'fpt_id': void 0
  };

  //END defaults
  FPTStatistic.prototype.observables = {
    'entry_count': 0,
    'virtual_entry_count': 0,
    'redeemed_entry_count': 0,
    'redeemed_virtual_entry_count': 0,
    'participant_count': 0,
    'game_kit_count': 0,
    'registered_franchisee_count': 0,
    "survey_response_count": 0,
    "regional_acquisition_percentage": 0,
    'average_entries_per_participant': function() {
      var participant_count, redeemed_entry_count;
      participant_count = this.get('participant_count') || 0;
      if (!(participant_count > 0)) {
        return 0;
      }
      redeemed_entry_count = this.get('redeemed_entry_count') || 0;
      return redeemed_entry_count / participant_count;
    }
  };

  return FPTStatistic;

}).call(this);

//END expand
//END FPTStatistic

},{"../jsonapi_expander":87,"./promise.base.model":69}],63:[function(require,module,exports){
var Franchisee, PromiseBaseModel;

PromiseBaseModel = require("./promise.base.model");

module.exports = Franchisee = (function() {
  class Franchisee extends PromiseBaseModel {
    //END average_entries_per_participant
    //END observables
    hasOwner() {
      return Helpers.isUUID(this.get('owner_id'));
    }

    hasFPT() {
      return Helpers.isUUID(this.get('fpt_id'));
    }

    expand(data) {
      var FPT, FranchiseeContestStatistic, FranchiseeContestStatistics, FranchiseeStatistic, FranchiseeStatistics, JSONApiExpander, Region, User, Users;
      JSONApiExpander = require("../jsonapi_expander");
      FPT = require("./fpt.model");
      Region = require("./region.model");
      FranchiseeStatistic = require("./franchisee_statistic.model");
      FranchiseeStatistics = require("../$collections/franchisee_statistics.collection");
      FranchiseeContestStatistic = require("./franchisee_contest_statistic.model");
      FranchiseeContestStatistics = require("../$collections/franchisee_contest_statistics.collection");
      User = require("./user.model");
      Users = require("../$collections/users.collection");
      return new JSONApiExpander(data).relation('fpt').attributes(FPT.prototype.attributes).done().relation('region').attributes(Region.prototype.attributes).done().relation('owner').attributes(User.prototype.attributes).done().relation('users').attributes(User.prototype.attributes).done().relation('statistics').attributes(FranchiseeStatistic.prototype.attributes).done().relation('contest_statistics').attributes(FranchiseeContestStatistic.prototype.attributes).done().attributes(Franchisee.prototype.attributes);
    }

  };

  Franchisee.prototype.endpoint = 'franchisees';

  Franchisee.prototype.type = 'franchisees';

  Franchisee.prototype.label = 'Franchisee';

  Franchisee.prototype.attributes = ['id', 'name', 'email', 'address_1', 'address_2', 'city', 'state', 'country', 'zip_code', 'phone_number', 'bp_number', 'locale', 'snapon_sso_id', 'owner_id', 'fpt_id', 'created_at', 'updated_at'];

  Franchisee.prototype.defaults = {
    'fpt': function() {
      var FPT;
      FPT = require("./fpt.model");
      return new FPT();
    },
    'region': function() {
      var Region;
      Region = require("./region.model");
      return new Region();
    },
    'owner': function() {
      var User;
      User = require("./user.model");
      return new User();
    },
    'users': function() {
      var Users;
      Users = require("../$collections/users.collection");
      return new Users();
    },
    'statistics': function() {
      var FranchiseeStatistics;
      FranchiseeStatistics = require("../$collections/franchisee_statistics.collection");
      return new FranchiseeStatistics();
    },
    'contest_statistics': function() {
      var FranchiseeContestStatistics;
      FranchiseeContestStatistics = require("../$collections/franchisee_contest_statistics.collection");
      return new FranchiseeContestStatistics();
    },
    'franchisee_settings': function() {
      var FranchiseeSettings;
      FranchiseeSettings = require("../$collections/franchisee_settings.collection");
      return new FranchiseeSettings();
    }
  };

  //END defaults
  Franchisee.prototype.observables = {
    'id': void 0,
    'name': void 0,
    'email': void 0,
    'address_1': void 0,
    'address_2': void 0,
    'city': void 0,
    'state': void 0,
    'country': void 0,
    'zip_code': void 0,
    'phone_number': void 0,
    'bp_number': void 0,
    'owner_id': void 0,
    'fpt_id': void 0,
    'snapon_sso_id': void 0,
    'created_at': void 0,
    'updated_at': void 0,
    'locale': void 0,
    'average_entries_per_participant': function() {
      var participant_count, redeemed_entry_count;
      participant_count = this.get('participant_count') || 0;
      if (!(participant_count > 0)) {
        return 0;
      }
      redeemed_entry_count = this.get('redeemed_entry_count') || 0;
      return redeemed_entry_count / participant_count;
    }
  };

  return Franchisee;

}).call(this);

//END expand
//END Franchisee

},{"../$collections/franchisee_contest_statistics.collection":31,"../$collections/franchisee_settings.collection":32,"../$collections/franchisee_statistics.collection":33,"../$collections/users.collection":47,"../jsonapi_expander":87,"./fpt.model":60,"./franchisee_contest_statistic.model":64,"./franchisee_statistic.model":66,"./promise.base.model":69,"./region.model":74,"./user.model":81}],64:[function(require,module,exports){
var FranchiseeContestStatistic, PromiseBaseModel;

PromiseBaseModel = require("./promise.base.model");

module.exports = FranchiseeContestStatistic = (function() {
  class FranchiseeContestStatistic extends PromiseBaseModel {
    //END average_entries_per_participant
    //END observables
    expand(data) {
      var Contest, JSONApiExpander;
      JSONApiExpander = require("../jsonapi_expander");
      Contest = require("./contest.model");
      return new JSONApiExpander(data).attributes(FranchiseeContestStatistic.prototype.attributes).relation('contest').attributes(Contest.prototype.attributes).done();
    }

  };

  FranchiseeContestStatistic.prototype.endpoint = 'franchisee_contest_statistics';

  FranchiseeContestStatistic.prototype.type = 'franchisee_contest_statistics';

  FranchiseeContestStatistic.prototype.label = 'Franchisee Contest Statistics';

  FranchiseeContestStatistic.prototype.attributes = ['franchisee_id', 'contest_id', 'entry_count', 'virtual_entry_count', 'redeemed_entry_count', 'redeemed_virtual_entry_count', 'participant_count', 'game_kit_count'];

  FranchiseeContestStatistic.prototype.defaults = {
    'franchisee_id': void 0,
    'contest_id': void 0
  };

  //END defaults
  FranchiseeContestStatistic.prototype.observables = {
    'entry_count': 0,
    'virtual_entry_count': 0,
    'redeemed_entry_count': 0,
    'redeemed_virtual_entry_count': 0,
    'participant_count': 0,
    'game_kit_count': 0,
    'average_entries_per_participant': function() {
      var participant_count, redeemed_entry_count;
      participant_count = this.get('participant_count') || 0;
      if (!(participant_count > 0)) {
        return 0;
      }
      redeemed_entry_count = this.get('redeemed_entry_count') || 0;
      return redeemed_entry_count / participant_count;
    }
  };

  return FranchiseeContestStatistic;

}).call(this);

//END expand
//END FranchiseeContestStatistic

},{"../jsonapi_expander":87,"./contest.model":56,"./promise.base.model":69}],65:[function(require,module,exports){
var FranchiseeSetting, Helpers, PromiseBaseModel;

PromiseBaseModel = require("./promise.base.model");

Helpers = require("../$helpers/default.helpers");

module.exports = FranchiseeSetting = (function() {
  class FranchiseeSetting extends PromiseBaseModel {
    //END observables
    expand(data) {
      var Franchisee, JSONApiExpander;
      JSONApiExpander = require("../jsonapi_expander");
      Franchisee = require("./franchisee.model");
      return new JSONApiExpander(data).relation('franchisee').attributes(Franchisee.prototype.attributes).done().attributes(FranchiseeSetting.prototype.attributes);
    }

  };

  FranchiseeSetting.prototype.endpoint = 'franchisee_settings';

  FranchiseeSetting.prototype.type = 'franchisee_settings';

  FranchiseeSetting.prototype.label = 'Franchisee Setting';

  FranchiseeSetting.prototype.attributes = ['id', 'franchisee_id', 'leaderboard_length', 'created_at', 'updated_at'];

  FranchiseeSetting.prototype.defaults = {
    'franchisee': function() {
      var Franchisee;
      Franchisee = require("./franchisee.model");
      return new Franchisee();
    }
  };

  //END franchisee
  //END defaults
  FranchiseeSetting.prototype.observables = {
    'id': void 0,
    'franchisee_id': void 0,
    'leaderboard_length': void 0,
    'created_at': "",
    'updated_at': ""
  };

  return FranchiseeSetting;

}).call(this);

//END expand
//END FranchiseeSetting

},{"../$helpers/default.helpers":50,"../jsonapi_expander":87,"./franchisee.model":63,"./promise.base.model":69}],66:[function(require,module,exports){
var FranchiseeStatistic, PromiseBaseModel;

PromiseBaseModel = require("./promise.base.model");

module.exports = FranchiseeStatistic = (function() {
  class FranchiseeStatistic extends PromiseBaseModel {
    //END average_entries_per_participant
    //END observables
    expand(data) {
      var JSONApiExpander;
      JSONApiExpander = require("../jsonapi_expander");
      return new JSONApiExpander(data).attributes(FranchiseeStatistic.prototype.attributes);
    }

  };

  FranchiseeStatistic.prototype.endpoint = 'franchisee_statistics';

  FranchiseeStatistic.prototype.type = 'franchisee_statistics';

  FranchiseeStatistic.prototype.label = 'Franchisee Statistics';

  FranchiseeStatistic.prototype.attributes = ['franchisee_id', 'entry_count', 'virtual_entry_count', 'redeemed_entry_count', 'redeemed_virtual_entry_count', 'participant_count', 'game_kit_count', "survey_response_count"];

  FranchiseeStatistic.prototype.defaults = {
    'franchisee_id': void 0
  };

  //END defaults
  FranchiseeStatistic.prototype.observables = {
    'entry_count': 0,
    'virtual_entry_count': 0,
    'redeemed_entry_count': 0,
    'redeemed_virtual_entry_count': 0,
    'participant_count': 0,
    'game_kit_count': 0,
    "survey_response_count": 0,
    'average_entries_per_participant': function() {
      var participant_count, redeemed_entry_count;
      participant_count = this.get('participant_count') || 0;
      if (!(participant_count > 0)) {
        return 0;
      }
      redeemed_entry_count = this.get('redeemed_entry_count') || 0;
      return redeemed_entry_count / participant_count;
    }
  };

  return FranchiseeStatistic;

}).call(this);

//END expand
//END FranchiseeStatistic

},{"../jsonapi_expander":87,"./promise.base.model":69}],67:[function(require,module,exports){
var GameKit, PromiseBaseModel;

PromiseBaseModel = require("./promise.base.model");

module.exports = GameKit = (function() {
  class GameKit extends PromiseBaseModel {
    //END observables
    expand(data) {
      var Contest, Contests, Entries, Entry, Franchisee, JSONApiExpander, User;
      JSONApiExpander = require("../jsonapi_expander");
      Entry = require("./entry.model");
      Entries = require("../$collections/entries.collection");
      Contests = require("../$collections/contests.collection");
      Contest = require("./contest.model");
      Franchisee = require("./franchisee.model");
      User = require("./user.model");
      return new JSONApiExpander(data).relation('franchisee').attributes(Franchisee.prototype.attributes).done().relation('entries').attributes(Entry.prototype.attributes).done().relation('contests').attributes(Contest.prototype.attributes).done().relation('redeemer').attributes(User.prototype.attributes).done().attributes(GameKit.prototype.attributes);
    }

    //END expand
    static isValidCode(code) {
      if (!_.isString(code)) {
        return false;
      }
      return /^[0-9]{10}$/.test(code);
    }

  };

  GameKit.prototype.endpoint = 'game_kits';

  GameKit.prototype.type = 'game_kits';

  GameKit.prototype.label = 'Game Kit';

  GameKit.prototype.attributes = ['id', 'code', 'contest_ids', 'participant_count', 'entry_count', 'redeemed_entry_count', 'franchisee_id', 'redeemed_at', 'created_at', 'updated_at'];

  GameKit.prototype.defaults = {
    'franchisee': function() {
      var Franchisee;
      Franchisee = require("./franchisee.model");
      return new Franchisee();
    },
    'entries': function() {
      var Entries;
      Entries = require("../$collections/entries.collection");
      return new Entries();
    },
    'contests': function() {
      var Contests;
      Contests = require("../$collections/contests.collection");
      return new Contests();
    },
    'redeemer': function() {
      var User;
      User = require("./user.model");
      return new User();
    }
  };

  //END defaults
  GameKit.prototype.observables = {
    'id': void 0,
    'code': void 0,
    'entry_count': void 0,
    'redeemed_entry_count': void 0,
    'participant_count': void 0,
    'contest_ids': [],
    'franchisee_id': void 0,
    'redeemed_at': void 0,
    'created_at': void 0,
    'updated_at': void 0
  };

  return GameKit;

}).call(this);

//END isValidCode
//END GameKit

},{"../$collections/contests.collection":26,"../$collections/entries.collection":27,"../jsonapi_expander":87,"./contest.model":56,"./entry.model":59,"./franchisee.model":63,"./promise.base.model":69,"./user.model":81}],68:[function(require,module,exports){
var Invite, PromiseBaseModel;

PromiseBaseModel = require("./promise.base.model");

module.exports = Invite = (function() {
  class Invite extends PromiseBaseModel {
    //END observables
    expand(data) {
      var FPT, Franchisee, JSONApiExpander, Region;
      JSONApiExpander = require("../jsonapi_expander");
      FPT = require("./fpt.model");
      Franchisee = require("./franchisee.model");
      Region = require("./region.model");
      return new JSONApiExpander(data).relation('fpt').attributes(FPT.prototype.attributes).done().relation('franchisee').attributes(Franchisee.prototype.attributes).done().relation('region').attributes(Region.prototype.attributes).done().attributes(Invite.prototype.attributes);
    }

  };

  Invite.prototype.endpoint = "invites";

  Invite.prototype.label = "Invite";

  Invite.TYPES = [Invite.ADMIN_TYPE = "admin", Invite.REGION_TYPE = "region", Invite.FPT_TYPE = "fpt", Invite.FRANCHISEE_TYPE = "franchisee"];

  Invite.prototype.attributes = ['id', 'code', 'type', 'email', 'fpt_id', 'franchisee_id', 'region_id', 'created_at', 'updated_at'];

  Invite.prototype.defaults = {
    'fpt': function() {
      var FPT;
      FPT = require("./fpt.model");
      return new FPT();
    },
    'franchisee': function() {
      var Franchisee;
      Franchisee = require("./franchisee.model");
      return new Franchisee();
    },
    'region': function() {
      var Region;
      Region = require("./region.model");
      return new Region();
    }
  };

  //END defaults
  Invite.prototype.observables = {
    'id': void 0,
    'code': "",
    'type': Invite.ADMIN_TYPE,
    'email': "",
    'fpt_id': void 0,
    'franchisee_id': void 0,
    'region_id': void 0,
    'created_at': void 0,
    'updated_at': void 0
  };

  return Invite;

}).call(this);

//END expand
//END invite

},{"../jsonapi_expander":87,"./fpt.model":60,"./franchisee.model":63,"./promise.base.model":69,"./region.model":74}],69:[function(require,module,exports){
var PromiseBaseModel;

module.exports = PromiseBaseModel = (function() {
  class PromiseBaseModel extends Falcon.Model {
    expand() {
      throw new Error(`expand not implemented for ${this.endpoint}`);
    }

    //END expand
    makeUrl(type, parent) {
      var endpoint, parent_url;
      if (parent == null) {
        return super.makeUrl(type, parent);
      }
      parent_url = parent.makeUrl(Falcon.GET);
      endpoint = (function() {
        switch (type) {
          //TODO: Determine the appropriate ur structure for parent GET and PUT
          case Falcon.GET:
          case Falcon.PUT:
            return this.endpoint + "/" + this.get('id');
          case Falcon.POST:
            return "links/" + this.endpoint;
          case Falcon.DELETE:
            return "links/" + this.endpoint + "/" + this.get('id');
          default:
            return this.endpoint;
        }
      }).call(this);
      //END endpoint
      return parent_url + "/" + endpoint;
    }

    //END makeUrl
    serializeRequestData(type, options) {
      var data;
      data = super.serializeRequestData(type, options);
      if ((options.parent != null) && type === Falcon.POST) {
        data = [data];
      }
      return {data};
    }

    //END serializeRequestData
    promiseFetch(options) {
      return Q.Promise((resolve, reject) => {
        options = RequestHelpers.preparePromiseOptions(resolve, reject, options, `An error occurred while fetching ${this.label}`);
        return this.fetch(options);
      });
    }

    //END promiseFetch
    promiseCreate(options) {
      return Q.Promise((resolve, reject) => {
        options = RequestHelpers.preparePromiseOptions(resolve, reject, options, `An error occurred while creating ${this.label}`);
        return this.create(options);
      });
    }

    //END promiseCreate
    promiseSave(options) {
      return Q.Promise((resolve, reject) => {
        options = RequestHelpers.preparePromiseOptions(resolve, reject, options, `An error occurred while saving ${this.label}`);
        return this.save(options);
      });
    }

    //END promiseSave
    promiseDestroy(options) {
      return Q.Promise((resolve, reject) => {
        options = RequestHelpers.preparePromiseOptions(resolve, reject, options, `An error occurred while destroying ${this.label}`);
        return this.destroy(options);
      });
    }

    //END promiseDestroy
    parseResponseData(data, type, options) {
      if (type === Falcon.DELETE) {
        return {};
      }
      return this.expand(data).toObject();
    }

  };

  PromiseBaseModel.prototype.attributes = [];

  PromiseBaseModel.prototype.label = "";

  PromiseBaseModel.prototype.type = "";

  return PromiseBaseModel;

}).call(this);

//END parseResponseData
//END PromiseBaseModel

},{}],70:[function(require,module,exports){
var PromiseBaseModel, Question, count;

PromiseBaseModel = require("./promise.base.model");

count = 0;

module.exports = Question = (function() {
  class Question extends PromiseBaseModel {
    //END observables
    makeIdentifier(index) {
      var identifier;
      identifier = `question--${this.get('id')}`;
      if (index) {
        identifier += `--${ko.unwrap(index)}`;
      }
      return identifier;
    }

    //END makeIdentifier
    expand(data) {
      var JSONApiExpander;
      JSONApiExpander = require("../jsonapi_expander");
      return new JSONApiExpander(data).attributes(Question.prototype.attributes);
    }

  };

  Question.prototype.endpoint = 'questions';

  Question.prototype.type = 'questions';

  Question.prototype.label = 'Question';

  Question.TYPES = [Question.MULTIPLE_CHOICE_TYPE = "multiple-choice", Question.SINGLE_CHOICE_TYPE = "single-choice"];

  Question.prototype.attributes = ['id', 'question', 'question_fr', 'type', 'order', 'options', 'options_fr', 'survey_id', 'created_at', 'updated_at'];

  Question.prototype.observables = {
    'id': void 0,
    'question': void 0,
    'question_fr': void 0,
    'type': void 0,
    'order': void 0,
    'survey_id': void 0,
    'options': [],
    'options_fr': [],
    'created_at': void 0,
    'updated_at': void 0,
    'is_single_choice': function() {
      return this.get('type') === Question.SINGLE_CHOICE_TYPE;
    },
    'is_multiple_choice': function() {
      return this.get('type') === Question.MULTIPLE_CHOICE_TYPE;
    }
  };

  return Question;

}).call(this);

//END expand
//END Question

},{"../jsonapi_expander":87,"./promise.base.model":69}],71:[function(require,module,exports){
var PromiseBaseModel, Race;

PromiseBaseModel = require("./promise.base.model");

module.exports = Race = (function() {
  class Race extends PromiseBaseModel {
    //END observables
    expand(data) {
      var JSONApiExpander, RaceOption;
      JSONApiExpander = require("../jsonapi_expander");
      RaceOption = require("./race_option.model");
      return new JSONApiExpander(data).relation('race_options').attributes(RaceOption.prototype.attributes).done().relation('selected_race_option').attributes(RaceOption.prototype.attributes).done().attributes(Race.prototype.attributes);
    }

  };

  Race.prototype.endpoint = 'races';

  Race.prototype.type = 'races';

  Race.prototype.label = 'Race';

  Race.prototype.attributes = ['id', 'name', 'name_fr', 'selected_race_option_id', 'start_date', 'end_date', 'created_at', 'updated_at'];

  Race.prototype.defaults = {
    'race_options': function() {
      var RaceOptions;
      RaceOptions = require("../$collections/race_options.collection");
      return new RaceOptions();
    },
    //END race_options
    'selected_race_option': function() {
      var RaceOption;
      RaceOption = require("./race_option.model");
      return new RaceOption();
    }
  };

  //END selected_race_option
  //END defaults
  Race.prototype.observables = {
    'id': void 0,
    'name': void 0,
    'start_date': void 0,
    'end_date': void 0,
    'selected_race_option_id': void 0,
    'created_at': void 0,
    'updated_at': void 0
  };

  return Race;

}).call(this);

//END expand
//END Race

},{"../$collections/race_options.collection":37,"../jsonapi_expander":87,"./promise.base.model":69,"./race_option.model":72}],72:[function(require,module,exports){
var PromiseBaseModel, RaceOption, count;

PromiseBaseModel = require("./promise.base.model");

count = 0;

module.exports = RaceOption = (function() {
  class RaceOption extends PromiseBaseModel {
    //END observables
    makeIdentifier(index) {
      var identifier;
      identifier = `race-option--${this.get('id')}`;
      if (index) {
        identifier += `--${ko.unwrap(index)}`;
      }
      return identifier;
    }

    //END makeIdentifier
    expand(data) {
      var JSONApiExpander;
      JSONApiExpander = require("../jsonapi_expander");
      return new JSONApiExpander(data).attributes(RaceOption.prototype.attributes);
    }

  };

  RaceOption.prototype.endpoint = 'race_options';

  RaceOption.prototype.type = 'race_options';

  RaceOption.prototype.label = 'RaceOption';

  RaceOption.prototype.attributes = ['id', 'label', 'label_fr', 'order', 'is_snapon_driver', 'race_id', 'created_at', 'updated_at'];

  RaceOption.prototype.observables = {
    'id': void 0,
    'label': void 0,
    'label_fr': void 0,
    'order': void 0,
    'race_id': void 0,
    'created_at': void 0,
    'updated_at': void 0
  };

  return RaceOption;

}).call(this);

//END expand
//END RaceOption

},{"../jsonapi_expander":87,"./promise.base.model":69}],73:[function(require,module,exports){
var PromiseBaseModel, RaceSelection;

PromiseBaseModel = require("./promise.base.model");

module.exports = RaceSelection = (function() {
  class RaceSelection extends PromiseBaseModel {
    //END observables
    initialize() {
      return this.validation.decorate("validatable");
    }

    //END initialize
    expand(data) {
      var Entry, Franchisee, JSONApiExpander, Race, RaceOption, User;
      JSONApiExpander = require("../jsonapi_expander");
      Race = require("./race.model");
      RaceOption = require("./race_option.model");
      User = require("./user.model");
      Franchisee = require("./franchisee.model");
      Entry = require("./entry.model");
      return new JSONApiExpander(data).relation('race').attributes(Race.prototype.attributes).relation('race_options').attributes(RaceOption.prototype.attributes).done().done().relation('race_option').attributes(RaceOption.prototype.attributes).done().relation('user').attributes(User.prototype.attributes).done().relation('franchisee').attributes(Franchisee.prototype.attributes).done().relation('entry').attributes(Entry.prototype.attributes).done().attributes(RaceSelection.prototype.attributes);
    }

  };

  RaceSelection.prototype.endpoint = 'race_selections';

  RaceSelection.prototype.type = 'race-selections';

  RaceSelection.prototype.label = 'RaceSelection';

  RaceSelection.prototype.attributes = ['id', 'race_id', 'race_option_id', 'user_id', 'franchisee_id', 'entry_id', 'did_notify', 'did_notify_at', 'created_at', 'updated_at'];

  RaceSelection.prototype.defaults = {
    race: function() {
      var Race;
      Race = require("./race.model");
      return new Race();
    },
    race_option: function() {
      var RaceOption;
      RaceOption = require("./race_option.model");
      return new RaceOption();
    },
    user: function() {
      var User;
      User = require("./user.model");
      return new User();
    },
    franchisee: function() {
      var Franchisee;
      Franchisee = require("./franchisee.model");
      return new Franchisee();
    },
    entry: function() {
      var Entry;
      Entry = require("./entry.model");
      return new Entry();
    }
  };

  //END defaults
  RaceSelection.prototype.observables = {
    'id': void 0,
    'race_id': void 0,
    'race_option_id': void 0,
    'user_id': void 0,
    'franchisee_id': void 0,
    'entry_id': void 0,
    'did_notify': void 0,
    'did_notify_at': void 0,
    'created_at': void 0,
    'updated_at': void 0,
    // Non serialized observables
    validation: void 0,
    has_error: function() {
      return ko.unwrap(this.validation.is_invalid);
    },
    error: function() {
      if (this.get('has_error')) {
        return ko.unwrap(this.validation.validation_message);
      } else {
        return void 0;
      }
    }
  };

  return RaceSelection;

}).call(this);

//END expand
//END RaceSelection

},{"../jsonapi_expander":87,"./entry.model":59,"./franchisee.model":63,"./promise.base.model":69,"./race.model":71,"./race_option.model":72,"./user.model":81}],74:[function(require,module,exports){
var PromiseBaseModel, Region;

PromiseBaseModel = require("./promise.base.model");

module.exports = Region = (function() {
  class Region extends PromiseBaseModel {
    //END average_entries_per_participant
    //END observables
    hasOwner() {
      return Helpers.isUUID(this.get('owner_id'));
    }

    expand(data) {
      var JSONApiExpander, RegionContestStatistic, RegionContestStatistics, RegionStatistic, RegionStatistics, User;
      JSONApiExpander = require("../jsonapi_expander");
      User = require("./user.model");
      RegionStatistic = require("./region_statistic.model");
      RegionStatistics = require("../$collections/region_statistics.collection");
      RegionContestStatistic = require("./region_contest_statistic.model");
      RegionContestStatistics = require("../$collections/region_contest_statistics.collection");
      return new JSONApiExpander(data).attributes(Region.prototype.attributes).relation('owner').attributes(User.prototype.attributes).done().relation('statistics').attributes(RegionStatistic.prototype.attributes).done().relation('contest_statistics').attributes(RegionContestStatistic.prototype.attributes).done();
    }

  };

  Region.prototype.endpoint = 'regions';

  Region.prototype.type = 'regions';

  Region.prototype.label = 'Region';

  Region.prototype.attributes = ['id', 'name', 'owner_id', 'snapon_sso_id', 'created_at', 'updated_at'];

  Region.prototype.defaults = {
    'owner': function() {
      var User;
      User = require("./user.model");
      return new User();
    },
    'statistics': function() {
      var RegionStatistics;
      RegionStatistics = require("../$collections/region_statistics.collection");
      return new RegionStatistics();
    },
    'contest_statistics': function() {
      var RegionContestStatistics;
      RegionContestStatistics = require("../$collections/region_contest_statistics.collection");
      return new RegionContestStatistics();
    }
  };

  //END defaults
  Region.prototype.observables = {
    'id': void 0,
    'name': void 0,
    'owner_id': void 0,
    'snapon_sso_id': void 0,
    'created_at': void 0,
    'updated_at': void 0,
    'average_entries_per_participant': function() {
      var participant_count, redeemed_entry_count;
      participant_count = this.get('participant_count') || 0;
      if (!(participant_count > 0)) {
        return 0;
      }
      redeemed_entry_count = this.get('redeemed_entry_count') || 0;
      return redeemed_entry_count / participant_count;
    }
  };

  return Region;

}).call(this);

//END expand
//END Region

},{"../$collections/region_contest_statistics.collection":40,"../$collections/region_statistics.collection":41,"../jsonapi_expander":87,"./promise.base.model":69,"./region_contest_statistic.model":75,"./region_statistic.model":76,"./user.model":81}],75:[function(require,module,exports){
var PromiseBaseModel, RegionContestStatistic;

PromiseBaseModel = require("./promise.base.model");

module.exports = RegionContestStatistic = (function() {
  class RegionContestStatistic extends PromiseBaseModel {
    //END average_entries_per_participant
    //END observables
    expand(data) {
      var Contest, JSONApiExpander;
      JSONApiExpander = require("../jsonapi_expander");
      Contest = require("./contest.model");
      return new JSONApiExpander(data).attributes(RegionContestStatistic.prototype.attributes).relation('contest').attributes(Contest.prototype.attributes).done();
    }

  };

  RegionContestStatistic.prototype.endpoint = 'region_contest_statistics';

  RegionContestStatistic.prototype.type = 'region_contest_statistics';

  RegionContestStatistic.prototype.label = 'Region Contest Statistics';

  RegionContestStatistic.prototype.attributes = ['region_id', 'contest_id', 'entry_count', 'virtual_entry_count', 'redeemed_entry_count', 'redeemed_virtual_entry_count', 'participant_count', 'game_kit_count', 'registered_franchisee_count'];

  RegionContestStatistic.prototype.defaults = {
    'region_id': void 0,
    'contest_id': void 0
  };

  //END defaults
  RegionContestStatistic.prototype.observables = {
    'entry_count': 0,
    'virtual_entry_count': 0,
    'redeemed_entry_count': 0,
    'redeemed_virtual_entry_count': 0,
    'participant_count': 0,
    'game_kit_count': 0,
    'registered_franchisee_count': 0,
    'average_entries_per_participant': function() {
      var participant_count, redeemed_entry_count;
      participant_count = this.get('participant_count') || 0;
      if (!(participant_count > 0)) {
        return 0;
      }
      redeemed_entry_count = this.get('redeemed_entry_count') || 0;
      return redeemed_entry_count / participant_count;
    }
  };

  return RegionContestStatistic;

}).call(this);

//END expand
//END RegionContestStatistic

},{"../jsonapi_expander":87,"./contest.model":56,"./promise.base.model":69}],76:[function(require,module,exports){
var PromiseBaseModel, RegionStatistic;

PromiseBaseModel = require("./promise.base.model");

module.exports = RegionStatistic = (function() {
  class RegionStatistic extends PromiseBaseModel {
    //END average_entries_per_participant
    //END observables
    expand(data) {
      var JSONApiExpander;
      JSONApiExpander = require("../jsonapi_expander");
      return new JSONApiExpander(data).attributes(RegionStatistic.prototype.attributes);
    }

  };

  RegionStatistic.prototype.endpoint = 'region_statistics';

  RegionStatistic.prototype.type = 'region_statistics';

  RegionStatistic.prototype.label = 'Region Statistics';

  RegionStatistic.prototype.attributes = ['region_id', 'entry_count', 'virtual_entry_count', 'redeemed_entry_count', 'redeemed_virtual_entry_count', 'participant_count', 'game_kit_count', 'registered_franchisee_count', "survey_response_count"];

  RegionStatistic.prototype.defaults = {
    'region_id': void 0
  };

  //END defaults
  RegionStatistic.prototype.observables = {
    'entry_count': 0,
    'virtual_entry_count': 0,
    'redeemed_entry_count': 0,
    'redeemed_virtual_entry_count': 0,
    'participant_count': 0,
    'game_kit_count': 0,
    'registered_franchisee_count': 0,
    "survey_response_count": 0,
    'average_entries_per_participant': function() {
      var participant_count, redeemed_entry_count;
      participant_count = this.get('participant_count') || 0;
      if (!(participant_count > 0)) {
        return 0;
      }
      redeemed_entry_count = this.get('redeemed_entry_count') || 0;
      return redeemed_entry_count / participant_count;
    }
  };

  return RegionStatistic;

}).call(this);

//END expand
//END RegionStatistic

},{"../jsonapi_expander":87,"./promise.base.model":69}],77:[function(require,module,exports){
var PromiseBaseModel, Session;

PromiseBaseModel = require("./promise.base.model");

module.exports = Session = (function() {
  class Session extends PromiseBaseModel {
    //END defaults
    makeUrl() {
      return `${Falcon.baseApiUrl}/${this.endpoint}`;
    }

    serializeRequestData(type, options) {
      var data;
      ({data} = super.serializeRequestData(type, options));
      if ('user' in data) {
        data['users'] = data['user'];
        delete data['user'];
      }
      //END if
      return {data};
    }

    //END serializeRequestData
    expand(data) {
      var FPT, FPTs, Franchisee, Franchisees, JSONApiExpander, Region, Regions, User;
      JSONApiExpander = require("../jsonapi_expander");
      User = require("./user.model");
      Franchisee = require("./franchisee.model");
      Franchisees = require("../$collections/franchisees.collection");
      FPT = require("./fpt.model");
      FPTs = require("../$collections/fpts.collection");
      Region = require("./region.model");
      Regions = require("../$collections/regions.collection");
      return new JSONApiExpander(data).relation('user').attributes(User.prototype.attributes).done().relation('franchisees').attributes(Franchisee.prototype.attributes).done().relation('fpts').attributes(FPT.prototype.attributes).done().relation('regions').attributes(Region.prototype.attributes).done().attributes(Session.prototype.attributes);
    }

  };

  Session.prototype.endpoint = 'sessions';

  Session.prototype.type = 'sessions';

  Session.prototype.label = 'Session';

  Session.prototype.attributes = ['email', 'auth_token'];

  Session.prototype.defaults = {
    'email': "",
    'auth_token': null,
    'user': function() {
      var User;
      User = require("./user.model");
      return new User();
    },
    'franchisees': function() {
      var Franchisees;
      Franchisees = require("../$collections/franchisees.collection");
      return new Franchisees();
    },
    'fpts': function() {
      var FPTs;
      FPTs = require("../$collections/fpts.collection");
      return new FPTs();
    },
    'regions': function() {
      var Regions;
      Regions = require("../$collections/regions.collection");
      return new Regions();
    }
  };

  return Session;

}).call(this);

//END expand
//END Session

},{"../$collections/fpts.collection":30,"../$collections/franchisees.collection":34,"../$collections/regions.collection":42,"../jsonapi_expander":87,"./fpt.model":60,"./franchisee.model":63,"./promise.base.model":69,"./region.model":74,"./user.model":81}],78:[function(require,module,exports){
var PromiseBaseModel, Survey;

PromiseBaseModel = require("./promise.base.model");

module.exports = Survey = (function() {
  class Survey extends PromiseBaseModel {
    //END observables
    expand(data) {
      var JSONApiExpander, Question, Questions;
      JSONApiExpander = require("../jsonapi_expander");
      Question = require("./question.model");
      Questions = require("../$collections/questions.collection");
      return new JSONApiExpander(data).relation('questions').attributes(Question.prototype.attributes).done().attributes(Survey.prototype.attributes);
    }

  };

  Survey.prototype.endpoint = 'surveys';

  Survey.prototype.type = 'surveys';

  Survey.prototype.label = 'Survey';

  Survey.prototype.attributes = ['id', 'name', 'name_fr', 'start_date', 'end_date', 'created_at', 'updated_at'];

  Survey.prototype.defaults = {
    'questions': function() {
      var Questions;
      Questions = require("../$collections/questions.collection");
      return new Questions();
    }
  };

  //END defaults
  Survey.prototype.observables = {
    'id': void 0,
    'name': void 0,
    'start_date': void 0,
    'end_date': void 0,
    'created_at': void 0,
    'updated_at': void 0
  };

  return Survey;

}).call(this);

//END expand
//END Survey

},{"../$collections/questions.collection":36,"../jsonapi_expander":87,"./promise.base.model":69,"./question.model":70}],79:[function(require,module,exports){
var PromiseBaseModel, SurveyAnswer;

PromiseBaseModel = require("./promise.base.model");

module.exports = SurveyAnswer = (function() {
  class SurveyAnswer extends PromiseBaseModel {
    //END observables
    initialize() {
      return this.validation.decorate("validatable");
    }

    //END initialize
    validate() {
      var Question, options, selections, type;
      Question = require("./question.model");
      type = this.question.get('type');
      options = this.question.get('options') || [];
      selections = this.get('selections') || [];
      if (selections.length <= 0) {
        return this.validation.setIsValid(false, "Please make a selection");
      }
      if (type === Question.SINGLE_CHOICE) {
        if (selections.length > 1) {
          return this.validation.setIsValid(false, "Single choice questions may only have one selection");
        }
      }
      if (selections.length > options.length) {
        //END if
        return this.validation.setIsValid(false, "Improper selections");
      }
      if (selections.length > _.uniq(selections).length) {
        return this.validation.setIsValid(false, "Duplicate selections");
      }
      return this.validation.setIsValid(true);
    }

    //END validate
    expand(data) {
      var JSONApiExpander, Question, Survey, User;
      JSONApiExpander = require("../jsonapi_expander");
      Survey = require("./survey.model");
      Question = require("./question.model");
      User = require("./user.model");
      return new JSONApiExpander(data).relation('survey_response').attributes(SurveyResponse.prototype.attributes).done().relation('survey').attributes(Survey.prototype.attributes).done().relation('responder').attributes(User.prototype.attributes).done().relation('question').attributes(Question.prototype.attributes).done().attributes(SurveyAnswer.prototype.attributes);
    }

  };

  SurveyAnswer.prototype.endpoint = 'survey_answers';

  SurveyAnswer.prototype.type = 'survey-answers';

  SurveyAnswer.prototype.label = 'SurveyAnswer';

  SurveyAnswer.prototype.attributes = ['id', 'selections', 'response_id', 'question_id', 'survey_id', 'responder_id', 'created_at', 'updated_at'];

  SurveyAnswer.prototype.defaults = {
    survey: function() {
      var Survey;
      Survey = require("./survey.model");
      return new Survey();
    },
    question: function() {
      var Question;
      Question = require("./question.model");
      return new Question();
    },
    responder: function() {
      var User;
      User = require("./user.model");
      return new User();
    }
  };

  //END defaults
  SurveyAnswer.prototype.observables = {
    'id': void 0,
    'question_id': void 0,
    'survey_id': void 0,
    'responder_id': void 0,
    'created_at': void 0,
    'updated_at': void 0,
    'input_selections': [], // Raw values from the form inputs
    'selections': {
      read: function() {
        var value;
        value = this.get('input_selections');
        if (value == null) {
          return [];
        }
        if (_.isArray(value)) {
          return value;
        }
        if (this.question.get('is_single_choice')) {
          return [value];
        }
        return [];
      },
      //END read
      write: function(value) {
        if (value == null) {
          value = [];
        }
        if (!_.isArray(value)) {
          value = [value];
        }
        value = value.map(function(item) {
          return item;
        });
        value = _.uniq(value);
        if (this.question.get('is_single_choice')) {
          value = value[0];
        }
        return this.set('input_selections', value);
      }
    },
    //END write
    //END selections

    // Non serialized observables
    validation: void 0,
    has_error: function() {
      return ko.unwrap(this.validation.is_invalid);
    },
    error: function() {
      return ko.unwrap(this.validation.validation_message);
    }
  };

  return SurveyAnswer;

}).call(this);

//END expand
//END SurveyAnswer

},{"../jsonapi_expander":87,"./promise.base.model":69,"./question.model":70,"./survey.model":78,"./user.model":81}],80:[function(require,module,exports){
var PromiseBaseModel, SurveyResponse;

PromiseBaseModel = require("./promise.base.model");

module.exports = SurveyResponse = (function() {
  class SurveyResponse extends PromiseBaseModel {
    //END observables
    initialize() {
      return this.validation.decorate("validatable");
    }

    //END initialize
    validate() {
      var is_valid;
      is_valid = true;
      if (this.answers.length() !== this.survey.questions.length()) {
        is_valid = false;
        this.validation.setIsValid(false, "Invalid number of answers given");
      }
      //eND if
      this.answers.each(function(answer) {
        return is_valid = answer.validate() && is_valid;
      });
      return is_valid;
    }

    //END validate
    mapSurvey(survey) {
      var SurveyAnswer;
      SurveyAnswer = require("../$models/survey_answer.model");
      this.fill({
        survey_id: survey.get('id'),
        survey: survey.serialize()
      });
      survey.questions.each((question) => {
        var answer;
        answer = this.answers.first((answer) => {
          return answer.get("question_id") === question.get("id");
        });
        if (answer == null) {
          answer = new SurveyAnswer();
          this.answers.push(answer);
        }
        //END unless
        return answer.fill({
          question_id: question.get('id'),
          question: question.serialize()
        });
      });
      return this;
    }

    //END mapSurvey
    expand(data) {
      var Entry, JSONApiExpander, Question, Survey, SurveyAnswer, SurveyAnswers, User;
      JSONApiExpander = require("../jsonapi_expander");
      Survey = require("./survey.model");
      Question = require("./question.model");
      User = require("./user.model");
      Entry = require("./entry.model");
      SurveyAnswer = require("./survey_answer.model");
      SurveyAnswers = require("../$collections/survey_answers.collection");
      return new JSONApiExpander(data).relation('survey').attributes(Survey.prototype.attributes).relation('questions').attributes(Question.prototype.attributes).done().done().relation('responder').attributes(User.prototype.attributes).done().relation('answers').attributes(SurveyAnswer.prototype.attributes).done().relation('entry').attributes(Entry.prototype.attributes).done().attributes(SurveyResponse.prototype.attributes);
    }

  };

  SurveyResponse.prototype.endpoint = 'survey_responses';

  SurveyResponse.prototype.type = 'survey-responses';

  SurveyResponse.prototype.label = 'SurveyResponse';

  SurveyResponse.prototype.attributes = ['id', 'survey_id', 'responder_id', 'entry_id', 'created_at', 'updated_at'];

  SurveyResponse.prototype.defaults = {
    survey: function() {
      var Survey;
      Survey = require("./survey.model");
      return new Survey();
    },
    answers: function() {
      var SurveyAnswers;
      SurveyAnswers = require("../$collections/survey_answers.collection");
      return new SurveyAnswers();
    },
    responder: function() {
      var User;
      User = require("./user.model");
      return new User();
    },
    entry: function() {
      var Entry;
      Entry = require("./entry.model");
      return new Entry();
    }
  };

  //END defaults
  SurveyResponse.prototype.observables = {
    'id': void 0,
    'survey_id': void 0,
    'responder_id': void 0,
    'entry_id': void 0,
    'created_at': void 0,
    'updated_at': void 0,
    // Non serialized observables
    validation: void 0,
    has_error: function() {
      return ko.unwrap(this.validation.is_invalid);
    },
    error: function() {
      if (this.get('has_error')) {
        return ko.unwrap(this.validation.validation_message);
      } else {
        return void 0;
      }
    }
  };

  return SurveyResponse;

}).call(this);

//END expand
//END SurveyResponse

},{"../$collections/survey_answers.collection":43,"../$models/survey_answer.model":79,"../jsonapi_expander":87,"./entry.model":59,"./promise.base.model":69,"./question.model":70,"./survey.model":78,"./survey_answer.model":79,"./user.model":81}],81:[function(require,module,exports){
var PromiseBaseModel, User,
  indexOf = [].indexOf;

PromiseBaseModel = require("./promise.base.model");

module.exports = User = (function() {
  class User extends PromiseBaseModel {
    //END first_name
    //END observables
    hasRole(...roles) {
      var assigned_roles, i, len, ref, role;
      assigned_roles = (ref = this.get('roles')) != null ? ref : [];
      for (i = 0, len = roles.length; i < len; i++) {
        role = roles[i];
        if (indexOf.call(assigned_roles, role) >= 0) {
          return true;
        }
      }
      //END for
      return false;
    }

    //END hasRole
    getFormattedAddress() {
      var address_1, address_2, city, line, lines, state, zip_code;
      lines = [];
      address_1 = this.get("address_1");
      if (address_1) {
        lines.push(address_1);
      }
      address_2 = this.get("address_2");
      if (address_2) {
        lines.push(address_2);
      }
      line = "";
      city = this.get("city");
      if (city) {
        line += city;
      }
      state = this.get("state");
      if (state) {
        if (line.length > 0) {
          line += ", ";
        }
        line += state;
      }
      //END if
      zip_code = this.get("zip_code");
      if (zip_code) {
        if (line.length > 0) {
          line += " ";
        }
        line += zip_code;
      }
      //END if
      lines.push(line);
      return lines.join("\n");
    }

    //END getFormattedAddress
    expand(data) {
      var JSONApiExpander, UserContestStatistic, UserContestStatistics;
      JSONApiExpander = require("../jsonapi_expander");
      UserContestStatistic = require("../$models/user_contest_statistic.model");
      UserContestStatistics = require("../$collections/user_contest_statistics.collection");
      return new JSONApiExpander(data).relation('contest_statistics').attributes(UserContestStatistic.prototype.attributes).done().attributes(User.prototype.attributes);
    }

  };

  User.prototype.endpoint = 'users';

  User.prototype.type = 'users';

  User.prototype.label = 'User';

  User.ROLES = [User.ADMIN_ROLE = 'admin', User.REGION_ROLE = 'region', User.FPT_ROLE = 'fpt', User.FRANCHISEE_ROLE = 'franchisee', User.USER_ROLE = 'user'];

  User.prototype.attributes = ['id', 'email', 'name', 'roles', 'created_at', 'updated_at', 'address_1', 'address_2', 'city', 'state', 'country', 'zip_code', 'phone_number', 'legal_agreements', 'snapon_sso_id', 'is_subscribed_to_newsletter'];

  User.prototype.defaults = {
    'contest_statistics': function() {
      var UserContestStatistics;
      UserContestStatistics = require("../$collections/user_contest_statistics.collection");
      return new UserContestStatistics();
    }
  };

  //END defaults
  User.prototype.observables = {
    'id': void 0,
    'name': void 0,
    'email': void 0,
    'roles': [],
    'password': void 0,
    'address_1': void 0,
    'address_2': void 0,
    'city': void 0,
    'state': void 0,
    'country': void 0,
    'zip_code': void 0,
    'phone_number': void 0,
    'legal_agreements': void 0,
    'is_subscribed_to_newsletter': void 0,
    'snapon_sso_id': void 0,
    'created_at': void 0,
    'updated_at': void 0,
    'first_name': function() {
      var name, ref, ref1;
      name = Helpers.trim((ref = this.get('name')) != null ? ref : "");
      return (ref1 = name.split(" ")[0]) != null ? ref1 : "";
    },
    //END first_name
    'last_name': function() {
      var first, name, ref, rest;
      name = Helpers.trim((ref = this.get('name')) != null ? ref : "");
      [first, ...rest] = name.split(" ");
      return rest.join(" ");
    }
  };

  return User;

}).call(this);

//END expand
//END User

},{"../$collections/user_contest_statistics.collection":46,"../$models/user_contest_statistic.model":82,"../jsonapi_expander":87,"./promise.base.model":69}],82:[function(require,module,exports){
var PromiseBaseModel, UserContestStatistic;

PromiseBaseModel = require("./promise.base.model");

module.exports = UserContestStatistic = (function() {
  class UserContestStatistic extends PromiseBaseModel {
    //END observables
    expand(data) {
      var JSONApiExpander;
      JSONApiExpander = require("../jsonapi_expander");
      return new JSONApiExpander(data).attributes(UserContestStatistic.prototype.attributes);
    }

  };

  UserContestStatistic.prototype.endpoint = 'user_contest_statistics';

  UserContestStatistic.prototype.type = 'user_contest_statistics';

  UserContestStatistic.prototype.label = 'Contest Winner';

  UserContestStatistic.prototype.attributes = ['user_id', 'contest_id', 'redeemed_entry_count'];

  UserContestStatistic.prototype.defaults = {
    'user_id': void 0,
    'contest_id': void 0
  };

  //END defaults
  UserContestStatistic.prototype.observables = {
    'redeemed_entry_count': void 0
  };

  return UserContestStatistic;

}).call(this);

//END expand
//END UserContestStatistic

},{"../jsonapi_expander":87,"./promise.base.model":69}],83:[function(require,module,exports){
var base;

if ((base = Function.prototype).bind == null) {
  base.bind = function(oThis) {
    var aArgs, fBound, fToBind, noop;
    if (typeof this !== "function") {
      throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");
    }
    //END unless
    aArgs = Array.prototype.slice.call(arguments, 1);
    fToBind = this;
    noop = (function() {});
    fBound = function() {
      var context;
      context = this instanceof noop && oThis ? this : oThis;
      return fToBind.apply(context, aArgs.concat(Array.prototype.slice.call(arguments)));
    };
    //END fBound
    noop.prototype = this.prototype;
    fBound.prototype = new noop();
    return fBound;
  };
}

//END bind

},{}],84:[function(require,module,exports){
(function() {
  var browserRaf, canceled, i, len, ref, targetTime, vendor, w;
  w = window;
  ref = ['ms', 'moz', 'webkit', 'o'];
  for (i = 0, len = ref.length; i < len; i++) {
    vendor = ref[i];
    if (w.requestAnimationFrame) {
      break;
    }
    w.requestAnimationFrame = w[`${vendor}RequestAnimationFrame`];
    w.cancelAnimationFrame = w[`${vendor}CancelAnimationFrame`] || w[`${vendor}CancelRequestAnimationFrame`];
  }
  // deal with the case where rAF is built in but cAF is not.
  if (w.requestAnimationFrame) {
    if (w.cancelAnimationFrame) {
      return;
    }
    browserRaf = w.requestAnimationFrame;
    canceled = {};
    w.requestAnimationFrame = function(callback) {
      var id;
      return id = browserRaf(function(time) {
        if (id in canceled) {
          return delete canceled[id];
        } else {
          return callback(time);
        }
      });
    };
    return w.cancelAnimationFrame = function(id) {
      return canceled[id] = true;
    };
  } else {
    // handle legacy browsers which don’t implement rAF
    targetTime = 0;
    w.requestAnimationFrame = function(callback) {
      var currentTime;
      targetTime = Math.max(targetTime + 16, currentTime = +new Date());
      return w.setTimeout((function() {
        return callback(+new Date());
      }), targetTime - currentTime);
    };
    return w.cancelAnimationFrame = function(id) {
      return clearTimeout(id);
    };
  }
})();

},{}],85:[function(require,module,exports){
var Analytics, mixpanel;

mixpanel = require("mixpanel-browser");

module.exports = Analytics = new (class {
  init(token, app, debug = false) {
    var e;
    try {
      mixpanel.init(token, {debug});
      mixpanel.register({app});
      this.track("Loaded Application");
      return this;
    } catch (error) {
      e = error;
      return console.error("Mixpanel failed to initialize", e);
    }
  }

  //END init
  identify(id) {
    var e;
    try {
      mixpanel.identify(id);
      return this;
    } catch (error) {
      e = error;
      return console.error("Mixpanel failed to identify", e);
    }
  }

  //END identify
  track(event, properties = {}) {
    var e;
    try {
      mixpanel.track(event, properties);
      return this;
    } catch (error) {
      e = error;
      return console.error("Mixpanel failed to track", e);
    }
  }

  //END track
  register(properties) {
    var e;
    try {
      mixpanel.register(properties);
      return this;
    } catch (error) {
      e = error;
      return console.error("Mixpanel failed to register", e);
    }
  }

  //END register
  unregister(key) {
    var e;
    try {
      mixpanel.unregister(key);
      return this;
    } catch (error) {
      e = error;
      return console.error("Mixpanel failed to unregister", e);
    }
  }

})();

//END unregister
//END Analytics

},{"mixpanel-browser":116}],86:[function(require,module,exports){
ko.subscribable.fn.decorate = function(...identifiers) {
  var extenders, i, identifier, len;
  extenders = {};
  for (i = 0, len = identifiers.length; i < len; i++) {
    identifier = identifiers[i];
    if (_.isString(identifier) && !_.isEmpty(identifier)) {
      extenders[identifier] = true;
    }
  }
  //END for
  return this.extend(extenders);
};


//END decorate
ko.extenders["errorable"] = function(target, options) {
  target.error = ko.observable("");
  target.has_error = ko.computed(function() {
    var err;
    err = target.error();
    if (!_.isString(err)) {
      err = "";
    }
    return Helpers.trim(err).length > 0;
  });
  //END has_error
  target.clearError = function() {
    return target.error("");
  };
  return target;
};

//END errorable extender
ko.extenders["validatable"] = function(target, options) {
  target.is_valid = ko.observable(false);
  target.is_invalid = ko.observable(false);
  target.has_validation = ko.computed(function() {
    return target.is_invalid() || target.is_valid();
  });
  target.validation_message = ko.observable(null);
  target.setIsValid = function(is_valid, message) {
    var is_invalid;
    if (is_valid != null) {
      is_invalid = !is_valid;
      target.is_invalid(is_invalid);
      target.is_valid(is_valid);
      target.validation_message(message);
      return !is_invalid;
    } else {
      target.resetValidations();
      return null;
    }
  };
  //END if
  //END setIsValid
  target.resetValidations = function() {
    target.is_invalid(false);
    target.is_valid(false);
    target.validation_message(null);
    return target;
  };
  //END resetValidations
  return target;
};

//END errorable extender
ko.extenders["lowercase"] = function(target, options) {
  target.subscribe(function(new_value) {
    if (new_value != null) {
      new_value = new_value.toString().toLowerCase();
    }
    return target(new_value);
  });
  //END subscribe
  return target;
};

//END errorable extender
ko.extenders["resetAfter"] = function(target, duration) {
  var original_value, timeout;
  if (!_.isNumber(duration)) {
    duration = 1000;
  }
  if (duration < 0) {
    duration = 0;
  }
  original_value = target();
  timeout = null;
  target.subscribe(function(new_value) {
    if (timeout != null) {
      clearTimeout(timeout);
    }
    timeout = null;
    if (new_value === original_value) {
      return;
    }
    return timeout = setTimeout(function() {
      timeout = null;
      return target(original_value);
    }, duration);
  });
  //END subscribe
  return target;
};

//END resetAfter extender
ko.extenders["transactable"] = function(target, options) {
  var previous;
  previous = ko.observable(target());
  target.commit = function() {
    return previous(target());
  };
  target.revert = function() {
    return target(previous());
  };
  target.hasChanged = function() {
    return target() !== previous();
  };
  return target;
};

//END transactable extender

},{}],87:[function(require,module,exports){
var JSONApiExpander, JSONApiExpanderBase, generateBaseOutputObject,
  indexOf = [].indexOf;

generateBaseOutputObject = function($included_datum) {
  if (!_.isObject($included_datum)) {
    throw new Error("$included_datum must be an object");
  }
  //END unless
  return {$included_datum};
};

JSONApiExpanderBase = (function() {
  //END generateBaseOutputObject
  class JSONApiExpanderBase {
    constructor(data, output, parent) {
      if (!_.isObject(data)) {
        throw new Error("data must be an object");
      }
      //END unless
      if (!_.isArray(output)) {
        throw new Error("output must be an array");
      }
      //END unless
      this.data = data;
      this.output = output;
      this.parent = parent;
    }

    //END constructor
    cleanOutputObject(output_object) {
      if (!_.isObject(output_object)) {
        throw new Error("output_object must be an Object");
      }
      if ('$included_datum' in output_object) {
        //END unless
        return delete output_object['$included_datum'];
      }
    }

    //END cleanOutputObject
    getRelationships(output_object, key) {
      var $included_datum;
      if (!_.isObject(output_object)) {
        throw new Error("output_object must be an Object");
      }
      //END unless
      ({$included_datum} = output_object);
      if ($included_datum == null) {
        if (this.debug) {
          if (typeof console !== "undefined" && console !== null) {
            console.warn("Missing '$included_datum' property on: ", output_object);
          }
        }
      } else if (!('relationships' in output_object['$included_datum'])) {
        if (this.debug) {
          if (typeof console !== "undefined" && console !== null) {
            console.warn(`Missing 'relationships' property on '${$included_datum['type']}', data given was:`, $included_datum);
          }
        }
      } else if (!(key in $included_datum['relationships'])) {
        if (this.debug) {
          if (typeof console !== "undefined" && console !== null) {
            console.warn(`Missing '${key}' property on '${$included_datum['type']}.relationships', data given was: `, $included_datum['relationships']);
          }
        }
      // Take a time out to check if the linked thing is null, return null if so
      } else if ($included_datum['relationships'][key] == null) {
        return null;
      } else if (!('data' in $included_datum['relationships'][key])) {
        if (this.debug) {
          if (typeof console !== "undefined" && console !== null) {
            console.warn(`Missing 'data' property on '${$included_datum['type']}.relationships.${key}', data given was: `, $included_datum['relationships'][key]);
          }
        }
      } else {
        return $included_datum['relationships'][key]['data'];
      }
      //END if
      return null;
    }

    //END getRelationships
    generateOutputObject(linkage, existing_output_array) {
      var $included_datum, existing_output_object, i, id, j, len, len1, output_object, ref, resource, type;
      if (!_.isObject(linkage)) {
        throw new Error("linkage must be an object");
      }
      //END unless
      if (!('id' in linkage)) {
        throw new Error("Linked objects must contain an id");
      }
      //END unless
      if (!('type' in linkage)) {
        throw new Error("Linked objects must contain a type");
      }
      //END unless
      ({type, id} = linkage);
      output_object = null;
      // Find existing output objects based on matching id and type, instead of reference to save time and memory
      if (_.isArray(existing_output_array)) {
        for (i = 0, len = existing_output_array.length; i < len; i++) {
          existing_output_object = existing_output_array[i];
          ({$included_datum} = existing_output_object);
          if ($included_datum['id'] !== id) {
            continue;
          }
          if ($included_datum['type'] !== type) {
            continue;
          }
          return existing_output_object;
        }
      }
      //END for
      //END if
      $included_datum = null;
      ref = this.data['included'];
      // Try and find the correct data from the included array (data sent from server to me)
      for (j = 0, len1 = ref.length; j < len1; j++) {
        resource = ref[j];
        if (!(resource != null)) {
          continue;
        }
        if (resource['id'] !== id) {
          continue;
        }
        if (resource['type'] !== type) {
          continue;
        }
        $included_datum = resource;
        break;
      }
      //END for

      // If we found some included data then generate a base (empty-ish) output Object
      // We do it this way to be able to reduce the different attributes from the response
      //TODO: Consider removing this and instead using an 'if' around 'output_object ='
      if ($included_datum == null) {
        $included_datum = {id};
      }
      output_object = generateBaseOutputObject($included_datum);
      return output_object;
    }

    //END generateOutputObject
    attributes(attrs) {
      var $included_datum, attr, i, index, j, len, len1, output_object, ref;
      if (!_.isArray(attrs)) {
        attrs = [];
      }
      ref = this.output;
      for (index = i = 0, len = ref.length; i < len; index = ++i) {
        output_object = ref[index];
        ({$included_datum} = output_object);
        if ($included_datum == null) {
          continue;
        }
        output_object['id'] = $included_datum['id'];
        if ($included_datum['attributes'] == null) {
          continue;
        }
        for (j = 0, len1 = attrs.length; j < len1; j++) {
          attr = attrs[j];
          if (attr in $included_datum['attributes']) {
            output_object[attr] = $included_datum['attributes'][attr];
          }
        }
      }
      //END for
      //END for
      return this;
    }

    //END attributes
    relation(key) {
      var child_output_array, child_output_object, i, included, j, len, len1, output_object, ref, relationship, relationships;
      if (!_.isString(key)) {
        throw new Error("key must be a string");
      }
      //END unless
      ({included} = this.data);
      child_output_array = [];
      ref = this.output;
      for (i = 0, len = ref.length; i < len; i++) {
        output_object = ref[i];
        relationships = this.getRelationships(output_object, key);
        // Output null
        if (_.isNull(relationships)) {
          output_object[key] = null;
        }
        // Output the array as a link if the relationships value is an array
        if (_.isArray(relationships)) {
          for (j = 0, len1 = relationships.length; j < len1; j++) {
            relationship = relationships[j];
            if (!(relationship != null)) {
              continue;
            }
            // Retrieve the proper child output object, pass in the existing child_output_array to
            // re-use the 'same' objects based on type and id and re-use the existing reference
            child_output_object = this.generateOutputObject(relationship, child_output_array);
            if (child_output_object != null) {
              if (indexOf.call(child_output_array, child_output_object) < 0) {
                // Ony push this on to the output array if it doesn't already exist in the output array
                // Because we're using references here, if the actual output array has duplicate models
                // this will actual save time as the expanded json will still be correct but will need less memory
                // and iterations to perform the expansion
                child_output_array.push(child_output_object);
              }
              // Always push this on the the actual output as, even if there's duplicate models in the same array,
              // we'll still want to duplicate that model in the generated output
              (output_object[key] != null ? output_object[key] : output_object[key] = []).push(child_output_object);
            }
          }
        //END if
        //END for

        // Output the array as a relationship if the relationships value is an object
        } else if (_.isObject(relationships)) {
          // Retrieve the proper child output object, pass in the existing child_output_array to
          // re-use the 'same' objects based on type and id and re-use the existing reference
          child_output_object = this.generateOutputObject(relationships, child_output_array);
          if (child_output_object != null) {
            child_output_array.push(child_output_object);
            output_object[key] = child_output_object;
          }
        }
      }
      //END if
      //END if
      //END for
      return new JSONApiExpanderBase(this.data, child_output_array, this);
    }

    //END relation
    done() {
      var i, len, output_object, ref;
      ref = this.output;
      for (i = 0, len = ref.length; i < len; i++) {
        output_object = ref[i];
        this.cleanOutputObject(output_object);
      }
      return this.parent;
    }

  };

  JSONApiExpanderBase.prototype.parent = null;

  JSONApiExpanderBase.prototype.data = null;

  JSONApiExpanderBase.prototype.output = null;

  JSONApiExpanderBase.prototype.debug = false;

  return JSONApiExpanderBase;

}).call(this);

//END done
//END JSONApiExpanderBase
module.exports = JSONApiExpander = class JSONApiExpander extends JSONApiExpanderBase {
  constructor(data) {
    var output, root, root_datum;
    if (!_.isObject(data)) {
      throw new Error("data must be an object");
    }
    //END unless
    root = data['data'];
    if (_.isObject(root) && !_.isArray(root)) {
      root = [root];
    }
    if (!_.isArray(root)) {
      throw new Error("root must be an object or an array");
    }
    //END unless
    output = (function() {
      var i, len, results;
      results = [];
      for (i = 0, len = root.length; i < len; i++) {
        root_datum = root[i];
        results.push(generateBaseOutputObject(root_datum));
      }
      return results;
    })();
    super(data, output);
    this.parent = this;
  }

  //END constructor
  toArray() {
    return this.done().output;
  }

  toObject() {
    return this.done().output[0];
  }

};

//END JSONApiExpander

},{}],88:[function(require,module,exports){
var JWTAdapater;

module.exports = JWTAdapater = class JWTAdapater extends jQueryRestDataAdapter {
  standardizeOptions(data_object, type, options, context) {
    var sync_options;
    sync_options = super.standardizeOptions(...arguments);
    sync_options['xhrFields'] = {};
    sync_options['xhrFields']['withCredentials'] = true;
    sync_options['crossDomain'] = true;
    return sync_options;
  }

  //END standardizeOptions
  errorResponseHandler(data_object, type, options, context, response_args) {
    var ref, ref1;
    switch (parseInt((ref = response_args != null ? (ref1 = response_args.xhr) != null ? ref1.status : void 0 : void 0) != null ? ref : 0)) {
      case 401:
        // TODO: Logout the user
        this.trigger('unauthorized');
    }
    //END when
    //END switch
    return super.errorResponseHandler(...arguments);
  }

};

//END errorResponseHandler
//END JWTAdapter

},{}],89:[function(require,module,exports){
var Contest, ContestFinalist, ContestFinalists, ContestWinner, ContestWinners, Entries, Entry, FPT, Franchisee, Franchisees, GameKit, Invite, RPC, Race, RaceSelection, Session, User;

Contest = require("./$models/contest.model");

ContestFinalist = require("./$models/contest_finalist.model");

ContestFinalists = require("./$collections/contest_finalists.collection");

ContestWinner = require("./$models/contest_winner.model");

ContestWinners = require("./$collections/contest_winners.collection");

Entries = require("./$collections/entries.collection");

Entry = require("./$models/entry.model");

FPT = require("./$models/fpt.model");

Franchisee = require("./$models/franchisee.model");

Franchisees = require("./$collections/franchisees.collection");

GameKit = require("./$models/game_kit.model");

Invite = require("./$models/invite.model");

Race = require("./$models/race.model");

RaceSelection = require("./$models/race_selection.model");

Session = require("./$models/session.model");

User = require("./$models/user.model");

module.exports = RPC = new (class {
  promiseGetPresignedUrl({size, name, type} = {}) {
    return Q.Promise((resolve, reject) => {
      return (new Falcon.Model({
        endpoint: "rpc/presigned_url"
      })).set({size, name, type}).create({
        parent: null,
        attributes: ['size', 'name', 'type'],
        success: (model, resp) => {
          return resolve(resp);
        },
        error: () => {
          return reject("Could not retrieve a presigned url");
        }
      });
    });
  }

  //END Falcon.Model
  //END promiseGetPresignedUrl
  promiseUploadFile(file) {
    return Q.Promise((resolve, reject) => {
      return RPC.promiseGetPresignedUrl(file).then(function(urls) {
        return $.ajax({
          url: urls.presigned_url,
          type: 'PUT',
          data: file,
          processData: false,
          headers: {
            'Accept': file.type,
            'Content-Type': file.type
          }
        //END headers
        }).success(function() {
          return resolve(urls.public_url);
        }).error(reject);
      });
    });
  }

  //END promiseUploadFile
  promiseForgotPassword(email, role = "web") {
    return Q.Promise((resolve, reject) => {
      if (!email) {
        throw new Error("email must be present");
      }
      if (!Helpers.isEmail(email)) {
        throw new Error("email must be an valid email");
      }
      return (new Falcon.Model({
        endpoint: "rpc/forgot_password"
      })).set({email, role}).create({
        parent: null,
        attributes: ['email', 'role'],
        success: () => {
          return resolve();
        },
        error: () => {
          return reject({
            human: "No account found for this email."
          });
        }
      });
    });
  }

  //END Falcon.Model
  //END promiseForgotPassword
  promiseResetPassword({email, reset_code, password} = {}) {
    return Q.Promise((resolve, reject) => {
      if (!email) {
        throw new Error("email must be present");
      }
      if (!Helpers.isEmail(email)) {
        throw new Error("email must be an valid email");
      }
      if (!reset_code) {
        throw new Error("reset_code must be present");
      }
      if (!password) {
        throw new Error("password must be present");
      }
      return (new Falcon.Model({
        endpoint: "rpc/reset_password"
      })).set({email, reset_code, password}).create({
        parent: null,
        attributes: ['email', 'reset_code', 'password'],
        success: (model, data) => {
          var user, user_data;
          user_data = User.prototype.expand(data).toObject();
          user = new User(user_data);
          return resolve(user);
        },
        //END success
        error: () => {
          return reject(new Error("Could not reset password"));
        }
      });
    });
  }

  //END Falcon.Model
  //END promiseResetPassword
  promiseChangePassword(old_password, new_password) {
    return Q.Promise((resolve, reject) => {
      if (!_.isString(old_password)) {
        throw new Error("old_password must be a string");
      }
      if (!_.isString(new_password)) {
        throw new Error("new_password must be a string");
      }
      if (_.isEmpty(old_password)) {
        throw new Error("old_password must not be empty");
      }
      if (_.isEmpty(new_password)) {
        throw new Error("new_password must not be empty");
      }
      return (new Falcon.Model({
        endpoint: "rpc/change_password"
      })).set({old_password, new_password}).create({
        parent: null,
        attributes: ['old_password', 'new_password'],
        success: (model, data) => {
          var user, user_data;
          user_data = User.prototype.expand(data);
          user = new User(user_data);
          return resolve(user);
        },
        //END success
        error: () => {
          return reject("Could not change password");
        }
      });
    });
  }

  //END create
  //END promiseChangePassword
  promiseAdminChangePassword(user, new_password) {
    return Q.Promise((resolve, reject) => {
      var user_id;
      if (!(user instanceof User)) {
        throw new Error("user must be a User");
      }
      if (user.isNew()) {
        throw new Error("user must not be new");
      }
      if (!_.isString(new_password)) {
        throw new Error("new_password must be a string");
      }
      if (_.isEmpty(new_password)) {
        throw new Error("new_password must not be empty");
      }
      user_id = user.get('id');
      return (new Falcon.Model({
        endpoint: "rpc/admin_change_password"
      })).set({user_id, new_password}).create({
        parent: null,
        attributes: ['user_id', 'new_password'],
        success: (model, data) => {
          var user_data;
          user_data = User.prototype.expand(data);
          user = new User(user_data);
          return resolve(user);
        },
        //END success
        error: () => {
          return reject("Could not change password");
        }
      });
    });
  }

  //END create
  //END promiseChangePassword
  promiseCheckBPNumber(bp_number) {
    return Q.Promise((resolve, reject) => {
      if (!_.isString(bp_number)) {
        throw new Error("bp_number must be a string");
      }
      return (new Falcon.Model({
        endpoint: "rpc/check_bp_number"
      })).set({bp_number}).create({
        parent: null,
        attributes: ['bp_number'],
        success: (model, data) => {
          if ((data != null ? data.success : void 0)) {
            return resolve();
          }
          return reject({});
        },
        //END success
        error: (model, error = {}) => {
          return reject(error);
        }
      });
    });
  }

  //END promiseCheckBPNumber
  //END error
  promiseInviteByBPNumber(bp_number) {
    return Q.Promise((resolve, reject) => {
      if (!_.isString(bp_number)) {
        throw new Error("bp_number must be a string");
      }
      return (new Falcon.Model({
        endpoint: "rpc/invite_by_bp_number"
      })).set({bp_number}).create({
        parent: null,
        attributes: ['bp_number'],
        success: (model, data) => {
          var invite, invite_data;
          invite_data = Invite.prototype.expand(data).toObject();
          invite = new Invite(invite_data);
          return resolve(invite);
        },
        //END success
        error: (model, error = {}) => {
          return reject(error);
        }
      });
    });
  }

  //END promiseInviteByBPNumber
  //END error
  promiseRegisterFranchisee({password, invite_code} = {}) {
    return Q.Promise((resolve, reject) => {
      if (!_.isString(password)) {
        throw new Error("Password must be a string");
      }
      if (_.isEmpty(password)) {
        throw new Error("Password must not be empty");
      }
      if (!_.isString(invite_code)) {
        throw new Error("Invite code must be a string");
      }
      if (_.isEmpty(invite_code)) {
        throw new Error("Invite code must not be empty");
      }
      return (new Falcon.Model({
        endpoint: "rpc/register_franchisee"
      })).set({password, invite_code}).create({
        parent: null,
        attributes: ['password', 'invite_code'],
        success: (model, data) => {
          var user, user_data;
          user_data = User.prototype.expand(data).toObject();
          user = new User(user_data);
          return resolve(user);
        },
        //END success
        error: (model, error) => {
          return reject(error);
        }
      });
    });
  }

  //END promiseRegisterFranchisee
  //END error
  promiseRegisterFPT({password, invite_code} = {}) {
    return Q.Promise((resolve, reject) => {
      if (!_.isString(password)) {
        throw new Error("Password must be a string");
      }
      if (_.isEmpty(password)) {
        throw new Error("Password must not be empty");
      }
      if (!_.isString(invite_code)) {
        throw new Error("Invite code must be a string");
      }
      if (_.isEmpty(invite_code)) {
        throw new Error("Invite code must not be empty");
      }
      return (new Falcon.Model({
        endpoint: "rpc/register_fpt"
      })).set({password, invite_code}).create({
        parent: null,
        attributes: ['password', 'invite_code'],
        success: (model, data) => {
          var user, user_data;
          user_data = User.prototype.expand(data).toObject();
          user = new User(user_data);
          return resolve(user);
        },
        //END success
        error: (model, error) => {
          return reject(error);
        }
      });
    });
  }

  //END promiseRegisterFPT
  //END error
  promiseRegisterRegion({password, invite_code} = {}) {
    return Q.Promise((resolve, reject) => {
      if (!_.isString(password)) {
        throw new Error("Password must be a string");
      }
      if (_.isEmpty(password)) {
        throw new Error("Password must not be empty");
      }
      if (!_.isString(invite_code)) {
        throw new Error("Invite code must be a string");
      }
      if (_.isEmpty(invite_code)) {
        throw new Error("Invite code must not be empty");
      }
      return (new Falcon.Model({
        endpoint: "rpc/register_region"
      })).set({password, invite_code}).create({
        parent: null,
        attributes: ['password', 'invite_code'],
        success: (model, data) => {
          var user, user_data;
          user_data = User.prototype.expand(data).toObject();
          user = new User(user_data);
          return resolve(user);
        },
        //END success
        error: (model, error) => {
          return reject(error);
        }
      });
    });
  }

  //END promiseRegisterRegion
  //END error
  promiseClaimGameKit({franchisee_id, game_kit_code} = {}) {
    return Q.Promise((resolve, reject) => {
      if (franchisee_id == null) {
        throw new Error("Franchisee Id must be specified");
      }
      if (game_kit_code == null) {
        throw new Error("GameKit code must be specified");
      }
      if (!GameKit.isValidCode(game_kit_code)) {
        throw new Error("Valid GameKit code must be given");
      }
      return (new Falcon.Model({
        endpoint: "rpc/claim_game_kit"
      })).set({franchisee_id, game_kit_code}).create({
        parent: null,
        attributes: ['franchisee_id', 'game_kit_code'],
        success: (model, data) => {
          var game_kit, game_kit_data;
          game_kit_data = GameKit.prototype.expand(data).toObject();
          game_kit = new GameKit(game_kit_data);
          return resolve(game_kit);
        },
        //END success
        error: (model, error) => {
          return reject(error);
        }
      });
    });
  }

  //END promiseClaimGameKit
  //END error
  promiseCheckGameCode(code) {
    return Q.Promise((resolve, reject) => {
      // throw new Error("GameKit code must be specified") unless code?
      // throw new Error("Valid game code must be given") unless Entry.isValidCode(code)
      return (new Falcon.Model({
        endpoint: "rpc/check_game_code"
      })).set({code}).create({
        parent: null,
        attributes: ['code'],
        success: (model, data) => {
          var entry, entry_data;
          entry_data = Entry.prototype.expand(data).toObject();
          entry = new Entry(entry_data);
          return resolve(entry);
        },
        //END success
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promiseCheckGameCode
  //END error
  promiseClaimGameCode(code) {
    return Q.Promise((resolve, reject) => {
      if (code == null) {
        throw new Error("Game code must be specified");
      }
      if (!Entry.isValidCode(code)) {
        throw new Error("Valid game code must be given");
      }
      return (new Falcon.Model({
        endpoint: "rpc/claim_game_code"
      })).set({code}).create({
        parent: null,
        attributes: ['code'],
        success: (model, data) => {
          var entry, entry_data;
          entry_data = Entry.prototype.expand(data).toObject();
          entry = new Entry(entry_data);
          return resolve(entry);
        },
        //END success
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promiseClaimGameCode
  //END error
  promisePickGlobalContestWinner({contest} = {}) {
    return Q.Promise((resolve, reject) => {
      if (!(contest instanceof Contest)) {
        throw new Error("contest must be an instanceof Contest");
      }
      if (contest.isNew()) {
        throw new Error("contest must not be new");
      }
      if (contest.get('type') !== Contest.GLOBAL_TYPE) {
        throw new Error("contest must be a franchisee type contest");
      }
      return (new Falcon.Model({
        endpoint: "rpc/pick_global_contest_winner"
      })).set({
        contest_id: contest.get('id')
      }).create({
        parent: null,
        attributes: ['contest_id'],
        success: (model, data) => {
          var contest_winner, contest_winner_data;
          contest_winner_data = ContestWinner.prototype.expand(data).toObject();
          contest_winner = new ContestWinner(contest_winner_data);
          return resolve(contest_winner);
        },
        //END success
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promisePickGlobalContestWinner
  //END error
  promiseManuallyPickGlobalContestWinner({contest, winner_name} = {}) {
    return Q.Promise((resolve, reject) => {
      if (!(contest instanceof Contest)) {
        throw new Error("contest must be an instanceof Contest");
      }
      if (contest.isNew()) {
        throw new Error("contest must not be new");
      }
      if (contest.get('type') !== Contest.GLOBAL_TYPE) {
        throw new Error("contest must be a global type contest");
      }
      return (new Falcon.Model({
        endpoint: "rpc/manually_pick_global_contest_winner"
      })).set({
        contest_id: contest.get('id'),
        winner_name: winner_name
      }).create({
        parent: null,
        attributes: ['contest_id', 'winner_name'],
        success: (model, data) => {
          var contest_winner, contest_winner_data;
          contest_winner_data = ContestWinner.prototype.expand(data).toObject();
          contest_winner = new ContestWinner(contest_winner_data);
          return resolve(contest_winner);
        },
        //END success
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promiseManuallyPickFPTContestWinner
  //END error
  promisePickFPTContestWinners({contest} = {}) {
    return Q.Promise((resolve, reject) => {
      if (!(contest instanceof Contest)) {
        throw new Error("contest must be an instanceof Contest");
      }
      if (contest.isNew()) {
        throw new Error("contest must not be new");
      }
      if (contest.get('type') !== Contest.FPT_TYPE) {
        throw new Error("contest must be a franchisee type contest");
      }
      return (new Falcon.Model({
        endpoint: "rpc/pick_fpt_contest_winners"
      })).set({
        contest_id: contest.get('id')
      }).create({
        parent: null,
        attributes: ['contest_id'],
        success: (model, data) => {
          var contest_winners, contest_winners_data;
          contest_winners_data = ContestWinner.prototype.expand(data).toArray();
          contest_winners = new ContestWinners(contest_winners_data);
          return resolve(contest_winners);
        },
        //END success
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promisePickFPTContestWinners
  //END error
  promisePickFPTContestWinner({fpt, contest} = {}) {
    return Q.Promise((resolve, reject) => {
      if (!(fpt instanceof FPT)) {
        throw new Error("fpt must be an instanceof FPT");
      }
      if (fpt.isNew()) {
        throw new Error("fpt must not be new");
      }
      if (!(contest instanceof Contest)) {
        throw new Error("contest must be an instanceof Contest");
      }
      if (contest.isNew()) {
        throw new Error("contest must not be new");
      }
      if (contest.get('type') !== Contest.FPT_TYPE) {
        throw new Error("contest must be a fpt type contest");
      }
      return (new Falcon.Model({
        endpoint: "rpc/pick_fpt_contest_winner"
      })).set({
        fpt_id: fpt.get('id'),
        contest_id: contest.get('id')
      }).create({
        parent: null,
        attributes: ['fpt_id', 'contest_id'],
        success: (model, data) => {
          var contest_winner, contest_winner_data;
          contest_winner_data = ContestWinner.prototype.expand(data).toObject();
          contest_winner = new ContestWinner(contest_winner_data);
          return resolve(contest_winner);
        },
        //END success
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promisePickFPTContestWinner
  //END error
  promiseManuallyPickFPTContestWinner({fpt, contest, winner_name} = {}) {
    return Q.Promise((resolve, reject) => {
      if (!(fpt instanceof FPT)) {
        throw new Error("fpt must be an instanceof FPT");
      }
      if (fpt.isNew()) {
        throw new Error("fpt must not be new");
      }
      if (!(contest instanceof Contest)) {
        throw new Error("contest must be an instanceof Contest");
      }
      if (contest.isNew()) {
        throw new Error("contest must not be new");
      }
      if (contest.get('type') !== Contest.FPT_TYPE) {
        throw new Error("contest must be a fpt type contest");
      }
      return (new Falcon.Model({
        endpoint: "rpc/manually_pick_fpt_contest_winner"
      })).set({
        fpt_id: fpt.get('id'),
        contest_id: contest.get('id'),
        winner_name: winner_name
      }).create({
        parent: null,
        attributes: ['fpt_id', 'contest_id', 'winner_name'],
        success: (model, data) => {
          var contest_winner, contest_winner_data;
          contest_winner_data = ContestWinner.prototype.expand(data).toObject();
          contest_winner = new ContestWinner(contest_winner_data);
          return resolve(contest_winner);
        },
        //END success
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promiseManuallyPickFPTContestWinner
  //END error
  promisePickFranchiseeContestWinner({franchisee, contest} = {}) {
    return Q.Promise((resolve, reject) => {
      if (!(franchisee instanceof Franchisee)) {
        throw new Error("franchisee must be an instanceof Franchisee");
      }
      if (franchisee.isNew()) {
        throw new Error("franchisee must not be new");
      }
      if (!(contest instanceof Contest)) {
        throw new Error("contest must be an instanceof Contest");
      }
      if (contest.isNew()) {
        throw new Error("contest must not be new");
      }
      if (contest.get('type') !== Contest.FRANCHISEE_TYPE) {
        throw new Error("contest must be a franchisee type contest");
      }
      return (new Falcon.Model({
        endpoint: "rpc/pick_franchisee_contest_winner"
      })).set({
        franchisee_id: franchisee.get('id'),
        contest_id: contest.get('id')
      }).create({
        parent: null,
        attributes: ['franchisee_id', 'contest_id'],
        success: (model, data) => {
          var contest_winner, contest_winner_data;
          contest_winner_data = ContestWinner.prototype.expand(data).toObject();
          contest_winner = new ContestWinner(contest_winner_data);
          return resolve(contest_winner);
        },
        //END success
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promisePickFranchiseeContestWinner
  //END error
  promiseManuallyPickFranchiseeContestWinner({franchisee, contest, winner_name} = {}) {
    return Q.Promise((resolve, reject) => {
      if (!(franchisee instanceof Franchisee)) {
        throw new Error("franchisee must be an instanceof Franchisee");
      }
      if (franchisee.isNew()) {
        throw new Error("franchisee must not be new");
      }
      if (!(contest instanceof Contest)) {
        throw new Error("contest must be an instanceof Contest");
      }
      if (contest.isNew()) {
        throw new Error("contest must not be new");
      }
      if (contest.get('type') !== Contest.FRANCHISEE_TYPE) {
        throw new Error("contest must be a franchisee type contest");
      }
      return (new Falcon.Model({
        endpoint: "rpc/manually_pick_franchisee_contest_winner"
      })).set({
        franchisee_id: franchisee.get('id'),
        contest_id: contest.get('id'),
        winner_name: winner_name
      }).create({
        parent: null,
        attributes: ['franchisee_id', 'contest_id', 'winner_name'],
        success: (model, data) => {
          var contest_winner, contest_winner_data;
          contest_winner_data = ContestWinner.prototype.expand(data).toObject();
          contest_winner = new ContestWinner(contest_winner_data);
          return resolve(contest_winner);
        },
        //END success
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promiseManuallyPickFranchiseeContestWinner
  //END error
  promiseDrawContestFinalists({contest, fpt, franchisee}) {
    return Q.Promise((resolve, reject) => {
      var data;
      if (!(contest instanceof Contest)) {
        throw new Error("contest must be provided");
      }
      if (contest.isNew()) {
        throw new Error("contest must not be new");
      }
      data = {};
      data['contest_id'] = contest.get('id');
      if (contest.get('type') === Contest.FPT_TYPE) {
        if (!(fpt instanceof FPT)) {
          throw new Error("fpt must be provided");
        }
        if (fpt.isNew()) {
          throw new Error("fpt must not be new");
        }
        data["fpt_id"] = fpt.get('id');
      } else if (contest.get('type') === Contest.FRANCHISEE_TYPE) {
        if (!(franchisee instanceof Franchisee)) {
          throw new Error("franchisee must be provided");
        }
        if (franchisee.isNew()) {
          throw new Error("franchisee must not be new");
        }
        data["franchisee_id"] = franchisee.get('id');
      }
      //END if
      return new Falcon.Model({
        endpoint: "rpc/draw_contest_finalists"
      }).set(data).create({
        parent: null,
        attributes: _.keys(data),
        success: (model, data) => {
          var contest_finalist_data, contest_finalists;
          contest_finalist_data = ContestFinalist.prototype.expand(data).toArray();
          contest_finalists = new ContestFinalists(contest_finalist_data);
          return resolve(contest_finalists);
        },
        //END success
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promiseDrawContestFinalists
  //END error
  promiseMoveParticipantEntries({user_id, contest_id, franchisee_id}) {
    return Q.Promise((resolve, reject) => {
      if (user_id == null) {
        throw new Error("user_id must be present");
      }
      if (contest_id == null) {
        throw new Error("contest_id must be present");
      }
      if (franchisee_id == null) {
        throw new Error("franchisee_id must be present");
      }
      return new Falcon.Model({
        endpoint: "rpc/move_participant_entries",
        user_id,
        contest_id,
        franchisee_id
      }).create({
        attributes: ['user_id', 'contest_id', 'franchisee_id'],
        parent: null,
        success: (model, data) => {
          var entries, entries_data;
          entries_data = Entry.prototype.expand(data).toArray();
          entries = new Entries(entries_data);
          return resolve(entries);
        },
        //END success
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promiseMoveParticipantEntries
  //END error
  promiseMoveEntriesBetweenUsers({from_user_id, to_user_id}) {
    return Q.Promise((resolve, reject) => {
      if (from_user_id == null) {
        throw new Error("from_user_id must be present");
      }
      if (to_user_id == null) {
        throw new Error("to_user_id must be present");
      }
      return new Falcon.Model({
        endpoint: "rpc/move_entries_between_users",
        from_user_id,
        to_user_id
      }).create({
        attributes: ['from_user_id', 'to_user_id'],
        parent: null,
        success: (model, data) => {
          return resolve();
        },
        //END success
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promiseMoveEntriesBetweenUsers

    //TODO: Move these attributes over to a ContestStatistic Model
  //END error
  promiseAdditionalContestStatistics({contest_id}) {
    return Q.Promise((resolve, reject) => {
      if (contest_id == null) {
        throw new Error("contest_id must be present");
      }
      return new Falcon.Model({
        endpoint: "rpc/additional_contest_statistics",
        contest_id
      }).create({
        attributes: ['contest_id'],
        parent: null,
        success: (model, data) => {
          return resolve(data);
        },
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promiseAdditionalContestStatistics
  //END error
  promiseEmailParticipants({franchisee_id, email_template, subject, headline, body, media, tag}) {
    return Q.Promise((resolve, reject) => {
      if (franchisee_id == null) {
        throw new Error("franchisee_id must be present");
      }
      if (subject == null) {
        throw new Error("subject must be present");
      }
      if (body == null) {
        throw new Error("body must be present");
      }
      if (headline == null) {
        throw new Error("headline must be present");
      }
      return new Falcon.Model({
        endpoint: "rpc/email_participants",
        franchisee_id,
        email_template,
        subject,
        headline,
        body,
        media,
        tag
      }).create({
        attributes: ['franchisee_id', 'email_template', 'subject', 'headline', 'body', 'media', 'tag'],
        parent: null,
        success: (model, data) => {
          return resolve(data);
        },
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promiseEmailParticipants
  //END error
  promiseGetFranchiseeUserStats({franchisee_id, tags = []}) {
    return Q.Promise((resolve, reject) => {
      if (franchisee_id == null) {
        throw new Error("franchisee_id must be present");
      }
      return new Falcon.Model({
        endpoint: "rpc/franchisee_user_stats",
        franchisee_id,
        tags
      }).create({
        attributes: ['franchisee_id', 'tags'],
        parent: null,
        success: (model, data) => {
          return resolve(data);
        },
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promiseGetFranchiseeUserStats
  //END error
  promiseGetFranchiseeTagStats({franchisee_id, tags = []}) {
    return Q.Promise((resolve, reject) => {
      if (franchisee_id == null) {
        throw new Error("franchisee_id must be present");
      }
      return new Falcon.Model({
        endpoint: "rpc/franchisee_tag_stats",
        franchisee_id,
        tags
      }).create({
        attributes: ['franchisee_id', 'tags'],
        parent: null,
        success: (model, data) => {
          return resolve(data);
        },
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promiseGetFranchiseeTagStats
  //END error
  promiseDrawIntermediaryWinner({franchisee_id}) {
    return Q.Promise((resolve, reject) => {
      if (franchisee_id == null) {
        throw new Error("franchisee_id must be present");
      }
      return new Falcon.Model({
        endpoint: "rpc/draw_intermediary_winner",
        franchisee_id
      }).create({
        attributes: ['franchisee_id'],
        parent: null,
        success: (model, data) => {
          var entry, entry_data;
          entry_data = Entry.prototype.expand(data).toObject();
          entry = new Entry(entry_data);
          return resolve(entry);
        },
        //END success
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promiseDrawIntermediaryWinner
  //END error
  promiseUnlinkUser({tag, user_id, franchisee_id}) {
    return Q.Promise((resolve, reject) => {
      if (tag == null) {
        throw new Error("tag must be present");
      }
      if (franchisee_id == null) {
        throw new Error("franchisee_id must be present");
      }
      if (user_id == null) {
        throw new Error("user_id must be present");
      }
      return new Falcon.Model({
        endpoint: "rpc/unlink_user",
        franchisee_id,
        user_id,
        tag
      }).create({
        attributes: ['franchisee_id', 'user_id', 'tag'],
        parent: null,
        success: (model, data) => {
          var franchisee, franchisee_data;
          franchisee_data = Franchisee.prototype.expand(data).toObject();
          franchisee = new Franchisee(franchisee_data);
          return resolve(franchisee);
        },
        //END success
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promiseUnlinkUser
  //END error
  promiseCheckEmail(email) {
    return Q.Promise((resolve, reject) => {
      if (email == null) {
        throw new Error("email must be present");
      }
      return new Falcon.Model({
        endpoint: "rpc/check_email",
        email
      }).create({
        attributes: ['email'],
        parent: null,
        success: (model, data) => {
          return resolve((data != null ? data.is_taken : void 0) || false);
        },
        //END success
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promiseCheckEmail
  //END error
  promiseSelectRaceWinner(race) {
    return Q.Promise((resolve, reject) => {
      if (!(race instanceof Race)) {
        throw new Error("race must be an instanceof Race");
      }
      return new Falcon.Model({
        endpoint: "rpc/select_race_winner",
        race_id: race.get('id'),
        selected_race_option_id: race.get('selected_race_option_id')
      }).create({
        attributes: ['race_id', 'selected_race_option_id'],
        parent: null,
        success: (model, data) => {
          var race_data;
          race_data = Race.prototype.expand(data).toObject();
          race = new Race().fill(race_data);
          return resolve(race);
        },
        //END success
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promiseSelectRaceWinner
  //END error
  promiseMarkRaceSelection(race_selection) {
    return Q.Promise((resolve, reject) => {
      if (!(race_selection instanceof RaceSelection)) {
        throw new Error("race_selection must be an instanceof RaceSelection");
      }
      return new Falcon.Model({
        endpoint: "rpc/mark_race_selection",
        race_selection_id: race_selection.get('id')
      }).create({
        attributes: ['race_selection_id'],
        parent: null,
        success: (model, data) => {
          var race_selection_data;
          race_selection_data = RaceSelection.prototype.expand(data).toObject();
          race_selection = new Race().fill(race_selection_data);
          return resolve(race_selection);
        },
        //END success
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

})();

//END promiseMarkRaceSelection
//END class
//END error

},{"./$collections/contest_finalists.collection":24,"./$collections/contest_winners.collection":25,"./$collections/entries.collection":27,"./$collections/franchisees.collection":34,"./$models/contest.model":56,"./$models/contest_finalist.model":57,"./$models/contest_winner.model":58,"./$models/entry.model":59,"./$models/fpt.model":60,"./$models/franchisee.model":63,"./$models/game_kit.model":67,"./$models/invite.model":68,"./$models/race.model":71,"./$models/race_selection.model":73,"./$models/session.model":77,"./$models/user.model":81}],90:[function(require,module,exports){
//Import environment specific requirements
var Application, Entry, Environment, LayoutView, Session;

Environment = require("./environment");

Session = require("../$models/session.model");

Entry = require("../$models/entry.model");

LayoutView = require("./views/layout.view");

module.exports = Application = new ((function() {
  var _Class, ref;

  _Class = class extends Falcon.Object {
    //END current_user
    //END observables
    init() {
      Environment.resolve();
      Language.loadFromCache();
      Tutorial.loadFromCache();
      window.RPC = require("../rpc");
      this.checkIsOnMobile();
      this.checkIncomingGameCode();
      this.attachWindowEvents();
      this.attachAdapterEvents();
      this.Layout = new LayoutView();
      return this.promiseCheckSession().then((session) => {
        return this.login(session);
      }).fail((error) => {
        if (error == null) {
          return;
        }
        return this.flashError(error);
      }).fin(() => {
        return Falcon.apply(this.Layout, '#application', () => {
          return Finch.options({
            CoerceParameterTypes: true
          }).listen();
        });
      }).done();
    }

    //END promiseCheckSession
    //END init
    promiseCheckSession() {
      return Q.Promise((resolve, reject) => {
        if (this.is_checking_session()) {
          return reject(null);
        }
        this.is_checking_session(true);
        return (new Session()).promiseFetch().then(resolve, reject).fin(() => {
          return this.is_checking_session(false);
        }).done();
      });
    }

    //END promise chain
    //END checkSession
    login(session) {
      session = ko.unwrap(session);
      if (!(session instanceof Session)) {
        throw new Error("session must be an instance of Session");
      }
      //END unless
      this.current_session(session);
      Application.trigger('login', session);
      return this;
    }

    //END login
    logout() {
      if (!this.is_logged_in()) {
        return this;
      }
      (new Session()).promiseDestroy().then(() => {
        this.current_session(null);
        return this.trigger('logout');
      }).done();
      //END promise chain
      return this;
    }

    //END logout
    flashError(error) {
      switch (false) {
        case !RequestHelpers.isUnauthorized(error):
          return typeof console !== "undefined" && console !== null ? console.error("Session Expired") : void 0;
        default:
          return Application.reportError(error);
      }
    }

    //END flashError
    reportError(error) {
      var ref1, ref2;
      if (error == null) {
        error = {
          human: "An error occurred"
        };
      }
      if (typeof console !== "undefined" && console !== null) {
        console.error((ref1 = (ref2 = error.stack) != null ? ref2 : error.human) != null ? ref1 : "An error occurred");
      }
      return this;
    }

    //END reportError
    attachWindowEvents() {
      window.addEventListener('online', () => {
        return this.is_online(true);
      });
      window.addEventListener('offline', () => {
        return this.is_online(false);
      });
      window.addEventListener('resize', () => {
        return this.checkIsOnMobile();
      });
      window.addEventListener('click', () => {
        return Application.trigger("window:click");
      });
      return this;
    }

    //END attachWindowEvents
    attachAdapterEvents() {
      this.listenTo(Falcon.dataAdapter, 'unauthorized', this.logout);
      return this;
    }

    //END attachAdapterEvents
    checkIsOnMobile() {
      if (window.hasOwnProperty('matchMedia')) {
        return this.is_on_mobile(window.matchMedia("(max-width: 640px) and (orientation: portrait), screen and (max-width: 1138px) and (orientation: landscape)").matches);
      } else {
        return this.is_on_mobile(false);
      }
    }

    //END if
    //EHC checkIsOnMobile
    checkIncomingGameCode() {
      var code, e, i, key, len, params, query_piece, query_pieces, query_string, value;
      params = {};
      query_string = window.location.search;
      if (query_string.charAt("0") === "?") {
        query_string = query_string.slice(1);
      }
      query_pieces = query_string.split("&");
      code = null;
      for (i = 0, len = query_pieces.length; i < len; i++) {
        query_piece = query_pieces[i];
        [key, value] = query_piece.split("=", 2);
        if (key === "code") {
          code = value;
        }
      }
      //END for
      this.incoming_code(code);
      if (code != null) {
        try {
          return gtag('event', 'load', {
            'event_category': 'qr-code',
            'event_label': 'Dream Drive 2021',
            'value': 1
          });
        } catch (error1) {
          e = error1;
          return console.error(e);
        }
      }
    }

    //END try/catch
    //END if
    //END checkIncomingGameCode
    hasClaimedEntry() {
      return this.claimed_entry() instanceof Entry;
    }

    getClaimedEntry() {
      return this.claimed_entry();
    }

    clearClaimedEntry() {
      return this.claimed_entry(null);
    }

    setClaimedEntry(entry) {
      if (!(entry instanceof Entry)) {
        throw new Error("entry must be an instanceof Entry");
      }
      return this.claimed_entry(entry);
    }

    //END setClaimedEntry
    retrieveIncomingGameCode() {
      var code;
      code = this.incoming_code();
      this.incoming_code(null);
      return code;
    }

  };

  _Class.prototype.observables = {
    'is_online': (ref = typeof navigator !== "undefined" && navigator !== null ? navigator.onLine : void 0) != null ? ref : true,
    'is_checking_session': false,
    'claimed_entry': null,
    'incoming_code': null,
    'current_session': null,
    'is_logged_in': function() {
      return this.current_session() instanceof Session;
    },
    'is_on_mobile': false,
    'current_user': function() {
      if (!this.is_logged_in()) {
        return null;
      }
      return this.current_session().get('user');
    }
  };

  return _Class;

}).call(this))();

//END retrieveIncomingGameCode
//END Application

},{"../$models/entry.model":59,"../$models/session.model":77,"../rpc":89,"./environment":95,"./views/layout.view":106}],91:[function(require,module,exports){
var DOMHelpers;

DOMHelpers = require("../../$helpers/dom.helpers");

Falcon.addBinding("customHeroAnimation", {
  init: function(element, valueAccessor) {
    var hero_banners, hero_content, player, src;
    src = ko.unwrap(valueAccessor());
    element.setAttribute("src", src);
    player = new Vimeo.Player(element);
    player.setMuted(true);
    player.ready().then(() => {
      return console.log("READY");
    });
    hero_content = $(".so-hero--content");
    hero_banners = $(".so-hero--banners");
    return player.on('timeupdate', (info) => {
      if (info.seconds >= 4) {
        hero_banners.addClass("is-visible");
      }
      if (info.seconds >= 4.5) {
        return hero_content.addClass("is-visible");
      }
    });
  }
});

//END on
//END customHeroAnimation

},{"../../$helpers/dom.helpers":51}],92:[function(require,module,exports){
var tempElm;

tempElm = document.createElement("div");

Falcon.addBinding("lang", true, function(element, valueAccessor) {
  tempElm.innerHTML = Language(ko.unwrap(valueAccessor()));
  return ko.virtualElements.setDomNodeChildren(element, Array.prototype.slice.call(tempElm.childNodes));
});

//END lang

},{}],93:[function(require,module,exports){
Falcon.addBinding('placeholder', function(element, valueAccessor) {
  var temp;
  temp = document.createElement('span');
  temp.innerHTML = Language(ko.unwrap(valueAccessor()));
  return element.setAttribute('placeholder', temp.textContent);
});

//END addBinding

},{}],94:[function(require,module,exports){
(function (global){(function (){
// Import globals
require("../$polyfills/function.bind");

require("../$polyfills/requestAnimationFrame");

require("../$bindings/dateText.binding");

require("../$bindings/dateTimeText.binding");

require("../$bindings/dateValue.binding");

require("../$bindings/daysUntilText.binding");

require("../$bindings/fromNowText.binding");

require("../$bindings/hashHref.binding");

require("../$bindings/href.binding");

require("../$bindings/isHovered.binding");

require("../$bindings/moment.binding");

require("../$bindings/monthText.binding");

require("../$bindings/monthYearText.binding");

require("../$bindings/followCursor.binding");

require("../$bindings/onEnter.binding");

require("../$bindings/onScrollBottom.binding");

require("../$bindings/preventDefault.binding");

require("../$bindings/s3Upload.binding");

require("../$bindings/selectize.binding");

require("../$bindings/src.binding");

require("../$bindings/stopEvent.binding");

require("../$bindings/stopPropagation.binding");

require("../$bindings/percent.binding");

require("../$bindings/integer.binding");

require("../$bindings/decimal.binding");

require("./bindings/lang.binding");

require("./bindings/placeholder.binding");

require("./bindings/customHeroAnimation.binding");

require("../extenders");

require("./ipinfo");

global.Helpers = require("../$helpers/default.helpers");

global.DOMHelpers = require("../$helpers/dom.helpers");

global.RequestHelpers = require("../$helpers/request.helpers");

global.Router = require("./router");

global.Application = require("./application");

global.Language = require("./language");

global.Tutorial = require("./tutorial");

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../$bindings/dateText.binding":1,"../$bindings/dateTimeText.binding":2,"../$bindings/dateValue.binding":3,"../$bindings/daysUntilText.binding":4,"../$bindings/decimal.binding":5,"../$bindings/followCursor.binding":6,"../$bindings/fromNowText.binding":7,"../$bindings/hashHref.binding":8,"../$bindings/href.binding":9,"../$bindings/integer.binding":10,"../$bindings/isHovered.binding":11,"../$bindings/moment.binding":12,"../$bindings/monthText.binding":13,"../$bindings/monthYearText.binding":14,"../$bindings/onEnter.binding":15,"../$bindings/onScrollBottom.binding":16,"../$bindings/percent.binding":17,"../$bindings/preventDefault.binding":18,"../$bindings/s3Upload.binding":19,"../$bindings/selectize.binding":20,"../$bindings/src.binding":21,"../$bindings/stopEvent.binding":22,"../$bindings/stopPropagation.binding":23,"../$helpers/default.helpers":50,"../$helpers/dom.helpers":51,"../$helpers/request.helpers":52,"../$polyfills/function.bind":83,"../$polyfills/requestAnimationFrame":84,"../extenders":86,"./application":90,"./bindings/customHeroAnimation.binding":91,"./bindings/lang.binding":92,"./bindings/placeholder.binding":93,"./ipinfo":96,"./language":97,"./router":98,"./tutorial":99}],95:[function(require,module,exports){
//==================================================================
// Class: Environment
//	Class used to configure the application with specific
//	environment related settings.  This should never be instantiated
//	and should only be used for its static methods
//==================================================================
var Analytics, Environment, JWTAdapater;

JWTAdapater = require("../jwt_adapter");

Analytics = require("../analytics");

module.exports = Environment = new ((function() {
  var _Class;

  _Class = class {
    //--------------------------------------------------------------
    // Method: Environment.configure('environment')
    //	Used to configure the environment variables for a given
    //	environment. If no environment is given or the given
    //	environment is not defined, the "local" environment method
    //	is called.
    //--------------------------------------------------------------
    configure(environment) {
      var setup_method;
      if (!_.isString(environment)) {
        environment = "local";
      }
      environment = Helpers.trim(environment).toLowerCase();
      if (environment === "configure") {
        environment = "local";
      }
      setup_method = this[environment];
      if (!_.isFunction(setup_method)) {
        setup_method = this.local;
      }
      if (setup_method == null) {
        setup_method = (function() {});
      }
      this.all();
      setup_method();
      return this;
    }

    //END configure

      //--------------------------------------------------------------
    // Method: Environment.resolve()
    //	Attempts to resolve the environment based on the window location
    //--------------------------------------------------------------
    resolve() {
      var _match;
      _match = function(url) {
        return window.location.href.indexOf(url) > -1;
      };
      if (_match("localhost:9000") || _match("localhost.com:9000")) {
        // return @redirect('localhost:9000') if _match("localhost.com:9000")
        return this.configure('local');
      }
      if (_match("www-dev.toronto.snaponpromotion.com")) {
        return this.configure('development');
      }
      if (_match("toronto.snaponpromotion.com")) {
        // return @configure('production') if _match("www.snaponpromotion.com")
        return this.configure('production');
      }
      throw "Could not resolve the environment.";
    }

    //END resolve
    redirect(url) {
      url = url + "/" + window.location.hash;
      url = ` ${url}`.replace(/([^:])\/+/gi, "$1/");
      url = Helpers.trim(url);
      if (!/^https?:\/\//gi.test(url)) {
        url = `http://${url}`;
      }
      window.location.href = url;
      return this;
    }

    //END redirect

      //--------------------------------------------------------------
    // Method: Environment.all
    //	Called before each environment specific configure
    //--------------------------------------------------------------
    all() {
      Falcon.dataAdapter = new JWTAdapater();
      Falcon.dataAdapter.cache = true;
      //Set up cors
      $.ajaxSetup({
        headers: {
          'Accept': "application/json; charset=utf-8",
          'Content-Type': "application/json; charset=utf-8"
        },
        //END headers
        crossDomain: true
      });
      //END ajaxSetup
      $.support.cors = true;
      return this;
    }

    //END all

      //--------------------------------------------------------------
    // Method: Environment.production()
    //	Sets up production settings
    //--------------------------------------------------------------
    production() {
      Falcon.baseApiUrl = "https://api.toronto.snaponpromotion.com";
      if (typeof Raven !== "undefined" && Raven !== null) {
        Raven.config('https://f50384c08c0c46f48bd5f681ed254ccd@o58646.ingest.sentry.io/4504052875001856').install({
          environment: "production",
          tags: {
            app: "web"
          }
        });
      }
      Analytics.init("e2388cfbb4cb18b9e0f580360d8305e2", 'technician');
      return this;
    }

    //END production

      //--------------------------------------------------------------
    // Method: Environment.development()
    //	Sets up development settings
    //--------------------------------------------------------------
    development() {
      Falcon.baseApiUrl = "https://api-dev.toronto.snaponpromotion.com";
      if (typeof Raven !== "undefined" && Raven !== null) {
        Raven.config('https://4a6ed715b0ea45ff91894d97f8b30e5a@o58646.ingest.sentry.io/4504052871659520').install({
          environment: "development",
          tags: {
            app: "web"
          }
        });
      }
      Analytics.init("b3b9b35d23a5fc6a02f7168f6cf95dab", 'technician', true);
      return this;
    }

    //END development

      //--------------------------------------------------------------
    // Method: Environment.local()
    //	Sets up local settings
    //--------------------------------------------------------------
    local() {
      Falcon.baseApiUrl = "https://localhost:65431";
      if (typeof Raven !== "undefined" && Raven !== null) {
        Raven.config('https://69ad8cff7b9b499aad29bb135da1f8ec@o58646.ingest.sentry.io/4504052891582464').install({
          environment: "local",
          tags: {
            app: "web"
          }
        });
      }
      Analytics.init("a469757d470f4a7bb24cd0803954a408", 'technician', true);
      return this;
    }

  };

  window.ENV = {};

  return _Class;

}).call(this))();

//END local
//END Environement

},{"../analytics":85,"../jwt_adapter":88}],96:[function(require,module,exports){
(function() {
  var country, ip, script;
  ip = ko.observable();
  country = ko.observable();
  window.IPInfo = {
    ip,
    country,
    isLoaded: ko.observable(false),
    isInUnitedStates: ko.computed(function() {
      return /^(united states|us)$/i.test(country());
    }),
    //END isInUnitedStates
    isInCanada: ko.computed(function() {
      return /^ca(nada)?$/i.test(country());
    })
  };
  //END isInCanada
  window.ipinfoJsonpResponse = function(data) {
    IPInfo.ip(data.ip);
    IPInfo.country(data.country);
    return IPInfo.isLoaded(true);
  };
  //END ipinfoJsonpResponse
  script = document.createElement('script');
  script.src = window.location.protocol + '//ipinfo.io?callback=ipinfoJsonpResponse';
  return document.head.appendChild(script);
})();

// document.getElementsByTagName('head')[0].appendChild(script);
//END do

},{}],97:[function(require,module,exports){
var LANGUAGE_CODE_KEY, Language;

LANGUAGE_CODE_KEY = "__SO_LANGUAGE_CODE__";

Language = function(translationText) {
  var language;
  if (!_.isString(translationText)) {
    return translationText;
  }
  language = Language.resolveLanguage();
  if ((translationText in language.translations) && (language.translations[translationText] != null)) {
    return language.translations[translationText];
  }
  //END if
  if (language !== Language.DEFAULT) {
    if (typeof console !== "undefined" && console !== null) {
      console.warn(`Couldn't find translation for: '${translationText}'`);
    }
  }
  //END if
  return translationText;
};

//END Language
Language.LANGUAGES = {
  "us/en": require("../$languages/en-us.language"),
  "ca/en": require("../$languages/en-ca.language"),
  "ca/fr": require("../$languages/fr-ca.language")
};

Language.DEFAULT = Language.LANGUAGES["us/en"];

Language.selectedLanguageCode = ko.observable(void 0);

Language.hasSelectedLanguage = ko.computed(function() {
  var code;
  code = Language.selectedLanguageCode();
  if (code == null) {
    return false;
  }
  return code in Language.LANGUAGES;
});

//END hasSelectedLanguage
Language.isFrench = ko.computed(function() {
  return Language.selectedLanguageCode() === "ca/fr";
});

Language.selectCode = function(code) {
  var e, message, ref;
  if (_.isString(code) && (code in Language.LANGUAGES)) {
    Language.selectedLanguageCode(code);
    try {
      localStorage[LANGUAGE_CODE_KEY] = code;
    } catch (error) {
      e = error;
      message = (ref = e.message) != null ? ref : "QuotaExceededError";
      if (typeof Raven !== "undefined" && Raven !== null) {
        Raven.captureMessage(message, {
          'level': 'warning'
        });
      }
      if (typeof console !== "undefined" && console !== null) {
        console.error(e);
      }
    }
  }
  //END try
  //END if
  return Language.selectedLanguageCode();
};

//END selectByCode
Language.loadFromCache = function() {
  var code, e, language, message, ref;
  try {
    if (localStorage[LANGUAGE_CODE_KEY] == null) {
      return;
    }
    code = localStorage[LANGUAGE_CODE_KEY];
    if (!_.isString(code)) {
      delete localStorage[LANGUAGE_CODE_KEY];
      return;
    }
    //END unless
    language = Language.LANGUAGES[code];
    if (code in Language.LANGUAGES) {
      return Language.selectedLanguageCode(code);
    } else {
      return delete localStorage[LANGUAGE_CODE_KEY];
    }
  } catch (error) {
    //END If
    e = error;
    message = (ref = e.message) != null ? ref : "QuotaExceededError";
    if (typeof Raven !== "undefined" && Raven !== null) {
      Raven.captureMessage(message, {
        'level': 'warning'
      });
    }
    return typeof console !== "undefined" && console !== null ? console.error(e) : void 0;
  }
};

//END try
//END loadFromCache
Language.clear = function() {
  var code, e, message, ref;
  if (!Language.hasSelectedLanguage()) {
    return;
  }
  code = Language.selectedLanguageCode();
  Language.selectedLanguageCode(void 0);
  try {
    return delete localStorage[code];
  } catch (error) {
    e = error;
    message = (ref = e.message) != null ? ref : "QuotaExceededError";
    if (typeof Raven !== "undefined" && Raven !== null) {
      Raven.captureMessage(message, {
        'level': 'warning'
      });
    }
    return typeof console !== "undefined" && console !== null ? console.error(e) : void 0;
  }
};

//END try
//END clear
Language.resolveLanguage = function() {
  var code, ref;
  code = Language.selectedLanguageCode() || "";
  return (ref = Language.LANGUAGES[code]) != null ? ref : Language.DEFAULT;
};

//END resolveLanguage
Language.isWithinUnitedStates = ko.computed(function() {
  var ref;
  return (ref = Language.selectedLanguageCode()) === "us/en";
});

Language.isWithinCanada = ko.computed(function() {
  var ref;
  return (ref = Language.selectedLanguageCode()) === "ca/en" || ref === "ca/fr";
});

module.exports = Language;

},{"../$languages/en-ca.language":53,"../$languages/en-us.language":54,"../$languages/fr-ca.language":55}],98:[function(require,module,exports){
//Require models
var ChangePasswordView, CheckGameCodeView, DashboardView, ForgotPasswordView, HomeView, LoginView, ManageAccountView, RegistrationView, ResetPasswordView, Router, SurveyView, User;

User = require("../$models/user.model");

//Require Views
ChangePasswordView = require("./views/change_password.view");

CheckGameCodeView = require("./views/check_game_code.view");

DashboardView = require("./views/dashboard.view");

ForgotPasswordView = require("./views/forgot_password.view");

HomeView = require("./views/home.view");

LoginView = require("./views/login.view");

ManageAccountView = require("./views/manage_account.view");

RegistrationView = require("./views/registration.view");

ResetPasswordView = require("./views/reset_password.view");

SurveyView = require("./views/survey.view");

//Definition
module.exports = Router = new ((function() {
  var _Class, appendParams;

  _Class = class {
    //END load
    //END setup
    makeMainUrl(params) {
      return appendParams("/", params);
    }

    gotoMain(params) {
      var main_url;
      main_url = Router.makeMainUrl(params);
      Finch.navigate(main_url);
      return Router;
    }

    //END unload
    //END route
    makeCheckGameCodeUrl(params) {
      return appendParams("/check_game_code", params);
    }

    //END makeCheckGameCodeUrl
    gotoCheckGameCode(params) {
      var url;
      url = Router.makeCheckGameCodeUrl(params);
      Finch.navigate(url);
      return Router;
    }

    //END unload
    //END route
    makeLoginUrl(params) {
      return appendParams("/login", params);
    }

    //END makeLoginUrl
    gotoLogin(params) {
      var url;
      url = Router.makeLoginUrl(params);
      Finch.navigate(url);
      return Router;
    }

    //END unload
    //END route
    makeForgotPasswordUrl(params) {
      return appendParams("/forgot_password", params);
    }

    //END makeForgotPasswordUrl
    gotoForgotPassword() {
      var url;
      url = Router.makeForgotPasswordUrl();
      Finch.navigate(url);
      return Router;
    }

    //END unload
    //END route
    makeResetPasswordUrl(params) {
      return appendParams("/forgot_password", params);
    }

    //END makeResetPasswordUrl
    gotoResetPassword() {
      var url;
      url = Router.makeResetPasswordUrl();
      Finch.navigate(url);
      return Router;
    }

    //END unload
    //END route
    makeRegistrationUrl(params) {
      return appendParams("/registration", params);
    }

    //END makeRegistrationUrl
    gotoRegistration(params) {
      var url;
      url = Router.makeRegistrationUrl(params);
      Finch.navigate(url);
      return Router;
    }

    //END unload
    //END route
    makeManageAccountUrl(params) {
      return appendParams("/manage_account", params);
    }

    //END makeManageAccountUrl
    gotoManageAccount() {
      var url;
      url = Router.makeManageAccountUrl();
      Finch.navigate(url);
      return Router;
    }

    //END unload
    //END route
    createChangePasswordUrl(params) {
      return appendParams("/change_password", params);
    }

    //END createChangePasswordUrl
    gotoChangePassword() {
      var url;
      url = Router.createChangePasswordUrl();
      Finch.navigate(url);
      return Router;
    }

    //END teardown
    //END route
    makeSurveyUrl(params) {
      return appendParams("/manage_account", params);
    }

    //END makeSurveyUrl
    gotoSurvey() {
      var url;
      url = Router.makeSurveyUrl();
      Finch.navigate(url);
      return Router;
    }

  };

  appendParams = function(url, params) {
    var key, value;
    url = Helpers.trim(url);
    if (params == null) {
      return url;
    }
    url += (url.indexOf("?") === -1 ? "?" : "&");
    url += ((function() {
      var results;
      results = [];
      for (key in params) {
        value = params[key];
        results.push(`${key}=${value}`);
      }
      return results;
    })()).join("&");
    return url;
  };

  //END appendParams
  Finch.route("/", {
    setup: function() {
      if (!Application.is_logged_in()) {
        Finch.abort();
        return Router.gotoCheckGameCode();
      }
    },
    //END unless
    //END setup
    load: function() {
      return Application.Layout.setAuthorizedView(this.view = new HomeView());
    }
  });

  //END gotoMain
  Finch.route("/check_game_code", {
    setup: function() {
      if (Application.is_logged_in()) {
        Finch.abort();
        return Router.gotoMain();
      }
    },
    //END unless
    //END setup
    load: function() {
      Application.Layout.forceShowUnauthorizedView();
      this.view = new CheckGameCodeView();
      Finch.observe("not_authorized", (not_authorized) => {
        if (not_authorized) {
          return this.view.showNotAuthorized();
        }
      });
      return Application.Layout.setUnauthorizedView(this.view);
    },
    //END load
    unload: function() {
      var ref;
      Application.Layout.tryShowAuthorizedView();
      return (ref = this.view) != null ? ref.off() : void 0;
    }
  });

  //END gotoCheckGameCode
  Finch.route("/login", {
    load: function() {
      Application.Layout.forceShowUnauthorizedView();
      this.view = new LoginView();
      Finch.observe((params) => {
        var game_code, not_authorized;
        not_authorized = params('not_authorized');
        if (not_authorized) {
          this.view.showNotAuthorized();
        }
        game_code = params('game_code');
        Application.Layout.setGameCode(game_code);
        return this.view.setGameCode(game_code);
      });
      //END observe
      return Application.Layout.setUnauthorizedView(this.view);
    },
    //END load
    unload: function() {
      Application.Layout.tryShowAuthorizedView();
      return this.view.off();
    }
  });

  //END gotoLogin
  Finch.route("/forgot_password", {
    load: function() {
      Application.Layout.forceShowUnauthorizedView();
      this.view = new ForgotPasswordView();
      return Application.Layout.setUnauthorizedView(this.view);
    },
    //END load
    unload: function() {
      Application.Layout.tryShowAuthorizedView();
      return this.view.off();
    }
  });

  //END gotoForgotPassword
  Finch.route("/reset_password", {
    load: function() {
      Application.Layout.forceShowUnauthorizedView();
      this.view = new ResetPasswordView();
      Finch.observe((params) => {
        this.view.setEmail(params('email'));
        return this.view.setResetCode(params('reset_code'));
      });
      //END observe
      return Application.Layout.setUnauthorizedView(this.view);
    },
    //END load
    unload: function() {
      Application.Layout.tryShowAuthorizedView();
      return this.view.off();
    }
  });

  //END gotoResetPassword
  Finch.route("/registration", {
    load: function() {
      Application.Layout.forceShowUnauthorizedView();
      this.view = new RegistrationView();
      Finch.observe("game_code", (game_code) => {
        Application.Layout.setGameCode(game_code);
        return this.view.setGameCode(game_code);
      });
      //END observe
      return Application.Layout.setUnauthorizedView(this.view);
    },
    //END load
    unload: function() {
      Application.Layout.tryShowAuthorizedView();
      return this.view.off();
    }
  });

  //END gotoRegistration
  Finch.route("[/]manage_account", {
    load: function() {
      this.view = new ManageAccountView();
      return Application.Layout.setAuthorizedView(this.view);
    },
    //END load
    unload: function() {
      return this.view.off();
    }
  });

  //END gotoManageAccount
  Finch.route("[/]change_password", {
    load: function() {
      this.view = new ChangePasswordView();
      return Application.Layout.setAuthorizedView(this.view);
    },
    //END load
    unload: function() {
      return this.view.off();
    }
  });

  //END gotoChangePassword
  Finch.route("[/]survey", {
    setup: function() {
      this.view = new SurveyView();
      return Application.Layout.setAuthorizedView(this.view);
    },
    //END setup
    teardown: function() {
      return this.view.off();
    }
  });

  return _Class;

}).call(this))();

//END gotoSurvey
//END Router

},{"../$models/user.model":81,"./views/change_password.view":100,"./views/check_game_code.view":101,"./views/dashboard.view":102,"./views/forgot_password.view":104,"./views/home.view":105,"./views/login.view":107,"./views/manage_account.view":108,"./views/registration.view":111,"./views/reset_password.view":112,"./views/survey.view":114}],99:[function(require,module,exports){
var TUTORIAL_KEY, Tutorial;

TUTORIAL_KEY = "__SO_COMPLETED_TUTORIAL__";

Tutorial = {};

Tutorial.didComplete = ko.observable(false);

Tutorial.complete = function() {
  var e, message, ref;
  Tutorial.didComplete(true);
  try {
    return localStorage[TUTORIAL_KEY] = true;
  } catch (error) {
    e = error;
    message = (ref = e.message) != null ? ref : "QuotaExceededError";
    if (typeof Raven !== "undefined" && Raven !== null) {
      Raven.captureMessage(message, {
        'level': 'warning'
      });
    }
    return typeof console !== "undefined" && console !== null ? console.error(e) : void 0;
  }
};

//END try
//END complete
Tutorial.loadFromCache = function() {
  var didComplete, e, message, ref;
  try {
    didComplete = ["true", true].indexOf(localStorage[TUTORIAL_KEY]) !== -1;
    return Tutorial.didComplete(didComplete);
  } catch (error) {
    e = error;
    message = (ref = e.message) != null ? ref : "QuotaExceededError";
    if (typeof Raven !== "undefined" && Raven !== null) {
      Raven.captureMessage(message, {
        'level': 'warning'
      });
    }
    return typeof console !== "undefined" && console !== null ? console.error(e) : void 0;
  }
};

//END try
//END loadFromCache
Tutorial.clear = function() {
  var e, message, ref;
  Tutorial.didComplete(false);
  try {
    return delete localStorage[TUTORIAL_KEY];
  } catch (error) {
    e = error;
    message = (ref = e.message) != null ? ref : "QuotaExceededError";
    if (typeof Raven !== "undefined" && Raven !== null) {
      Raven.captureMessage(message, {
        'level': 'warning'
      });
    }
    return typeof console !== "undefined" && console !== null ? console.error(e) : void 0;
  }
};

//END try
//END clear
module.exports = Tutorial;

},{}],100:[function(require,module,exports){
var ChangePasswordView, RPC;

RPC = require("../../rpc");

module.exports = ChangePasswordView = (function() {
  class ChangePasswordView extends Falcon.View {
    //END observables
    initialize() {
      this.alert.decorate('validatable');
      //END alert
      this.old_password.decorate('validatable').subscribe(this.validateOldPassword, this);
      //END old_password
      this.new_password.decorate('validatable').subscribe(this.validateNewPassword, this);
      //END new_password
      return this.retype_password.decorate('validatable').subscribe(this.validateRetypePassword, this);
    }

    //END retype_password
    //END initialize
    validateOldPassword() {
      var old_password;
      old_password = Helpers.trim(this.old_password());
      if (_.isEmpty(old_password)) {
        return this.old_password.setIsValid(false, "Please enter your current password");
      }
      return this.old_password.setIsValid(true);
    }

    //END validateOldPassword
    validateNewPassword() {
      var new_password;
      new_password = Helpers.trim(this.new_password());
      if (_.isEmpty(new_password)) {
        return this.new_password.setIsValid(false, "Please enter a new password");
      }
      return this.new_password.setIsValid(true);
    }

    //END validateNewPassword
    validateRetypePassword() {
      var new_password, retype_password;
      retype_password = Helpers.trim(this.retype_password());
      if (_.isEmpty(retype_password)) {
        return this.retype_password.setIsValid(false, "Please retype your new password");
      }
      new_password = Helpers.trim(this.new_password());
      if (new_password !== retype_password) {
        return this.retype_password.setIsValid(false, "Passwords don't match");
      }
      return this.retype_password.setIsValid(true);
    }

    //END validateRetypePassword
    save() {
      var new_password, old_password;
      if (!Application.is_logged_in()) {
        return this;
      }
      if (this.is_saving()) {
        return this;
      }
      if (!(this.validateOldPassword() && this.validateNewPassword() && this.validateRetypePassword())) {
        return this;
      }
      old_password = ko.unwrap(this.old_password);
      new_password = ko.unwrap(this.new_password);
      this.is_saving(true);
      RPC.promiseChangePassword(old_password, new_password).then((user) => {
        this.alert.setIsValid(true, "Successfully changed password!");
        return this.resetFields();
      }).fail(() => {
        //TODO: Add better error handlin here
        return this.alert.setIsValid(false, "An error occurred while saving account information");
      }).fin(() => {
        return this.is_saving(false);
      }).done();
      //END RPC
      return this;
    }

    //END save
    resetFields() {
      this.old_password("");
      this.old_password.resetValidations();
      this.new_password("");
      this.new_password.resetValidations();
      this.retype_password("");
      this.retype_password.resetValidations();
      return this;
    }

  };

  ChangePasswordView.prototype.endpoint = "#change_password-template";

  ChangePasswordView.prototype.observables = {
    'is_saving': false,
    'alert': "",
    'old_password': "",
    'new_password': "",
    'retype_password': ""
  };

  return ChangePasswordView;

}).call(this);

//END resetFields
//END ChangePasswordView

},{"../../rpc":89}],101:[function(require,module,exports){
var CheckGameCodeView, Entry, RPC, VideoModalView;

Entry = require("../../$models/entry.model");

RPC = require("../../rpc");

VideoModalView = require("./video_modal.view");

module.exports = CheckGameCodeView = (function() {
  class CheckGameCodeView extends Falcon.View {
    //END observables
    initialize() {
      var incoming_code;
      this.alert.decorate('validatable');
      //END alert
      this.game_code.decorate('validatable').subscribe(this.validateGameCode, this);
      //END password
      incoming_code = Application.retrieveIncomingGameCode();
      if (incoming_code != null) {
        this.game_code(incoming_code);
        return this.check();
      }
    }

    //END if
    //END initialize
    validateGameCode() {
      var game_code;
      game_code = this.game_code();
      if (!Entry.isValidCode(game_code)) {
        return this.game_code.setIsValid(false, "Please enter a valid Game Code");
      }
      return this.game_code.setIsValid(true);
    }

    //END validateGameCode
    resetFields() {
      this.alert("");
      this.alert.resetValidations();
      this.game_code("");
      this.game_code.resetValidations();
      return this;
    }

    //END resetFields
    check() {
      var game_code, game_code_is_valid;
      game_code_is_valid = this.validateGameCode();
      if (!game_code_is_valid) {
        return this;
      }
      if (this.is_checking()) {
        return this;
      }
      game_code = this.game_code();
      this.is_checking(true);
      RPC.promiseCheckGameCode(game_code).then((entry) => {
        this.resetFields();
        return Router.gotoRegistration({game_code});
      }).fail((error) => {
        if ((error != null ? error.human : void 0) != null) {
          alert(Language(error.human));
        }
        Application.flashError(error);
        return this.alert.setIsValid(false, error.human);
      }).fin(() => {
        return this.is_checking(false);
      }).done();
      //END user
      return this;
    }

    //END check
    showNotAuthorized() {
      return this.alert.setIsValid(false, "You're not authorized to login here");
    }

    //END showNotAuthorized
    gotoLogin() {
      return Router.gotoLogin();
    }

    gotoRegistration() {
      return Router.gotoRegistration();
    }

    showVideoModal() {
      return Application.Layout.setModalView(new VideoModalView());
    }

  };

  CheckGameCodeView.prototype.endpoint = '#check_game_code-template';

  CheckGameCodeView.prototype.observables = {
    'alert': "",
    'is_checking': false,
    'submit_is_disabled': function() {
      if (this.is_checking()) {
        return true;
      }
      if (this.game_code().length !== 12) {
        return true;
      }
      return false;
    },
    //END submit_is_disabled
    'game_code': ""
  };

  return CheckGameCodeView;

}).call(this);

//END CheckGameCodeView

},{"../../$models/entry.model":59,"../../rpc":89,"./video_modal.view":115}],102:[function(require,module,exports){
var DashboardView, HomeView, ManageAccountView;

HomeView = require("./home.view");

ManageAccountView = require("./manage_account.view");

module.exports = DashboardView = (function() {
  class DashboardView extends Falcon.View {
    //END observables
    setInternalView(view) {
      if (!Falcon.isView(view)) {
        throw new Error("view must be a Falcon.View");
      }
      this.internal_view(view);
      return this;
    }

    //END setInternalView
    gotoHome() {
      return Router.gotoMain();
    }

    gotoManageAccount() {
      return Router.gotoManageAccount();
    }

    logout() {
      Application.logout();
      return Router.gotoLogin();
    }

  };

  DashboardView.prototype.endpoint = "#dashboard-template";

  DashboardView.prototype.observables = {
    'internal_view': null,
    'home_is_selected': function() {
      return this.internal_view() instanceof HomeView;
    },
    'manage_account_is_selected': function() {
      return this.internal_view() instanceof ManageAccountView;
    }
  };

  return DashboardView;

}).call(this);

//END logout
//END DashboardView

},{"./home.view":105,"./manage_account.view":108}],103:[function(require,module,exports){
var EntryModalView, RPC;

RPC = require("../../rpc");

module.exports = EntryModalView = (function() {
  class EntryModalView extends Falcon.View {
    //END content_class
    //END observables
    show(entry) {
      this.deferred = Q.defer();
      this.entry(entry);
      this.is_visible(true);
      return this.deferred.promise;
    }

    //END show
    close() {
      this.is_visible(false);
      return this.deferred.resolve();
    }

    //END close
    shareImageUrl() {
      return `${window.location.origin}/images/${Language("super-speedway-share.png")}`;
    }

    shareFacebook() {
      var params, text, url;
      if (Application.is_on_mobile() && (typeof navigator !== "undefined" && navigator !== null ? navigator.share : void 0)) {
        navigator.share({
          url: this.shareImageUrl()
        });
      } else {
        text = "";
        params = [];
        params.push(`u=${encodeURIComponent(this.shareImageUrl())}`);
        params.push(`text=${encodeURIComponent(text)}`);
        url = `https://www.facebook.com/sharer/sharer.php?${params.join('&')}`;
        window.open(url, "_blank");
      }
    }

    //END shareFacebook
    //END if
    shareTwitter() {
      var params, text, url;
      if (Application.is_on_mobile() && (typeof navigator !== "undefined" && navigator !== null ? navigator.share : void 0)) {
        navigator.share({
          url: this.shareImageUrl()
        });
      } else {
        text = "";
        params = [];
        params.push(`url=${encodeURIComponent(this.shareImageUrl())}`);
        params.push(`text=${encodeURIComponent(text)}`);
        url = `https://twitter.com/share?${params.join('&')}`;
        window.open(url, "_blank");
      }
    }

  };

  EntryModalView.prototype.endpoint = "#entry_modal-template";

  EntryModalView.prototype.defaults = {
    'promise': null
  };

  //END defaults
  EntryModalView.prototype.observables = {
    'is_visible': false,
    'entry': null,
    'entry_count': function() {
      var entry;
      entry = this.entry();
      if (entry == null) {
        return 0;
      }
      return 1 + (entry.get('bonus_entries') || 0);
    },
    //END entry_count
    'has_multiple_entries': function() {
      return this.entry_count() > 1;
    },
    'content_class': function() {
      if (this.entry_count() === 1) {
        return 'is-one-entry';
      }
      if (this.entry_count() === 5) {
        return 'is-five-entries';
      }
      if (this.entry_count() === 10) {
        return 'is-ten-entries';
      }
      if (this.entry_count() === 20) {
        return 'is-twenty-entries';
      }
    }
  };

  return EntryModalView;

}).call(this);

//END shareTwitter
//END EntryModalView
//END if

},{"../../rpc":89}],104:[function(require,module,exports){
var ForgotPasswordView, RPC;

RPC = require("../../rpc");

module.exports = ForgotPasswordView = (function() {
  class ForgotPasswordView extends Falcon.View {
    //END observables
    initialize() {
      this.alert.decorate('validatable');
      //END alert
      return this.email.decorate('validatable').subscribe(this.validateEmail, this);
    }

    //END email
    //END initialize
    validateEmail() {
      var email;
      email = Helpers.trim(this.email());
      if (_.isEmpty(email)) {
        return this.email.setIsValid(false, "Email must not be empty");
      }
      if (!Helpers.isEmail(email)) {
        return this.email.setIsValid(false, "Email is formatted incorrectly");
      }
      return this.email.setIsValid(true);
    }

    //END validateEmail
    resetFields() {
      this.alert("");
      this.alert.resetValidations();
      this.email("");
      this.email.resetValidations();
      return this;
    }

    //END resetFields
    send() {
      var email;
      if (!this.validateEmail()) {
        return this;
      }
      if (this.is_sending()) {
        return this;
      }
      email = Helpers.trim(this.email());
      this.is_sending(true);
      RPC.promiseForgotPassword(email).then(() => {
        this.reset_did_send(true);
        return this.resetFields();
      }).fail((error) => {
        Application.flashError(error);
        return this.alert.setIsValid(false, error.human);
      }).fin(() => {
        return this.is_sending(false);
      }).done();
      //END RPC
      return this;
    }

    //END send
    gotoLogin() {
      return Router.gotoLogin();
    }

  };

  ForgotPasswordView.prototype.endpoint = '#forgot_password-template';

  ForgotPasswordView.prototype.observables = {
    'alert': "",
    'is_sending': false,
    'reset_did_send': false,
    'email': ""
  };

  return ForgotPasswordView;

}).call(this);

//END ForgotPasswordView

},{"../../rpc":89}],105:[function(require,module,exports){
var Contest, Contests, Entry, HomeView, RPC, Race, RaceSelection, RaceSelections, RaceView, RaceWinnerModalView, Races, SELECTED_CONTEST, SurveyView, Surveys, User, UserContestStatistic, UserContestStatistics, VideoModalView;

User = require("../../$models/user.model");

Entry = require("../../$models/entry.model");

Contest = require("../../$models/contest.model");

Contests = require("../../$collections/contests.collection");

UserContestStatistic = require("../../$models/user_contest_statistic.model");

UserContestStatistics = require("../../$collections/user_contest_statistics.collection");

Surveys = require("../../$collections/surveys.collection");

Race = require("../../$models/race.model");

Races = require("../../$collections/races.collection");

RaceSelection = require("../../$models/race_selection.model");

RaceSelections = require("../../$collections/race_selections.collection");

RPC = require("../../rpc");

RaceView = require("./race.view");

RaceWinnerModalView = require("./race_winner_modal.view");

SurveyView = require("./survey.view");

VideoModalView = require("./video_modal.view");

SELECTED_CONTEST = "global-1";

module.exports = HomeView = (function() {
  class HomeView extends Falcon.View {
    //END obseravbles
    initialize() {
      var incoming_code;
      this.alert.decorate('validatable');
      this.game_code.decorate('validatable').subscribe(this.validateGameCode, this);
      //END game_code
      if (Application.is_logged_in()) {
        this.fetchInformation();
      } else {
        this.listenToOnce(Application, 'login', this.fetchInformation);
      }
      //END if
      incoming_code = Application.retrieveIncomingGameCode();
      if (incoming_code != null) {
        this.game_code(incoming_code);
        return this.claimGameCode();
      }
    }

    //END if
    //END initialize
    validateGameCode() {
      var game_code;
      game_code = ko.unwrap(this.game_code);
      if (!Entry.isValidCode(game_code)) {
        return this.game_code.setIsValid(false, "Invalid Game Code");
      }
      return this.game_code.setIsValid(true);
    }

    //END validateGameCode
    fetchInformation() {
      var current_user;
      if (!Application.is_logged_in()) {
        return this;
      }
      if (this.is_loading()) {
        return this;
      }
      this.is_loading(true);
      current_user = Application.current_user();
      Q.all([
        this.contests.promiseFetch({
          parent: current_user
        }),
        this.races.promiseFetch(),
        this.race_selections.promiseFetch({
          parent: current_user
        }),
        this.user_contest_statistics.promiseFetch({
          parent: current_user
        })
      ]).fail((error) => {
        return console.error(error);
      }).fin(() => {
        var entry;
        this.is_loading(false);
        if (!Application.hasClaimedEntry()) {
          return this.tryShowOverlay();
        }
        entry = Application.getClaimedEntry();
        Application.trigger("entry:save", entry);
        this.trigger("entry:save", entry);
        return Application.Layout.entry_modal.show(entry).then(() => {
          Application.clearClaimedEntry();
          return this.tryShowOverlay();
        });
      });
      return this;
    }

    //END fetchInformation
    tryShowOverlay() {
      return Q.Promise((resolve, reject) => {
        var current_user, race_selection, race_winner_modal_view;
        return resolve(); // TODO: Remove this for the next contest
        if (!Application.is_logged_in()) {
          return resolve();
        }
        race_selection = this.race_selections.first((race_selection) => {
          if (!race_selection.get('entry_id')) {
            return false;
          }
          if (race_selection.get('did_notify')) {
            return false;
          }
          return true;
        });
        //END first
        if (race_selection != null) {
          race_winner_modal_view = new RaceWinnerModalView(race_selection);
          race_winner_modal_view.on("close", () => {
            Application.Layout.clearModalView();
            return this.tryShowOverlay();
          });
          return Application.Layout.setModalView(race_winner_modal_view);
        } else if (this.redeemed_entry_count() > 0 && !this.did_close_survey()) {
          current_user = Application.current_user();
          return this.surveys.promiseFetch({
            parent: current_user
          }).then(() => {
            var survey_view;
            if (!(this.surveys.length() > 0)) {
              return;
            }
            survey_view = new SurveyView(this.surveys.first());
            survey_view.on("entry:create", () => {
              return this.refreshStatistics();
            });
            survey_view.on("close", () => {
              Application.Layout.clearModalView();
              return this.did_close_survey(true);
            });
            return Application.Layout.setModalView(survey_view);
          }).then(resolve, reject);
        } else {
          return resolve();
        }
      });
    }

    //END if
    //END tryShowOverlay
    showRaceModal() {
      var race_view;
      if (!this.has_active_race()) {
        return;
      }
      race_view = new RaceView(this.active_race());
      race_view.on("race_selection:create", (race_selection) => {
        return this.race_selections.push(race_selection);
      });
      race_view.on("close", () => {
        return Application.Layout.clearModalView();
      });
      return Application.Layout.setModalView(race_view);
    }

    //END showRaceModal
    refreshStatistics() {
      var current_user;
      if (!Application.is_logged_in()) {
        return this;
      }
      if (this.is_loading()) {
        return this;
      }
      current_user = Application.current_user();
      this.user_contest_statistics.promiseFetch({
        parent: current_user
      });
      return this;
    }

    //END refreshStatistics
    resetFields() {
      this.game_code("");
      this.game_code.resetValidations();
      return this;
    }

    //END resetFields
    claimGameCode() {
      var game_code;
      if (!Application.is_logged_in()) {
        return this;
      }
      if (this.is_claiming()) {
        return this;
      }
      if (!(this.validateGameCode())) {
        return this;
      }
      game_code = this.game_code();
      this.is_claiming(true);
      RPC.promiseClaimGameCode(game_code).then((entry) => {
        this.resetFields();
        Application.trigger("entry:save", entry);
        this.trigger("entry:save", entry);
        Application.Layout.entry_modal.show(entry).then(() => {
          var statistic;
          statistic = this.getStatisticsFor(this.getContest(SELECTED_CONTEST));
          if (statistic == null) {
            return;
          }
          if (statistic.get('redeemed_entry_count') !== 1) {
            return;
          }
          return this.tryShowOverlay();
        });
        return Q.all([
          this.user_contest_statistics.promiseFetch({
            parent: Application.current_user()
          })
        ]);
      }).fail((error) => {
        if ((error != null ? error.human : void 0) != null) {
          alert(Language(error.human));
        }
        Application.flashError(error);
        return this.game_code.setIsValid(false, error.human);
      }).fin(() => {
        return this.is_claiming(false);
      });
      //END RPC
      return this;
    }

    //END claimGameCode
    getContest(code) {
      return this.contests.first(function(contest) {
        return contest.get('code') === code;
      });
    }

    getStatisticsFor(contest) {
      return this.user_contest_statistics.first(function(statistic) {
        return contest.equals(statistic.get('contest_id'));
      });
    }

    makeFacebookLink() {
      var params, text;
      text = `I've got ${this.redeemed_entry_count()} entries! #SnaponSuperSpeedway`;
      params = [];
      params.push(`u=${encodeURIComponent("https://www.snapon.com/dreamdrive")}`);
      params.push(`text=${encodeURIComponent(text)}`);
      return `https://www.facebook.com/sharer/sharer.php?${params.join('&amp;')}`;
    }

    //END makeFacebookLink
    makeTwitterLink() {
      var params, text;
      text = `I've got ${this.redeemed_entry_count()} entries! #SnaponSuperSpeedway`;
      params = [];
      params.push(`url=${encodeURIComponent("https://www.snapon.com/dreamdrive")}`);
      params.push(`text=${encodeURIComponent(text)}`);
      return `https://twitter.com/share?${params.join('&amp;')}`;
    }

    //END makeTwitterLink
    showVideoModal() {
      return Application.Layout.setModalView(new VideoModalView());
    }

  };

  HomeView.prototype.endpoint = "#home-template";

  HomeView.prototype.defaults = {
    'contests': function() {
      return (new Contests()).setFilter('codes', [SELECTED_CONTEST]);
    },
    'surveys': function() {
      return new Surveys();
    },
    'races': function() {
      return new Races();
    },
    'race_selections': function() {
      return new RaceSelections();
    },
    'user_contest_statistics': function() {
      return new UserContestStatistics();
    }
  };

  //END defaults
  HomeView.prototype.observables = {
    'alert': "",
    'is_loading': false,
    'is_claiming': false,
    'name': function() {
      var ref;
      return (ref = Application.current_user()) != null ? ref.get('name') : void 0;
    },
    'game_code': "",
    'game_code_has_focus': false,
    'did_close_survey': false,
    'should_show_add_code_button': function() {
      if (this.game_code_has_focus()) {
        return true;
      }
      if (!_.isEmpty(this.game_code())) {
        return true;
      }
      return false;
    },
    //END should_show_add_code_button
    'add_is_disabled': function() {
      if (!Entry.isValidCode(this.game_code())) {
        return true;
      }
      return false;
    },
    //END add_is_disabled
    'current_user_first_name': function() {
      var ref, ref1;
      if (!Application.is_logged_in()) {
        return "";
      }
      return (ref = (ref1 = Application.current_user()) != null ? ref1.get('first_name') : void 0) != null ? ref : "";
    },
    //END current_user_first_name
    'redeemed_entry_count': function() {
      var contest, statistic;
      contest = this.getContest(SELECTED_CONTEST);
      if (contest == null) {
        return 0;
      }
      statistic = this.getStatisticsFor(contest);
      if (statistic == null) {
        return 0;
      }
      return statistic.get('redeemed_entry_count');
    },
    //END redeemed_entry_count
    'has_redeemed_entry': function() {
      return this.redeemed_entry_count() > 0;
    },
    'end_date': function() {
      var contest;
      contest = this.getContest(SELECTED_CONTEST);
      return contest != null ? contest.get('end_date') : void 0;
    },
    //END end_date
    'active_race': function() {
      var now_moment, races;
      now_moment = moment();
      races = this.races.all();
      races = races.filter((race) => {
        if (now_moment.isBefore(race.get('start_date'))) {
          return false;
        }
        if (now_moment.isAfter(race.get('end_date'))) {
          return false;
        }
        return true;
      });
      //END filter
      races = races.sort((a, b) => {
        var a_moment, b_moment;
        a_moment = moment(a.get('start_date'));
        b_moment = moment(b.get('start_date'));
        if (a_moment.isBefore(b_moment)) {
          return -1;
        }
        if (a_moment.isAfter(b_moment)) {
          return 1;
        }
        return 0;
      });
      //END sort
      return races[0];
    },
    //END active_race
    'has_active_race': function() {
      return this.active_race() instanceof Race;
    },
    'active_race_selection': function() {
      var active_race;
      if (!this.has_active_race()) {
        return null;
      }
      active_race = this.active_race();
      return this.race_selections.first((race_selection) => {
        return race_selection.get('race_id') === active_race.get('id');
      });
    },
    //END first
    //END active_race_selection
    'active_race_selection_label': function() {
      var ref, ref1;
      return (ref = this.active_race_selection()) != null ? (ref1 = ref.get('race_option')) != null ? ref1.get('label') : void 0 : void 0;
    },
    'has_active_race_selection': function() {
      return this.active_race_selection() instanceof RaceSelection;
    },
    'upcoming_race': function() {
      var now_moment, races;
      if (this.has_active_race()) {
        return null;
      }
      now_moment = moment();
      races = this.races.all();
      races = races.filter((race) => {
        return now_moment.isBefore(race.get('start_date'));
      });
      //END filter
      races = races.sort((a, b) => {
        var a_moment, b_moment;
        a_moment = moment(a.get('start_date'));
        b_moment = moment(b.get('start_date'));
        if (a_moment.isBefore(b_moment)) {
          return -1;
        }
        if (a_moment.isAfter(b_moment)) {
          return 1;
        }
        return 0;
      });
      //END sort
      return races[0];
    },
    //END upcoming_race
    'has_upcoming_race': function() {
      return this.upcoming_race() instanceof Race;
    },
    'upcoming_race_week_of': function() {
      return moment(this.upcoming_race().get('start_date')).startOf('week').format("MM/DD");
    }
  };

  return HomeView;

}).call(this);

//END HomeView

},{"../../$collections/contests.collection":26,"../../$collections/race_selections.collection":38,"../../$collections/races.collection":39,"../../$collections/surveys.collection":45,"../../$collections/user_contest_statistics.collection":46,"../../$models/contest.model":56,"../../$models/entry.model":59,"../../$models/race.model":71,"../../$models/race_selection.model":73,"../../$models/user.model":81,"../../$models/user_contest_statistic.model":82,"../../rpc":89,"./race.view":109,"./race_winner_modal.view":110,"./survey.view":114,"./video_modal.view":115}],106:[function(require,module,exports){
var ChangePasswordView, CheckGameCodeView, EntryModalView, ForgotPasswordView, HomeView, LayoutView, LoginView, ManageAccountView, RegistrationView, ResetPasswordView, RulesView;

ChangePasswordView = require("./change_password.view");

CheckGameCodeView = require("./check_game_code.view");

EntryModalView = require("./entry_modal.view");

ForgotPasswordView = require("./forgot_password.view");

ResetPasswordView = require("./reset_password.view");

HomeView = require("./home.view");

LoginView = require("./login.view");

ManageAccountView = require("./manage_account.view");

RegistrationView = require("./registration.view");

RulesView = require("./rules.view");

module.exports = LayoutView = (function() {
  class LayoutView extends Falcon.View {
    //END observables
    initialize() {
      var computed;
      return computed = ko.computed(() => {
        if (!Language.hasSelectedLanguage() && IPInfo.isLoaded()) {
          // Check if they're in canada
          if (IPInfo.isInCanada()) {
            this.showSelectLanguage();
          } else {
            this.selectEnUsLanguage();
          }
          //END if
          return computed != null ? computed.dispose() : void 0;
        }
      });
    }

    //END if
    //END computed
    //END initialize
    setAuthorizedView(view) {
      if (!Falcon.isView(view)) {
        throw new Error("view must be an instanceof a Falcon.View");
      }
      //END unless
      this.authorized_view(view);
      return view;
    }

    //END setAuthorizedView
    clearAuthorizedView() {
      return this.authorized_view(null);
    }

    tryShowAuthorizedView() {
      this.force_show_unauthorized_view(false);
      return this;
    }

    //END tryShowAuthorizedView
    setUnauthorizedView(view) {
      if (!Falcon.isView(view)) {
        throw new Error("view must be an instanceof a Falcon.View");
      }
      //END unless
      this.unauthorized_view(view);
      return view;
    }

    //END setAuthorizedView
    clearUnauthorizedView() {
      this.unauthorized_view(null);
      return this;
    }

    //END clearUnauthorizedView
    forceShowUnauthorizedView() {
      this.force_show_unauthorized_view(true);
      return this;
    }

    //END forceShowUnauthorizedView
    setModalView(view) {
      if (!Falcon.isView(view)) {
        throw new Error("view must be an instanceof Falcon.View");
      }
      this.modal_view(view);
      return view;
    }

    //END setModalView
    clearModalView() {
      this.modal_view(null);
      return this;
    }

    //END clearModalView
    showRules() {
      return this.rules_view(new RulesView());
    }

    hideRules() {
      return this.rules_view(null);
    }

    gotoLogin() {
      var params;
      this.hideMenu();
      this.hideSelectLanguage();
      params = {};
      if (this.has_game_code()) {
        params['game_code'] = this.game_code();
      }
      return Router.gotoLogin(params);
    }

    //END gotoLogin
    gotoRegistration() {
      var params;
      this.hideMenu();
      this.hideSelectLanguage();
      params = {};
      if (this.has_game_code()) {
        params['game_code'] = this.game_code();
      }
      return Router.gotoRegistration(params);
    }

    //END gotoRegistration
    gotoMain() {
      this.hideMenu();
      this.hideSelectLanguage();
      return Router.gotoMain();
    }

    //END gotoMain
    gotoManageAccount() {
      this.hideMenu();
      this.hideSelectLanguage();
      return Router.gotoManageAccount();
    }

    //END gotoManageAccount
    gotoChangePassword() {
      this.hideMenu();
      this.hideSelectLanguage();
      return Router.gotoChangePassword();
    }

    //END gotoChangePassword
    logout() {
      this.hideMenu();
      this.hideSelectLanguage();
      Application.logout();
      return Router.gotoLogin();
    }

    //END logout
    showMenu() {
      this.menu_is_visible(true);
      return this.hideSelectLanguage();
    }

    //END showMenu
    hideMenu() {
      return this.menu_is_visible(false);
    }

    //END hideMenu
    toggleSelectLanguage() {
      this.select_language_is_visible(!this.select_language_is_visible());
      return this.hideMenu();
    }

    //END toggleSelectLanguage
    showSelectLanguage() {
      this.select_language_is_visible(true);
      return this.hideMenu();
    }

    //END showSelectlanguage
    hideSelectLanguage() {
      return this.select_language_is_visible(false);
    }

    //END hideSelectLanguage
    selectEnUsLanguage() {
      Language.selectCode("us/en");
      return this.hideSelectLanguage();
    }

    //END selectEnUsLanguage
    selectEnCaLanguage() {
      Language.selectCode("ca/en");
      return this.hideSelectLanguage();
    }

    //END selectEnCaLanguage
    selectFrCaLanguage() {
      Language.selectCode("ca/fr");
      return this.hideSelectLanguage();
    }

    //END selectFrCaLanguage
    toggleLanguage() {
      if (Language.selectedLanguageCode() === "us/en") {
        return Language.selectCode("ca/fr");
      } else {
        return Language.selectCode("us/en");
      }
    }

    //END if
    //END toggleLanguage
    frCaIsSelected() {
      return Language.selectedLanguageCode() === "ca/fr";
    }

    //END selectFrCaLanguage
    setGameCode(game_code) {
      this.game_code(game_code);
      return this;
    }

  };

  LayoutView.prototype.endpoint = '#layout-template';

  LayoutView.prototype.defaults = {
    'entry_modal': function() {
      return new EntryModalView();
    }
  };

  //END defaults
  LayoutView.prototype.observables = {
    'is_displayed': false,
    'game_code': null,
    'has_game_code': function() {
      return this.game_code() != null;
    },
    'is_on_light_background': function() {
      if (this.should_show_authorized_view()) {
        if (this.authorized_view() instanceof ManageAccountView) {
          return true;
        }
        if (this.authorized_view() instanceof ChangePasswordView) {
          return true;
        }
      } else {
        if (this.unauthorized_view() instanceof LoginView) {
          return true;
        }
        if (this.unauthorized_view() instanceof RegistrationView) {
          return true;
        }
        if (this.unauthorized_view() instanceof ForgotPasswordView) {
          return true;
        }
        if (this.unauthorized_view() instanceof ResetPasswordView) {
          return true;
        }
      }
      //END if
      return false;
    },
    //END is_on_light_background
    'background_class': function() {
      if (this.should_show_authorized_view()) {
        if (this.authorized_view() instanceof HomeView) {
          return 'with-plain-background';
        }
      } else {
        if (this.unauthorized_view() instanceof CheckGameCodeView) {
          return 'with-plain-background';
        }
      }
      //END if
      return null;
    },
    //END has_plain_background
    'should_show_loader': function() {
      return ko.unwrap(Application.is_checking_session);
    },
    //END should_show_loader
    'should_render_views': function() {
      return !ko.unwrap(Application.is_checking_session);
    },
    //END should_render_views
    'force_show_unauthorized_view': false,
    'authorized_view': null,
    'should_show_authorized_view': function() {
      if (Application.is_checking_session()) {
        return false;
      }
      if (!Application.is_logged_in()) {
        return false;
      }
      return !this.force_show_unauthorized_view();
    },
    //END should_show_authorized_view
    'unauthorized_view': null,
    'should_show_unauthorized_view': function() {
      if (Application.is_checking_session()) {
        return false;
      }
      return !this.should_show_authorized_view();
    },
    //END should_show_unauthorized_view
    'modal_view': null,
    'should_show_modal_view': function() {
      if (Application.is_checking_session()) {
        return false;
      }
      return Falcon.isView(this.modal_view());
    },
    //END should_show_modal_view
    'rules_view': null,
    'should_show_rules_view': function() {
      if (Application.is_checking_session()) {
        return false;
      }
      return Falcon.isView(this.rules_view());
    },
    //END should_show_rules_view
    'current_user_first_name': function() {
      var current_user, ref;
      if (!Application.is_logged_in()) {
        return "";
      }
      current_user = Application.current_user();
      return (ref = current_user != null ? current_user.get('first_name') : void 0) != null ? ref : "";
    },
    //END current_user_first_name
    'select_language_is_visible': false,
    'menu_is_visible': false,
    'is_showing_manage_account': function() {
      return this.authorized_view() instanceof ManageAccountView;
    }
  };

  return LayoutView;

}).call(this);

//END setGameCode
//END LayoutView

},{"./change_password.view":100,"./check_game_code.view":101,"./entry_modal.view":103,"./forgot_password.view":104,"./home.view":105,"./login.view":107,"./manage_account.view":108,"./registration.view":111,"./reset_password.view":112,"./rules.view":113}],107:[function(require,module,exports){
var Entry, LoginView, RPC, Session;

Session = require("../../$models/session.model");

Entry = require("../../$models/entry.model");

RPC = require("../../rpc");

module.exports = LoginView = (function() {
  class LoginView extends Falcon.View {
    //END observables
    initialize() {
      this.alert.decorate('validatable');
      //END alert
      this.email.decorate('validatable').subscribe(this.validateEmail, this);
      //END email
      return this.password.decorate('validatable').subscribe(this.validatePassword, this);
    }

    //END password
    //END initialize
    validateEmail() {
      var email;
      email = Helpers.trim(this.email());
      if (_.isEmpty(email)) {
        return this.email.setIsValid(false, "Email must not be empty");
      }
      if (!Helpers.isEmail(email)) {
        return this.email.setIsValid(false, "Email is formatted incorrectly");
      }
      return this.email.setIsValid(true);
    }

    //END validateEmail
    validatePassword() {
      var password;
      password = this.password();
      if (!Helpers.isPassword(password)) {
        return this.password.setIsValid(false, "Password must be at least 6 characters long and must not contain white space");
      }
      return this.password.setIsValid(true);
    }

    //END validatePassword
    resetFields() {
      this.alert("");
      this.alert.resetValidations();
      this.email("");
      this.email.resetValidations();
      this.password("");
      this.password.resetValidations();
      return this;
    }

    //END resetFields
    login() {
      var email, email_is_valid, password, password_is_valid;
      email_is_valid = this.validateEmail();
      password_is_valid = this.validatePassword();
      if (!(email_is_valid && password_is_valid)) {
        return this;
      }
      if (this.is_logging_in()) {
        return this;
      }
      email = Helpers.trim(this.email());
      password = this.password();
      this.is_logging_in(true);
      new Session({email, password}).promiseCreate({
        attributes: ['email', 'password']
      }).then((session) => {
        Application.login(session);
        this.trigger('session:create', session);
        return Application.trigger('session:create', session);
      }).then(() => {
        if (!this.has_game_code()) {
          return null;
        }
        return RPC.promiseClaimGameCode(this.game_code()).then(function(entry) {
          return Application.setClaimedEntry(entry);
        });
      }).then((entry) => {
        this.resetFields();
        return Router.gotoMain();
      }).fail((error) => {
        if (typeof console !== "undefined" && console !== null) {
          console.log(error);
        }
        if (typeof console !== "undefined" && console !== null) {
          console.log(JSON.stringify(error));
        }
        Application.flashError(error);
        return this.alert.setIsValid(false, error.human);
      }).fin(() => {
        return this.is_logging_in(false);
      }).done();
      //END session
      return this;
    }

    //END login
    setGameCode(game_code) {
      this.game_code(game_code);
      return this;
    }

    //END setGameCode
    showNotAuthorized() {
      return this.alert.setIsValid(false, "You're not authorized to login here");
    }

    //END showNotAuthorized
    gotoRegistration() {
      var params;
      params = {};
      if (this.has_game_code()) {
        params['game_code'] = this.game_code();
      }
      return Router.gotoRegistration(params);
    }

    //END gotoRegistration
    gotoForgotPassword() {
      return Router.gotoForgotPassword();
    }

  };

  LoginView.prototype.endpoint = '#login-template';

  LoginView.prototype.observables = {
    'alert': "",
    'is_logging_in': false,
    'email': "",
    'password': "",
    'game_code': "",
    'has_game_code': function() {
      return Entry.isValidCode(this.game_code());
    }
  };

  return LoginView;

}).call(this);

//END LoginView

},{"../../$models/entry.model":59,"../../$models/session.model":77,"../../rpc":89}],108:[function(require,module,exports){
var ManageAccountView, STATES;

STATES = require("../../$constants/states.constants");

module.exports = ManageAccountView = (function() {
  class ManageAccountView extends Falcon.View {
    //END if
    //END read
    //END formatted_phone_number
    //END observables
    initialize() {
      this.alert.decorate('validatable');
      //END alert
      this.name.decorate('validatable').subscribe(this.validateName, this);
      //END name
      this.email.decorate('validatable').subscribe(this.validateEmail, this);
      //END email
      this.phone_number.decorate('validatable').subscribe(this.validatePhoneNumber, this);
      //END phone_number
      if (Application.is_logged_in()) {
        return this.populateData();
      } else {
        return this.listenToOnce(Application, 'login', this.populateData);
      }
    }

    //END if
    //END initialize
    validateName() {
      var name;
      name = Helpers.trim(this.name());
      if (_.isEmpty(name)) {
        return this.name.setIsValid(false, "Name must not be empty");
      }
      return this.name.setIsValid(true);
    }

    //END validateName
    validateEmail() {
      var email;
      email = Helpers.trim(this.email());
      if (_.isEmpty(email)) {
        return this.email.setIsValid(false, "Email must not be empty");
      }
      if (!Helpers.isEmail(email)) {
        return this.email.setIsValid(false, "Email is formatted incorrectly");
      }
      return this.email.setIsValid(true);
    }

    //END validateEmail
    validatePhoneNumber() {
      var phone_number;
      phone_number = this.phone_number() || "";
      if (phone_number.length !== 10 && !/[0-9]{10}/.test(phone_number)) {
        return this.phone_number.setIsValid(false, "Please enter a valid phone number");
      }
      return this.phone_number.setIsValid(true);
    }

    //END validatePhoneNumber
    populateData() {
      var current_user;
      if (!Application.is_logged_in()) {
        return this;
      }
      current_user = Application.current_user();
      this.name(current_user.get("name"));
      this.email(current_user.get("email"));
      this.address_1(current_user.get('address_1'));
      this.address_2(current_user.get('address_2'));
      this.city(current_user.get('city'));
      this.state(current_user.get('state'));
      this.zip_code(current_user.get('zip_code'));
      this.formatted_phone_number(current_user.get('phone_number'));
      return this.is_subscribed_to_newsletter(current_user.get('is_subscribed_to_newsletter'));
    }

    //END populateData
    save() {
      if (!Application.is_logged_in()) {
        return this;
      }
      if (this.is_saving()) {
        return this;
      }
      if (!(this.validateName() && this.validateEmail() && this.validatePhoneNumber())) {
        return this;
      }
      this.is_saving(true);
      Application.current_user().clone(['id']).set({
        name: this.name(),
        email: this.email(),
        address_1: this.address_1(),
        address_2: this.address_2(),
        city: this.city(),
        state: this.state(),
        zip_code: this.zip_code(),
        phone_number: this.phone_number(),
        is_subscribed_to_newsletter: this.is_subscribed_to_newsletter()
      }).promiseSave({
        parent: null,
        attributes: ['name', 'email', 'address_1', 'address_2', 'city', 'state', 'zip_code', 'phone_number', 'is_subscribed_to_newsletter']
      }).then((user) => {
        this.alert.setIsValid(true, "Successfully saved account information!");
        return Application.current_user().set({
          name: user.get('name'),
          email: user.get('email'),
          ddress_1: user.get('address_1'),
          address_2: user.get('address_2'),
          city: user.get('city'),
          state: user.get('state'),
          zip_code: user.get('zip_code'),
          phone_number: user.get('phone_number')
        });
      }).fail(() => {
        //TODO: Add better error handlin here
        return this.alert.setIsValid(false, "An error occurred while saving account information");
      }).fin(() => {
        return this.is_saving(false);
      }).done();
      //END application
      return this;
    }

  };

  ManageAccountView.prototype.endpoint = "#manage_account-template";

  ManageAccountView.prototype.STATES = STATES;

  ManageAccountView.prototype.observables = {
    'is_saving': false,
    'alert': "",
    'name': null,
    'email': null,
    'address_1': null,
    'address_2': null,
    'city': null,
    'state': null,
    'zip_code': null,
    'phone_number': null,
    'is_subscribed_to_newsletter': null,
    'formatted_phone_number': {
      write: function(value) {
        value = (value || "").toString().replace(/[^0-9]*/gi, "");
        return this.phone_number(value);
      },
      //END write
      read: function() {
        var first_piece, phone, second_piece, third_piece;
        phone = (this.phone_number() || "").toString().replace(/[^0-9]*/gi, "");
        first_piece = phone.slice(0, 3);
        second_piece = phone.slice(3, 6);
        third_piece = phone.slice(6, 10);
        if (third_piece.length > 0) {
          return `(${first_piece}) ${second_piece}-${third_piece}`;
        } else if (second_piece.length > 0) {
          return `${first_piece}-${second_piece}`;
        } else {
          return `${first_piece}`;
        }
      }
    }
  };

  return ManageAccountView;

}).call(this);

//END save
//END ManageAccountView

},{"../../$constants/states.constants":49}],109:[function(require,module,exports){
var Question, Race, RaceOption, RaceOptions, RaceSelection, RaceSelections, RaceView, Races;

Question = require("../../$models/question.model");

Race = require("../../$models/race.model");

RaceOption = require("../../$models/race_option.model");

RaceOptions = require("../../$collections/race_options.collection");

RaceSelection = require("../../$models/race_selection.model");

RaceSelections = require("../../$collections/race_selections.collection");

Races = require("../../$collections/races.collection");

module.exports = RaceView = (function() {
  class RaceView extends Falcon.View {
    //END sorted_race_options
    //END observables
    initialize() {
      return this.alert.decorate("validatable");
    }

    //END initialize
    raceOptionId(race_option) {
      return `race_option-${race_option.get('id')}`;
    }

    close() {
      return this.trigger("close");
    }

    isFrench() {
      return Language.selectedLanguageCode() === "ca/fr";
    }

    submit() {
      if (this.is_saving()) {
        return this;
      }
      if (!this.race_selection.validate()) {
        return;
      }
      this.is_saving(true);
      return this.race_selection.clone().promiseCreate({
        attributes: ['race_id', 'race_option_id']
      }).then((race_selection) => {
        this.alert.setIsValid(true);
        this.trigger("race_selection:create", race_selection);
        Application.trigger("race_selection:create", race_selection);
        return this.close();
      }).fail((error) => {
        console.error(error);
        return this.alert.setIsValid(false, error.human || error.msg || "An error occurred");
      }).fin(() => {
        return this.is_saving(false);
      }).done();
    }

  };

  RaceView.prototype.endpoint = "#race-template";

  RaceView.prototype.defaults = {
    race: function(race) {
      return race;
    },
    race_selection: function(race) {
      return new RaceSelection().fill({
        race_id: race.get('id')
      });
    }
  };

  //END defaults
  RaceView.prototype.observables = {
    alert: void 0,
    is_loading: false,
    is_saving: false,
    sorted_race_options: function() {
      return this.race.race_options.sort((a, b) => {
        if (a.get('order') < b.get('order')) {
          return -1;
        }
        if (a.get('order') > b.get('order')) {
          return 1;
        }
        return 0;
      });
    }
  };

  return RaceView;

}).call(this);

//END submit
//END ManageAccountView

},{"../../$collections/race_options.collection":37,"../../$collections/race_selections.collection":38,"../../$collections/races.collection":39,"../../$models/question.model":70,"../../$models/race.model":71,"../../$models/race_option.model":72,"../../$models/race_selection.model":73}],110:[function(require,module,exports){
var RPC, RaceWinnerModalView;

RPC = require("../../rpc");

module.exports = RaceWinnerModalView = (function() {
  class RaceWinnerModalView extends Falcon.View {
    //END observables'
    initialize(race_selection) {
      return RPC.promiseMarkRaceSelection(race_selection).then((race_selection) => {
        return this.race_selection.fill(race_selection);
      });
    }

    //END promiseMarkRaceSelection
    //END initiailize
    close() {
      return this.trigger("close");
    }

  };

  RaceWinnerModalView.prototype.endpoint = "#race_winner_modal-template";

  RaceWinnerModalView.prototype.defaults = {
    'race_selection': function(race_selection) {
      return race_selection;
    }
  };

  //END defaults
  RaceWinnerModalView.prototype.observables = {
    'is_visible': false,
    'entry': function() {
      return this.race_selection.entry;
    },
    'entry_count': function() {
      var entry;
      entry = this.entry();
      if (entry == null) {
        return 0;
      }
      return 1 + (entry.get('bonus_entries') || 0);
    },
    //END entry_count
    'has_multiple_entries': function() {
      return this.entry_count() > 1;
    }
  };

  return RaceWinnerModalView;

}).call(this);

//END RaceWinnerModalView

},{"../../rpc":89}],111:[function(require,module,exports){
var Entry, RPC, RegistrationView, Session, User;

Session = require("../../$models/session.model");

Entry = require("../../$models/entry.model");

User = require("../../$models/user.model");

RPC = require("../../rpc");

module.exports = RegistrationView = (function() {
  class RegistrationView extends Falcon.View {
    //END can_goto_second_screen
    //END observables
    initialize() {
      this.alert.decorate('validatable');
      //END alert
      this.first_name.decorate('validatable').subscribe(this.validateFirstName, this);
      //END first_name
      this.last_name.decorate('validatable').subscribe(this.validateLastName, this);
      //END last_name
      this.email.decorate('lowercase').decorate('validatable').subscribe(this.validateEmail, this);
      //END email
      this.email.subscribe(this.checkEmail, this);
      this.repeat_email.decorate('lowercase').decorate('validatable').subscribe(this.validateRepeatEmail, this);
      //END repeat_email
      this.phone.decorate('validatable').subscribe(this.validatePhone, this);
      //END phone
      this.password.decorate('validatable').subscribe(this.validatePassword, this);
      //END password
      return this.repeat_password.decorate('validatable').subscribe(this.validateRepeatPassword, this);
    }

    //END repeat_password
    //END initialize
    validateFirstName() {
      var first_name;
      first_name = Helpers.trim(this.first_name());
      if (_.isEmpty(first_name)) {
        return this.first_name.setIsValid(false, "First name must not be empty");
      }
      return this.first_name.setIsValid(true);
    }

    //END validateFirstName
    validateLastName() {
      var last_name;
      last_name = Helpers.trim(this.last_name());
      if (_.isEmpty(last_name)) {
        return this.last_name.setIsValid(false, "Last name must not be empty");
      }
      return this.last_name.setIsValid(true);
    }

    checkEmail() {
      var email;
      email = Helpers.trim(this.email());
      if (this._checkEmailTimeout) {
        clearTimeout(this._checkEmailTimeout);
      }
      //END if
      return this._checkEmailTimeout = setTimeout(() => {
        this._checkEmailTimeout = null;
        return RPC.promiseCheckEmail(email).then((is_taken) => {
          return this.email_is_taken(is_taken);
        });
      }, 250);
    }

    //END checkEmail
    validateEmail() {
      var email;
      email = Helpers.trim(this.email());
      if (_.isEmpty(email)) {
        return this.email.setIsValid(false, "Email must not be empty");
      }
      if (!Helpers.isEmail(email)) {
        return this.email.setIsValid(false, "Email is formatted incorrectly");
      }
      if (!_.isEmpty(this.repeat_email())) {
        this.validateRepeatEmail();
      }
      return this.email.setIsValid(true);
    }

    //END validateEmail
    validateRepeatEmail() {
      var email, repeat_email;
      email = this.email();
      repeat_email = this.repeat_email();
      if (_.isEmpty(repeat_email)) {
        return this.repeat_email.setIsValid(false, "Please re-enter your email");
      }
      if (email !== repeat_email) {
        return this.repeat_email.setIsValid(false, "Emails do not match");
      }
      return this.repeat_email.setIsValid(true);
    }

    //END validateRepeatEmail
    validatePassword() {
      var password;
      password = this.password();
      if (!Helpers.isPassword(password)) {
        return this.password.setIsValid(false, "Password must be at least 6 characters long and must not contain white space");
      }
      if (!_.isEmpty(this.repeat_password())) {
        this.validateRepeatPassword();
      }
      return this.password.setIsValid(true);
    }

    //END validatePassword
    validateRepeatPassword() {
      var password, repeat_password;
      password = this.password();
      repeat_password = this.repeat_password();
      if (_.isEmpty(repeat_password)) {
        return this.repeat_password.setIsValid(false, "Please re-enter your password");
      }
      if (password !== repeat_password) {
        return this.repeat_password.setIsValid(false, "Passwords do not match");
      }
      return this.repeat_password.setIsValid(true);
    }

    //END validateRepeatPassword
    validatePhone() {
      var phone;
      phone = this.phone() || "";
      if (phone.length !== 10 && !/[0-9]{10}/.test(phone)) {
        return this.phone.setIsValid(false, "Please enter a valid phone number");
      }
      return this.phone.setIsValid(true);
    }

    //END validatePhone
    resetFields() {
      this.alert("");
      this.alert.resetValidations();
      this.first_name("");
      this.first_name.resetValidations();
      this.last_name("");
      this.last_name.resetValidations();
      this.email("");
      this.email.resetValidations();
      this.repeat_email("");
      this.repeat_email.resetValidations();
      this.password("");
      this.password.resetValidations();
      this.repeat_password("");
      this.repeat_password.resetValidations();
      this.phone("");
      this.phone.resetValidations();
      return this;
    }

    //END resetFields
    gotoFirstScreen() {
      this.showing_first_screen(true);
      return true;
    }

    //END gotoFirstScreen
    gotoSecondScreen() {
      if (!this.can_goto_second_screen()) {
        return false;
      }
      this.showing_first_screen(false);
      return true;
    }

    //END gotoSecondScreen
    register() {
      var attributes, email, email_is_valid, first_name_is_valid, is_subscribed_to_newsletter, last_name_is_valid, legal_agreements, name, password, password_is_valid, phone_is_valid, phone_number, repeat_email_is_valid, repeat_password_is_valid, user;
      first_name_is_valid = this.validateFirstName();
      last_name_is_valid = this.validateLastName();
      email_is_valid = this.validateEmail();
      repeat_email_is_valid = this.validateRepeatEmail();
      password_is_valid = this.validatePassword();
      repeat_password_is_valid = this.validateRepeatPassword();
      phone_is_valid = this.validatePhone();
      if (!(first_name_is_valid && last_name_is_valid && email_is_valid && repeat_email_is_valid)) {
        this.gotoFirstScreen();
      }
      if (!(first_name_is_valid && last_name_is_valid && email_is_valid && repeat_email_is_valid && password_is_valid && repeat_password_is_valid && phone_is_valid)) {
        return this;
      }
      if (!this.can_register()) {
        return this;
      }
      if (this.is_registering()) {
        return this;
      }
      name = Helpers.trim(this.name());
      email = Helpers.trim(this.email());
      phone_number = this.formatted_phone();
      password = this.password();
      is_subscribed_to_newsletter = this.opted_in_emails();
      legal_agreements = {
        'did_read_rules_dream_drive_2019': true,
        'opted_in_to_dream_drive_2019': true
      };
      this.is_registering(true);
      user = new User({name, email, password, phone_number, is_subscribed_to_newsletter, legal_agreements});
      attributes = ['name', 'email', 'password', 'phone_number', 'is_subscribed_to_newsletter', 'legal_agreements'];
      user.promiseCreate({attributes}).then((user) => {
        this.trigger('user:create', user);
        Application.trigger('user:create', user);
        return user;
      }).then((user) => {
        return new Session({email, password}).promiseCreate({
          attributes: ['email', 'password']
        });
      }).then((session) => {
        Application.login(session);
        this.trigger('session:create', session);
        return Application.trigger('session:create', session);
      }).then(() => {
        if (!this.has_game_code()) {
          return null;
        }
        return RPC.promiseClaimGameCode(this.game_code()).then(function(entry) {
          return Application.setClaimedEntry(entry);
        });
      }).then((entry) => {
        this.resetFields();
        Router.gotoMain();
        return Tutorial.clear();
      }).fail((error) => {
        Application.flashError(error);
        this.alert.setIsValid(false, error.human);
        return this.gotoFirstScreen();
      }).fin(() => {
        return this.is_registering(false);
      }).done();
      //END user
      return this;
    }

    //END register
    setGameCode(game_code) {
      this.game_code(game_code);
      return this;
    }

    //END setGameCode
    gotoLogin() {
      var params;
      params = {};
      if (this.has_game_code()) {
        params['game_code'] = this.game_code();
      }
      return Router.gotoLogin(params);
    }

    //END gotoLogin
    showRules() {
      return Application.Layout.showRules();
    }

  };

  RegistrationView.prototype.endpoint = '#registration-template';

  RegistrationView.prototype.observables = {
    'alert': "",
    'is_registering': false,
    'email_is_taken': false,
    'first_name': "",
    'last_name': "",
    'name': function() {
      return Helpers.trim(this.first_name() + " " + this.last_name());
    },
    'email': "",
    'repeat_email': "",
    'phone': "",
    'password': "",
    'repeat_password': "",
    'game_code': "",
    'has_game_code': function() {
      return Entry.isValidCode(this.game_code());
    },
    'formatted_phone': {
      write: function(value) {
        value = (value || "").toString().replace(/[^0-9]+/gi, "");
        return this.phone(value);
      },
      //END write
      read: function() {
        var first_piece, phone, second_piece, third_piece;
        phone = (this.phone() || "").toString();
        if (!/^[0-9]+$/.test(phone)) {
          return phone;
        }
        first_piece = phone.slice(0, 3);
        second_piece = phone.slice(3, 6);
        third_piece = phone.slice(6, 10);
        if (third_piece.length > 0) {
          return `(${first_piece}) ${second_piece}-${third_piece}`;
        } else if (second_piece.length > 0) {
          return `${first_piece}-${second_piece}`;
        } else {
          return `${first_piece}`;
        }
      }
    },
    //END if
    //END read
    //END formatted_phone
    '_opted_in_emails': void 0,
    'opted_in_emails': {
      write: function(value) {
        return this._opted_in_emails(value);
      },
      read: function() {
        var opted_in_emails;
        opted_in_emails = this._opted_in_emails();
        if (opted_in_emails != null) {
          return opted_in_emails;
        }
        return Language.isWithinUnitedStates();
      }
    },
    //END read
    //END opted_in_emails
    'did_read_rules': false,
    'can_register': function() {
      if (this.is_registering()) {
        return false;
      }
      if (!this.first_name.is_valid()) {
        return false;
      }
      if (!this.last_name.is_valid()) {
        return false;
      }
      if (!this.email.is_valid()) {
        return false;
      }
      if (!this.repeat_email.is_valid()) {
        return false;
      }
      if (!this.phone.is_valid()) {
        return false;
      }
      if (!this.password.is_valid()) {
        return false;
      }
      if (!this.repeat_password.is_valid()) {
        return false;
      }
      if (!this.did_read_rules()) {
        return false;
      }
      return true;
    },
    //END can_register
    'showing_first_screen': true,
    'should_show_first_screen': function() {
      if (Application.is_on_mobile()) {
        return true;
      }
      return this.showing_first_screen();
    },
    //END should_show_first_screen
    'should_show_first_screen_actions': function() {
      if (Application.is_on_mobile()) {
        return false;
      }
      return true;
    },
    //END should_show_first_screen_actions
    'should_show_second_screen': function() {
      if (Application.is_on_mobile()) {
        return true;
      }
      return !this.showing_first_screen();
    },
    //END should_show_second_screen
    'should_show_back_action': function() {
      if (Application.is_on_mobile()) {
        return false;
      }
      return true;
    },
    //END should_show_back_action
    'can_goto_second_screen': function() {
      if (this.is_registering()) {
        return false;
      }
      if (!this.first_name.is_valid()) {
        return false;
      }
      if (!this.last_name.is_valid()) {
        return false;
      }
      if (!this.email.is_valid()) {
        return false;
      }
      if (!this.repeat_email.is_valid()) {
        return false;
      }
      return true;
    }
  };

  //END validateLastName
  RegistrationView.prototype._checkEmailTimeout = null;

  return RegistrationView;

}).call(this);

//END RegistrationView

},{"../../$models/entry.model":59,"../../$models/session.model":77,"../../$models/user.model":81,"../../rpc":89}],112:[function(require,module,exports){
var RPC, ResetPasswordView, Session;

RPC = require("../../rpc");

Session = require("../../$models/session.model");

module.exports = ResetPasswordView = (function() {
  class ResetPasswordView extends Falcon.View {
    //END can_reset_password
    //END observables
    initialize() {
      this.alert.decorate('validatable');
      //END alert
      this.password.decorate('validatable').subscribe(this.validatePassword, this);
      //END password
      return this.repeat_password.decorate('validatable').subscribe(this.validateRepeatPassword, this);
    }

    //END repeat_password
    //END initialize
    setEmail(email) {
      return this.email(decodeURIComponent(email));
    }

    setResetCode(reset_code) {
      return this.reset_code(decodeURIComponent(reset_code));
    }

    validatePassword() {
      var password;
      password = this.password();
      if (!Helpers.isPassword(password)) {
        return this.password.setIsValid(false, "Password must be at least 6 characters long and must not contain white space");
      }
      if (!_.isEmpty(this.repeat_password())) {
        this.validateRepeatPassword();
      }
      return this.password.setIsValid(true);
    }

    //END validatePassword
    validateRepeatPassword() {
      var password, repeat_password;
      password = this.password();
      repeat_password = this.repeat_password();
      if (_.isEmpty(repeat_password)) {
        return this.repeat_password.setIsValid(false, "Please re-enter your password");
      }
      if (password !== repeat_password) {
        return this.repeat_password.setIsValid(false, "Passwords do not match");
      }
      return this.repeat_password.setIsValid(true);
    }

    //END validateRepeatPassword
    resetFields() {
      this.alert("");
      this.alert.resetValidations();
      this.password("");
      this.password.resetValidations();
      this.repeat_password("");
      this.repeat_password.resetValidations();
      return this;
    }

    //END resetFields
    reset() {
      var email, password, reset_code;
      if (!(this.validatePassword() && this.validateRepeatPassword())) {
        return this;
      }
      if (!this.can_reset_password()) {
        return this;
      }
      if (this.is_resetting()) {
        return this;
      }
      email = Helpers.trim(this.email());
      reset_code = Helpers.trim(this.reset_code());
      password = Helpers.trim(this.password());
      this.is_resetting(true);
      RPC.promiseResetPassword({email, reset_code, password}).then((user) => {
        return new Session({email, password}).promiseCreate({
          attributes: ['email', 'password']
        });
      }).then((session) => {
        Application.login(session);
        this.resetFields();
        this.trigger('session:create', session);
        Application.trigger('session:create', session);
        return Router.gotoMain();
      }).fail((error) => {
        var ref;
        Application.flashError(error);
        return this.alert.setIsValid(false, (ref = error.human) != null ? ref : error.message);
      }).fin(() => {
        return this.is_resetting(false);
      }).done();
      //END RPC
      return this;
    }

    //END send
    gotoLogin() {
      return Router.gotoLogin();
    }

  };

  ResetPasswordView.prototype.endpoint = '#reset_password-template';

  ResetPasswordView.prototype.observables = {
    'alert': "",
    'is_resetting': false,
    'email': "",
    'reset_code': "",
    'password': "",
    'repeat_password': "",
    'email_is_valid': function() {
      return Helpers.isEmail(this.email());
    },
    'reset_code_is_valid': function() {
      return !_.isEmpty(this.reset_code());
    },
    'can_reset_password': function() {
      if (!this.email_is_valid()) {
        return false;
      }
      if (!this.reset_code_is_valid()) {
        return false;
      }
      return true;
    }
  };

  return ResetPasswordView;

}).call(this);

//END ResetPasswordView

},{"../../$models/session.model":77,"../../rpc":89}],113:[function(require,module,exports){
var Language, RulesView;

Language = require("../language");

module.exports = RulesView = class RulesView extends Falcon.View {
  endpoint() {
    var ret;
    ret = (function() {
      switch (Language.selectedLanguageCode()) {
        case "ca/en":
          return "#rules_ca_en-template";
        case "ca/fr":
          return "#rules_ca_fr-template";
        default:
          return "#rules_us_en-template";
      }
    })();
    //END switch
    return ret;
  }

};

//END endpoint
//END RulesView

},{"../language":97}],114:[function(require,module,exports){
var Question, Survey, SurveyAnswer, SurveyAnswers, SurveyResponse, SurveyResponses, SurveyView, Surveys;

Question = require("../../$models/question.model");

Survey = require("../../$models/survey.model");

SurveyAnswer = require("../../$models/survey_answer.model");

SurveyAnswers = require("../../$collections/survey_answers.collection");

SurveyResponse = require("../../$models/survey_response.model");

SurveyResponses = require("../../$collections/survey_responses.collection");

Surveys = require("../../$collections/surveys.collection");

module.exports = SurveyView = (function() {
  class SurveyView extends Falcon.View {
    //END active_answer
    //END observables
    initialize() {
      return this.alert.decorate("validatable");
    }

    //END initialize
    gotoNext() {
      var active_answer;
      if (this.is_saving()) {
        return this;
      }
      active_answer = this.active_answer();
      if ((active_answer != null) && !active_answer.validate()) {
        return;
      }
      this.active_index(this.active_index() + 1);
      if (this.active_index() === this.survey_response.answers.length()) {
        return this.submit();
      }
    }

    //END gotoNext
    close() {
      return this.trigger("close");
    }

    isFrench() {
      return Language.selectedLanguageCode() === "ca/fr";
    }

    submit() {
      if (this.is_saving() || this.is_successful()) {
        return this;
      }
      if (!this.survey_response.validate()) {
        return;
      }
      this.is_saving(true);
      return this.survey_response.clone().promiseCreate({
        attributes: {
          'survey_id': true,
          'answers': ['question_id', 'selections']
        }
      }).then((survey_response) => {
        this.is_successful(true);
        this.alert.setIsValid(true);
        this.trigger("entry:create", survey_response.entry);
        return Application.trigger("entry:create", survey_response.entry);
      }).fail((error) => {
        console.error(error);
        return this.alert.setIsValid(false, error.human || error.msg || "An error occurred");
      }).fin(() => {
        return this.is_saving(false);
      }).done();
    }

  };

  SurveyView.prototype.endpoint = "#survey-template";

  SurveyView.prototype.defaults = {
    survey: function(survey) {
      return survey;
    },
    survey_response: function(survey) {
      return (new SurveyResponse()).mapSurvey(survey);
    }
  };

  //END defaults
  SurveyView.prototype.observables = {
    alert: void 0,
    is_loading: false,
    is_saving: false,
    is_successful: false,
    active_index: 0,
    is_showing_thank_you: function() {
      return this.active_index() === this.survey_response.answers.length();
    },
    has_next_question: function() {
      return this.active_index() < this.survey_response.answers.length() - 1;
    },
    active_answer: function() {
      var answers;
      answers = this.survey_response.answers.all();
      answers.sort((a, b) => {
        a = parseInt(a.question.get('order'));
        b = parseInt(b.question.get('order'));
        if (a < b) {
          return -1;
        }
        if (a > b) {
          return 1;
        }
        return 0;
      });
      return answers[this.active_index()];
    }
  };

  return SurveyView;

}).call(this);

//END submit
//END ManageAccountView

},{"../../$collections/survey_answers.collection":43,"../../$collections/survey_responses.collection":44,"../../$collections/surveys.collection":45,"../../$models/question.model":70,"../../$models/survey.model":78,"../../$models/survey_answer.model":79,"../../$models/survey_response.model":80}],115:[function(require,module,exports){
var RPC, VideoModalView;

RPC = require("../../rpc");

module.exports = VideoModalView = (function() {
  class VideoModalView extends Falcon.View {
    close() {
      return Application.Layout.clearModalView();
    }

  };

  VideoModalView.prototype.endpoint = "#video_modal-template";

  return VideoModalView;

}).call(this);

//END close
//END VideoModalView

},{"../../rpc":89}],116:[function(require,module,exports){
'use strict';

var Config = {
    DEBUG: false,
    LIB_VERSION: '2.45.0'
};

// since es6 imports are static and we run unit tests from the console, window won't be defined when importing this file
var window$1;
if (typeof(window) === 'undefined') {
    var loc = {
        hostname: ''
    };
    window$1 = {
        navigator: { userAgent: '' },
        document: {
            location: loc,
            referrer: ''
        },
        screen: { width: 0, height: 0 },
        location: loc
    };
} else {
    window$1 = window;
}

/*
 * Saved references to long variable names, so that closure compiler can
 * minimize file size.
 */

var ArrayProto = Array.prototype;
var FuncProto = Function.prototype;
var ObjProto = Object.prototype;
var slice = ArrayProto.slice;
var toString = ObjProto.toString;
var hasOwnProperty = ObjProto.hasOwnProperty;
var windowConsole = window$1.console;
var navigator = window$1.navigator;
var document$1 = window$1.document;
var windowOpera = window$1.opera;
var screen = window$1.screen;
var userAgent = navigator.userAgent;
var nativeBind = FuncProto.bind;
var nativeForEach = ArrayProto.forEach;
var nativeIndexOf = ArrayProto.indexOf;
var nativeMap = ArrayProto.map;
var nativeIsArray = Array.isArray;
var breaker = {};
var _ = {
    trim: function(str) {
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    }
};

// Console override
var console = {
    /** @type {function(...*)} */
    log: function() {
        if (Config.DEBUG && !_.isUndefined(windowConsole) && windowConsole) {
            try {
                windowConsole.log.apply(windowConsole, arguments);
            } catch (err) {
                _.each(arguments, function(arg) {
                    windowConsole.log(arg);
                });
            }
        }
    },
    /** @type {function(...*)} */
    warn: function() {
        if (Config.DEBUG && !_.isUndefined(windowConsole) && windowConsole) {
            var args = ['Mixpanel warning:'].concat(_.toArray(arguments));
            try {
                windowConsole.warn.apply(windowConsole, args);
            } catch (err) {
                _.each(args, function(arg) {
                    windowConsole.warn(arg);
                });
            }
        }
    },
    /** @type {function(...*)} */
    error: function() {
        if (Config.DEBUG && !_.isUndefined(windowConsole) && windowConsole) {
            var args = ['Mixpanel error:'].concat(_.toArray(arguments));
            try {
                windowConsole.error.apply(windowConsole, args);
            } catch (err) {
                _.each(args, function(arg) {
                    windowConsole.error(arg);
                });
            }
        }
    },
    /** @type {function(...*)} */
    critical: function() {
        if (!_.isUndefined(windowConsole) && windowConsole) {
            var args = ['Mixpanel error:'].concat(_.toArray(arguments));
            try {
                windowConsole.error.apply(windowConsole, args);
            } catch (err) {
                _.each(args, function(arg) {
                    windowConsole.error(arg);
                });
            }
        }
    }
};

var log_func_with_prefix = function(func, prefix) {
    return function() {
        arguments[0] = '[' + prefix + '] ' + arguments[0];
        return func.apply(console, arguments);
    };
};
var console_with_prefix = function(prefix) {
    return {
        log: log_func_with_prefix(console.log, prefix),
        error: log_func_with_prefix(console.error, prefix),
        critical: log_func_with_prefix(console.critical, prefix)
    };
};


// UNDERSCORE
// Embed part of the Underscore Library
_.bind = function(func, context) {
    var args, bound;
    if (nativeBind && func.bind === nativeBind) {
        return nativeBind.apply(func, slice.call(arguments, 1));
    }
    if (!_.isFunction(func)) {
        throw new TypeError();
    }
    args = slice.call(arguments, 2);
    bound = function() {
        if (!(this instanceof bound)) {
            return func.apply(context, args.concat(slice.call(arguments)));
        }
        var ctor = {};
        ctor.prototype = func.prototype;
        var self = new ctor();
        ctor.prototype = null;
        var result = func.apply(self, args.concat(slice.call(arguments)));
        if (Object(result) === result) {
            return result;
        }
        return self;
    };
    return bound;
};

/**
 * @param {*=} obj
 * @param {function(...*)=} iterator
 * @param {Object=} context
 */
_.each = function(obj, iterator, context) {
    if (obj === null || obj === undefined) {
        return;
    }
    if (nativeForEach && obj.forEach === nativeForEach) {
        obj.forEach(iterator, context);
    } else if (obj.length === +obj.length) {
        for (var i = 0, l = obj.length; i < l; i++) {
            if (i in obj && iterator.call(context, obj[i], i, obj) === breaker) {
                return;
            }
        }
    } else {
        for (var key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                if (iterator.call(context, obj[key], key, obj) === breaker) {
                    return;
                }
            }
        }
    }
};

_.extend = function(obj) {
    _.each(slice.call(arguments, 1), function(source) {
        for (var prop in source) {
            if (source[prop] !== void 0) {
                obj[prop] = source[prop];
            }
        }
    });
    return obj;
};

_.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
};

// from a comment on http://dbj.org/dbj/?p=286
// fails on only one very rare and deliberate custom object:
// var bomb = { toString : undefined, valueOf: function(o) { return "function BOMBA!"; }};
_.isFunction = function(f) {
    try {
        return /^\s*\bfunction\b/.test(f);
    } catch (x) {
        return false;
    }
};

_.isArguments = function(obj) {
    return !!(obj && hasOwnProperty.call(obj, 'callee'));
};

_.toArray = function(iterable) {
    if (!iterable) {
        return [];
    }
    if (iterable.toArray) {
        return iterable.toArray();
    }
    if (_.isArray(iterable)) {
        return slice.call(iterable);
    }
    if (_.isArguments(iterable)) {
        return slice.call(iterable);
    }
    return _.values(iterable);
};

_.map = function(arr, callback, context) {
    if (nativeMap && arr.map === nativeMap) {
        return arr.map(callback, context);
    } else {
        var results = [];
        _.each(arr, function(item) {
            results.push(callback.call(context, item));
        });
        return results;
    }
};

_.keys = function(obj) {
    var results = [];
    if (obj === null) {
        return results;
    }
    _.each(obj, function(value, key) {
        results[results.length] = key;
    });
    return results;
};

_.values = function(obj) {
    var results = [];
    if (obj === null) {
        return results;
    }
    _.each(obj, function(value) {
        results[results.length] = value;
    });
    return results;
};

_.include = function(obj, target) {
    var found = false;
    if (obj === null) {
        return found;
    }
    if (nativeIndexOf && obj.indexOf === nativeIndexOf) {
        return obj.indexOf(target) != -1;
    }
    _.each(obj, function(value) {
        if (found || (found = (value === target))) {
            return breaker;
        }
    });
    return found;
};

_.includes = function(str, needle) {
    return str.indexOf(needle) !== -1;
};

// Underscore Addons
_.inherit = function(subclass, superclass) {
    subclass.prototype = new superclass();
    subclass.prototype.constructor = subclass;
    subclass.superclass = superclass.prototype;
    return subclass;
};

_.isObject = function(obj) {
    return (obj === Object(obj) && !_.isArray(obj));
};

_.isEmptyObject = function(obj) {
    if (_.isObject(obj)) {
        for (var key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                return false;
            }
        }
        return true;
    }
    return false;
};

_.isUndefined = function(obj) {
    return obj === void 0;
};

_.isString = function(obj) {
    return toString.call(obj) == '[object String]';
};

_.isDate = function(obj) {
    return toString.call(obj) == '[object Date]';
};

_.isNumber = function(obj) {
    return toString.call(obj) == '[object Number]';
};

_.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
};

_.encodeDates = function(obj) {
    _.each(obj, function(v, k) {
        if (_.isDate(v)) {
            obj[k] = _.formatDate(v);
        } else if (_.isObject(v)) {
            obj[k] = _.encodeDates(v); // recurse
        }
    });
    return obj;
};

_.timestamp = function() {
    Date.now = Date.now || function() {
        return +new Date;
    };
    return Date.now();
};

_.formatDate = function(d) {
    // YYYY-MM-DDTHH:MM:SS in UTC
    function pad(n) {
        return n < 10 ? '0' + n : n;
    }
    return d.getUTCFullYear() + '-' +
        pad(d.getUTCMonth() + 1) + '-' +
        pad(d.getUTCDate()) + 'T' +
        pad(d.getUTCHours()) + ':' +
        pad(d.getUTCMinutes()) + ':' +
        pad(d.getUTCSeconds());
};

_.strip_empty_properties = function(p) {
    var ret = {};
    _.each(p, function(v, k) {
        if (_.isString(v) && v.length > 0) {
            ret[k] = v;
        }
    });
    return ret;
};

/*
 * this function returns a copy of object after truncating it.  If
 * passed an Array or Object it will iterate through obj and
 * truncate all the values recursively.
 */
_.truncate = function(obj, length) {
    var ret;

    if (typeof(obj) === 'string') {
        ret = obj.slice(0, length);
    } else if (_.isArray(obj)) {
        ret = [];
        _.each(obj, function(val) {
            ret.push(_.truncate(val, length));
        });
    } else if (_.isObject(obj)) {
        ret = {};
        _.each(obj, function(val, key) {
            ret[key] = _.truncate(val, length);
        });
    } else {
        ret = obj;
    }

    return ret;
};

_.JSONEncode = (function() {
    return function(mixed_val) {
        var value = mixed_val;
        var quote = function(string) {
            var escapable = /[\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g; // eslint-disable-line no-control-regex
            var meta = { // table of character substitutions
                '\b': '\\b',
                '\t': '\\t',
                '\n': '\\n',
                '\f': '\\f',
                '\r': '\\r',
                '"': '\\"',
                '\\': '\\\\'
            };

            escapable.lastIndex = 0;
            return escapable.test(string) ?
                '"' + string.replace(escapable, function(a) {
                    var c = meta[a];
                    return typeof c === 'string' ? c :
                        '\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
                }) + '"' :
                '"' + string + '"';
        };

        var str = function(key, holder) {
            var gap = '';
            var indent = '    ';
            var i = 0; // The loop counter.
            var k = ''; // The member key.
            var v = ''; // The member value.
            var length = 0;
            var mind = gap;
            var partial = [];
            var value = holder[key];

            // If the value has a toJSON method, call it to obtain a replacement value.
            if (value && typeof value === 'object' &&
                typeof value.toJSON === 'function') {
                value = value.toJSON(key);
            }

            // What happens next depends on the value's type.
            switch (typeof value) {
                case 'string':
                    return quote(value);

                case 'number':
                    // JSON numbers must be finite. Encode non-finite numbers as null.
                    return isFinite(value) ? String(value) : 'null';

                case 'boolean':
                case 'null':
                    // If the value is a boolean or null, convert it to a string. Note:
                    // typeof null does not produce 'null'. The case is included here in
                    // the remote chance that this gets fixed someday.

                    return String(value);

                case 'object':
                    // If the type is 'object', we might be dealing with an object or an array or
                    // null.
                    // Due to a specification blunder in ECMAScript, typeof null is 'object',
                    // so watch out for that case.
                    if (!value) {
                        return 'null';
                    }

                    // Make an array to hold the partial results of stringifying this object value.
                    gap += indent;
                    partial = [];

                    // Is the value an array?
                    if (toString.apply(value) === '[object Array]') {
                        // The value is an array. Stringify every element. Use null as a placeholder
                        // for non-JSON values.

                        length = value.length;
                        for (i = 0; i < length; i += 1) {
                            partial[i] = str(i, value) || 'null';
                        }

                        // Join all of the elements together, separated with commas, and wrap them in
                        // brackets.
                        v = partial.length === 0 ? '[]' :
                            gap ? '[\n' + gap +
                            partial.join(',\n' + gap) + '\n' +
                            mind + ']' :
                                '[' + partial.join(',') + ']';
                        gap = mind;
                        return v;
                    }

                    // Iterate through all of the keys in the object.
                    for (k in value) {
                        if (hasOwnProperty.call(value, k)) {
                            v = str(k, value);
                            if (v) {
                                partial.push(quote(k) + (gap ? ': ' : ':') + v);
                            }
                        }
                    }

                    // Join all of the member texts together, separated with commas,
                    // and wrap them in braces.
                    v = partial.length === 0 ? '{}' :
                        gap ? '{' + partial.join(',') + '' +
                        mind + '}' : '{' + partial.join(',') + '}';
                    gap = mind;
                    return v;
            }
        };

        // Make a fake root object containing our value under the key of ''.
        // Return the result of stringifying the value.
        return str('', {
            '': value
        });
    };
})();

/**
 * From https://github.com/douglascrockford/JSON-js/blob/master/json_parse.js
 * Slightly modified to throw a real Error rather than a POJO
 */
_.JSONDecode = (function() {
    var at, // The index of the current character
        ch, // The current character
        escapee = {
            '"': '"',
            '\\': '\\',
            '/': '/',
            'b': '\b',
            'f': '\f',
            'n': '\n',
            'r': '\r',
            't': '\t'
        },
        text,
        error = function(m) {
            var e = new SyntaxError(m);
            e.at = at;
            e.text = text;
            throw e;
        },
        next = function(c) {
            // If a c parameter is provided, verify that it matches the current character.
            if (c && c !== ch) {
                error('Expected \'' + c + '\' instead of \'' + ch + '\'');
            }
            // Get the next character. When there are no more characters,
            // return the empty string.
            ch = text.charAt(at);
            at += 1;
            return ch;
        },
        number = function() {
            // Parse a number value.
            var number,
                string = '';

            if (ch === '-') {
                string = '-';
                next('-');
            }
            while (ch >= '0' && ch <= '9') {
                string += ch;
                next();
            }
            if (ch === '.') {
                string += '.';
                while (next() && ch >= '0' && ch <= '9') {
                    string += ch;
                }
            }
            if (ch === 'e' || ch === 'E') {
                string += ch;
                next();
                if (ch === '-' || ch === '+') {
                    string += ch;
                    next();
                }
                while (ch >= '0' && ch <= '9') {
                    string += ch;
                    next();
                }
            }
            number = +string;
            if (!isFinite(number)) {
                error('Bad number');
            } else {
                return number;
            }
        },

        string = function() {
            // Parse a string value.
            var hex,
                i,
                string = '',
                uffff;
            // When parsing for string values, we must look for " and \ characters.
            if (ch === '"') {
                while (next()) {
                    if (ch === '"') {
                        next();
                        return string;
                    }
                    if (ch === '\\') {
                        next();
                        if (ch === 'u') {
                            uffff = 0;
                            for (i = 0; i < 4; i += 1) {
                                hex = parseInt(next(), 16);
                                if (!isFinite(hex)) {
                                    break;
                                }
                                uffff = uffff * 16 + hex;
                            }
                            string += String.fromCharCode(uffff);
                        } else if (typeof escapee[ch] === 'string') {
                            string += escapee[ch];
                        } else {
                            break;
                        }
                    } else {
                        string += ch;
                    }
                }
            }
            error('Bad string');
        },
        white = function() {
            // Skip whitespace.
            while (ch && ch <= ' ') {
                next();
            }
        },
        word = function() {
            // true, false, or null.
            switch (ch) {
                case 't':
                    next('t');
                    next('r');
                    next('u');
                    next('e');
                    return true;
                case 'f':
                    next('f');
                    next('a');
                    next('l');
                    next('s');
                    next('e');
                    return false;
                case 'n':
                    next('n');
                    next('u');
                    next('l');
                    next('l');
                    return null;
            }
            error('Unexpected "' + ch + '"');
        },
        value, // Placeholder for the value function.
        array = function() {
            // Parse an array value.
            var array = [];

            if (ch === '[') {
                next('[');
                white();
                if (ch === ']') {
                    next(']');
                    return array; // empty array
                }
                while (ch) {
                    array.push(value());
                    white();
                    if (ch === ']') {
                        next(']');
                        return array;
                    }
                    next(',');
                    white();
                }
            }
            error('Bad array');
        },
        object = function() {
            // Parse an object value.
            var key,
                object = {};

            if (ch === '{') {
                next('{');
                white();
                if (ch === '}') {
                    next('}');
                    return object; // empty object
                }
                while (ch) {
                    key = string();
                    white();
                    next(':');
                    if (Object.hasOwnProperty.call(object, key)) {
                        error('Duplicate key "' + key + '"');
                    }
                    object[key] = value();
                    white();
                    if (ch === '}') {
                        next('}');
                        return object;
                    }
                    next(',');
                    white();
                }
            }
            error('Bad object');
        };

    value = function() {
        // Parse a JSON value. It could be an object, an array, a string,
        // a number, or a word.
        white();
        switch (ch) {
            case '{':
                return object();
            case '[':
                return array();
            case '"':
                return string();
            case '-':
                return number();
            default:
                return ch >= '0' && ch <= '9' ? number() : word();
        }
    };

    // Return the json_parse function. It will have access to all of the
    // above functions and variables.
    return function(source) {
        var result;

        text = source;
        at = 0;
        ch = ' ';
        result = value();
        white();
        if (ch) {
            error('Syntax error');
        }

        return result;
    };
})();

_.base64Encode = function(data) {
    var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    var o1, o2, o3, h1, h2, h3, h4, bits, i = 0,
        ac = 0,
        enc = '',
        tmp_arr = [];

    if (!data) {
        return data;
    }

    data = _.utf8Encode(data);

    do { // pack three octets into four hexets
        o1 = data.charCodeAt(i++);
        o2 = data.charCodeAt(i++);
        o3 = data.charCodeAt(i++);

        bits = o1 << 16 | o2 << 8 | o3;

        h1 = bits >> 18 & 0x3f;
        h2 = bits >> 12 & 0x3f;
        h3 = bits >> 6 & 0x3f;
        h4 = bits & 0x3f;

        // use hexets to index into b64, and append result to encoded string
        tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
    } while (i < data.length);

    enc = tmp_arr.join('');

    switch (data.length % 3) {
        case 1:
            enc = enc.slice(0, -2) + '==';
            break;
        case 2:
            enc = enc.slice(0, -1) + '=';
            break;
    }

    return enc;
};

_.utf8Encode = function(string) {
    string = (string + '').replace(/\r\n/g, '\n').replace(/\r/g, '\n');

    var utftext = '',
        start,
        end;
    var stringl = 0,
        n;

    start = end = 0;
    stringl = string.length;

    for (n = 0; n < stringl; n++) {
        var c1 = string.charCodeAt(n);
        var enc = null;

        if (c1 < 128) {
            end++;
        } else if ((c1 > 127) && (c1 < 2048)) {
            enc = String.fromCharCode((c1 >> 6) | 192, (c1 & 63) | 128);
        } else {
            enc = String.fromCharCode((c1 >> 12) | 224, ((c1 >> 6) & 63) | 128, (c1 & 63) | 128);
        }
        if (enc !== null) {
            if (end > start) {
                utftext += string.substring(start, end);
            }
            utftext += enc;
            start = end = n + 1;
        }
    }

    if (end > start) {
        utftext += string.substring(start, string.length);
    }

    return utftext;
};

_.UUID = (function() {

    // Time/ticks information
    // 1*new Date() is a cross browser version of Date.now()
    var T = function() {
        var d = 1 * new Date(),
            i = 0;

        // this while loop figures how many browser ticks go by
        // before 1*new Date() returns a new number, ie the amount
        // of ticks that go by per millisecond
        while (d == 1 * new Date()) {
            i++;
        }

        return d.toString(16) + i.toString(16);
    };

    // Math.Random entropy
    var R = function() {
        return Math.random().toString(16).replace('.', '');
    };

    // User agent entropy
    // This function takes the user agent string, and then xors
    // together each sequence of 8 bytes.  This produces a final
    // sequence of 8 bytes which it returns as hex.
    var UA = function() {
        var ua = userAgent,
            i, ch, buffer = [],
            ret = 0;

        function xor(result, byte_array) {
            var j, tmp = 0;
            for (j = 0; j < byte_array.length; j++) {
                tmp |= (buffer[j] << j * 8);
            }
            return result ^ tmp;
        }

        for (i = 0; i < ua.length; i++) {
            ch = ua.charCodeAt(i);
            buffer.unshift(ch & 0xFF);
            if (buffer.length >= 4) {
                ret = xor(ret, buffer);
                buffer = [];
            }
        }

        if (buffer.length > 0) {
            ret = xor(ret, buffer);
        }

        return ret.toString(16);
    };

    return function() {
        var se = (screen.height * screen.width).toString(16);
        return (T() + '-' + R() + '-' + UA() + '-' + se + '-' + T());
    };
})();

// _.isBlockedUA()
// This is to block various web spiders from executing our JS and
// sending false tracking data
var BLOCKED_UA_STRS = [
    'ahrefsbot',
    'baiduspider',
    'bingbot',
    'bingpreview',
    'facebookexternal',
    'petalbot',
    'pinterest',
    'screaming frog',
    'yahoo! slurp',
    'yandexbot',

    // a whole bunch of goog-specific crawlers
    // https://developers.google.com/search/docs/advanced/crawling/overview-google-crawlers
    'adsbot-google',
    'apis-google',
    'duplexweb-google',
    'feedfetcher-google',
    'google favicon',
    'google web preview',
    'google-read-aloud',
    'googlebot',
    'googleweblight',
    'mediapartners-google',
    'storebot-google'
];
_.isBlockedUA = function(ua) {
    var i;
    ua = ua.toLowerCase();
    for (i = 0; i < BLOCKED_UA_STRS.length; i++) {
        if (ua.indexOf(BLOCKED_UA_STRS[i]) !== -1) {
            return true;
        }
    }
    return false;
};

/**
 * @param {Object=} formdata
 * @param {string=} arg_separator
 */
_.HTTPBuildQuery = function(formdata, arg_separator) {
    var use_val, use_key, tmp_arr = [];

    if (_.isUndefined(arg_separator)) {
        arg_separator = '&';
    }

    _.each(formdata, function(val, key) {
        use_val = encodeURIComponent(val.toString());
        use_key = encodeURIComponent(key);
        tmp_arr[tmp_arr.length] = use_key + '=' + use_val;
    });

    return tmp_arr.join(arg_separator);
};

_.getQueryParam = function(url, param) {
    // Expects a raw URL

    param = param.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
    var regexS = '[\\?&]' + param + '=([^&#]*)',
        regex = new RegExp(regexS),
        results = regex.exec(url);
    if (results === null || (results && typeof(results[1]) !== 'string' && results[1].length)) {
        return '';
    } else {
        var result = results[1];
        try {
            result = decodeURIComponent(result);
        } catch(err) {
            console.error('Skipping decoding for malformed query param: ' + result);
        }
        return result.replace(/\+/g, ' ');
    }
};


// _.cookie
// Methods partially borrowed from quirksmode.org/js/cookies.html
_.cookie = {
    get: function(name) {
        var nameEQ = name + '=';
        var ca = document$1.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) === 0) {
                return decodeURIComponent(c.substring(nameEQ.length, c.length));
            }
        }
        return null;
    },

    parse: function(name) {
        var cookie;
        try {
            cookie = _.JSONDecode(_.cookie.get(name)) || {};
        } catch (err) {
            // noop
        }
        return cookie;
    },

    set_seconds: function(name, value, seconds, is_cross_subdomain, is_secure, is_cross_site, domain_override) {
        var cdomain = '',
            expires = '',
            secure = '';

        if (domain_override) {
            cdomain = '; domain=' + domain_override;
        } else if (is_cross_subdomain) {
            var domain = extract_domain(document$1.location.hostname);
            cdomain = domain ? '; domain=.' + domain : '';
        }

        if (seconds) {
            var date = new Date();
            date.setTime(date.getTime() + (seconds * 1000));
            expires = '; expires=' + date.toGMTString();
        }

        if (is_cross_site) {
            is_secure = true;
            secure = '; SameSite=None';
        }
        if (is_secure) {
            secure += '; secure';
        }

        document$1.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/' + cdomain + secure;
    },

    set: function(name, value, days, is_cross_subdomain, is_secure, is_cross_site, domain_override) {
        var cdomain = '', expires = '', secure = '';

        if (domain_override) {
            cdomain = '; domain=' + domain_override;
        } else if (is_cross_subdomain) {
            var domain = extract_domain(document$1.location.hostname);
            cdomain = domain ? '; domain=.' + domain : '';
        }

        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toGMTString();
        }

        if (is_cross_site) {
            is_secure = true;
            secure = '; SameSite=None';
        }
        if (is_secure) {
            secure += '; secure';
        }

        var new_cookie_val = name + '=' + encodeURIComponent(value) + expires + '; path=/' + cdomain + secure;
        document$1.cookie = new_cookie_val;
        return new_cookie_val;
    },

    remove: function(name, is_cross_subdomain, domain_override) {
        _.cookie.set(name, '', -1, is_cross_subdomain, false, false, domain_override);
    }
};

var _localStorageSupported = null;
var localStorageSupported = function(storage, forceCheck) {
    if (_localStorageSupported !== null && !forceCheck) {
        return _localStorageSupported;
    }

    var supported = true;
    try {
        storage = storage || window.localStorage;
        var key = '__mplss_' + cheap_guid(8),
            val = 'xyz';
        storage.setItem(key, val);
        if (storage.getItem(key) !== val) {
            supported = false;
        }
        storage.removeItem(key);
    } catch (err) {
        supported = false;
    }

    _localStorageSupported = supported;
    return supported;
};

// _.localStorage
_.localStorage = {
    is_supported: function(force_check) {
        var supported = localStorageSupported(null, force_check);
        if (!supported) {
            console.error('localStorage unsupported; falling back to cookie store');
        }
        return supported;
    },

    error: function(msg) {
        console.error('localStorage error: ' + msg);
    },

    get: function(name) {
        try {
            return window.localStorage.getItem(name);
        } catch (err) {
            _.localStorage.error(err);
        }
        return null;
    },

    parse: function(name) {
        try {
            return _.JSONDecode(_.localStorage.get(name)) || {};
        } catch (err) {
            // noop
        }
        return null;
    },

    set: function(name, value) {
        try {
            window.localStorage.setItem(name, value);
        } catch (err) {
            _.localStorage.error(err);
        }
    },

    remove: function(name) {
        try {
            window.localStorage.removeItem(name);
        } catch (err) {
            _.localStorage.error(err);
        }
    }
};

_.register_event = (function() {
    // written by Dean Edwards, 2005
    // with input from Tino Zijdel - crisp@xs4all.nl
    // with input from Carl Sverre - mail@carlsverre.com
    // with input from Mixpanel
    // http://dean.edwards.name/weblog/2005/10/add-event/
    // https://gist.github.com/1930440

    /**
     * @param {Object} element
     * @param {string} type
     * @param {function(...*)} handler
     * @param {boolean=} oldSchool
     * @param {boolean=} useCapture
     */
    var register_event = function(element, type, handler, oldSchool, useCapture) {
        if (!element) {
            console.error('No valid element provided to register_event');
            return;
        }

        if (element.addEventListener && !oldSchool) {
            element.addEventListener(type, handler, !!useCapture);
        } else {
            var ontype = 'on' + type;
            var old_handler = element[ontype]; // can be undefined
            element[ontype] = makeHandler(element, handler, old_handler);
        }
    };

    function makeHandler(element, new_handler, old_handlers) {
        var handler = function(event) {
            event = event || fixEvent(window.event);

            // this basically happens in firefox whenever another script
            // overwrites the onload callback and doesn't pass the event
            // object to previously defined callbacks.  All the browsers
            // that don't define window.event implement addEventListener
            // so the dom_loaded handler will still be fired as usual.
            if (!event) {
                return undefined;
            }

            var ret = true;
            var old_result, new_result;

            if (_.isFunction(old_handlers)) {
                old_result = old_handlers(event);
            }
            new_result = new_handler.call(element, event);

            if ((false === old_result) || (false === new_result)) {
                ret = false;
            }

            return ret;
        };

        return handler;
    }

    function fixEvent(event) {
        if (event) {
            event.preventDefault = fixEvent.preventDefault;
            event.stopPropagation = fixEvent.stopPropagation;
        }
        return event;
    }
    fixEvent.preventDefault = function() {
        this.returnValue = false;
    };
    fixEvent.stopPropagation = function() {
        this.cancelBubble = true;
    };

    return register_event;
})();


var TOKEN_MATCH_REGEX = new RegExp('^(\\w*)\\[(\\w+)([=~\\|\\^\\$\\*]?)=?"?([^\\]"]*)"?\\]$');

_.dom_query = (function() {
    /* document.getElementsBySelector(selector)
    - returns an array of element objects from the current document
    matching the CSS selector. Selectors can contain element names,
    class names and ids and can be nested. For example:

    elements = document.getElementsBySelector('div#main p a.external')

    Will return an array of all 'a' elements with 'external' in their
    class attribute that are contained inside 'p' elements that are
    contained inside the 'div' element which has id="main"

    New in version 0.4: Support for CSS2 and CSS3 attribute selectors:
    See http://www.w3.org/TR/css3-selectors/#attribute-selectors

    Version 0.4 - Simon Willison, March 25th 2003
    -- Works in Phoenix 0.5, Mozilla 1.3, Opera 7, Internet Explorer 6, Internet Explorer 5 on Windows
    -- Opera 7 fails

    Version 0.5 - Carl Sverre, Jan 7th 2013
    -- Now uses jQuery-esque `hasClass` for testing class name
    equality.  This fixes a bug related to '-' characters being
    considered not part of a 'word' in regex.
    */

    function getAllChildren(e) {
        // Returns all children of element. Workaround required for IE5/Windows. Ugh.
        return e.all ? e.all : e.getElementsByTagName('*');
    }

    var bad_whitespace = /[\t\r\n]/g;

    function hasClass(elem, selector) {
        var className = ' ' + selector + ' ';
        return ((' ' + elem.className + ' ').replace(bad_whitespace, ' ').indexOf(className) >= 0);
    }

    function getElementsBySelector(selector) {
        // Attempt to fail gracefully in lesser browsers
        if (!document$1.getElementsByTagName) {
            return [];
        }
        // Split selector in to tokens
        var tokens = selector.split(' ');
        var token, bits, tagName, found, foundCount, i, j, k, elements, currentContextIndex;
        var currentContext = [document$1];
        for (i = 0; i < tokens.length; i++) {
            token = tokens[i].replace(/^\s+/, '').replace(/\s+$/, '');
            if (token.indexOf('#') > -1) {
                // Token is an ID selector
                bits = token.split('#');
                tagName = bits[0];
                var id = bits[1];
                var element = document$1.getElementById(id);
                if (!element || (tagName && element.nodeName.toLowerCase() != tagName)) {
                    // element not found or tag with that ID not found, return false
                    return [];
                }
                // Set currentContext to contain just this element
                currentContext = [element];
                continue; // Skip to next token
            }
            if (token.indexOf('.') > -1) {
                // Token contains a class selector
                bits = token.split('.');
                tagName = bits[0];
                var className = bits[1];
                if (!tagName) {
                    tagName = '*';
                }
                // Get elements matching tag, filter them for class selector
                found = [];
                foundCount = 0;
                for (j = 0; j < currentContext.length; j++) {
                    if (tagName == '*') {
                        elements = getAllChildren(currentContext[j]);
                    } else {
                        elements = currentContext[j].getElementsByTagName(tagName);
                    }
                    for (k = 0; k < elements.length; k++) {
                        found[foundCount++] = elements[k];
                    }
                }
                currentContext = [];
                currentContextIndex = 0;
                for (j = 0; j < found.length; j++) {
                    if (found[j].className &&
                        _.isString(found[j].className) && // some SVG elements have classNames which are not strings
                        hasClass(found[j], className)
                    ) {
                        currentContext[currentContextIndex++] = found[j];
                    }
                }
                continue; // Skip to next token
            }
            // Code to deal with attribute selectors
            var token_match = token.match(TOKEN_MATCH_REGEX);
            if (token_match) {
                tagName = token_match[1];
                var attrName = token_match[2];
                var attrOperator = token_match[3];
                var attrValue = token_match[4];
                if (!tagName) {
                    tagName = '*';
                }
                // Grab all of the tagName elements within current context
                found = [];
                foundCount = 0;
                for (j = 0; j < currentContext.length; j++) {
                    if (tagName == '*') {
                        elements = getAllChildren(currentContext[j]);
                    } else {
                        elements = currentContext[j].getElementsByTagName(tagName);
                    }
                    for (k = 0; k < elements.length; k++) {
                        found[foundCount++] = elements[k];
                    }
                }
                currentContext = [];
                currentContextIndex = 0;
                var checkFunction; // This function will be used to filter the elements
                switch (attrOperator) {
                    case '=': // Equality
                        checkFunction = function(e) {
                            return (e.getAttribute(attrName) == attrValue);
                        };
                        break;
                    case '~': // Match one of space seperated words
                        checkFunction = function(e) {
                            return (e.getAttribute(attrName).match(new RegExp('\\b' + attrValue + '\\b')));
                        };
                        break;
                    case '|': // Match start with value followed by optional hyphen
                        checkFunction = function(e) {
                            return (e.getAttribute(attrName).match(new RegExp('^' + attrValue + '-?')));
                        };
                        break;
                    case '^': // Match starts with value
                        checkFunction = function(e) {
                            return (e.getAttribute(attrName).indexOf(attrValue) === 0);
                        };
                        break;
                    case '$': // Match ends with value - fails with "Warning" in Opera 7
                        checkFunction = function(e) {
                            return (e.getAttribute(attrName).lastIndexOf(attrValue) == e.getAttribute(attrName).length - attrValue.length);
                        };
                        break;
                    case '*': // Match ends with value
                        checkFunction = function(e) {
                            return (e.getAttribute(attrName).indexOf(attrValue) > -1);
                        };
                        break;
                    default:
                        // Just test for existence of attribute
                        checkFunction = function(e) {
                            return e.getAttribute(attrName);
                        };
                }
                currentContext = [];
                currentContextIndex = 0;
                for (j = 0; j < found.length; j++) {
                    if (checkFunction(found[j])) {
                        currentContext[currentContextIndex++] = found[j];
                    }
                }
                // alert('Attribute Selector: '+tagName+' '+attrName+' '+attrOperator+' '+attrValue);
                continue; // Skip to next token
            }
            // If we get here, token is JUST an element (not a class or ID selector)
            tagName = token;
            found = [];
            foundCount = 0;
            for (j = 0; j < currentContext.length; j++) {
                elements = currentContext[j].getElementsByTagName(tagName);
                for (k = 0; k < elements.length; k++) {
                    found[foundCount++] = elements[k];
                }
            }
            currentContext = found;
        }
        return currentContext;
    }

    return function(query) {
        if (_.isElement(query)) {
            return [query];
        } else if (_.isObject(query) && !_.isUndefined(query.length)) {
            return query;
        } else {
            return getElementsBySelector.call(this, query);
        }
    };
})();

_.info = {
    campaignParams: function() {
        var campaign_keywords = 'utm_source utm_medium utm_campaign utm_content utm_term'.split(' '),
            kw = '',
            params = {};
        _.each(campaign_keywords, function(kwkey) {
            kw = _.getQueryParam(document$1.URL, kwkey);
            if (kw.length) {
                params[kwkey] = kw;
            }
        });

        return params;
    },

    searchEngine: function(referrer) {
        if (referrer.search('https?://(.*)google.([^/?]*)') === 0) {
            return 'google';
        } else if (referrer.search('https?://(.*)bing.com') === 0) {
            return 'bing';
        } else if (referrer.search('https?://(.*)yahoo.com') === 0) {
            return 'yahoo';
        } else if (referrer.search('https?://(.*)duckduckgo.com') === 0) {
            return 'duckduckgo';
        } else {
            return null;
        }
    },

    searchInfo: function(referrer) {
        var search = _.info.searchEngine(referrer),
            param = (search != 'yahoo') ? 'q' : 'p',
            ret = {};

        if (search !== null) {
            ret['$search_engine'] = search;

            var keyword = _.getQueryParam(referrer, param);
            if (keyword.length) {
                ret['mp_keyword'] = keyword;
            }
        }

        return ret;
    },

    /**
     * This function detects which browser is running this script.
     * The order of the checks are important since many user agents
     * include key words used in later checks.
     */
    browser: function(user_agent, vendor, opera) {
        vendor = vendor || ''; // vendor is undefined for at least IE9
        if (opera || _.includes(user_agent, ' OPR/')) {
            if (_.includes(user_agent, 'Mini')) {
                return 'Opera Mini';
            }
            return 'Opera';
        } else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) {
            return 'BlackBerry';
        } else if (_.includes(user_agent, 'IEMobile') || _.includes(user_agent, 'WPDesktop')) {
            return 'Internet Explorer Mobile';
        } else if (_.includes(user_agent, 'SamsungBrowser/')) {
            // https://developer.samsung.com/internet/user-agent-string-format
            return 'Samsung Internet';
        } else if (_.includes(user_agent, 'Edge') || _.includes(user_agent, 'Edg/')) {
            return 'Microsoft Edge';
        } else if (_.includes(user_agent, 'FBIOS')) {
            return 'Facebook Mobile';
        } else if (_.includes(user_agent, 'Chrome')) {
            return 'Chrome';
        } else if (_.includes(user_agent, 'CriOS')) {
            return 'Chrome iOS';
        } else if (_.includes(user_agent, 'UCWEB') || _.includes(user_agent, 'UCBrowser')) {
            return 'UC Browser';
        } else if (_.includes(user_agent, 'FxiOS')) {
            return 'Firefox iOS';
        } else if (_.includes(vendor, 'Apple')) {
            if (_.includes(user_agent, 'Mobile')) {
                return 'Mobile Safari';
            }
            return 'Safari';
        } else if (_.includes(user_agent, 'Android')) {
            return 'Android Mobile';
        } else if (_.includes(user_agent, 'Konqueror')) {
            return 'Konqueror';
        } else if (_.includes(user_agent, 'Firefox')) {
            return 'Firefox';
        } else if (_.includes(user_agent, 'MSIE') || _.includes(user_agent, 'Trident/')) {
            return 'Internet Explorer';
        } else if (_.includes(user_agent, 'Gecko')) {
            return 'Mozilla';
        } else {
            return '';
        }
    },

    /**
     * This function detects which browser version is running this script,
     * parsing major and minor version (e.g., 42.1). User agent strings from:
     * http://www.useragentstring.com/pages/useragentstring.php
     */
    browserVersion: function(userAgent, vendor, opera) {
        var browser = _.info.browser(userAgent, vendor, opera);
        var versionRegexs = {
            'Internet Explorer Mobile': /rv:(\d+(\.\d+)?)/,
            'Microsoft Edge': /Edge?\/(\d+(\.\d+)?)/,
            'Chrome': /Chrome\/(\d+(\.\d+)?)/,
            'Chrome iOS': /CriOS\/(\d+(\.\d+)?)/,
            'UC Browser' : /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/,
            'Safari': /Version\/(\d+(\.\d+)?)/,
            'Mobile Safari': /Version\/(\d+(\.\d+)?)/,
            'Opera': /(Opera|OPR)\/(\d+(\.\d+)?)/,
            'Firefox': /Firefox\/(\d+(\.\d+)?)/,
            'Firefox iOS': /FxiOS\/(\d+(\.\d+)?)/,
            'Konqueror': /Konqueror:(\d+(\.\d+)?)/,
            'BlackBerry': /BlackBerry (\d+(\.\d+)?)/,
            'Android Mobile': /android\s(\d+(\.\d+)?)/,
            'Samsung Internet': /SamsungBrowser\/(\d+(\.\d+)?)/,
            'Internet Explorer': /(rv:|MSIE )(\d+(\.\d+)?)/,
            'Mozilla': /rv:(\d+(\.\d+)?)/
        };
        var regex = versionRegexs[browser];
        if (regex === undefined) {
            return null;
        }
        var matches = userAgent.match(regex);
        if (!matches) {
            return null;
        }
        return parseFloat(matches[matches.length - 2]);
    },

    os: function() {
        var a = userAgent;
        if (/Windows/i.test(a)) {
            if (/Phone/.test(a) || /WPDesktop/.test(a)) {
                return 'Windows Phone';
            }
            return 'Windows';
        } else if (/(iPhone|iPad|iPod)/.test(a)) {
            return 'iOS';
        } else if (/Android/.test(a)) {
            return 'Android';
        } else if (/(BlackBerry|PlayBook|BB10)/i.test(a)) {
            return 'BlackBerry';
        } else if (/Mac/i.test(a)) {
            return 'Mac OS X';
        } else if (/Linux/.test(a)) {
            return 'Linux';
        } else if (/CrOS/.test(a)) {
            return 'Chrome OS';
        } else {
            return '';
        }
    },

    device: function(user_agent) {
        if (/Windows Phone/i.test(user_agent) || /WPDesktop/.test(user_agent)) {
            return 'Windows Phone';
        } else if (/iPad/.test(user_agent)) {
            return 'iPad';
        } else if (/iPod/.test(user_agent)) {
            return 'iPod Touch';
        } else if (/iPhone/.test(user_agent)) {
            return 'iPhone';
        } else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) {
            return 'BlackBerry';
        } else if (/Android/.test(user_agent)) {
            return 'Android';
        } else {
            return '';
        }
    },

    referringDomain: function(referrer) {
        var split = referrer.split('/');
        if (split.length >= 3) {
            return split[2];
        }
        return '';
    },

    properties: function() {
        return _.extend(_.strip_empty_properties({
            '$os': _.info.os(),
            '$browser': _.info.browser(userAgent, navigator.vendor, windowOpera),
            '$referrer': document$1.referrer,
            '$referring_domain': _.info.referringDomain(document$1.referrer),
            '$device': _.info.device(userAgent)
        }), {
            '$current_url': window$1.location.href,
            '$browser_version': _.info.browserVersion(userAgent, navigator.vendor, windowOpera),
            '$screen_height': screen.height,
            '$screen_width': screen.width,
            'mp_lib': 'web',
            '$lib_version': Config.LIB_VERSION,
            '$insert_id': cheap_guid(),
            'time': _.timestamp() / 1000 // epoch time in seconds
        });
    },

    people_properties: function() {
        return _.extend(_.strip_empty_properties({
            '$os': _.info.os(),
            '$browser': _.info.browser(userAgent, navigator.vendor, windowOpera)
        }), {
            '$browser_version': _.info.browserVersion(userAgent, navigator.vendor, windowOpera)
        });
    },

    pageviewInfo: function(page) {
        return _.strip_empty_properties({
            'mp_page': page,
            'mp_referrer': document$1.referrer,
            'mp_browser': _.info.browser(userAgent, navigator.vendor, windowOpera),
            'mp_platform': _.info.os()
        });
    }
};

var cheap_guid = function(maxlen) {
    var guid = Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
    return maxlen ? guid.substring(0, maxlen) : guid;
};

// naive way to extract domain name (example.com) from full hostname (my.sub.example.com)
var SIMPLE_DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]*\.[a-z]+$/i;
// this next one attempts to account for some ccSLDs, e.g. extracting oxford.ac.uk from www.oxford.ac.uk
var DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i;
/**
 * Attempts to extract main domain name from full hostname, using a few blunt heuristics. For
 * common TLDs like .com/.org that always have a simple SLD.TLD structure (example.com), we
 * simply extract the last two .-separated parts of the hostname (SIMPLE_DOMAIN_MATCH_REGEX).
 * For others, we attempt to account for short ccSLD+TLD combos (.ac.uk) with the legacy
 * DOMAIN_MATCH_REGEX (kept to maintain backwards compatibility with existing Mixpanel
 * integrations). The only _reliable_ way to extract domain from hostname is with an up-to-date
 * list like at https://publicsuffix.org/ so for cases that this helper fails at, the SDK
 * offers the 'cookie_domain' config option to set it explicitly.
 * @example
 * extract_domain('my.sub.example.com')
 * // 'example.com'
 */
var extract_domain = function(hostname) {
    var domain_regex = DOMAIN_MATCH_REGEX;
    var parts = hostname.split('.');
    var tld = parts[parts.length - 1];
    if (tld.length > 4 || tld === 'com' || tld === 'org') {
        domain_regex = SIMPLE_DOMAIN_MATCH_REGEX;
    }
    var matches = hostname.match(domain_regex);
    return matches ? matches[0] : '';
};

var JSONStringify = null;
var JSONParse = null;
if (typeof JSON !== 'undefined') {
    JSONStringify = JSON.stringify;
    JSONParse = JSON.parse;
}
JSONStringify = JSONStringify || _.JSONEncode;
JSONParse = JSONParse || _.JSONDecode;

// EXPORTS (for closure compiler)
_['toArray']                = _.toArray;
_['isObject']               = _.isObject;
_['JSONEncode']             = _.JSONEncode;
_['JSONDecode']             = _.JSONDecode;
_['isBlockedUA']            = _.isBlockedUA;
_['isEmptyObject']          = _.isEmptyObject;
_['info']                   = _.info;
_['info']['device']         = _.info.device;
_['info']['browser']        = _.info.browser;
_['info']['browserVersion'] = _.info.browserVersion;
_['info']['properties']     = _.info.properties;

/**
 * DomTracker Object
 * @constructor
 */
var DomTracker = function() {};


// interface
DomTracker.prototype.create_properties = function() {};
DomTracker.prototype.event_handler = function() {};
DomTracker.prototype.after_track_handler = function() {};

DomTracker.prototype.init = function(mixpanel_instance) {
    this.mp = mixpanel_instance;
    return this;
};

/**
 * @param {Object|string} query
 * @param {string} event_name
 * @param {Object=} properties
 * @param {function=} user_callback
 */
DomTracker.prototype.track = function(query, event_name, properties, user_callback) {
    var that = this;
    var elements = _.dom_query(query);

    if (elements.length === 0) {
        console.error('The DOM query (' + query + ') returned 0 elements');
        return;
    }

    _.each(elements, function(element) {
        _.register_event(element, this.override_event, function(e) {
            var options = {};
            var props = that.create_properties(properties, this);
            var timeout = that.mp.get_config('track_links_timeout');

            that.event_handler(e, this, options);

            // in case the mixpanel servers don't get back to us in time
            window.setTimeout(that.track_callback(user_callback, props, options, true), timeout);

            // fire the tracking event
            that.mp.track(event_name, props, that.track_callback(user_callback, props, options));
        });
    }, this);

    return true;
};

/**
 * @param {function} user_callback
 * @param {Object} props
 * @param {boolean=} timeout_occured
 */
DomTracker.prototype.track_callback = function(user_callback, props, options, timeout_occured) {
    timeout_occured = timeout_occured || false;
    var that = this;

    return function() {
        // options is referenced from both callbacks, so we can have
        // a 'lock' of sorts to ensure only one fires
        if (options.callback_fired) { return; }
        options.callback_fired = true;

        if (user_callback && user_callback(timeout_occured, props) === false) {
            // user can prevent the default functionality by
            // returning false from their callback
            return;
        }

        that.after_track_handler(props, options, timeout_occured);
    };
};

DomTracker.prototype.create_properties = function(properties, element) {
    var props;

    if (typeof(properties) === 'function') {
        props = properties(element);
    } else {
        props = _.extend({}, properties);
    }

    return props;
};

/**
 * LinkTracker Object
 * @constructor
 * @extends DomTracker
 */
var LinkTracker = function() {
    this.override_event = 'click';
};
_.inherit(LinkTracker, DomTracker);

LinkTracker.prototype.create_properties = function(properties, element) {
    var props = LinkTracker.superclass.create_properties.apply(this, arguments);

    if (element.href) { props['url'] = element.href; }

    return props;
};

LinkTracker.prototype.event_handler = function(evt, element, options) {
    options.new_tab = (
        evt.which === 2 ||
        evt.metaKey ||
        evt.ctrlKey ||
        element.target === '_blank'
    );
    options.href = element.href;

    if (!options.new_tab) {
        evt.preventDefault();
    }
};

LinkTracker.prototype.after_track_handler = function(props, options) {
    if (options.new_tab) { return; }

    setTimeout(function() {
        window.location = options.href;
    }, 0);
};

/**
 * FormTracker Object
 * @constructor
 * @extends DomTracker
 */
var FormTracker = function() {
    this.override_event = 'submit';
};
_.inherit(FormTracker, DomTracker);

FormTracker.prototype.event_handler = function(evt, element, options) {
    options.element = element;
    evt.preventDefault();
};

FormTracker.prototype.after_track_handler = function(props, options) {
    setTimeout(function() {
        options.element.submit();
    }, 0);
};

// eslint-disable-line camelcase

var logger$2 = console_with_prefix('lock');

/**
 * SharedLock: a mutex built on HTML5 localStorage, to ensure that only one browser
 * window/tab at a time will be able to access shared resources.
 *
 * Based on the Alur and Taubenfeld fast lock
 * (http://www.cs.rochester.edu/research/synchronization/pseudocode/fastlock.html)
 * with an added timeout to ensure there will be eventual progress in the event
 * that a window is closed in the middle of the callback.
 *
 * Implementation based on the original version by David Wolever (https://github.com/wolever)
 * at https://gist.github.com/wolever/5fd7573d1ef6166e8f8c4af286a69432.
 *
 * @example
 * const myLock = new SharedLock('some-key');
 * myLock.withLock(function() {
 *   console.log('I hold the mutex!');
 * });
 *
 * @constructor
 */
var SharedLock = function(key, options) {
    options = options || {};

    this.storageKey = key;
    this.storage = options.storage || window.localStorage;
    this.pollIntervalMS = options.pollIntervalMS || 100;
    this.timeoutMS = options.timeoutMS || 2000;
};

// pass in a specific pid to test contention scenarios; otherwise
// it is chosen randomly for each acquisition attempt
SharedLock.prototype.withLock = function(lockedCB, errorCB, pid) {
    if (!pid && typeof errorCB !== 'function') {
        pid = errorCB;
        errorCB = null;
    }

    var i = pid || (new Date().getTime() + '|' + Math.random());
    var startTime = new Date().getTime();

    var key = this.storageKey;
    var pollIntervalMS = this.pollIntervalMS;
    var timeoutMS = this.timeoutMS;
    var storage = this.storage;

    var keyX = key + ':X';
    var keyY = key + ':Y';
    var keyZ = key + ':Z';

    var reportError = function(err) {
        errorCB && errorCB(err);
    };

    var delay = function(cb) {
        if (new Date().getTime() - startTime > timeoutMS) {
            logger$2.error('Timeout waiting for mutex on ' + key + '; clearing lock. [' + i + ']');
            storage.removeItem(keyZ);
            storage.removeItem(keyY);
            loop();
            return;
        }
        setTimeout(function() {
            try {
                cb();
            } catch(err) {
                reportError(err);
            }
        }, pollIntervalMS * (Math.random() + 0.1));
    };

    var waitFor = function(predicate, cb) {
        if (predicate()) {
            cb();
        } else {
            delay(function() {
                waitFor(predicate, cb);
            });
        }
    };

    var getSetY = function() {
        var valY = storage.getItem(keyY);
        if (valY && valY !== i) { // if Y == i then this process already has the lock (useful for test cases)
            return false;
        } else {
            storage.setItem(keyY, i);
            if (storage.getItem(keyY) === i) {
                return true;
            } else {
                if (!localStorageSupported(storage, true)) {
                    throw new Error('localStorage support dropped while acquiring lock');
                }
                return false;
            }
        }
    };

    var loop = function() {
        storage.setItem(keyX, i);

        waitFor(getSetY, function() {
            if (storage.getItem(keyX) === i) {
                criticalSection();
                return;
            }

            delay(function() {
                if (storage.getItem(keyY) !== i) {
                    loop();
                    return;
                }
                waitFor(function() {
                    return !storage.getItem(keyZ);
                }, criticalSection);
            });
        });
    };

    var criticalSection = function() {
        storage.setItem(keyZ, '1');
        try {
            lockedCB();
        } finally {
            storage.removeItem(keyZ);
            if (storage.getItem(keyY) === i) {
                storage.removeItem(keyY);
            }
            if (storage.getItem(keyX) === i) {
                storage.removeItem(keyX);
            }
        }
    };

    try {
        if (localStorageSupported(storage, true)) {
            loop();
        } else {
            throw new Error('localStorage support check failed');
        }
    } catch(err) {
        reportError(err);
    }
};

// eslint-disable-line camelcase

var logger$1 = console_with_prefix('batch');

/**
 * RequestQueue: queue for batching API requests with localStorage backup for retries.
 * Maintains an in-memory queue which represents the source of truth for the current
 * page, but also writes all items out to a copy in the browser's localStorage, which
 * can be read on subsequent pageloads and retried. For batchability, all the request
 * items in the queue should be of the same type (events, people updates, group updates)
 * so they can be sent in a single request to the same API endpoint.
 *
 * LocalStorage keying and locking: In order for reloads and subsequent pageloads of
 * the same site to access the same persisted data, they must share the same localStorage
 * key (for instance based on project token and queue type). Therefore access to the
 * localStorage entry is guarded by an asynchronous mutex (SharedLock) to prevent
 * simultaneously open windows/tabs from overwriting each other's data (which would lead
 * to data loss in some situations).
 * @constructor
 */
var RequestQueue = function(storageKey, options) {
    options = options || {};
    this.storageKey = storageKey;
    this.storage = options.storage || window.localStorage;
    this.reportError = options.errorReporter || _.bind(logger$1.error, logger$1);
    this.lock = new SharedLock(storageKey, {storage: this.storage});

    this.pid = options.pid || null; // pass pid to test out storage lock contention scenarios

    this.memQueue = [];
};

/**
 * Add one item to queues (memory and localStorage). The queued entry includes
 * the given item along with an auto-generated ID and a "flush-after" timestamp.
 * It is expected that the item will be sent over the network and dequeued
 * before the flush-after time; if this doesn't happen it is considered orphaned
 * (e.g., the original tab where it was enqueued got closed before it could be
 * sent) and the item can be sent by any tab that finds it in localStorage.
 *
 * The final callback param is called with a param indicating success or
 * failure of the enqueue operation; it is asynchronous because the localStorage
 * lock is asynchronous.
 */
RequestQueue.prototype.enqueue = function(item, flushInterval, cb) {
    var queueEntry = {
        'id': cheap_guid(),
        'flushAfter': new Date().getTime() + flushInterval * 2,
        'payload': item
    };

    this.lock.withLock(_.bind(function lockAcquired() {
        var succeeded;
        try {
            var storedQueue = this.readFromStorage();
            storedQueue.push(queueEntry);
            succeeded = this.saveToStorage(storedQueue);
            if (succeeded) {
                // only add to in-memory queue when storage succeeds
                this.memQueue.push(queueEntry);
            }
        } catch(err) {
            this.reportError('Error enqueueing item', item);
            succeeded = false;
        }
        if (cb) {
            cb(succeeded);
        }
    }, this), _.bind(function lockFailure(err) {
        this.reportError('Error acquiring storage lock', err);
        if (cb) {
            cb(false);
        }
    }, this), this.pid);
};

/**
 * Read out the given number of queue entries. If this.memQueue
 * has fewer than batchSize items, then look for "orphaned" items
 * in the persisted queue (items where the 'flushAfter' time has
 * already passed).
 */
RequestQueue.prototype.fillBatch = function(batchSize) {
    var batch = this.memQueue.slice(0, batchSize);
    if (batch.length < batchSize) {
        // don't need lock just to read events; localStorage is thread-safe
        // and the worst that could happen is a duplicate send of some
        // orphaned events, which will be deduplicated on the server side
        var storedQueue = this.readFromStorage();
        if (storedQueue.length) {
            // item IDs already in batch; don't duplicate out of storage
            var idsInBatch = {}; // poor man's Set
            _.each(batch, function(item) { idsInBatch[item['id']] = true; });

            for (var i = 0; i < storedQueue.length; i++) {
                var item = storedQueue[i];
                if (new Date().getTime() > item['flushAfter'] && !idsInBatch[item['id']]) {
                    item.orphaned = true;
                    batch.push(item);
                    if (batch.length >= batchSize) {
                        break;
                    }
                }
            }
        }
    }
    return batch;
};

/**
 * Remove items with matching 'id' from array (immutably)
 * also remove any item without a valid id (e.g., malformed
 * storage entries).
 */
var filterOutIDsAndInvalid = function(items, idSet) {
    var filteredItems = [];
    _.each(items, function(item) {
        if (item['id'] && !idSet[item['id']]) {
            filteredItems.push(item);
        }
    });
    return filteredItems;
};

/**
 * Remove items with matching IDs from both in-memory queue
 * and persisted queue
 */
RequestQueue.prototype.removeItemsByID = function(ids, cb) {
    var idSet = {}; // poor man's Set
    _.each(ids, function(id) { idSet[id] = true; });

    this.memQueue = filterOutIDsAndInvalid(this.memQueue, idSet);

    var removeFromStorage = _.bind(function() {
        var succeeded;
        try {
            var storedQueue = this.readFromStorage();
            storedQueue = filterOutIDsAndInvalid(storedQueue, idSet);
            succeeded = this.saveToStorage(storedQueue);

            // an extra check: did storage report success but somehow
            // the items are still there?
            if (succeeded) {
                storedQueue = this.readFromStorage();
                for (var i = 0; i < storedQueue.length; i++) {
                    var item = storedQueue[i];
                    if (item['id'] && !!idSet[item['id']]) {
                        this.reportError('Item not removed from storage');
                        return false;
                    }
                }
            }
        } catch(err) {
            this.reportError('Error removing items', ids);
            succeeded = false;
        }
        return succeeded;
    }, this);

    this.lock.withLock(function lockAcquired() {
        var succeeded = removeFromStorage();
        if (cb) {
            cb(succeeded);
        }
    }, _.bind(function lockFailure(err) {
        var succeeded = false;
        this.reportError('Error acquiring storage lock', err);
        if (!localStorageSupported(this.storage, true)) {
            // Looks like localStorage writes have stopped working sometime after
            // initialization (probably full), and so nobody can acquire locks
            // anymore. Consider it temporarily safe to remove items without the
            // lock, since nobody's writing successfully anyway.
            succeeded = removeFromStorage();
            if (!succeeded) {
                // OK, we couldn't even write out the smaller queue. Try clearing it
                // entirely.
                try {
                    this.storage.removeItem(this.storageKey);
                } catch(err) {
                    this.reportError('Error clearing queue', err);
                }
            }
        }
        if (cb) {
            cb(succeeded);
        }
    }, this), this.pid);
};

// internal helper for RequestQueue.updatePayloads
var updatePayloads = function(existingItems, itemsToUpdate) {
    var newItems = [];
    _.each(existingItems, function(item) {
        var id = item['id'];
        if (id in itemsToUpdate) {
            var newPayload = itemsToUpdate[id];
            if (newPayload !== null) {
                item['payload'] = newPayload;
                newItems.push(item);
            }
        } else {
            // no update
            newItems.push(item);
        }
    });
    return newItems;
};

/**
 * Update payloads of given items in both in-memory queue and
 * persisted queue. Items set to null are removed from queues.
 */
RequestQueue.prototype.updatePayloads = function(itemsToUpdate, cb) {
    this.memQueue = updatePayloads(this.memQueue, itemsToUpdate);
    this.lock.withLock(_.bind(function lockAcquired() {
        var succeeded;
        try {
            var storedQueue = this.readFromStorage();
            storedQueue = updatePayloads(storedQueue, itemsToUpdate);
            succeeded = this.saveToStorage(storedQueue);
        } catch(err) {
            this.reportError('Error updating items', itemsToUpdate);
            succeeded = false;
        }
        if (cb) {
            cb(succeeded);
        }
    }, this), _.bind(function lockFailure(err) {
        this.reportError('Error acquiring storage lock', err);
        if (cb) {
            cb(false);
        }
    }, this), this.pid);
};

/**
 * Read and parse items array from localStorage entry, handling
 * malformed/missing data if necessary.
 */
RequestQueue.prototype.readFromStorage = function() {
    var storageEntry;
    try {
        storageEntry = this.storage.getItem(this.storageKey);
        if (storageEntry) {
            storageEntry = JSONParse(storageEntry);
            if (!_.isArray(storageEntry)) {
                this.reportError('Invalid storage entry:', storageEntry);
                storageEntry = null;
            }
        }
    } catch (err) {
        this.reportError('Error retrieving queue', err);
        storageEntry = null;
    }
    return storageEntry || [];
};

/**
 * Serialize the given items array to localStorage.
 */
RequestQueue.prototype.saveToStorage = function(queue) {
    try {
        this.storage.setItem(this.storageKey, JSONStringify(queue));
        return true;
    } catch (err) {
        this.reportError('Error saving queue', err);
        return false;
    }
};

/**
 * Clear out queues (memory and localStorage).
 */
RequestQueue.prototype.clear = function() {
    this.memQueue = [];
    this.storage.removeItem(this.storageKey);
};

// eslint-disable-line camelcase

// maximum interval between request retries after exponential backoff
var MAX_RETRY_INTERVAL_MS = 10 * 60 * 1000; // 10 minutes

var logger = console_with_prefix('batch');

/**
 * RequestBatcher: manages the queueing, flushing, retry etc of requests of one
 * type (events, people, groups).
 * Uses RequestQueue to manage the backing store.
 * @constructor
 */
var RequestBatcher = function(storageKey, options) {
    this.errorReporter = options.errorReporter;
    this.queue = new RequestQueue(storageKey, {
        errorReporter: _.bind(this.reportError, this),
        storage: options.storage
    });

    this.libConfig = options.libConfig;
    this.sendRequest = options.sendRequestFunc;
    this.beforeSendHook = options.beforeSendHook;
    this.stopAllBatching = options.stopAllBatchingFunc;

    // seed variable batch size + flush interval with configured values
    this.batchSize = this.libConfig['batch_size'];
    this.flushInterval = this.libConfig['batch_flush_interval_ms'];

    this.stopped = !this.libConfig['batch_autostart'];
    this.consecutiveRemovalFailures = 0;
};

/**
 * Add one item to queue.
 */
RequestBatcher.prototype.enqueue = function(item, cb) {
    this.queue.enqueue(item, this.flushInterval, cb);
};

/**
 * Start flushing batches at the configured time interval. Must call
 * this method upon SDK init in order to send anything over the network.
 */
RequestBatcher.prototype.start = function() {
    this.stopped = false;
    this.consecutiveRemovalFailures = 0;
    this.flush();
};

/**
 * Stop flushing batches. Can be restarted by calling start().
 */
RequestBatcher.prototype.stop = function() {
    this.stopped = true;
    if (this.timeoutID) {
        clearTimeout(this.timeoutID);
        this.timeoutID = null;
    }
};

/**
 * Clear out queue.
 */
RequestBatcher.prototype.clear = function() {
    this.queue.clear();
};

/**
 * Restore batch size configuration to whatever is set in the main SDK.
 */
RequestBatcher.prototype.resetBatchSize = function() {
    this.batchSize = this.libConfig['batch_size'];
};

/**
 * Restore flush interval time configuration to whatever is set in the main SDK.
 */
RequestBatcher.prototype.resetFlush = function() {
    this.scheduleFlush(this.libConfig['batch_flush_interval_ms']);
};

/**
 * Schedule the next flush in the given number of milliseconds.
 */
RequestBatcher.prototype.scheduleFlush = function(flushMS) {
    this.flushInterval = flushMS;
    if (!this.stopped) { // don't schedule anymore if batching has been stopped
        this.timeoutID = setTimeout(_.bind(this.flush, this), this.flushInterval);
    }
};

/**
 * Flush one batch to network. Depending on success/failure modes, it will either
 * remove the batch from the queue or leave it in for retry, and schedule the next
 * flush. In cases of most network or API failures, it will back off exponentially
 * when retrying.
 * @param {Object} [options]
 * @param {boolean} [options.sendBeacon] - whether to send batch with
 * navigator.sendBeacon (only useful for sending batches before page unloads, as
 * sendBeacon offers no callbacks or status indications)
 */
RequestBatcher.prototype.flush = function(options) {
    try {

        if (this.requestInProgress) {
            logger.log('Flush: Request already in progress');
            return;
        }

        options = options || {};
        var timeoutMS = this.libConfig['batch_request_timeout_ms'];
        var startTime = new Date().getTime();
        var currentBatchSize = this.batchSize;
        var batch = this.queue.fillBatch(currentBatchSize);
        var dataForRequest = [];
        var transformedItems = {};
        _.each(batch, function(item) {
            var payload = item['payload'];
            if (this.beforeSendHook && !item.orphaned) {
                payload = this.beforeSendHook(payload);
            }
            if (payload) {
                dataForRequest.push(payload);
            }
            transformedItems[item['id']] = payload;
        }, this);
        if (dataForRequest.length < 1) {
            this.resetFlush();
            return; // nothing to do
        }

        this.requestInProgress = true;

        var batchSendCallback = _.bind(function(res) {
            this.requestInProgress = false;

            try {

                // handle API response in a try-catch to make sure we can reset the
                // flush operation if something goes wrong

                var removeItemsFromQueue = false;
                if (options.unloading) {
                    // update persisted data to include hook transformations
                    this.queue.updatePayloads(transformedItems);
                } else if (
                    _.isObject(res) &&
                    res.error === 'timeout' &&
                    new Date().getTime() - startTime >= timeoutMS
                ) {
                    this.reportError('Network timeout; retrying');
                    this.flush();
                } else if (
                    _.isObject(res) &&
                    res.xhr_req &&
                    (res.xhr_req['status'] >= 500 || res.xhr_req['status'] === 429 || res.error === 'timeout')
                ) {
                    // network or API error, or 429 Too Many Requests, retry
                    var retryMS = this.flushInterval * 2;
                    var headers = res.xhr_req['responseHeaders'];
                    if (headers) {
                        var retryAfter = headers['Retry-After'];
                        if (retryAfter) {
                            retryMS = (parseInt(retryAfter, 10) * 1000) || retryMS;
                        }
                    }
                    retryMS = Math.min(MAX_RETRY_INTERVAL_MS, retryMS);
                    this.reportError('Error; retry in ' + retryMS + ' ms');
                    this.scheduleFlush(retryMS);
                } else if (_.isObject(res) && res.xhr_req && res.xhr_req['status'] === 413) {
                    // 413 Payload Too Large
                    if (batch.length > 1) {
                        var halvedBatchSize = Math.max(1, Math.floor(currentBatchSize / 2));
                        this.batchSize = Math.min(this.batchSize, halvedBatchSize, batch.length - 1);
                        this.reportError('413 response; reducing batch size to ' + this.batchSize);
                        this.resetFlush();
                    } else {
                        this.reportError('Single-event request too large; dropping', batch);
                        this.resetBatchSize();
                        removeItemsFromQueue = true;
                    }
                } else {
                    // successful network request+response; remove each item in batch from queue
                    // (even if it was e.g. a 400, in which case retrying won't help)
                    removeItemsFromQueue = true;
                }

                if (removeItemsFromQueue) {
                    this.queue.removeItemsByID(
                        _.map(batch, function(item) { return item['id']; }),
                        _.bind(function(succeeded) {
                            if (succeeded) {
                                this.consecutiveRemovalFailures = 0;
                                this.flush(); // handle next batch if the queue isn't empty
                            } else {
                                this.reportError('Failed to remove items from queue');
                                if (++this.consecutiveRemovalFailures > 5) {
                                    this.reportError('Too many queue failures; disabling batching system.');
                                    this.stopAllBatching();
                                } else {
                                    this.resetFlush();
                                }
                            }
                        }, this)
                    );
                }

            } catch(err) {
                this.reportError('Error handling API response', err);
                this.resetFlush();
            }
        }, this);
        var requestOptions = {
            method: 'POST',
            verbose: true,
            ignore_json_errors: true, // eslint-disable-line camelcase
            timeout_ms: timeoutMS // eslint-disable-line camelcase
        };
        if (options.unloading) {
            requestOptions.transport = 'sendBeacon';
        }
        logger.log('MIXPANEL REQUEST:', dataForRequest);
        this.sendRequest(dataForRequest, requestOptions, batchSendCallback);

    } catch(err) {
        this.reportError('Error flushing request queue', err);
        this.resetFlush();
    }
};

/**
 * Log error to global logger and optional user-defined logger.
 */
RequestBatcher.prototype.reportError = function(msg, err) {
    logger.error.apply(logger.error, arguments);
    if (this.errorReporter) {
        try {
            if (!(err instanceof Error)) {
                err = new Error(msg);
            }
            this.errorReporter(msg, err);
        } catch(err) {
            logger.error(err);
        }
    }
};

/**
 * A function used to track a Mixpanel event (e.g. MixpanelLib.track)
 * @callback trackFunction
 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
 */

/** Public **/

var GDPR_DEFAULT_PERSISTENCE_PREFIX = '__mp_opt_in_out_';

/**
 * Opt the user in to data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */
function optIn(token, options) {
    _optInOut(true, token, options);
}

/**
 * Opt the user out of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-out cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-out cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-out cookie is set as secure or not
 */
function optOut(token, options) {
    _optInOut(false, token, options);
}

/**
 * Check whether the user has opted in to data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} whether the user has opted in to the given opt type
 */
function hasOptedIn(token, options) {
    return _getStorageValue(token, options) === '1';
}

/**
 * Check whether the user has opted out of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {boolean} [options.ignoreDnt] - flag to ignore browser DNT settings and always return false
 * @returns {boolean} whether the user has opted out of the given opt type
 */
function hasOptedOut(token, options) {
    if (_hasDoNotTrackFlagOn(options)) {
        console.warn('This browser has "Do Not Track" enabled. This will prevent the Mixpanel SDK from sending any data. To ignore the "Do Not Track" browser setting, initialize the Mixpanel instance with the config "ignore_dnt: true"');
        return true;
    }
    var optedOut = _getStorageValue(token, options) === '0';
    if (optedOut) {
        console.warn('You are opted out of Mixpanel tracking. This will prevent the Mixpanel SDK from sending any data.');
    }
    return optedOut;
}

/**
 * Wrap a MixpanelLib method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */
function addOptOutCheckMixpanelLib(method) {
    return _addOptOutCheck(method, function(name) {
        return this.get_config(name);
    });
}

/**
 * Wrap a MixpanelPeople method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */
function addOptOutCheckMixpanelPeople(method) {
    return _addOptOutCheck(method, function(name) {
        return this._get_config(name);
    });
}

/**
 * Wrap a MixpanelGroup method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */
function addOptOutCheckMixpanelGroup(method) {
    return _addOptOutCheck(method, function(name) {
        return this._get_config(name);
    });
}

/**
 * Clear the user's opt in/out status of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */
function clearOptInOut(token, options) {
    options = options || {};
    _getStorage(options).remove(
        _getStorageKey(token, options), !!options.crossSubdomainCookie, options.cookieDomain
    );
}

/** Private **/

/**
 * Get storage util
 * @param {Object} [options]
 * @param {string} [options.persistenceType]
 * @returns {object} either _.cookie or _.localstorage
 */
function _getStorage(options) {
    options = options || {};
    return options.persistenceType === 'localStorage' ? _.localStorage : _.cookie;
}

/**
 * Get the name of the cookie that is used for the given opt type (tracking, cookie, etc.)
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {string} the name of the cookie for the given opt type
 */
function _getStorageKey(token, options) {
    options = options || {};
    return (options.persistencePrefix || GDPR_DEFAULT_PERSISTENCE_PREFIX) + token;
}

/**
 * Get the value of the cookie that is used for the given opt type (tracking, cookie, etc.)
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {string} the value of the cookie for the given opt type
 */
function _getStorageValue(token, options) {
    return _getStorage(options).get(_getStorageKey(token, options));
}

/**
 * Check whether the user has set the DNT/doNotTrack setting to true in their browser
 * @param {Object} [options]
 * @param {string} [options.window] - alternate window object to check; used to force various DNT settings in browser tests
 * @param {boolean} [options.ignoreDnt] - flag to ignore browser DNT settings and always return false
 * @returns {boolean} whether the DNT setting is true
 */
function _hasDoNotTrackFlagOn(options) {
    if (options && options.ignoreDnt) {
        return false;
    }
    var win = (options && options.window) || window$1;
    var nav = win['navigator'] || {};
    var hasDntOn = false;

    _.each([
        nav['doNotTrack'], // standard
        nav['msDoNotTrack'],
        win['doNotTrack']
    ], function(dntValue) {
        if (_.includes([true, 1, '1', 'yes'], dntValue)) {
            hasDntOn = true;
        }
    });

    return hasDntOn;
}

/**
 * Set cookie/localstorage for the user indicating that they are opted in or out for the given opt type
 * @param {boolean} optValue - whether to opt the user in or out for the given opt type
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */
function _optInOut(optValue, token, options) {
    if (!_.isString(token) || !token.length) {
        console.error('gdpr.' + (optValue ? 'optIn' : 'optOut') + ' called with an invalid token');
        return;
    }

    options = options || {};

    _getStorage(options).set(
        _getStorageKey(token, options),
        optValue ? 1 : 0,
        _.isNumber(options.cookieExpiration) ? options.cookieExpiration : null,
        !!options.crossSubdomainCookie,
        !!options.secureCookie,
        !!options.crossSiteCookie,
        options.cookieDomain
    );

    if (options.track && optValue) { // only track event if opting in (optValue=true)
        options.track(options.trackEventName || '$opt_in', options.trackProperties, {
            'send_immediately': true
        });
    }
}

/**
 * Wrap a method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @param {function} getConfigValue - getter function for the Mixpanel API token and other options to be used with opt-out check
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */
function _addOptOutCheck(method, getConfigValue) {
    return function() {
        var optedOut = false;

        try {
            var token = getConfigValue.call(this, 'token');
            var ignoreDnt = getConfigValue.call(this, 'ignore_dnt');
            var persistenceType = getConfigValue.call(this, 'opt_out_tracking_persistence_type');
            var persistencePrefix = getConfigValue.call(this, 'opt_out_tracking_cookie_prefix');
            var win = getConfigValue.call(this, 'window'); // used to override window during browser tests

            if (token) { // if there was an issue getting the token, continue method execution as normal
                optedOut = hasOptedOut(token, {
                    ignoreDnt: ignoreDnt,
                    persistenceType: persistenceType,
                    persistencePrefix: persistencePrefix,
                    window: win
                });
            }
        } catch(err) {
            console.error('Unexpected error when checking tracking opt-out status: ' + err);
        }

        if (!optedOut) {
            return method.apply(this, arguments);
        }

        var callback = arguments[arguments.length - 1];
        if (typeof(callback) === 'function') {
            callback(0);
        }

        return;
    };
}

/** @const */ var SET_ACTION      = '$set';
/** @const */ var SET_ONCE_ACTION = '$set_once';
/** @const */ var UNSET_ACTION    = '$unset';
/** @const */ var ADD_ACTION      = '$add';
/** @const */ var APPEND_ACTION   = '$append';
/** @const */ var UNION_ACTION    = '$union';
/** @const */ var REMOVE_ACTION   = '$remove';
/** @const */ var DELETE_ACTION   = '$delete';

// Common internal methods for mixpanel.people and mixpanel.group APIs.
// These methods shouldn't involve network I/O.
var apiActions = {
    set_action: function(prop, to) {
        var data = {};
        var $set = {};
        if (_.isObject(prop)) {
            _.each(prop, function(v, k) {
                if (!this._is_reserved_property(k)) {
                    $set[k] = v;
                }
            }, this);
        } else {
            $set[prop] = to;
        }

        data[SET_ACTION] = $set;
        return data;
    },

    unset_action: function(prop) {
        var data = {};
        var $unset = [];
        if (!_.isArray(prop)) {
            prop = [prop];
        }

        _.each(prop, function(k) {
            if (!this._is_reserved_property(k)) {
                $unset.push(k);
            }
        }, this);

        data[UNSET_ACTION] = $unset;
        return data;
    },

    set_once_action: function(prop, to) {
        var data = {};
        var $set_once = {};
        if (_.isObject(prop)) {
            _.each(prop, function(v, k) {
                if (!this._is_reserved_property(k)) {
                    $set_once[k] = v;
                }
            }, this);
        } else {
            $set_once[prop] = to;
        }
        data[SET_ONCE_ACTION] = $set_once;
        return data;
    },

    union_action: function(list_name, values) {
        var data = {};
        var $union = {};
        if (_.isObject(list_name)) {
            _.each(list_name, function(v, k) {
                if (!this._is_reserved_property(k)) {
                    $union[k] = _.isArray(v) ? v : [v];
                }
            }, this);
        } else {
            $union[list_name] = _.isArray(values) ? values : [values];
        }
        data[UNION_ACTION] = $union;
        return data;
    },

    append_action: function(list_name, value) {
        var data = {};
        var $append = {};
        if (_.isObject(list_name)) {
            _.each(list_name, function(v, k) {
                if (!this._is_reserved_property(k)) {
                    $append[k] = v;
                }
            }, this);
        } else {
            $append[list_name] = value;
        }
        data[APPEND_ACTION] = $append;
        return data;
    },

    remove_action: function(list_name, value) {
        var data = {};
        var $remove = {};
        if (_.isObject(list_name)) {
            _.each(list_name, function(v, k) {
                if (!this._is_reserved_property(k)) {
                    $remove[k] = v;
                }
            }, this);
        } else {
            $remove[list_name] = value;
        }
        data[REMOVE_ACTION] = $remove;
        return data;
    },

    delete_action: function() {
        var data = {};
        data[DELETE_ACTION] = '';
        return data;
    }
};

/**
 * Mixpanel Group Object
 * @constructor
 */
var MixpanelGroup = function() {};

_.extend(MixpanelGroup.prototype, apiActions);

MixpanelGroup.prototype._init = function(mixpanel_instance, group_key, group_id) {
    this._mixpanel = mixpanel_instance;
    this._group_key = group_key;
    this._group_id = group_id;
};

/**
 * Set properties on a group.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').set('Location', '405 Howard');
 *
 *     // or set multiple properties at once
 *     mixpanel.get_group('company', 'mixpanel').set({
 *          'Location': '405 Howard',
 *          'Founded' : 2009,
 *     });
 *     // properties can be strings, integers, dates, or lists
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */
MixpanelGroup.prototype.set = addOptOutCheckMixpanelGroup(function(prop, to, callback) {
    var data = this.set_action(prop, to);
    if (_.isObject(prop)) {
        callback = to;
    }
    return this._send_request(data, callback);
});

/**
 * Set properties on a group, only if they do not yet exist.
 * This will not overwrite previous group property values, unlike
 * group.set().
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').set_once('Location', '405 Howard');
 *
 *     // or set multiple properties at once
 *     mixpanel.get_group('company', 'mixpanel').set_once({
 *          'Location': '405 Howard',
 *          'Founded' : 2009,
 *     });
 *     // properties can be strings, integers, lists or dates
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */
MixpanelGroup.prototype.set_once = addOptOutCheckMixpanelGroup(function(prop, to, callback) {
    var data = this.set_once_action(prop, to);
    if (_.isObject(prop)) {
        callback = to;
    }
    return this._send_request(data, callback);
});

/**
 * Unset properties on a group permanently.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').unset('Founded');
 *
 * @param {String} prop The name of the property.
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */
MixpanelGroup.prototype.unset = addOptOutCheckMixpanelGroup(function(prop, callback) {
    var data = this.unset_action(prop);
    return this._send_request(data, callback);
});

/**
 * Merge a given list with a list-valued group property, excluding duplicate values.
 *
 * ### Usage:
 *
 *     // merge a value to a list, creating it if needed
 *     mixpanel.get_group('company', 'mixpanel').union('Location', ['San Francisco', 'London']);
 *
 * @param {String} list_name Name of the property.
 * @param {Array} values Values to merge with the given property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */
MixpanelGroup.prototype.union = addOptOutCheckMixpanelGroup(function(list_name, values, callback) {
    if (_.isObject(list_name)) {
        callback = values;
    }
    var data = this.union_action(list_name, values);
    return this._send_request(data, callback);
});

/**
 * Permanently delete a group.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').delete();
 *
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */
MixpanelGroup.prototype['delete'] = addOptOutCheckMixpanelGroup(function(callback) {
    // bracket notation above prevents a minification error related to reserved words
    var data = this.delete_action();
    return this._send_request(data, callback);
});

/**
 * Remove a property from a group. The value will be ignored if doesn't exist.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').remove('Location', 'London');
 *
 * @param {String} list_name Name of the property.
 * @param {Object} value Value to remove from the given group property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */
MixpanelGroup.prototype.remove = addOptOutCheckMixpanelGroup(function(list_name, value, callback) {
    var data = this.remove_action(list_name, value);
    return this._send_request(data, callback);
});

MixpanelGroup.prototype._send_request = function(data, callback) {
    data['$group_key'] = this._group_key;
    data['$group_id'] = this._group_id;
    data['$token'] = this._get_config('token');

    var date_encoded_data = _.encodeDates(data);
    return this._mixpanel._track_or_batch({
        type: 'groups',
        data: date_encoded_data,
        endpoint: this._get_config('api_host') + '/groups/',
        batcher: this._mixpanel.request_batchers.groups
    }, callback);
};

MixpanelGroup.prototype._is_reserved_property = function(prop) {
    return prop === '$group_key' || prop === '$group_id';
};

MixpanelGroup.prototype._get_config = function(conf) {
    return this._mixpanel.get_config(conf);
};

MixpanelGroup.prototype.toString = function() {
    return this._mixpanel.toString() + '.group.' + this._group_key + '.' + this._group_id;
};

// MixpanelGroup Exports
MixpanelGroup.prototype['remove']   = MixpanelGroup.prototype.remove;
MixpanelGroup.prototype['set']      = MixpanelGroup.prototype.set;
MixpanelGroup.prototype['set_once'] = MixpanelGroup.prototype.set_once;
MixpanelGroup.prototype['union']    = MixpanelGroup.prototype.union;
MixpanelGroup.prototype['unset']    = MixpanelGroup.prototype.unset;
MixpanelGroup.prototype['toString'] = MixpanelGroup.prototype.toString;

/**
 * Mixpanel People Object
 * @constructor
 */
var MixpanelPeople = function() {};

_.extend(MixpanelPeople.prototype, apiActions);

MixpanelPeople.prototype._init = function(mixpanel_instance) {
    this._mixpanel = mixpanel_instance;
};

/*
* Set properties on a user record.
*
* ### Usage:
*
*     mixpanel.people.set('gender', 'm');
*
*     // or set multiple properties at once
*     mixpanel.people.set({
*         'Company': 'Acme',
*         'Plan': 'Premium',
*         'Upgrade date': new Date()
*     });
*     // properties can be strings, integers, dates, or lists
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [to] A value to set on the given property name
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/
MixpanelPeople.prototype.set = addOptOutCheckMixpanelPeople(function(prop, to, callback) {
    var data = this.set_action(prop, to);
    if (_.isObject(prop)) {
        callback = to;
    }
    // make sure that the referrer info has been updated and saved
    if (this._get_config('save_referrer')) {
        this._mixpanel['persistence'].update_referrer_info(document.referrer);
    }

    // update $set object with default people properties
    data[SET_ACTION] = _.extend(
        {},
        _.info.people_properties(),
        this._mixpanel['persistence'].get_referrer_info(),
        data[SET_ACTION]
    );
    return this._send_request(data, callback);
});

/*
* Set properties on a user record, only if they do not yet exist.
* This will not overwrite previous people property values, unlike
* people.set().
*
* ### Usage:
*
*     mixpanel.people.set_once('First Login Date', new Date());
*
*     // or set multiple properties at once
*     mixpanel.people.set_once({
*         'First Login Date': new Date(),
*         'Starting Plan': 'Premium'
*     });
*
*     // properties can be strings, integers or dates
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [to] A value to set on the given property name
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/
MixpanelPeople.prototype.set_once = addOptOutCheckMixpanelPeople(function(prop, to, callback) {
    var data = this.set_once_action(prop, to);
    if (_.isObject(prop)) {
        callback = to;
    }
    return this._send_request(data, callback);
});

/*
* Unset properties on a user record (permanently removes the properties and their values from a profile).
*
* ### Usage:
*
*     mixpanel.people.unset('gender');
*
*     // or unset multiple properties at once
*     mixpanel.people.unset(['gender', 'Company']);
*
* @param {Array|String} prop If a string, this is the name of the property. If an array, this is a list of property names.
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/
MixpanelPeople.prototype.unset = addOptOutCheckMixpanelPeople(function(prop, callback) {
    var data = this.unset_action(prop);
    return this._send_request(data, callback);
});

/*
* Increment/decrement numeric people analytics properties.
*
* ### Usage:
*
*     mixpanel.people.increment('page_views', 1);
*
*     // or, for convenience, if you're just incrementing a counter by
*     // 1, you can simply do
*     mixpanel.people.increment('page_views');
*
*     // to decrement a counter, pass a negative number
*     mixpanel.people.increment('credits_left', -1);
*
*     // like mixpanel.people.set(), you can increment multiple
*     // properties at once:
*     mixpanel.people.increment({
*         counter1: 1,
*         counter2: 6
*     });
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and numeric values.
* @param {Number} [by] An amount to increment the given property
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/
MixpanelPeople.prototype.increment = addOptOutCheckMixpanelPeople(function(prop, by, callback) {
    var data = {};
    var $add = {};
    if (_.isObject(prop)) {
        _.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) {
                if (isNaN(parseFloat(v))) {
                    console.error('Invalid increment value passed to mixpanel.people.increment - must be a number');
                    return;
                } else {
                    $add[k] = v;
                }
            }
        }, this);
        callback = by;
    } else {
        // convenience: mixpanel.people.increment('property'); will
        // increment 'property' by 1
        if (_.isUndefined(by)) {
            by = 1;
        }
        $add[prop] = by;
    }
    data[ADD_ACTION] = $add;

    return this._send_request(data, callback);
});

/*
* Append a value to a list-valued people analytics property.
*
* ### Usage:
*
*     // append a value to a list, creating it if needed
*     mixpanel.people.append('pages_visited', 'homepage');
*
*     // like mixpanel.people.set(), you can append multiple
*     // properties at once:
*     mixpanel.people.append({
*         list1: 'bob',
*         list2: 123
*     });
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] value An item to append to the list
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/
MixpanelPeople.prototype.append = addOptOutCheckMixpanelPeople(function(list_name, value, callback) {
    if (_.isObject(list_name)) {
        callback = value;
    }
    var data = this.append_action(list_name, value);
    return this._send_request(data, callback);
});

/*
* Remove a value from a list-valued people analytics property.
*
* ### Usage:
*
*     mixpanel.people.remove('School', 'UCB');
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] value Item to remove from the list
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/
MixpanelPeople.prototype.remove = addOptOutCheckMixpanelPeople(function(list_name, value, callback) {
    if (_.isObject(list_name)) {
        callback = value;
    }
    var data = this.remove_action(list_name, value);
    return this._send_request(data, callback);
});

/*
* Merge a given list with a list-valued people analytics property,
* excluding duplicate values.
*
* ### Usage:
*
*     // merge a value to a list, creating it if needed
*     mixpanel.people.union('pages_visited', 'homepage');
*
*     // like mixpanel.people.set(), you can append multiple
*     // properties at once:
*     mixpanel.people.union({
*         list1: 'bob',
*         list2: 123
*     });
*
*     // like mixpanel.people.append(), you can append multiple
*     // values to the same list:
*     mixpanel.people.union({
*         list1: ['bob', 'billy']
*     });
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] Value / values to merge with the given property
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/
MixpanelPeople.prototype.union = addOptOutCheckMixpanelPeople(function(list_name, values, callback) {
    if (_.isObject(list_name)) {
        callback = values;
    }
    var data = this.union_action(list_name, values);
    return this._send_request(data, callback);
});

/*
* Record that you have charged the current user a certain amount
* of money. Charges recorded with track_charge() will appear in the
* Mixpanel revenue report.
*
* ### Usage:
*
*     // charge a user $50
*     mixpanel.people.track_charge(50);
*
*     // charge a user $30.50 on the 2nd of january
*     mixpanel.people.track_charge(30.50, {
*         '$time': new Date('jan 1 2012')
*     });
*
* @param {Number} amount The amount of money charged to the current user
* @param {Object} [properties] An associative array of properties associated with the charge
* @param {Function} [callback] If provided, the callback will be called when the server responds
*/
MixpanelPeople.prototype.track_charge = addOptOutCheckMixpanelPeople(function(amount, properties, callback) {
    if (!_.isNumber(amount)) {
        amount = parseFloat(amount);
        if (isNaN(amount)) {
            console.error('Invalid value passed to mixpanel.people.track_charge - must be a number');
            return;
        }
    }

    return this.append('$transactions', _.extend({
        '$amount': amount
    }, properties), callback);
});

/*
* Permanently clear all revenue report transactions from the
* current user's people analytics profile.
*
* ### Usage:
*
*     mixpanel.people.clear_charges();
*
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/
MixpanelPeople.prototype.clear_charges = function(callback) {
    return this.set('$transactions', [], callback);
};

/*
* Permanently deletes the current people analytics profile from
* Mixpanel (using the current distinct_id).
*
* ### Usage:
*
*     // remove the all data you have stored about the current user
*     mixpanel.people.delete_user();
*
*/
MixpanelPeople.prototype.delete_user = function() {
    if (!this._identify_called()) {
        console.error('mixpanel.people.delete_user() requires you to call identify() first');
        return;
    }
    var data = {'$delete': this._mixpanel.get_distinct_id()};
    return this._send_request(data);
};

MixpanelPeople.prototype.toString = function() {
    return this._mixpanel.toString() + '.people';
};

MixpanelPeople.prototype._send_request = function(data, callback) {
    data['$token'] = this._get_config('token');
    data['$distinct_id'] = this._mixpanel.get_distinct_id();
    var device_id = this._mixpanel.get_property('$device_id');
    var user_id = this._mixpanel.get_property('$user_id');
    var had_persisted_distinct_id = this._mixpanel.get_property('$had_persisted_distinct_id');
    if (device_id) {
        data['$device_id'] = device_id;
    }
    if (user_id) {
        data['$user_id'] = user_id;
    }
    if (had_persisted_distinct_id) {
        data['$had_persisted_distinct_id'] = had_persisted_distinct_id;
    }

    var date_encoded_data = _.encodeDates(data);

    if (!this._identify_called()) {
        this._enqueue(data);
        if (!_.isUndefined(callback)) {
            if (this._get_config('verbose')) {
                callback({status: -1, error: null});
            } else {
                callback(-1);
            }
        }
        return _.truncate(date_encoded_data, 255);
    }

    return this._mixpanel._track_or_batch({
        type: 'people',
        data: date_encoded_data,
        endpoint: this._get_config('api_host') + '/engage/',
        batcher: this._mixpanel.request_batchers.people
    }, callback);
};

MixpanelPeople.prototype._get_config = function(conf_var) {
    return this._mixpanel.get_config(conf_var);
};

MixpanelPeople.prototype._identify_called = function() {
    return this._mixpanel._flags.identify_called === true;
};

// Queue up engage operations if identify hasn't been called yet.
MixpanelPeople.prototype._enqueue = function(data) {
    if (SET_ACTION in data) {
        this._mixpanel['persistence']._add_to_people_queue(SET_ACTION, data);
    } else if (SET_ONCE_ACTION in data) {
        this._mixpanel['persistence']._add_to_people_queue(SET_ONCE_ACTION, data);
    } else if (UNSET_ACTION in data) {
        this._mixpanel['persistence']._add_to_people_queue(UNSET_ACTION, data);
    } else if (ADD_ACTION in data) {
        this._mixpanel['persistence']._add_to_people_queue(ADD_ACTION, data);
    } else if (APPEND_ACTION in data) {
        this._mixpanel['persistence']._add_to_people_queue(APPEND_ACTION, data);
    } else if (REMOVE_ACTION in data) {
        this._mixpanel['persistence']._add_to_people_queue(REMOVE_ACTION, data);
    } else if (UNION_ACTION in data) {
        this._mixpanel['persistence']._add_to_people_queue(UNION_ACTION, data);
    } else {
        console.error('Invalid call to _enqueue():', data);
    }
};

MixpanelPeople.prototype._flush_one_queue = function(action, action_method, callback, queue_to_params_fn) {
    var _this = this;
    var queued_data = _.extend({}, this._mixpanel['persistence']._get_queue(action));
    var action_params = queued_data;

    if (!_.isUndefined(queued_data) && _.isObject(queued_data) && !_.isEmptyObject(queued_data)) {
        _this._mixpanel['persistence']._pop_from_people_queue(action, queued_data);
        if (queue_to_params_fn) {
            action_params = queue_to_params_fn(queued_data);
        }
        action_method.call(_this, action_params, function(response, data) {
            // on bad response, we want to add it back to the queue
            if (response === 0) {
                _this._mixpanel['persistence']._add_to_people_queue(action, queued_data);
            }
            if (!_.isUndefined(callback)) {
                callback(response, data);
            }
        });
    }
};

// Flush queued engage operations - order does not matter,
// and there are network level race conditions anyway
MixpanelPeople.prototype._flush = function(
    _set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback
) {
    var _this = this;
    var $append_queue = this._mixpanel['persistence']._get_queue(APPEND_ACTION);
    var $remove_queue = this._mixpanel['persistence']._get_queue(REMOVE_ACTION);

    this._flush_one_queue(SET_ACTION, this.set, _set_callback);
    this._flush_one_queue(SET_ONCE_ACTION, this.set_once, _set_once_callback);
    this._flush_one_queue(UNSET_ACTION, this.unset, _unset_callback, function(queue) { return _.keys(queue); });
    this._flush_one_queue(ADD_ACTION, this.increment, _add_callback);
    this._flush_one_queue(UNION_ACTION, this.union, _union_callback);

    // we have to fire off each $append individually since there is
    // no concat method server side
    if (!_.isUndefined($append_queue) && _.isArray($append_queue) && $append_queue.length) {
        var $append_item;
        var append_callback = function(response, data) {
            if (response === 0) {
                _this._mixpanel['persistence']._add_to_people_queue(APPEND_ACTION, $append_item);
            }
            if (!_.isUndefined(_append_callback)) {
                _append_callback(response, data);
            }
        };
        for (var i = $append_queue.length - 1; i >= 0; i--) {
            $append_item = $append_queue.pop();
            if (!_.isEmptyObject($append_item)) {
                _this.append($append_item, append_callback);
            }
        }
        // Save the shortened append queue
        _this._mixpanel['persistence'].save();
    }

    // same for $remove
    if (!_.isUndefined($remove_queue) && _.isArray($remove_queue) && $remove_queue.length) {
        var $remove_item;
        var remove_callback = function(response, data) {
            if (response === 0) {
                _this._mixpanel['persistence']._add_to_people_queue(REMOVE_ACTION, $remove_item);
            }
            if (!_.isUndefined(_remove_callback)) {
                _remove_callback(response, data);
            }
        };
        for (var j = $remove_queue.length - 1; j >= 0; j--) {
            $remove_item = $remove_queue.pop();
            if (!_.isEmptyObject($remove_item)) {
                _this.remove($remove_item, remove_callback);
            }
        }
        _this._mixpanel['persistence'].save();
    }
};

MixpanelPeople.prototype._is_reserved_property = function(prop) {
    return prop === '$distinct_id' || prop === '$token' || prop === '$device_id' || prop === '$user_id' || prop === '$had_persisted_distinct_id';
};

// MixpanelPeople Exports
MixpanelPeople.prototype['set']           = MixpanelPeople.prototype.set;
MixpanelPeople.prototype['set_once']      = MixpanelPeople.prototype.set_once;
MixpanelPeople.prototype['unset']         = MixpanelPeople.prototype.unset;
MixpanelPeople.prototype['increment']     = MixpanelPeople.prototype.increment;
MixpanelPeople.prototype['append']        = MixpanelPeople.prototype.append;
MixpanelPeople.prototype['remove']        = MixpanelPeople.prototype.remove;
MixpanelPeople.prototype['union']         = MixpanelPeople.prototype.union;
MixpanelPeople.prototype['track_charge']  = MixpanelPeople.prototype.track_charge;
MixpanelPeople.prototype['clear_charges'] = MixpanelPeople.prototype.clear_charges;
MixpanelPeople.prototype['delete_user']   = MixpanelPeople.prototype.delete_user;
MixpanelPeople.prototype['toString']      = MixpanelPeople.prototype.toString;

/*
 * Constants
 */
/** @const */ var SET_QUEUE_KEY          = '__mps';
/** @const */ var SET_ONCE_QUEUE_KEY     = '__mpso';
/** @const */ var UNSET_QUEUE_KEY        = '__mpus';
/** @const */ var ADD_QUEUE_KEY          = '__mpa';
/** @const */ var APPEND_QUEUE_KEY       = '__mpap';
/** @const */ var REMOVE_QUEUE_KEY       = '__mpr';
/** @const */ var UNION_QUEUE_KEY        = '__mpu';
// This key is deprecated, but we want to check for it to see whether aliasing is allowed.
/** @const */ var PEOPLE_DISTINCT_ID_KEY = '$people_distinct_id';
/** @const */ var ALIAS_ID_KEY           = '__alias';
/** @const */ var EVENT_TIMERS_KEY       = '__timers';
/** @const */ var RESERVED_PROPERTIES = [
    SET_QUEUE_KEY,
    SET_ONCE_QUEUE_KEY,
    UNSET_QUEUE_KEY,
    ADD_QUEUE_KEY,
    APPEND_QUEUE_KEY,
    REMOVE_QUEUE_KEY,
    UNION_QUEUE_KEY,
    PEOPLE_DISTINCT_ID_KEY,
    ALIAS_ID_KEY,
    EVENT_TIMERS_KEY
];

/**
 * Mixpanel Persistence Object
 * @constructor
 */
var MixpanelPersistence = function(config) {
    this['props'] = {};
    this.campaign_params_saved = false;

    if (config['persistence_name']) {
        this.name = 'mp_' + config['persistence_name'];
    } else {
        this.name = 'mp_' + config['token'] + '_mixpanel';
    }

    var storage_type = config['persistence'];
    if (storage_type !== 'cookie' && storage_type !== 'localStorage') {
        console.critical('Unknown persistence type ' + storage_type + '; falling back to cookie');
        storage_type = config['persistence'] = 'cookie';
    }

    if (storage_type === 'localStorage' && _.localStorage.is_supported()) {
        this.storage = _.localStorage;
    } else {
        this.storage = _.cookie;
    }

    this.load();
    this.update_config(config);
    this.upgrade(config);
    this.save();
};

MixpanelPersistence.prototype.properties = function() {
    var p = {};
    // Filter out reserved properties
    _.each(this['props'], function(v, k) {
        if (!_.include(RESERVED_PROPERTIES, k)) {
            p[k] = v;
        }
    });
    return p;
};

MixpanelPersistence.prototype.load = function() {
    if (this.disabled) { return; }

    var entry = this.storage.parse(this.name);

    if (entry) {
        this['props'] = _.extend({}, entry);
    }
};

MixpanelPersistence.prototype.upgrade = function(config) {
    var upgrade_from_old_lib = config['upgrade'],
        old_cookie_name,
        old_cookie;

    if (upgrade_from_old_lib) {
        old_cookie_name = 'mp_super_properties';
        // Case where they had a custom cookie name before.
        if (typeof(upgrade_from_old_lib) === 'string') {
            old_cookie_name = upgrade_from_old_lib;
        }

        old_cookie = this.storage.parse(old_cookie_name);

        // remove the cookie
        this.storage.remove(old_cookie_name);
        this.storage.remove(old_cookie_name, true);

        if (old_cookie) {
            this['props'] = _.extend(
                this['props'],
                old_cookie['all'],
                old_cookie['events']
            );
        }
    }

    if (!config['cookie_name'] && config['name'] !== 'mixpanel') {
        // special case to handle people with cookies of the form
        // mp_TOKEN_INSTANCENAME from the first release of this library
        old_cookie_name = 'mp_' + config['token'] + '_' + config['name'];
        old_cookie = this.storage.parse(old_cookie_name);

        if (old_cookie) {
            this.storage.remove(old_cookie_name);
            this.storage.remove(old_cookie_name, true);

            // Save the prop values that were in the cookie from before -
            // this should only happen once as we delete the old one.
            this.register_once(old_cookie);
        }
    }

    if (this.storage === _.localStorage) {
        old_cookie = _.cookie.parse(this.name);

        _.cookie.remove(this.name);
        _.cookie.remove(this.name, true);

        if (old_cookie) {
            this.register_once(old_cookie);
        }
    }
};

MixpanelPersistence.prototype.save = function() {
    if (this.disabled) { return; }
    this.storage.set(
        this.name,
        _.JSONEncode(this['props']),
        this.expire_days,
        this.cross_subdomain,
        this.secure,
        this.cross_site,
        this.cookie_domain
    );
};

MixpanelPersistence.prototype.remove = function() {
    // remove both domain and subdomain cookies
    this.storage.remove(this.name, false, this.cookie_domain);
    this.storage.remove(this.name, true, this.cookie_domain);
};

// removes the storage entry and deletes all loaded data
// forced name for tests
MixpanelPersistence.prototype.clear = function() {
    this.remove();
    this['props'] = {};
};

/**
* @param {Object} props
* @param {*=} default_value
* @param {number=} days
*/
MixpanelPersistence.prototype.register_once = function(props, default_value, days) {
    if (_.isObject(props)) {
        if (typeof(default_value) === 'undefined') { default_value = 'None'; }
        this.expire_days = (typeof(days) === 'undefined') ? this.default_expiry : days;

        _.each(props, function(val, prop) {
            if (!this['props'].hasOwnProperty(prop) || this['props'][prop] === default_value) {
                this['props'][prop] = val;
            }
        }, this);

        this.save();

        return true;
    }
    return false;
};

/**
* @param {Object} props
* @param {number=} days
*/
MixpanelPersistence.prototype.register = function(props, days) {
    if (_.isObject(props)) {
        this.expire_days = (typeof(days) === 'undefined') ? this.default_expiry : days;

        _.extend(this['props'], props);

        this.save();

        return true;
    }
    return false;
};

MixpanelPersistence.prototype.unregister = function(prop) {
    if (prop in this['props']) {
        delete this['props'][prop];
        this.save();
    }
};

MixpanelPersistence.prototype.update_campaign_params = function() {
    if (!this.campaign_params_saved) {
        this.register_once(_.info.campaignParams());
        this.campaign_params_saved = true;
    }
};

MixpanelPersistence.prototype.update_search_keyword = function(referrer) {
    this.register(_.info.searchInfo(referrer));
};

// EXPORTED METHOD, we test this directly.
MixpanelPersistence.prototype.update_referrer_info = function(referrer) {
    // If referrer doesn't exist, we want to note the fact that it was type-in traffic.
    this.register_once({
        '$initial_referrer': referrer || '$direct',
        '$initial_referring_domain': _.info.referringDomain(referrer) || '$direct'
    }, '');
};

MixpanelPersistence.prototype.get_referrer_info = function() {
    return _.strip_empty_properties({
        '$initial_referrer': this['props']['$initial_referrer'],
        '$initial_referring_domain': this['props']['$initial_referring_domain']
    });
};

// safely fills the passed in object with stored properties,
// does not override any properties defined in both
// returns the passed in object
MixpanelPersistence.prototype.safe_merge = function(props) {
    _.each(this['props'], function(val, prop) {
        if (!(prop in props)) {
            props[prop] = val;
        }
    });

    return props;
};

MixpanelPersistence.prototype.update_config = function(config) {
    this.default_expiry = this.expire_days = config['cookie_expiration'];
    this.set_disabled(config['disable_persistence']);
    this.set_cookie_domain(config['cookie_domain']);
    this.set_cross_site(config['cross_site_cookie']);
    this.set_cross_subdomain(config['cross_subdomain_cookie']);
    this.set_secure(config['secure_cookie']);
};

MixpanelPersistence.prototype.set_disabled = function(disabled) {
    this.disabled = disabled;
    if (this.disabled) {
        this.remove();
    } else {
        this.save();
    }
};

MixpanelPersistence.prototype.set_cookie_domain = function(cookie_domain) {
    if (cookie_domain !== this.cookie_domain) {
        this.remove();
        this.cookie_domain = cookie_domain;
        this.save();
    }
};

MixpanelPersistence.prototype.set_cross_site = function(cross_site) {
    if (cross_site !== this.cross_site) {
        this.cross_site = cross_site;
        this.remove();
        this.save();
    }
};

MixpanelPersistence.prototype.set_cross_subdomain = function(cross_subdomain) {
    if (cross_subdomain !== this.cross_subdomain) {
        this.cross_subdomain = cross_subdomain;
        this.remove();
        this.save();
    }
};

MixpanelPersistence.prototype.get_cross_subdomain = function() {
    return this.cross_subdomain;
};

MixpanelPersistence.prototype.set_secure = function(secure) {
    if (secure !== this.secure) {
        this.secure = secure ? true : false;
        this.remove();
        this.save();
    }
};

MixpanelPersistence.prototype._add_to_people_queue = function(queue, data) {
    var q_key = this._get_queue_key(queue),
        q_data = data[queue],
        set_q = this._get_or_create_queue(SET_ACTION),
        set_once_q = this._get_or_create_queue(SET_ONCE_ACTION),
        unset_q = this._get_or_create_queue(UNSET_ACTION),
        add_q = this._get_or_create_queue(ADD_ACTION),
        union_q = this._get_or_create_queue(UNION_ACTION),
        remove_q = this._get_or_create_queue(REMOVE_ACTION, []),
        append_q = this._get_or_create_queue(APPEND_ACTION, []);

    if (q_key === SET_QUEUE_KEY) {
        // Update the set queue - we can override any existing values
        _.extend(set_q, q_data);
        // if there was a pending increment, override it
        // with the set.
        this._pop_from_people_queue(ADD_ACTION, q_data);
        // if there was a pending union, override it
        // with the set.
        this._pop_from_people_queue(UNION_ACTION, q_data);
        this._pop_from_people_queue(UNSET_ACTION, q_data);
    } else if (q_key === SET_ONCE_QUEUE_KEY) {
        // only queue the data if there is not already a set_once call for it.
        _.each(q_data, function(v, k) {
            if (!(k in set_once_q)) {
                set_once_q[k] = v;
            }
        });
        this._pop_from_people_queue(UNSET_ACTION, q_data);
    } else if (q_key === UNSET_QUEUE_KEY) {
        _.each(q_data, function(prop) {

            // undo previously-queued actions on this key
            _.each([set_q, set_once_q, add_q, union_q], function(enqueued_obj) {
                if (prop in enqueued_obj) {
                    delete enqueued_obj[prop];
                }
            });
            _.each(append_q, function(append_obj) {
                if (prop in append_obj) {
                    delete append_obj[prop];
                }
            });

            unset_q[prop] = true;

        });
    } else if (q_key === ADD_QUEUE_KEY) {
        _.each(q_data, function(v, k) {
            // If it exists in the set queue, increment
            // the value
            if (k in set_q) {
                set_q[k] += v;
            } else {
                // If it doesn't exist, update the add
                // queue
                if (!(k in add_q)) {
                    add_q[k] = 0;
                }
                add_q[k] += v;
            }
        }, this);
        this._pop_from_people_queue(UNSET_ACTION, q_data);
    } else if (q_key === UNION_QUEUE_KEY) {
        _.each(q_data, function(v, k) {
            if (_.isArray(v)) {
                if (!(k in union_q)) {
                    union_q[k] = [];
                }
                // We may send duplicates, the server will dedup them.
                union_q[k] = union_q[k].concat(v);
            }
        });
        this._pop_from_people_queue(UNSET_ACTION, q_data);
    } else if (q_key === REMOVE_QUEUE_KEY) {
        remove_q.push(q_data);
        this._pop_from_people_queue(APPEND_ACTION, q_data);
    } else if (q_key === APPEND_QUEUE_KEY) {
        append_q.push(q_data);
        this._pop_from_people_queue(UNSET_ACTION, q_data);
    }

    console.log('MIXPANEL PEOPLE REQUEST (QUEUED, PENDING IDENTIFY):');
    console.log(data);

    this.save();
};

MixpanelPersistence.prototype._pop_from_people_queue = function(queue, data) {
    var q = this._get_queue(queue);
    if (!_.isUndefined(q)) {
        _.each(data, function(v, k) {
            if (queue === APPEND_ACTION || queue === REMOVE_ACTION) {
                // list actions: only remove if both k+v match
                // e.g. remove should not override append in a case like
                // append({foo: 'bar'}); remove({foo: 'qux'})
                _.each(q, function(queued_action) {
                    if (queued_action[k] === v) {
                        delete queued_action[k];
                    }
                });
            } else {
                delete q[k];
            }
        }, this);

        this.save();
    }
};

MixpanelPersistence.prototype._get_queue_key = function(queue) {
    if (queue === SET_ACTION) {
        return SET_QUEUE_KEY;
    } else if (queue === SET_ONCE_ACTION) {
        return SET_ONCE_QUEUE_KEY;
    } else if (queue === UNSET_ACTION) {
        return UNSET_QUEUE_KEY;
    } else if (queue === ADD_ACTION) {
        return ADD_QUEUE_KEY;
    } else if (queue === APPEND_ACTION) {
        return APPEND_QUEUE_KEY;
    } else if (queue === REMOVE_ACTION) {
        return REMOVE_QUEUE_KEY;
    } else if (queue === UNION_ACTION) {
        return UNION_QUEUE_KEY;
    } else {
        console.error('Invalid queue:', queue);
    }
};

MixpanelPersistence.prototype._get_queue = function(queue) {
    return this['props'][this._get_queue_key(queue)];
};
MixpanelPersistence.prototype._get_or_create_queue = function(queue, default_val) {
    var key = this._get_queue_key(queue);
    default_val = _.isUndefined(default_val) ? {} : default_val;

    return this['props'][key] || (this['props'][key] = default_val);
};

MixpanelPersistence.prototype.set_event_timer = function(event_name, timestamp) {
    var timers = this['props'][EVENT_TIMERS_KEY] || {};
    timers[event_name] = timestamp;
    this['props'][EVENT_TIMERS_KEY] = timers;
    this.save();
};

MixpanelPersistence.prototype.remove_event_timer = function(event_name) {
    var timers = this['props'][EVENT_TIMERS_KEY] || {};
    var timestamp = timers[event_name];
    if (!_.isUndefined(timestamp)) {
        delete this['props'][EVENT_TIMERS_KEY][event_name];
        this.save();
    }
    return timestamp;
};

/*
 * Mixpanel JS Library
 *
 * Copyright 2012, Mixpanel, Inc. All Rights Reserved
 * http://mixpanel.com/
 *
 * Includes portions of Underscore.js
 * http://documentcloud.github.com/underscore/
 * (c) 2011 Jeremy Ashkenas, DocumentCloud Inc.
 * Released under the MIT License.
 */

// ==ClosureCompiler==
// @compilation_level ADVANCED_OPTIMIZATIONS
// @output_file_name mixpanel-2.8.min.js
// ==/ClosureCompiler==

/*
SIMPLE STYLE GUIDE:

this.x === public function
this._x === internal - only use within this file
this.__x === private - only use within the class

Globals should be all caps
*/

var init_type;       // MODULE or SNIPPET loader
var mixpanel_master; // main mixpanel instance / object
var INIT_MODULE  = 0;
var INIT_SNIPPET = 1;

var IDENTITY_FUNC = function(x) {return x;};
var NOOP_FUNC = function() {};

/** @const */ var PRIMARY_INSTANCE_NAME = 'mixpanel';
/** @const */ var PAYLOAD_TYPE_BASE64   = 'base64';
/** @const */ var PAYLOAD_TYPE_JSON     = 'json';


/*
 * Dynamic... constants? Is that an oxymoron?
 */
// http://hacks.mozilla.org/2009/07/cross-site-xmlhttprequest-with-cors/
// https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#withCredentials
var USE_XHR = (window$1.XMLHttpRequest && 'withCredentials' in new XMLHttpRequest());

// IE<10 does not support cross-origin XHR's but script tags
// with defer won't block window.onload; ENQUEUE_REQUESTS
// should only be true for Opera<12
var ENQUEUE_REQUESTS = !USE_XHR && (userAgent.indexOf('MSIE') === -1) && (userAgent.indexOf('Mozilla') === -1);

// save reference to navigator.sendBeacon so it can be minified
var sendBeacon = null;
if (navigator['sendBeacon']) {
    sendBeacon = function() {
        // late reference to navigator.sendBeacon to allow patching/spying
        return navigator['sendBeacon'].apply(navigator, arguments);
    };
}

/*
 * Module-level globals
 */
var DEFAULT_CONFIG = {
    'api_host':                          'https://api-js.mixpanel.com',
    'api_method':                        'POST',
    'api_transport':                     'XHR',
    'api_payload_format':                PAYLOAD_TYPE_BASE64,
    'app_host':                          'https://mixpanel.com',
    'cdn':                               'https://cdn.mxpnl.com',
    'cross_site_cookie':                 false,
    'cross_subdomain_cookie':            true,
    'error_reporter':                    NOOP_FUNC,
    'persistence':                       'cookie',
    'persistence_name':                  '',
    'cookie_domain':                     '',
    'cookie_name':                       '',
    'loaded':                            NOOP_FUNC,
    'store_google':                      true,
    'save_referrer':                     true,
    'test':                              false,
    'verbose':                           false,
    'img':                               false,
    'debug':                             false,
    'track_links_timeout':               300,
    'cookie_expiration':                 365,
    'upgrade':                           false,
    'disable_persistence':               false,
    'disable_cookie':                    false,
    'secure_cookie':                     false,
    'ip':                                true,
    'opt_out_tracking_by_default':       false,
    'opt_out_persistence_by_default':    false,
    'opt_out_tracking_persistence_type': 'localStorage',
    'opt_out_tracking_cookie_prefix':    null,
    'property_blacklist':                [],
    'xhr_headers':                       {}, // { header: value, header2: value }
    'ignore_dnt':                        false,
    'batch_requests':                    true,
    'batch_size':                        50,
    'batch_flush_interval_ms':           5000,
    'batch_request_timeout_ms':          90000,
    'batch_autostart':                   true,
    'hooks':                             {}
};

var DOM_LOADED = false;

/**
 * Mixpanel Library Object
 * @constructor
 */
var MixpanelLib = function() {};


/**
 * create_mplib(token:string, config:object, name:string)
 *
 * This function is used by the init method of MixpanelLib objects
 * as well as the main initializer at the end of the JSLib (that
 * initializes document.mixpanel as well as any additional instances
 * declared before this file has loaded).
 */
var create_mplib = function(token, config, name) {
    var instance,
        target = (name === PRIMARY_INSTANCE_NAME) ? mixpanel_master : mixpanel_master[name];

    if (target && init_type === INIT_MODULE) {
        instance = target;
    } else {
        if (target && !_.isArray(target)) {
            console.error('You have already initialized ' + name);
            return;
        }
        instance = new MixpanelLib();
    }

    instance._cached_groups = {}; // cache groups in a pool

    instance._init(token, config, name);

    instance['people'] = new MixpanelPeople();
    instance['people']._init(instance);

    // if any instance on the page has debug = true, we set the
    // global debug to be true
    Config.DEBUG = Config.DEBUG || instance.get_config('debug');

    // if target is not defined, we called init after the lib already
    // loaded, so there won't be an array of things to execute
    if (!_.isUndefined(target) && _.isArray(target)) {
        // Crunch through the people queue first - we queue this data up &
        // flush on identify, so it's better to do all these operations first
        instance._execute_array.call(instance['people'], target['people']);
        instance._execute_array(target);
    }

    return instance;
};

// Initialization methods

/**
 * This function initializes a new instance of the Mixpanel tracking object.
 * All new instances are added to the main mixpanel object as sub properties (such as
 * mixpanel.library_name) and also returned by this function. To define a
 * second instance on the page, you would call:
 *
 *     mixpanel.init('new token', { your: 'config' }, 'library_name');
 *
 * and use it like so:
 *
 *     mixpanel.library_name.track(...);
 *
 * @param {String} token   Your Mixpanel API token
 * @param {Object} [config]  A dictionary of config options to override. <a href="https://github.com/mixpanel/mixpanel-js/blob/8b2e1f7b/src/mixpanel-core.js#L87-L110">See a list of default config options</a>.
 * @param {String} [name]    The name for the new mixpanel instance that you want created
 */
MixpanelLib.prototype.init = function (token, config, name) {
    if (_.isUndefined(name)) {
        this.report_error('You must name your new library: init(token, config, name)');
        return;
    }
    if (name === PRIMARY_INSTANCE_NAME) {
        this.report_error('You must initialize the main mixpanel object right after you include the Mixpanel js snippet');
        return;
    }

    var instance = create_mplib(token, config, name);
    mixpanel_master[name] = instance;
    instance._loaded();

    return instance;
};

// mixpanel._init(token:string, config:object, name:string)
//
// This function sets up the current instance of the mixpanel
// library.  The difference between this method and the init(...)
// method is this one initializes the actual instance, whereas the
// init(...) method sets up a new library and calls _init on it.
//
MixpanelLib.prototype._init = function(token, config, name) {
    config = config || {};

    this['__loaded'] = true;
    this['config'] = {};

    var variable_features = {};

    // default to JSON payload for standard mixpanel.com API hosts
    if (!('api_payload_format' in config)) {
        var api_host = config['api_host'] || DEFAULT_CONFIG['api_host'];
        if (api_host.match(/\.mixpanel\.com$/)) {
            variable_features['api_payload_format'] = PAYLOAD_TYPE_JSON;
        }
    }

    this.set_config(_.extend({}, DEFAULT_CONFIG, variable_features, config, {
        'name': name,
        'token': token,
        'callback_fn': ((name === PRIMARY_INSTANCE_NAME) ? name : PRIMARY_INSTANCE_NAME + '.' + name) + '._jsc'
    }));

    this['_jsc'] = NOOP_FUNC;

    this.__dom_loaded_queue = [];
    this.__request_queue = [];
    this.__disabled_events = [];
    this._flags = {
        'disable_all_events': false,
        'identify_called': false
    };

    // set up request queueing/batching
    this.request_batchers = {};
    this._batch_requests = this.get_config('batch_requests');
    if (this._batch_requests) {
        if (!_.localStorage.is_supported(true) || !USE_XHR) {
            this._batch_requests = false;
            console.log('Turning off Mixpanel request-queueing; needs XHR and localStorage support');
        } else {
            this.init_batchers();
            if (sendBeacon && window$1.addEventListener) {
                // Before page closes or hides (user tabs away etc), attempt to flush any events
                // queued up via navigator.sendBeacon. Since sendBeacon doesn't report success/failure,
                // events will not be removed from the persistent store; if the site is loaded again,
                // the events will be flushed again on startup and deduplicated on the Mixpanel server
                // side.
                // There is no reliable way to capture only page close events, so we lean on the
                // visibilitychange and pagehide events as recommended at
                // https://developer.mozilla.org/en-US/docs/Web/API/Window/unload_event#usage_notes.
                // These events fire when the user clicks away from the current page/tab, so will occur
                // more frequently than page unload, but are the only mechanism currently for capturing
                // this scenario somewhat reliably.
                var flush_on_unload = _.bind(function() {
                    if (!this.request_batchers.events.stopped) {
                        this.request_batchers.events.flush({unloading: true});
                    }
                }, this);
                window$1.addEventListener('pagehide', function(ev) {
                    if (ev['persisted']) {
                        flush_on_unload();
                    }
                });
                window$1.addEventListener('visibilitychange', function() {
                    if (document$1['visibilityState'] === 'hidden') {
                        flush_on_unload();
                    }
                });
            }
        }
    }

    this['persistence'] = this['cookie'] = new MixpanelPersistence(this['config']);
    this.unpersisted_superprops = {};
    this._gdpr_init();

    var uuid = _.UUID();
    if (!this.get_distinct_id()) {
        // There is no need to set the distinct id
        // or the device id if something was already stored
        // in the persitence
        this.register_once({
            'distinct_id': uuid,
            '$device_id': uuid
        }, '');
    }
};

// Private methods

MixpanelLib.prototype._loaded = function() {
    this.get_config('loaded')(this);
    this._set_default_superprops();
};

// update persistence with info on referrer, UTM params, etc
MixpanelLib.prototype._set_default_superprops = function() {
    this['persistence'].update_search_keyword(document$1.referrer);
    if (this.get_config('store_google')) {
        this['persistence'].update_campaign_params();
    }
    if (this.get_config('save_referrer')) {
        this['persistence'].update_referrer_info(document$1.referrer);
    }
};

MixpanelLib.prototype._dom_loaded = function() {
    _.each(this.__dom_loaded_queue, function(item) {
        this._track_dom.apply(this, item);
    }, this);

    if (!this.has_opted_out_tracking()) {
        _.each(this.__request_queue, function(item) {
            this._send_request.apply(this, item);
        }, this);
    }

    delete this.__dom_loaded_queue;
    delete this.__request_queue;
};

MixpanelLib.prototype._track_dom = function(DomClass, args) {
    if (this.get_config('img')) {
        this.report_error('You can\'t use DOM tracking functions with img = true.');
        return false;
    }

    if (!DOM_LOADED) {
        this.__dom_loaded_queue.push([DomClass, args]);
        return false;
    }

    var dt = new DomClass().init(this);
    return dt.track.apply(dt, args);
};

/**
 * _prepare_callback() should be called by callers of _send_request for use
 * as the callback argument.
 *
 * If there is no callback, this returns null.
 * If we are going to make XHR/XDR requests, this returns a function.
 * If we are going to use script tags, this returns a string to use as the
 * callback GET param.
 */
MixpanelLib.prototype._prepare_callback = function(callback, data) {
    if (_.isUndefined(callback)) {
        return null;
    }

    if (USE_XHR) {
        var callback_function = function(response) {
            callback(response, data);
        };
        return callback_function;
    } else {
        // if the user gives us a callback, we store as a random
        // property on this instances jsc function and update our
        // callback string to reflect that.
        var jsc = this['_jsc'];
        var randomized_cb = '' + Math.floor(Math.random() * 100000000);
        var callback_string = this.get_config('callback_fn') + '[' + randomized_cb + ']';
        jsc[randomized_cb] = function(response) {
            delete jsc[randomized_cb];
            callback(response, data);
        };
        return callback_string;
    }
};

MixpanelLib.prototype._send_request = function(url, data, options, callback) {
    var succeeded = true;

    if (ENQUEUE_REQUESTS) {
        this.__request_queue.push(arguments);
        return succeeded;
    }

    var DEFAULT_OPTIONS = {
        method: this.get_config('api_method'),
        transport: this.get_config('api_transport'),
        verbose: this.get_config('verbose')
    };
    var body_data = null;

    if (!callback && (_.isFunction(options) || typeof options === 'string')) {
        callback = options;
        options = null;
    }
    options = _.extend(DEFAULT_OPTIONS, options || {});
    if (!USE_XHR) {
        options.method = 'GET';
    }
    var use_post = options.method === 'POST';
    var use_sendBeacon = sendBeacon && use_post && options.transport.toLowerCase() === 'sendbeacon';

    // needed to correctly format responses
    var verbose_mode = options.verbose;
    if (data['verbose']) { verbose_mode = true; }

    if (this.get_config('test')) { data['test'] = 1; }
    if (verbose_mode) { data['verbose'] = 1; }
    if (this.get_config('img')) { data['img'] = 1; }
    if (!USE_XHR) {
        if (callback) {
            data['callback'] = callback;
        } else if (verbose_mode || this.get_config('test')) {
            // Verbose output (from verbose mode, or an error in test mode) is a json blob,
            // which by itself is not valid javascript. Without a callback, this verbose output will
            // cause an error when returned via jsonp, so we force a no-op callback param.
            // See the ECMA script spec: http://www.ecma-international.org/ecma-262/5.1/#sec-12.4
            data['callback'] = '(function(){})';
        }
    }

    data['ip'] = this.get_config('ip')?1:0;
    data['_'] = new Date().getTime().toString();

    if (use_post) {
        body_data = 'data=' + encodeURIComponent(data['data']);
        delete data['data'];
    }

    url += '?' + _.HTTPBuildQuery(data);

    var lib = this;
    if ('img' in data) {
        var img = document$1.createElement('img');
        img.src = url;
        document$1.body.appendChild(img);
    } else if (use_sendBeacon) {
        try {
            succeeded = sendBeacon(url, body_data);
        } catch (e) {
            lib.report_error(e);
            succeeded = false;
        }
        try {
            if (callback) {
                callback(succeeded ? 1 : 0);
            }
        } catch (e) {
            lib.report_error(e);
        }
    } else if (USE_XHR) {
        try {
            var req = new XMLHttpRequest();
            req.open(options.method, url, true);

            var headers = this.get_config('xhr_headers');
            if (use_post) {
                headers['Content-Type'] = 'application/x-www-form-urlencoded';
            }
            _.each(headers, function(headerValue, headerName) {
                req.setRequestHeader(headerName, headerValue);
            });

            if (options.timeout_ms && typeof req.timeout !== 'undefined') {
                req.timeout = options.timeout_ms;
                var start_time = new Date().getTime();
            }

            // send the mp_optout cookie
            // withCredentials cannot be modified until after calling .open on Android and Mobile Safari
            req.withCredentials = true;
            req.onreadystatechange = function () {
                if (req.readyState === 4) { // XMLHttpRequest.DONE == 4, except in safari 4
                    if (req.status === 200) {
                        if (callback) {
                            if (verbose_mode) {
                                var response;
                                try {
                                    response = _.JSONDecode(req.responseText);
                                } catch (e) {
                                    lib.report_error(e);
                                    if (options.ignore_json_errors) {
                                        response = req.responseText;
                                    } else {
                                        return;
                                    }
                                }
                                callback(response);
                            } else {
                                callback(Number(req.responseText));
                            }
                        }
                    } else {
                        var error;
                        if (
                            req.timeout &&
                            !req.status &&
                            new Date().getTime() - start_time >= req.timeout
                        ) {
                            error = 'timeout';
                        } else {
                            error = 'Bad HTTP status: ' + req.status + ' ' + req.statusText;
                        }
                        lib.report_error(error);
                        if (callback) {
                            if (verbose_mode) {
                                callback({status: 0, error: error, xhr_req: req});
                            } else {
                                callback(0);
                            }
                        }
                    }
                }
            };
            req.send(body_data);
        } catch (e) {
            lib.report_error(e);
            succeeded = false;
        }
    } else {
        var script = document$1.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.defer = true;
        script.src = url;
        var s = document$1.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(script, s);
    }

    return succeeded;
};

/**
 * _execute_array() deals with processing any mixpanel function
 * calls that were called before the Mixpanel library were loaded
 * (and are thus stored in an array so they can be called later)
 *
 * Note: we fire off all the mixpanel function calls && user defined
 * functions BEFORE we fire off mixpanel tracking calls. This is so
 * identify/register/set_config calls can properly modify early
 * tracking calls.
 *
 * @param {Array} array
 */
MixpanelLib.prototype._execute_array = function(array) {
    var fn_name, alias_calls = [], other_calls = [], tracking_calls = [];
    _.each(array, function(item) {
        if (item) {
            fn_name = item[0];
            if (_.isArray(fn_name)) {
                tracking_calls.push(item); // chained call e.g. mixpanel.get_group().set()
            } else if (typeof(item) === 'function') {
                item.call(this);
            } else if (_.isArray(item) && fn_name === 'alias') {
                alias_calls.push(item);
            } else if (_.isArray(item) && fn_name.indexOf('track') !== -1 && typeof(this[fn_name]) === 'function') {
                tracking_calls.push(item);
            } else {
                other_calls.push(item);
            }
        }
    }, this);

    var execute = function(calls, context) {
        _.each(calls, function(item) {
            if (_.isArray(item[0])) {
                // chained call
                var caller = context;
                _.each(item, function(call) {
                    caller = caller[call[0]].apply(caller, call.slice(1));
                });
            } else {
                this[item[0]].apply(this, item.slice(1));
            }
        }, context);
    };

    execute(alias_calls, this);
    execute(other_calls, this);
    execute(tracking_calls, this);
};

// request queueing utils

MixpanelLib.prototype.are_batchers_initialized = function() {
    return !!this.request_batchers.events;
};

MixpanelLib.prototype.init_batchers = function() {
    var token = this.get_config('token');
    if (!this.are_batchers_initialized()) {
        var batcher_for = _.bind(function(attrs) {
            return new RequestBatcher(
                '__mpq_' + token + attrs.queue_suffix,
                {
                    libConfig: this['config'],
                    sendRequestFunc: _.bind(function(data, options, cb) {
                        this._send_request(
                            this.get_config('api_host') + attrs.endpoint,
                            this._encode_data_for_request(data),
                            options,
                            this._prepare_callback(cb, data)
                        );
                    }, this),
                    beforeSendHook: _.bind(function(item) {
                        return this._run_hook('before_send_' + attrs.type, item);
                    }, this),
                    errorReporter: this.get_config('error_reporter'),
                    stopAllBatchingFunc: _.bind(this.stop_batch_senders, this)
                }
            );
        }, this);
        this.request_batchers = {
            events: batcher_for({type: 'events', endpoint: '/track/', queue_suffix: '_ev'}),
            people: batcher_for({type: 'people', endpoint: '/engage/', queue_suffix: '_pp'}),
            groups: batcher_for({type: 'groups', endpoint: '/groups/', queue_suffix: '_gr'})
        };
    }
    if (this.get_config('batch_autostart')) {
        this.start_batch_senders();
    }
};

MixpanelLib.prototype.start_batch_senders = function() {
    if (this.are_batchers_initialized()) {
        this._batch_requests = true;
        _.each(this.request_batchers, function(batcher) {
            batcher.start();
        });
    }
};

MixpanelLib.prototype.stop_batch_senders = function() {
    this._batch_requests = false;
    _.each(this.request_batchers, function(batcher) {
        batcher.stop();
        batcher.clear();
    });
};

/**
 * push() keeps the standard async-array-push
 * behavior around after the lib is loaded.
 * This is only useful for external integrations that
 * do not wish to rely on our convenience methods
 * (created in the snippet).
 *
 * ### Usage:
 *     mixpanel.push(['register', { a: 'b' }]);
 *
 * @param {Array} item A [function_name, args...] array to be executed
 */
MixpanelLib.prototype.push = function(item) {
    this._execute_array([item]);
};

/**
 * Disable events on the Mixpanel object. If passed no arguments,
 * this function disables tracking of any event. If passed an
 * array of event names, those events will be disabled, but other
 * events will continue to be tracked.
 *
 * Note: this function does not stop other mixpanel functions from
 * firing, such as register() or people.set().
 *
 * @param {Array} [events] An array of event names to disable
 */
MixpanelLib.prototype.disable = function(events) {
    if (typeof(events) === 'undefined') {
        this._flags.disable_all_events = true;
    } else {
        this.__disabled_events = this.__disabled_events.concat(events);
    }
};

MixpanelLib.prototype._encode_data_for_request = function(data) {
    var encoded_data = _.JSONEncode(data);
    if (this.get_config('api_payload_format') === PAYLOAD_TYPE_BASE64) {
        encoded_data = _.base64Encode(encoded_data);
    }
    return {'data': encoded_data};
};

// internal method for handling track vs batch-enqueue logic
MixpanelLib.prototype._track_or_batch = function(options, callback) {
    var truncated_data = _.truncate(options.data, 255);
    var endpoint = options.endpoint;
    var batcher = options.batcher;
    var should_send_immediately = options.should_send_immediately;
    var send_request_options = options.send_request_options || {};
    callback = callback || NOOP_FUNC;

    var request_enqueued_or_initiated = true;
    var send_request_immediately = _.bind(function() {
        if (!send_request_options.skip_hooks) {
            truncated_data = this._run_hook('before_send_' + options.type, truncated_data);
        }
        if (truncated_data) {
            console.log('MIXPANEL REQUEST:');
            console.log(truncated_data);
            return this._send_request(
                endpoint,
                this._encode_data_for_request(truncated_data),
                send_request_options,
                this._prepare_callback(callback, truncated_data)
            );
        } else {
            return null;
        }
    }, this);

    if (this._batch_requests && !should_send_immediately) {
        batcher.enqueue(truncated_data, function(succeeded) {
            if (succeeded) {
                callback(1, truncated_data);
            } else {
                send_request_immediately();
            }
        });
    } else {
        request_enqueued_or_initiated = send_request_immediately();
    }

    return request_enqueued_or_initiated && truncated_data;
};

/**
 * Track an event. This is the most important and
 * frequently used Mixpanel function.
 *
 * ### Usage:
 *
 *     // track an event named 'Registered'
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 *     // track an event using navigator.sendBeacon
 *     mixpanel.track('Left page', {'duration_seconds': 35}, {transport: 'sendBeacon'});
 *
 * To track link clicks or form submissions, see track_links() or track_forms().
 *
 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
 * @param {Object} [options] Optional configuration for this track request.
 * @param {String} [options.transport] Transport method for network request ('xhr' or 'sendBeacon').
 * @param {Boolean} [options.send_immediately] Whether to bypass batching/queueing and send track request immediately.
 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
 * @returns {Boolean|Object} If the tracking request was successfully initiated/queued, an object
 * with the tracking payload sent to the API server is returned; otherwise false.
 */
MixpanelLib.prototype.track = addOptOutCheckMixpanelLib(function(event_name, properties, options, callback) {
    if (!callback && typeof options === 'function') {
        callback = options;
        options = null;
    }
    options = options || {};
    var transport = options['transport']; // external API, don't minify 'transport' prop
    if (transport) {
        options.transport = transport; // 'transport' prop name can be minified internally
    }
    var should_send_immediately = options['send_immediately'];
    if (typeof callback !== 'function') {
        callback = NOOP_FUNC;
    }

    if (_.isUndefined(event_name)) {
        this.report_error('No event name provided to mixpanel.track');
        return;
    }

    if (this._event_is_disabled(event_name)) {
        callback(0);
        return;
    }

    // set defaults
    properties = properties || {};
    properties['token'] = this.get_config('token');

    // set $duration if time_event was previously called for this event
    var start_timestamp = this['persistence'].remove_event_timer(event_name);
    if (!_.isUndefined(start_timestamp)) {
        var duration_in_ms = new Date().getTime() - start_timestamp;
        properties['$duration'] = parseFloat((duration_in_ms / 1000).toFixed(3));
    }

    this._set_default_superprops();

    // note: extend writes to the first object, so lets make sure we
    // don't write to the persistence properties object and info
    // properties object by passing in a new object

    // update properties with pageview info and super-properties
    properties = _.extend(
        {},
        _.info.properties(),
        this['persistence'].properties(),
        this.unpersisted_superprops,
        properties
    );

    var property_blacklist = this.get_config('property_blacklist');
    if (_.isArray(property_blacklist)) {
        _.each(property_blacklist, function(blacklisted_prop) {
            delete properties[blacklisted_prop];
        });
    } else {
        this.report_error('Invalid value for property_blacklist config: ' + property_blacklist);
    }

    var data = {
        'event': event_name,
        'properties': properties
    };
    var ret = this._track_or_batch({
        type: 'events',
        data: data,
        endpoint: this.get_config('api_host') + '/track/',
        batcher: this.request_batchers.events,
        should_send_immediately: should_send_immediately,
        send_request_options: options
    }, callback);

    return ret;
});

/**
 * Register the current user into one/many groups.
 *
 * ### Usage:
 *
 *      mixpanel.set_group('company', ['mixpanel', 'google']) // an array of IDs
 *      mixpanel.set_group('company', 'mixpanel')
 *      mixpanel.set_group('company', 128746312)
 *
 * @param {String} group_key Group key
 * @param {Array|String|Number} group_ids An array of group IDs, or a singular group ID
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 *
 */
MixpanelLib.prototype.set_group = addOptOutCheckMixpanelLib(function(group_key, group_ids, callback) {
    if (!_.isArray(group_ids)) {
        group_ids = [group_ids];
    }
    var prop = {};
    prop[group_key] = group_ids;
    this.register(prop);
    return this['people'].set(group_key, group_ids, callback);
});

/**
 * Add a new group for this user.
 *
 * ### Usage:
 *
 *      mixpanel.add_group('company', 'mixpanel')
 *
 * @param {String} group_key Group key
 * @param {*} group_id A valid Mixpanel property type
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */
MixpanelLib.prototype.add_group = addOptOutCheckMixpanelLib(function(group_key, group_id, callback) {
    var old_values = this.get_property(group_key);
    if (old_values === undefined) {
        var prop = {};
        prop[group_key] = [group_id];
        this.register(prop);
    } else {
        if (old_values.indexOf(group_id) === -1) {
            old_values.push(group_id);
            this.register(prop);
        }
    }
    return this['people'].union(group_key, group_id, callback);
});

/**
 * Remove a group from this user.
 *
 * ### Usage:
 *
 *      mixpanel.remove_group('company', 'mixpanel')
 *
 * @param {String} group_key Group key
 * @param {*} group_id A valid Mixpanel property type
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */
MixpanelLib.prototype.remove_group = addOptOutCheckMixpanelLib(function(group_key, group_id, callback) {
    var old_value = this.get_property(group_key);
    // if the value doesn't exist, the persistent store is unchanged
    if (old_value !== undefined) {
        var idx = old_value.indexOf(group_id);
        if (idx > -1) {
            old_value.splice(idx, 1);
            this.register({group_key: old_value});
        }
        if (old_value.length === 0) {
            this.unregister(group_key);
        }
    }
    return this['people'].remove(group_key, group_id, callback);
});

/**
 * Track an event with specific groups.
 *
 * ### Usage:
 *
 *      mixpanel.track_with_groups('purchase', {'product': 'iphone'}, {'University': ['UCB', 'UCLA']})
 *
 * @param {String} event_name The name of the event (see `mixpanel.track()`)
 * @param {Object=} properties A set of properties to include with the event you're sending (see `mixpanel.track()`)
 * @param {Object=} groups An object mapping group name keys to one or more values
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */
MixpanelLib.prototype.track_with_groups = addOptOutCheckMixpanelLib(function(event_name, properties, groups, callback) {
    var tracking_props = _.extend({}, properties || {});
    _.each(groups, function(v, k) {
        if (v !== null && v !== undefined) {
            tracking_props[k] = v;
        }
    });
    return this.track(event_name, tracking_props, callback);
});

MixpanelLib.prototype._create_map_key = function (group_key, group_id) {
    return group_key + '_' + JSON.stringify(group_id);
};

MixpanelLib.prototype._remove_group_from_cache = function (group_key, group_id) {
    delete this._cached_groups[this._create_map_key(group_key, group_id)];
};

/**
 * Look up reference to a Mixpanel group
 *
 * ### Usage:
 *
 *       mixpanel.get_group(group_key, group_id)
 *
 * @param {String} group_key Group key
 * @param {Object} group_id A valid Mixpanel property type
 * @returns {Object} A MixpanelGroup identifier
 */
MixpanelLib.prototype.get_group = function (group_key, group_id) {
    var map_key = this._create_map_key(group_key, group_id);
    var group = this._cached_groups[map_key];
    if (group === undefined || group._group_key !== group_key || group._group_id !== group_id) {
        group = new MixpanelGroup();
        group._init(this, group_key, group_id);
        this._cached_groups[map_key] = group;
    }
    return group;
};

/**
 * Track mp_page_view event. This is now ignored by the server.
 *
 * @param {String} [page] The url of the page to record. If you don't include this, it defaults to the current url.
 * @deprecated
 */
MixpanelLib.prototype.track_pageview = function(page) {
    if (_.isUndefined(page)) {
        page = document$1.location.href;
    }
    this.track('mp_page_view', _.info.pageviewInfo(page));
};

/**
 * Track clicks on a set of document elements. Selector must be a
 * valid query. Elements must exist on the page at the time track_links is called.
 *
 * ### Usage:
 *
 *     // track click for link id #nav
 *     mixpanel.track_links('#nav', 'Clicked Nav Link');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the Mixpanel
 * servers to respond. If they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] A properties object or function that returns a dictionary of properties when passed a DOMElement
 */
MixpanelLib.prototype.track_links = function() {
    return this._track_dom.call(this, LinkTracker, arguments);
};

/**
 * Track form submissions. Selector must be a valid query.
 *
 * ### Usage:
 *
 *     // track submission for form id 'register'
 *     mixpanel.track_forms('#register', 'Created Account');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the mixpanel
 * servers to respond, if they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] This can be a set of properties, or a function that returns a set of properties after being passed a DOMElement
 */
MixpanelLib.prototype.track_forms = function() {
    return this._track_dom.call(this, FormTracker, arguments);
};

/**
 * Time an event by including the time between this call and a
 * later 'track' call for the same event in the properties sent
 * with the event.
 *
 * ### Usage:
 *
 *     // time an event named 'Registered'
 *     mixpanel.time_event('Registered');
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 * When called for a particular event name, the next track call for that event
 * name will include the elapsed time between the 'time_event' and 'track'
 * calls. This value is stored as seconds in the '$duration' property.
 *
 * @param {String} event_name The name of the event.
 */
MixpanelLib.prototype.time_event = function(event_name) {
    if (_.isUndefined(event_name)) {
        this.report_error('No event name provided to mixpanel.time_event');
        return;
    }

    if (this._event_is_disabled(event_name)) {
        return;
    }

    this['persistence'].set_event_timer(event_name,  new Date().getTime());
};

var REGISTER_DEFAULTS = {
    'persistent': true
};
/**
 * Helper to parse options param for register methods, maintaining
 * legacy support for plain "days" param instead of options object
 * @param {Number|Object} [days_or_options] 'days' option (Number), or Options object for register methods
 * @returns {Object} options object
 */
var options_for_register = function(days_or_options) {
    var options;
    if (_.isObject(days_or_options)) {
        options = days_or_options;
    } else if (!_.isUndefined(days_or_options)) {
        options = {'days': days_or_options};
    } else {
        options = {};
    }
    return _.extend({}, REGISTER_DEFAULTS, options);
};

/**
 * Register a set of super properties, which are included with all
 * events. This will overwrite previous super property values.
 *
 * ### Usage:
 *
 *     // register 'Gender' as a super property
 *     mixpanel.register({'Gender': 'Female'});
 *
 *     // register several super properties when a user signs up
 *     mixpanel.register({
 *         'Email': 'jdoe@example.com',
 *         'Account Type': 'Free'
 *     });
 *
 *     // register only for the current pageload
 *     mixpanel.register({'Name': 'Pat'}, {persistent: false});
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {Number|Object} [days_or_options] Options object or number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.days] - number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.persistent=true] - whether to put in persistent storage (cookie/localStorage)
 */
MixpanelLib.prototype.register = function(props, days_or_options) {
    var options = options_for_register(days_or_options);
    if (options['persistent']) {
        this['persistence'].register(props, options['days']);
    } else {
        _.extend(this.unpersisted_superprops, props);
    }
};

/**
 * Register a set of super properties only once. This will not
 * overwrite previous super property values, unlike register().
 *
 * ### Usage:
 *
 *     // register a super property for the first time only
 *     mixpanel.register_once({
 *         'First Login Date': new Date().toISOString()
 *     });
 *
 *     // register once, only for the current pageload
 *     mixpanel.register_once({
 *         'First interaction time': new Date().toISOString()
 *     }, 'None', {persistent: false});
 *
 * ### Notes:
 *
 * If default_value is specified, current super properties
 * with that value will be overwritten.
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {*} [default_value] Value to override if already set in super properties (ex: 'False') Default: 'None'
 * @param {Number|Object} [days_or_options] Options object or number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.days] - number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.persistent=true] - whether to put in persistent storage (cookie/localStorage)
 */
MixpanelLib.prototype.register_once = function(props, default_value, days_or_options) {
    var options = options_for_register(days_or_options);
    if (options['persistent']) {
        this['persistence'].register_once(props, default_value, options['days']);
    } else {
        if (typeof(default_value) === 'undefined') {
            default_value = 'None';
        }
        _.each(props, function(val, prop) {
            if (!this.unpersisted_superprops.hasOwnProperty(prop) || this.unpersisted_superprops[prop] === default_value) {
                this.unpersisted_superprops[prop] = val;
            }
        }, this);
    }
};

/**
 * Delete a super property stored with the current user.
 *
 * @param {String} property The name of the super property to remove
 * @param {Object} [options]
 * @param {boolean} [options.persistent=true] - whether to look in persistent storage (cookie/localStorage)
 */
MixpanelLib.prototype.unregister = function(property, options) {
    options = options_for_register(options);
    if (options['persistent']) {
        this['persistence'].unregister(property);
    } else {
        delete this.unpersisted_superprops[property];
    }
};

MixpanelLib.prototype._register_single = function(prop, value) {
    var props = {};
    props[prop] = value;
    this.register(props);
};

/**
 * Identify a user with a unique ID to track user activity across
 * devices, tie a user to their events, and create a user profile.
 * If you never call this method, unique visitors are tracked using
 * a UUID generated the first time they visit the site.
 *
 * Call identify when you know the identity of the current user,
 * typically after login or signup. We recommend against using
 * identify for anonymous visitors to your site.
 *
 * ### Notes:
 * If your project has
 * <a href="https://help.mixpanel.com/hc/en-us/articles/360039133851">ID Merge</a>
 * enabled, the identify method will connect pre- and
 * post-authentication events when appropriate.
 *
 * If your project does not have ID Merge enabled, identify will
 * change the user's local distinct_id to the unique ID you pass.
 * Events tracked prior to authentication will not be connected
 * to the same user identity. If ID Merge is disabled, alias can
 * be used to connect pre- and post-registration events.
 *
 * @param {String} [unique_id] A string that uniquely identifies a user. If not provided, the distinct_id currently in the persistent store (cookie or localStorage) will be used.
 */
MixpanelLib.prototype.identify = function(
    new_distinct_id, _set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback
) {
    // Optional Parameters
    //  _set_callback:function  A callback to be run if and when the People set queue is flushed
    //  _add_callback:function  A callback to be run if and when the People add queue is flushed
    //  _append_callback:function  A callback to be run if and when the People append queue is flushed
    //  _set_once_callback:function  A callback to be run if and when the People set_once queue is flushed
    //  _union_callback:function  A callback to be run if and when the People union queue is flushed
    //  _unset_callback:function  A callback to be run if and when the People unset queue is flushed

    var previous_distinct_id = this.get_distinct_id();
    this.register({'$user_id': new_distinct_id});

    if (!this.get_property('$device_id')) {
        // The persisted distinct id might not actually be a device id at all
        // it might be a distinct id of the user from before
        var device_id = previous_distinct_id;
        this.register_once({
            '$had_persisted_distinct_id': true,
            '$device_id': device_id
        }, '');
    }

    // identify only changes the distinct id if it doesn't match either the existing or the alias;
    // if it's new, blow away the alias as well.
    if (new_distinct_id !== previous_distinct_id && new_distinct_id !== this.get_property(ALIAS_ID_KEY)) {
        this.unregister(ALIAS_ID_KEY);
        this.register({'distinct_id': new_distinct_id});
    }
    this._flags.identify_called = true;
    // Flush any queued up people requests
    this['people']._flush(_set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback);

    // send an $identify event any time the distinct_id is changing - logic on the server
    // will determine whether or not to do anything with it.
    if (new_distinct_id !== previous_distinct_id) {
        this.track('$identify', {
            'distinct_id': new_distinct_id,
            '$anon_distinct_id': previous_distinct_id
        }, {skip_hooks: true});
    }
};

/**
 * Clears super properties and generates a new random distinct_id for this instance.
 * Useful for clearing data when a user logs out.
 */
MixpanelLib.prototype.reset = function() {
    this['persistence'].clear();
    this._flags.identify_called = false;
    var uuid = _.UUID();
    this.register_once({
        'distinct_id': uuid,
        '$device_id': uuid
    }, '');
};

/**
 * Returns the current distinct id of the user. This is either the id automatically
 * generated by the library or the id that has been passed by a call to identify().
 *
 * ### Notes:
 *
 * get_distinct_id() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // set distinct_id after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             distinct_id = mixpanel.get_distinct_id();
 *         }
 *     });
 */
MixpanelLib.prototype.get_distinct_id = function() {
    return this.get_property('distinct_id');
};

/**
 * The alias method creates an alias which Mixpanel will use to
 * remap one id to another. Multiple aliases can point to the
 * same identifier.
 *
 * The following is a valid use of alias:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // You can add multiple id aliases to the existing ID
 *     mixpanel.alias('newer_id', 'existing_id');
 *
 * Aliases can also be chained - the following is a valid example:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // chain newer_id - new_id - existing_id
 *     mixpanel.alias('newer_id', 'new_id');
 *
 * Aliases cannot point to multiple identifiers - the following
 * example will not work:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // this is invalid as 'new_id' already points to 'existing_id'
 *     mixpanel.alias('new_id', 'newer_id');
 *
 * ### Notes:
 *
 * If your project does not have
 * <a href="https://help.mixpanel.com/hc/en-us/articles/360039133851">ID Merge</a>
 * enabled, the best practice is to call alias once when a unique
 * ID is first created for a user (e.g., when a user first registers
 * for an account). Do not use alias multiple times for a single
 * user without ID Merge enabled.
 *
 * @param {String} alias A unique identifier that you want to use for this user in the future.
 * @param {String} [original] The current identifier being used for this user.
 */
MixpanelLib.prototype.alias = function(alias, original) {
    // If the $people_distinct_id key exists in persistence, there has been a previous
    // mixpanel.people.identify() call made for this user. It is VERY BAD to make an alias with
    // this ID, as it will duplicate users.
    if (alias === this.get_property(PEOPLE_DISTINCT_ID_KEY)) {
        this.report_error('Attempting to create alias for existing People user - aborting.');
        return -2;
    }

    var _this = this;
    if (_.isUndefined(original)) {
        original = this.get_distinct_id();
    }
    if (alias !== original) {
        this._register_single(ALIAS_ID_KEY, alias);
        return this.track('$create_alias', {
            'alias': alias,
            'distinct_id': original
        }, {
            skip_hooks: true
        }, function() {
            // Flush the people queue
            _this.identify(alias);
        });
    } else {
        this.report_error('alias matches current distinct_id - skipping api call.');
        this.identify(alias);
        return -1;
    }
};

/**
 * Provide a string to recognize the user by. The string passed to
 * this method will appear in the Mixpanel Streams product rather
 * than an automatically generated name. Name tags do not have to
 * be unique.
 *
 * This value will only be included in Streams data.
 *
 * @param {String} name_tag A human readable name for the user
 * @deprecated
 */
MixpanelLib.prototype.name_tag = function(name_tag) {
    this._register_single('mp_name_tag', name_tag);
};

/**
 * Update the configuration of a mixpanel library instance.
 *
 * The default config is:
 *
 *     {
 *       // HTTP method for tracking requests
 *       api_method: 'POST'
 *
 *       // transport for sending requests ('XHR' or 'sendBeacon')
 *       // NB: sendBeacon should only be used for scenarios such as
 *       // page unload where a "best-effort" attempt to send is
 *       // acceptable; the sendBeacon API does not support callbacks
 *       // or any way to know the result of the request. Mixpanel
 *       // tracking via sendBeacon will not support any event-
 *       // batching or retry mechanisms.
 *       api_transport: 'XHR'
 *
 *       // turn on request-batching/queueing/retry
 *       batch_requests: false,
 *
 *       // maximum number of events/updates to send in a single
 *       // network request
 *       batch_size: 50,
 *
 *       // milliseconds to wait between sending batch requests
 *       batch_flush_interval_ms: 5000,
 *
 *       // milliseconds to wait for network responses to batch requests
 *       // before they are considered timed-out and retried
 *       batch_request_timeout_ms: 90000,
 *
 *       // override value for cookie domain, only useful for ensuring
 *       // correct cross-subdomain cookies on unusual domains like
 *       // subdomain.mainsite.avocat.fr; NB this cannot be used to
 *       // set cookies on a different domain than the current origin
 *       cookie_domain: ''
 *
 *       // super properties cookie expiration (in days)
 *       cookie_expiration: 365
 *
 *       // if true, cookie will be set with SameSite=None; Secure
 *       // this is only useful in special situations, like embedded
 *       // 3rd-party iframes that set up a Mixpanel instance
 *       cross_site_cookie: false
 *
 *       // super properties span subdomains
 *       cross_subdomain_cookie: true
 *
 *       // debug mode
 *       debug: false
 *
 *       // if this is true, the mixpanel cookie or localStorage entry
 *       // will be deleted, and no user persistence will take place
 *       disable_persistence: false
 *
 *       // if this is true, Mixpanel will automatically determine
 *       // City, Region and Country data using the IP address of
 *       //the client
 *       ip: true
 *
 *       // opt users out of tracking by this Mixpanel instance by default
 *       opt_out_tracking_by_default: false
 *
 *       // opt users out of browser data storage by this Mixpanel instance by default
 *       opt_out_persistence_by_default: false
 *
 *       // persistence mechanism used by opt-in/opt-out methods - cookie
 *       // or localStorage - falls back to cookie if localStorage is unavailable
 *       opt_out_tracking_persistence_type: 'localStorage'
 *
 *       // customize the name of cookie/localStorage set by opt-in/opt-out methods
 *       opt_out_tracking_cookie_prefix: null
 *
 *       // type of persistent store for super properties (cookie/
 *       // localStorage) if set to 'localStorage', any existing
 *       // mixpanel cookie value with the same persistence_name
 *       // will be transferred to localStorage and deleted
 *       persistence: 'cookie'
 *
 *       // name for super properties persistent store
 *       persistence_name: ''
 *
 *       // names of properties/superproperties which should never
 *       // be sent with track() calls
 *       property_blacklist: []
 *
 *       // if this is true, mixpanel cookies will be marked as
 *       // secure, meaning they will only be transmitted over https
 *       secure_cookie: false
 *
 *       // the amount of time track_links will
 *       // wait for Mixpanel's servers to respond
 *       track_links_timeout: 300
 *
 *       // if you set upgrade to be true, the library will check for
 *       // a cookie from our old js library and import super
 *       // properties from it, then the old cookie is deleted
 *       // The upgrade config option only works in the initialization,
 *       // so make sure you set it when you create the library.
 *       upgrade: false
 *
 *       // extra HTTP request headers to set for each API request, in
 *       // the format {'Header-Name': value}
 *       xhr_headers: {}
 *
 *       // whether to ignore or respect the web browser's Do Not Track setting
 *       ignore_dnt: false
 *     }
 *
 *
 * @param {Object} config A dictionary of new configuration values to update
 */
MixpanelLib.prototype.set_config = function(config) {
    if (_.isObject(config)) {
        _.extend(this['config'], config);

        var new_batch_size = config['batch_size'];
        if (new_batch_size) {
            _.each(this.request_batchers, function(batcher) {
                batcher.resetBatchSize();
            });
        }

        if (!this.get_config('persistence_name')) {
            this['config']['persistence_name'] = this['config']['cookie_name'];
        }
        if (!this.get_config('disable_persistence')) {
            this['config']['disable_persistence'] = this['config']['disable_cookie'];
        }

        if (this['persistence']) {
            this['persistence'].update_config(this['config']);
        }
        Config.DEBUG = Config.DEBUG || this.get_config('debug');
    }
};

/**
 * returns the current config object for the library.
 */
MixpanelLib.prototype.get_config = function(prop_name) {
    return this['config'][prop_name];
};

/**
 * Fetch a hook function from config, with safe default, and run it
 * against the given arguments
 * @param {string} hook_name which hook to retrieve
 * @returns {any|null} return value of user-provided hook, or null if nothing was returned
 */
MixpanelLib.prototype._run_hook = function(hook_name) {
    var ret = (this['config']['hooks'][hook_name] || IDENTITY_FUNC).apply(this, slice.call(arguments, 1));
    if (typeof ret === 'undefined') {
        this.report_error(hook_name + ' hook did not return a value');
        ret = null;
    }
    return ret;
};

/**
 * Returns the value of the super property named property_name. If no such
 * property is set, get_property() will return the undefined value.
 *
 * ### Notes:
 *
 * get_property() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // grab value for 'user_id' after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             user_id = mixpanel.get_property('user_id');
 *         }
 *     });
 *
 * @param {String} property_name The name of the super property you want to retrieve
 */
MixpanelLib.prototype.get_property = function(property_name) {
    return this['persistence']['props'][property_name];
};

MixpanelLib.prototype.toString = function() {
    var name = this.get_config('name');
    if (name !== PRIMARY_INSTANCE_NAME) {
        name = PRIMARY_INSTANCE_NAME + '.' + name;
    }
    return name;
};

MixpanelLib.prototype._event_is_disabled = function(event_name) {
    return _.isBlockedUA(userAgent) ||
        this._flags.disable_all_events ||
        _.include(this.__disabled_events, event_name);
};

// perform some housekeeping around GDPR opt-in/out state
MixpanelLib.prototype._gdpr_init = function() {
    var is_localStorage_requested = this.get_config('opt_out_tracking_persistence_type') === 'localStorage';

    // try to convert opt-in/out cookies to localStorage if possible
    if (is_localStorage_requested && _.localStorage.is_supported()) {
        if (!this.has_opted_in_tracking() && this.has_opted_in_tracking({'persistence_type': 'cookie'})) {
            this.opt_in_tracking({'enable_persistence': false});
        }
        if (!this.has_opted_out_tracking() && this.has_opted_out_tracking({'persistence_type': 'cookie'})) {
            this.opt_out_tracking({'clear_persistence': false});
        }
        this.clear_opt_in_out_tracking({
            'persistence_type': 'cookie',
            'enable_persistence': false
        });
    }

    // check whether the user has already opted out - if so, clear & disable persistence
    if (this.has_opted_out_tracking()) {
        this._gdpr_update_persistence({'clear_persistence': true});

    // check whether we should opt out by default
    // note: we don't clear persistence here by default since opt-out default state is often
    //       used as an initial state while GDPR information is being collected
    } else if (!this.has_opted_in_tracking() && (
        this.get_config('opt_out_tracking_by_default') || _.cookie.get('mp_optout')
    )) {
        _.cookie.remove('mp_optout');
        this.opt_out_tracking({
            'clear_persistence': this.get_config('opt_out_persistence_by_default')
        });
    }
};

/**
 * Enable or disable persistence based on options
 * only enable/disable if persistence is not already in this state
 * @param {boolean} [options.clear_persistence] If true, will delete all data stored by the sdk in persistence and disable it
 * @param {boolean} [options.enable_persistence] If true, will re-enable sdk persistence
 */
MixpanelLib.prototype._gdpr_update_persistence = function(options) {
    var disabled;
    if (options && options['clear_persistence']) {
        disabled = true;
    } else if (options && options['enable_persistence']) {
        disabled = false;
    } else {
        return;
    }

    if (!this.get_config('disable_persistence') && this['persistence'].disabled !== disabled) {
        this['persistence'].set_disabled(disabled);
    }

    if (disabled) {
        _.each(this.request_batchers, function(batcher) {
            batcher.clear();
        });
    }
};

// call a base gdpr function after constructing the appropriate token and options args
MixpanelLib.prototype._gdpr_call_func = function(func, options) {
    options = _.extend({
        'track': _.bind(this.track, this),
        'persistence_type': this.get_config('opt_out_tracking_persistence_type'),
        'cookie_prefix': this.get_config('opt_out_tracking_cookie_prefix'),
        'cookie_expiration': this.get_config('cookie_expiration'),
        'cross_site_cookie': this.get_config('cross_site_cookie'),
        'cross_subdomain_cookie': this.get_config('cross_subdomain_cookie'),
        'cookie_domain': this.get_config('cookie_domain'),
        'secure_cookie': this.get_config('secure_cookie'),
        'ignore_dnt': this.get_config('ignore_dnt')
    }, options);

    // check if localStorage can be used for recording opt out status, fall back to cookie if not
    if (!_.localStorage.is_supported()) {
        options['persistence_type'] = 'cookie';
    }

    return func(this.get_config('token'), {
        track: options['track'],
        trackEventName: options['track_event_name'],
        trackProperties: options['track_properties'],
        persistenceType: options['persistence_type'],
        persistencePrefix: options['cookie_prefix'],
        cookieDomain: options['cookie_domain'],
        cookieExpiration: options['cookie_expiration'],
        crossSiteCookie: options['cross_site_cookie'],
        crossSubdomainCookie: options['cross_subdomain_cookie'],
        secureCookie: options['secure_cookie'],
        ignoreDnt: options['ignore_dnt']
    });
};

/**
 * Opt the user in to data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage
 *
 *     // opt user in
 *     mixpanel.opt_in_tracking();
 *
 *     // opt user in with specific event name, properties, cookie configuration
 *     mixpanel.opt_in_tracking({
 *         track_event_name: 'User opted in',
 *         track_event_properties: {
 *             'Email': 'jdoe@example.com'
 *         },
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {function} [options.track] Function used for tracking a Mixpanel event to record the opt-in action (default is this Mixpanel instance's track method)
 * @param {string} [options.track_event_name=$opt_in] Event name to be used for tracking the opt-in action
 * @param {Object} [options.track_properties] Set of properties to be tracked along with the opt-in action
 * @param {boolean} [options.enable_persistence=true] If true, will re-enable sdk persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */
MixpanelLib.prototype.opt_in_tracking = function(options) {
    options = _.extend({
        'enable_persistence': true
    }, options);

    this._gdpr_call_func(optIn, options);
    this._gdpr_update_persistence(options);
};

/**
 * Opt the user out of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage
 *
 *     // opt user out
 *     mixpanel.opt_out_tracking();
 *
 *     // opt user out with different cookie configuration from Mixpanel instance
 *     mixpanel.opt_out_tracking({
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {boolean} [options.delete_user=true] If true, will delete the currently identified user's profile and clear all charges after opting the user out
 * @param {boolean} [options.clear_persistence=true] If true, will delete all data stored by the sdk in persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */
MixpanelLib.prototype.opt_out_tracking = function(options) {
    options = _.extend({
        'clear_persistence': true,
        'delete_user': true
    }, options);

    // delete user and clear charges since these methods may be disabled by opt-out
    if (options['delete_user'] && this['people'] && this['people']._identify_called()) {
        this['people'].delete_user();
        this['people'].clear_charges();
    }

    this._gdpr_call_func(optOut, options);
    this._gdpr_update_persistence(options);
};

/**
 * Check whether the user has opted in to data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage
 *
 *     var has_opted_in = mixpanel.has_opted_in_tracking();
 *     // use has_opted_in value
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} current opt-in status
 */
MixpanelLib.prototype.has_opted_in_tracking = function(options) {
    return this._gdpr_call_func(hasOptedIn, options);
};

/**
 * Check whether the user has opted out of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage
 *
 *     var has_opted_out = mixpanel.has_opted_out_tracking();
 *     // use has_opted_out value
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} current opt-out status
 */
MixpanelLib.prototype.has_opted_out_tracking = function(options) {
    return this._gdpr_call_func(hasOptedOut, options);
};

/**
 * Clear the user's opt in/out status of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage
 *
 *     // clear user's opt-in/out status
 *     mixpanel.clear_opt_in_out_tracking();
 *
 *     // clear user's opt-in/out status with specific cookie configuration - should match
 *     // configuration used when opt_in_tracking/opt_out_tracking methods were called.
 *     mixpanel.clear_opt_in_out_tracking({
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {boolean} [options.enable_persistence=true] If true, will re-enable sdk persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */
MixpanelLib.prototype.clear_opt_in_out_tracking = function(options) {
    options = _.extend({
        'enable_persistence': true
    }, options);

    this._gdpr_call_func(clearOptInOut, options);
    this._gdpr_update_persistence(options);
};

MixpanelLib.prototype.report_error = function(msg, err) {
    console.error.apply(console.error, arguments);
    try {
        if (!err && !(msg instanceof Error)) {
            msg = new Error(msg);
        }
        this.get_config('error_reporter')(msg, err);
    } catch(err) {
        console.error(err);
    }
};

// EXPORTS (for closure compiler)

// MixpanelLib Exports
MixpanelLib.prototype['init']                               = MixpanelLib.prototype.init;
MixpanelLib.prototype['reset']                              = MixpanelLib.prototype.reset;
MixpanelLib.prototype['disable']                            = MixpanelLib.prototype.disable;
MixpanelLib.prototype['time_event']                         = MixpanelLib.prototype.time_event;
MixpanelLib.prototype['track']                              = MixpanelLib.prototype.track;
MixpanelLib.prototype['track_links']                        = MixpanelLib.prototype.track_links;
MixpanelLib.prototype['track_forms']                        = MixpanelLib.prototype.track_forms;
MixpanelLib.prototype['track_pageview']                     = MixpanelLib.prototype.track_pageview;
MixpanelLib.prototype['register']                           = MixpanelLib.prototype.register;
MixpanelLib.prototype['register_once']                      = MixpanelLib.prototype.register_once;
MixpanelLib.prototype['unregister']                         = MixpanelLib.prototype.unregister;
MixpanelLib.prototype['identify']                           = MixpanelLib.prototype.identify;
MixpanelLib.prototype['alias']                              = MixpanelLib.prototype.alias;
MixpanelLib.prototype['name_tag']                           = MixpanelLib.prototype.name_tag;
MixpanelLib.prototype['set_config']                         = MixpanelLib.prototype.set_config;
MixpanelLib.prototype['get_config']                         = MixpanelLib.prototype.get_config;
MixpanelLib.prototype['get_property']                       = MixpanelLib.prototype.get_property;
MixpanelLib.prototype['get_distinct_id']                    = MixpanelLib.prototype.get_distinct_id;
MixpanelLib.prototype['toString']                           = MixpanelLib.prototype.toString;
MixpanelLib.prototype['opt_out_tracking']                   = MixpanelLib.prototype.opt_out_tracking;
MixpanelLib.prototype['opt_in_tracking']                    = MixpanelLib.prototype.opt_in_tracking;
MixpanelLib.prototype['has_opted_out_tracking']             = MixpanelLib.prototype.has_opted_out_tracking;
MixpanelLib.prototype['has_opted_in_tracking']              = MixpanelLib.prototype.has_opted_in_tracking;
MixpanelLib.prototype['clear_opt_in_out_tracking']          = MixpanelLib.prototype.clear_opt_in_out_tracking;
MixpanelLib.prototype['get_group']                          = MixpanelLib.prototype.get_group;
MixpanelLib.prototype['set_group']                          = MixpanelLib.prototype.set_group;
MixpanelLib.prototype['add_group']                          = MixpanelLib.prototype.add_group;
MixpanelLib.prototype['remove_group']                       = MixpanelLib.prototype.remove_group;
MixpanelLib.prototype['track_with_groups']                  = MixpanelLib.prototype.track_with_groups;
MixpanelLib.prototype['start_batch_senders']                = MixpanelLib.prototype.start_batch_senders;
MixpanelLib.prototype['stop_batch_senders']                 = MixpanelLib.prototype.stop_batch_senders;

// MixpanelPersistence Exports
MixpanelPersistence.prototype['properties']            = MixpanelPersistence.prototype.properties;
MixpanelPersistence.prototype['update_search_keyword'] = MixpanelPersistence.prototype.update_search_keyword;
MixpanelPersistence.prototype['update_referrer_info']  = MixpanelPersistence.prototype.update_referrer_info;
MixpanelPersistence.prototype['get_cross_subdomain']   = MixpanelPersistence.prototype.get_cross_subdomain;
MixpanelPersistence.prototype['clear']                 = MixpanelPersistence.prototype.clear;


var instances = {};
var extend_mp = function() {
    // add all the sub mixpanel instances
    _.each(instances, function(instance, name) {
        if (name !== PRIMARY_INSTANCE_NAME) { mixpanel_master[name] = instance; }
    });

    // add private functions as _
    mixpanel_master['_'] = _;
};

var override_mp_init_func = function() {
    // we override the snippets init function to handle the case where a
    // user initializes the mixpanel library after the script loads & runs
    mixpanel_master['init'] = function(token, config, name) {
        if (name) {
            // initialize a sub library
            if (!mixpanel_master[name]) {
                mixpanel_master[name] = instances[name] = create_mplib(token, config, name);
                mixpanel_master[name]._loaded();
            }
            return mixpanel_master[name];
        } else {
            var instance = mixpanel_master;

            if (instances[PRIMARY_INSTANCE_NAME]) {
                // main mixpanel lib already initialized
                instance = instances[PRIMARY_INSTANCE_NAME];
            } else if (token) {
                // intialize the main mixpanel lib
                instance = create_mplib(token, config, PRIMARY_INSTANCE_NAME);
                instance._loaded();
                instances[PRIMARY_INSTANCE_NAME] = instance;
            }

            mixpanel_master = instance;
            if (init_type === INIT_SNIPPET) {
                window$1[PRIMARY_INSTANCE_NAME] = mixpanel_master;
            }
            extend_mp();
        }
    };
};

var add_dom_loaded_handler = function() {
    // Cross browser DOM Loaded support
    function dom_loaded_handler() {
        // function flag since we only want to execute this once
        if (dom_loaded_handler.done) { return; }
        dom_loaded_handler.done = true;

        DOM_LOADED = true;
        ENQUEUE_REQUESTS = false;

        _.each(instances, function(inst) {
            inst._dom_loaded();
        });
    }

    function do_scroll_check() {
        try {
            document$1.documentElement.doScroll('left');
        } catch(e) {
            setTimeout(do_scroll_check, 1);
            return;
        }

        dom_loaded_handler();
    }

    if (document$1.addEventListener) {
        if (document$1.readyState === 'complete') {
            // safari 4 can fire the DOMContentLoaded event before loading all
            // external JS (including this file). you will see some copypasta
            // on the internet that checks for 'complete' and 'loaded', but
            // 'loaded' is an IE thing
            dom_loaded_handler();
        } else {
            document$1.addEventListener('DOMContentLoaded', dom_loaded_handler, false);
        }
    } else if (document$1.attachEvent) {
        // IE
        document$1.attachEvent('onreadystatechange', dom_loaded_handler);

        // check to make sure we arn't in a frame
        var toplevel = false;
        try {
            toplevel = window$1.frameElement === null;
        } catch(e) {
            // noop
        }

        if (document$1.documentElement.doScroll && toplevel) {
            do_scroll_check();
        }
    }

    // fallback handler, always will work
    _.register_event(window$1, 'load', dom_loaded_handler, true);
};

function init_as_module() {
    init_type = INIT_MODULE;
    mixpanel_master = new MixpanelLib();

    override_mp_init_func();
    mixpanel_master['init']();
    add_dom_loaded_handler();

    return mixpanel_master;
}

var mixpanel = init_as_module();

module.exports = mixpanel;
},{}]},{},[94]);
